import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { Component, useMemo, Fragment, useState, useRef, useEffect, useCallback, useContext, createContext } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { useIntl, injectIntl, FormattedMessage as FormattedMessage$2, IntlProvider } from 'react-intl';
import { useHistory as useHistory$1, Redirect, BrowserRouter, Switch as Switch$1, Route } from 'react-router-dom';
export { Link, NavLink, Redirect } from 'react-router-dom';
import { IconButton, Tooltip, Button, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem, Divider, List, Popover, Typography as Typography$1, Grid, Drawer, ListItem as ListItem$1, ListItemIcon as ListItemIcon$1, CircularProgress, ListItemText as ListItemText$1, Collapse, Accordion as Accordion$1, AccordionSummary as AccordionSummary$1, AccordionDetails as AccordionDetails$1, AppBar, Toolbar, Hidden, Switch, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Box, LinearProgress, Link, InputAdornment, Snackbar, CssBaseline, FormControl, InputLabel, Select, Fab, InputBase, Table as Table$4, TableHead, TableRow, TableCell, Checkbox, TableBody, TableFooter, TablePagination, FormControlLabel as FormControlLabel$1, Menu, withTheme as withTheme$1, withStyles as withStyles$2, ListItemSecondaryAction } from '@material-ui/core';
import { makeStyles, withStyles, withTheme, alpha, useTheme } from '@material-ui/core/styles';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import PropTypes from 'prop-types';
import _Helmet from 'react-helmet';
export { default as Helmet } from 'react-helmet';
import withWidth from '@material-ui/core/withWidth';
import { useHistory } from 'react-router';
export { useHistory, useLocation, useParams, useRouteMatch } from 'react-router';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import * as Icons from '@material-ui/icons';
import { ExitToApp, HelpOutline, Public, ExpandMore, YoutubeSearchedFor, Search } from '@material-ui/icons';
import { RSAA } from 'redux-api-middleware';
import uuid from 'lodash-uuid';
import _$1, { debounce } from 'lodash';
import SortIcon from '@material-ui/icons/UnfoldMore';
import SortAscIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import NepaliDate from 'nepali-date-converter';
import { useModulesManager as useModulesManager$1, SelectDialog as SelectDialog$2, ErrorBoundary as ErrorBoundary$1, useTranslations as useTranslations$1, TextInput as TextInput$2, TextAreaInput as TextAreaInput$1, PublishedComponent as PublishedComponent$2, NumberInput as NumberInput$2, SelectInput as SelectInput$2, SearcherActionButton as SearcherActionButton$1, formatMessage as formatMessage$1, withModulesManager as withModulesManager$1, withHistory as withHistory$1, useGraphqlQuery as useGraphqlQuery$1, Autocomplete as Autocomplete$3, Helmet, Searcher as Searcher$2, formatMessageWithValues as formatMessageWithValues$1, withTooltip as withTooltip$1, coreConfirm as coreConfirm$1, journalize as journalize$1, clearCurrentPaginationPage as clearCurrentPaginationPage$1, historyPush as historyPush$1, formatDateFromISO as formatDateFromISO$3, FormattedMessage as FormattedMessage$3, ValidatedTextInput as ValidatedTextInput$1, FormPanel as FormPanel$1, ProgressOrError as ProgressOrError$2, Form as Form$2, baseApiUrl as baseApiUrl$1, ConstantBasedPicker as ConstantBasedPicker$2 } from '@openimis/fe-core';
import clsx from 'clsx';
import MenuIcon from '@material-ui/icons/Menu';
import _typeof from '@babel/runtime/helpers/typeof';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { bindActionCreators } from 'redux';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MoreIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { makeStyles as makeStyles$1 } from '@material-ui/styles';
import zxcvbn from 'zxcvbn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ClearIcon from '@material-ui/icons/Clear';
import MuiAlert from '@material-ui/lab/Alert';
import Autosuggest from 'react-autosuggest';
import SearchIcon from '@material-ui/icons/Search';
import { Autocomplete as Autocomplete$2 } from '@material-ui/lab';
import withStyles$1 from '@material-ui/core/styles/withStyles';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import _debounce from 'lodash/debounce';
import Button$1 from '@material-ui/core/Button';
import Dialog$1 from '@material-ui/core/Dialog';
import DialogActions$1 from '@material-ui/core/DialogActions';
import DialogContent$1 from '@material-ui/core/DialogContent';
import DialogTitle$1 from '@material-ui/core/DialogTitle';
import Grid$1 from '@material-ui/core/Grid';
import FilterListIcon from '@material-ui/icons/FilterList';
import InfoIcon from '@material-ui/icons/Info';
import { DatePicker as DatePicker$1 } from '@material-ui/pickers';
import DatePicker from 'react-multi-date-picker';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import AccountBox from '@material-ui/icons/AccountBox';
import EditIcon from '@material-ui/icons/Edit';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';

function _callSuper$A(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$A() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$A() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$A = function _isNativeReflectConstruct() { return !!t; })(); }
var modulesManagerCtx = /*#__PURE__*/React.createContext(null);
// Since we can't reach the frontend package we have to rely on the old context API to get
// the modules manager and propagate it using the new API
var ModulesManagerProvider = modulesManagerCtx.Provider;
var useModulesManager = function useModulesManager() {
  var value = React.useContext(modulesManagerCtx);
  return value;
};
function withModulesManager(C) {
  var _ManagedComponent;
  return _ManagedComponent = /*#__PURE__*/function (_Component) {
    function ManagedComponent() {
      _classCallCheck(this, ManagedComponent);
      return _callSuper$A(this, ManagedComponent, arguments);
    }
    _inherits(ManagedComponent, _Component);
    return _createClass(ManagedComponent, [{
      key: "render",
      value: function render() {
        var modulesManager = this.context.modulesManager;
        return /*#__PURE__*/React.createElement(C, _extends({}, this.props, {
          modulesManager: modulesManager
        }));
      }
    }]);
  }(Component), _defineProperty(_ManagedComponent, "contextTypes", {
    modulesManager: PropTypes.object.isRequired
  }), _ManagedComponent;
}

function withHistory(C) {
  console.warn("[Deprecated]: Prefer using directly the `useHistory` hook to get the history");
  return function (props) {
    var history = useHistory();
    return /*#__PURE__*/React.createElement(C, _extends({}, props, {
      history: history
    }));
  };
}
function _historyPush(mm, history, route, asNewTab) {
  if (asNewTab) {
    var hasDynLink = mm.getConf("fe-core", "useDynPermalinks", false);
    var link = history.createHref({
      pathname: route
    });
    window.open(hasDynLink ? "/?dyn=".concat(btoa(link)) : link);
  } else {
    history.push(route);
  }
}
function historyPush(mm, history, route, params) {
  var newTab = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  _historyPush(mm, history, "/".concat(mm.getRef(route)).concat(!!params ? "/" + params.join("/") : ""), newTab);
}

var DEFAULT_DEBOUNCE_TIME = 500;
var DEFAULT_PAGE_SIZE = 10;
var ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
var CONTAINS_LOOKUP = "Icontains";
var LANGUAGE_EN = "en";
var QUERY_STRING_DUPLICATE = "duplicate";
var RIGHT_ROLE_SEARCH = 122001;
var RIGHT_ROLE_CREATE = 122002;
var RIGHT_ROLE_UPDATE = 122003;
var RIGHT_ROLE_DELETE = 122004;
var RIGHT_ROLE_DUPLICATE = 122005;
var MODULE_NAME = "core";
var USER_ACTIVITY_REPORT_ACTION_INSERT = "I";
var USER_ACTIVITY_REPORT_ACTION_UPDATE = "U";
var USER_ACTIVITY_REPORT_ACTION_DELETE = "D";
var USER_ACTIVITY_REPORT_ACTIONS = [USER_ACTIVITY_REPORT_ACTION_INSERT, USER_ACTIVITY_REPORT_ACTION_UPDATE, USER_ACTIVITY_REPORT_ACTION_DELETE];
var USER_ACTIVITY_REPORT_ENTITY_CLAIM = "Claim";
var USER_ACTIVITY_REPORT_ENTITY_BATCH_RUN = "BatchRun";
var USER_ACTIVITY_REPORT_ENTITY_CLAIM_ADMIN = "ClaimAdmin";
var USER_ACTIVITY_REPORT_ENTITY_LOCATION = "Location";
var USER_ACTIVITY_REPORT_ENTITY_EXTRACT = "Extract";
var USER_ACTIVITY_REPORT_ENTITY_FAMILY = "Family";
var USER_ACTIVITY_REPORT_ENTITY_FEEDBACK = "Feedback";
var USER_ACTIVITY_REPORT_ENTITY_LOC_HF = "HealthFacility";
var USER_ACTIVITY_REPORT_ENTITY_INSUREE = "Insuree";
var USER_ACTIVITY_REPORT_ENTITY_ITEM = "Item";
var USER_ACTIVITY_REPORT_ENTITY_OFFICER = "Officer";
var USER_ACTIVITY_REPORT_ENTITY_PAYER = "Payer";
var USER_ACTIVITY_REPORT_ENTITY_PHOTO = "InsureePhoto";
var USER_ACTIVITY_REPORT_ENTITY_PL_ITEM = "ItemsPricelist";
var USER_ACTIVITY_REPORT_ENTITY_PL_SERVICE = "ServicesPricelist";
var USER_ACTIVITY_REPORT_ENTITY_PL_ITEM_DETAILS = "ItemsPricelistDetail";
var USER_ACTIVITY_REPORT_ENTITY_PL_SERVICE_DETAILS = "ServicesPricelistDetail";
var USER_ACTIVITY_REPORT_ENTITY_POLICY = "Policy";
var USER_ACTIVITY_REPORT_ENTITY_PREMIUM = "Premium";
var USER_ACTIVITY_REPORT_ENTITY_PRODUCT = "Product";
var USER_ACTIVITY_REPORT_ENTITY_PRODUCT_ITEM = "ProductItem";
var USER_ACTIVITY_REPORT_ENTITY_PRODUCT_SERVICE = "ProductService";
var USER_ACTIVITY_REPORT_ENTITY_RELATIVE_DISTRIBUTION = "RelativeDistribution";
var USER_ACTIVITY_REPORT_ENTITY_SERVICE = "Service";
var USER_ACTIVITY_REPORT_ENTITY_USER = "InteractiveUser";
var USER_ACTIVITY_REPORT_ENTITY_USER_DISTRICT = "UserDistrict";
var STORAGE_KEY_SECONDARY_CALENDAR = "isSecondaryCalendarEnabled";
var DEFAULT_SETTINGS = {
  SECOND_CALENDAR_FORMAT: "DD-MM-YYYY",
  SECOND_CALENDAR_LANG: "en"
};
var USER_ACTIVITY_REPORT_ENTITIES = [USER_ACTIVITY_REPORT_ENTITY_BATCH_RUN, USER_ACTIVITY_REPORT_ENTITY_CLAIM, USER_ACTIVITY_REPORT_ENTITY_CLAIM_ADMIN, USER_ACTIVITY_REPORT_ENTITY_EXTRACT, USER_ACTIVITY_REPORT_ENTITY_FAMILY, USER_ACTIVITY_REPORT_ENTITY_FEEDBACK, USER_ACTIVITY_REPORT_ENTITY_LOCATION, USER_ACTIVITY_REPORT_ENTITY_LOC_HF, USER_ACTIVITY_REPORT_ENTITY_INSUREE, USER_ACTIVITY_REPORT_ENTITY_ITEM, USER_ACTIVITY_REPORT_ENTITY_OFFICER, USER_ACTIVITY_REPORT_ENTITY_PAYER, USER_ACTIVITY_REPORT_ENTITY_PHOTO, USER_ACTIVITY_REPORT_ENTITY_PL_ITEM, USER_ACTIVITY_REPORT_ENTITY_PL_SERVICE, USER_ACTIVITY_REPORT_ENTITY_PL_ITEM_DETAILS, USER_ACTIVITY_REPORT_ENTITY_PL_SERVICE_DETAILS, USER_ACTIVITY_REPORT_ENTITY_POLICY, USER_ACTIVITY_REPORT_ENTITY_PREMIUM, USER_ACTIVITY_REPORT_ENTITY_PRODUCT, USER_ACTIVITY_REPORT_ENTITY_PRODUCT_ITEM, USER_ACTIVITY_REPORT_ENTITY_PRODUCT_SERVICE, USER_ACTIVITY_REPORT_ENTITY_RELATIVE_DISTRIBUTION, USER_ACTIVITY_REPORT_ENTITY_SERVICE, USER_ACTIVITY_REPORT_ENTITY_USER, USER_ACTIVITY_REPORT_ENTITY_USER_DISTRICT];

// consts relate do custom filters
var BOOL_OPTIONS = [{
  value: "True",
  label: "True"
}, {
  value: "False",
  label: "False"
}];
var CLEARED_STATE_FILTER = {
  field: "",
  filter: "",
  type: "",
  value: ""
};
var CUSTOM_FILTERS = "customFilters";
var INTEGER = "integer";
var NUMBER = "number";
var STRING = "string";
var BOOLEAN = "boolean";
var DATE = "date";
var FIELD_TYPES = {
  INTEGER: INTEGER,
  NUMBER: NUMBER,
  STRING: STRING,
  BOOLEAN: BOOLEAN,
  DATE: DATE
};
var WHITE_SPACE = " ";
var DOUBLE_UNDERSCORE = "__";
var GLOBAL_UNDERSCORE = /_/g;
var EQUALS_SIGN = "=";
var CLAIM_STATS_ORDER = ["submitted", "checked", "processed", "valuated", "rejected", "items_passed", "items_rejected", "services_passed", "services_rejected"];
var CORE_MIS_CONFLUENCE_URL = "https://openimis.atlassian.net/wiki/spaces/OP/pages/3531407380/Project+2022.T3+CORE-MIS+Merger";
var DEFAULT_URL = "https://docs.openimis.org/";
var SAML_LOGIN_PATH = "/msystems/saml/login/";
var SAML_LOGOUT_PATH = "/msystems/saml/logout/";
var RIGHT_VIEW_EU_MODAL = 203000;
var ENTER_KEY = "Enter";
var PUBLIC_PAGE_LANGUAGE_COOKIE_KEY = "publicPageLanguage";
var DEFAULT = {
  IS_WORKER: false,
  ENABLE_PUBLIC_PAGE: false,
  SHOW_JOURNAL_SIDEBAR: true,
  DISABLED_VISIBILITY_BOOST: false
};
var EXPORT_FILE_FORMATS = {
  // By default, the export file format is CSV
  csv: "csv",
  // The other available export file format is XLSX.
  // It can be configured individually for each Searcher.
  xlsx: "xlsx"
};
var REQUEST_LIMIT = 5;

function ownKeys$r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$r(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _entityAndFilters(entity, filters) {
  return "".concat(entity).concat(!!filters && filters.length ? "(".concat(filters.join(","), ")") : "");
}
function _pageAndEdges(projections) {
  return "\n    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}\n    edges\n    {\n      node\n      {\n        ".concat(projections.join(","), "\n      }\n    }");
}
function formatQuery(entity, filters, projections) {
  return "\n    {\n      ".concat(_entityAndFilters(entity, filters), "\n      ").concat(!!projections ? "{\n        ".concat(projections.join(","), "\n      }") : "", "\n    }");
}
function formatNodeQuery(entityGQLType, nodeId) {
  var projections = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["id"];
  return "\n  {\n    node (id: \"".concat(nodeId, "\") {\n      ...on ").concat(entityGQLType, " {\n        ").concat(projections.join(','), "\n      }\n    }\n  }\n  ");
}
function formatPageQuery(entity, filters, projections) {
  return "\n    {\n      ".concat(_entityAndFilters(entity, filters), "\n      {\n        ").concat(_pageAndEdges(projections), "\n      }\n    }");
}
function formatPageQueryWithCount(entity, filters, projections) {
  return "\n    {\n      ".concat(_entityAndFilters(entity, filters), "\n      {\n        totalCount\n        ").concat(_pageAndEdges(projections), "\n      }\n    }");
}
function formatGQLString(str) {
  if (!str) return str;
  return str.replace(/[\"]/g, '\\"').replace(/[\\]/g, "\\\\").replace(/[\/]/g, "\\/").replace(/[\b]/g, "\\b").replace(/[\f]/g, "\\f").replace(/[\n]/g, "\\n").replace(/[\r]/g, "\\r").replace(/[\t]/g, "\\t");
}
function formatMutation(operationName, input, clientMutationLabel, clientMutationDetails) {
  var clientMutationId = uuid.uuid();
  var payload = "\n    mutation {\n      ".concat(operationName, "(\n        input: {\n          clientMutationId: \"").concat(clientMutationId, "\"\n          clientMutationLabel: \"").concat(clientMutationLabel, "\"\n          ").concat(!!clientMutationDetails ? "clientMutationDetails: ".concat(JSON.stringify(clientMutationDetails)) : "", "\n          ").concat(input.trim(), "\n        }\n      ) {\n        clientMutationId\n        internalId\n      }\n    }");
  return {
    clientMutationId: clientMutationId,
    payload: payload
  };
}
function decodeId(id) {
  if (/^\d+$/.test(id)) return id;else return atob(id).split(":")[1];
}
function encodeId(modulesManager, type, id) {
  return btoa("".concat(modulesManager.getRef(type), ":").concat(id));
}
function parseData(data) {
  if (!data) return [];
  return data["edges"].map(function (e) {
    return e["node"];
  });
}
function dispatchMutationReq(state, action) {
  return _objectSpread$r(_objectSpread$r({}, state), {}, {
    submittingMutation: true,
    mutation: action.meta
  });
}
function dispatchMutationResp(state, service, action) {
  var mutation = state.mutation;
  mutation.id = action.payload.data[service].internalId;
  return _objectSpread$r(_objectSpread$r({}, state), {}, {
    submittingMutation: false,
    mutation: mutation
  });
}
function dispatchMutationErr(state, action) {
  return _objectSpread$r(_objectSpread$r({}, state), {}, {
    alert: JSON.stringify(action.payload)
  });
}
function pageInfo(data) {
  if (!data) return {};
  return _objectSpread$r({
    totalCount: data["totalCount"]
  }, data["pageInfo"]);
}
function formatServerError(payload) {
  return {
    code: payload.status,
    message: payload.statusText,
    detail: !!payload.response && payload.response.errors ? payload.response.errors.map(function (e) {
      return e.message;
    }).join("; ") : null
  };
}
function formatGraphQLError(payload) {
  return !payload.errors ? null : {
    code: "Data error",
    message: "Server returned data error status",
    detail: payload.errors.map(function (e) {
      return e.message;
    }).join("; ")
  };
}
function openBlob(data, filename, mime) {
  var a = document.createElement("a");
  a.style = "display: none";
  var blob = new Blob([data], {
    type: "application/".concat(mime)
  });
  var url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 100);
}
function sort(orderBy, attr) {
  var asc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var targetSort = null;
  if (orderBy === attr) {
    targetSort = "-" + attr;
  } else if (orderBy === "-" + attr) {
    targetSort = attr;
  } else {
    targetSort = asc ? attr : "-" + attr;
  }
  return targetSort;
}
function formatSorter(orderBy, attr, asc) {
  if (orderBy === attr) {
    return /*#__PURE__*/React.createElement(IconButton, {
      size: "small"
    }, /*#__PURE__*/React.createElement(SortAscIcon, {
      size: 24
    }));
  } else if (orderBy === "-" + attr) {
    return /*#__PURE__*/React.createElement(IconButton, {
      size: "small"
    }, /*#__PURE__*/React.createElement(ExpandMoreIcon, {
      size: 24
    }));
  } else {
    return /*#__PURE__*/React.createElement(IconButton, {
      size: "small"
    }, /*#__PURE__*/React.createElement(SortIcon, {
      size: 24
    }));
  }
}

function ownKeys$q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$q(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var REQUESTED_WITH = 'webapp';
var ROLE_FULL_PROJECTION = function ROLE_FULL_PROJECTION() {
  return ["id", "uuid", "name", "altLanguage", "isSystem", "isBlocked", "validityFrom", "validityTo"];
};
var ROLERIGHT_FULL_PROJECTION = function ROLERIGHT_FULL_PROJECTION() {
  return ["rightId"];
};
var LANGUAGE_FULL_PROJECTION = function LANGUAGE_FULL_PROJECTION() {
  return ["name", "code"];
};
var MODULEPERMISSION_FULL_PROJECTION = function MODULEPERMISSION_FULL_PROJECTION() {
  return ["modulePermsList{moduleName, permissions{permsName, permsValue}}"];
};
var CUSTOM_FILTER_FULL_PROJECTION = function CUSTOM_FILTER_FULL_PROJECTION() {
  return ["type", "code", "possibleFilters {field, filter, type}"];
};
function fetchCustomFilter(params) {
  var payload = formatQuery("customFilters", params, CUSTOM_FILTER_FULL_PROJECTION());
  return graphql(payload, "FETCH_CUSTOM_FILTER");
}
function getApiUrl() {
  var _process$env$REACT_AP;
  var _baseApiUrl = (_process$env$REACT_AP = process.env.REACT_APP_API_URL) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : "/api";
  if (_baseApiUrl.indexOf("/") !== 0) {
    _baseApiUrl = "/".concat(_baseApiUrl);
  }
  return _baseApiUrl;
}
var baseApiUrl = getApiUrl();
function apiHeaders() {
  var headers = {
    "Content-Type": "application/json"
  };
  return headers;
}
function cacheFilters(key, filters) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CACHE_FILTER",
      payload: _defineProperty({}, key, filters)
    });
  };
}
function resetCacheFilters(key) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CACHE_FILTER_RESET",
      payload: key
    });
  };
}
function journalize(mutation, meta) {
  return function (dispatch) {
    mutation.status = 0;
    dispatch({
      type: "CORE_MUTATION_ADD",
      payload: mutation,
      meta: meta
    });
  };
}
function isCsrfError(error) {
  var _error$message;
  return error === null || error === void 0 || (_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.includes("CSRF token missing or incorrect.");
}
function graphql(payload) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GRAPHQL_QUERY";
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var req = type + "_REQ";
  var resp = type + "_RESP";
  var err = type + "_ERR";
  if (Array.isArray(type)) {
    var _type = _slicedToArray(type, 3);
    req = _type[0];
    resp = _type[1];
    err = _type[2];
  }
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _response$payload, response, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return dispatch(fetch$1({
              endpoint: "".concat(baseApiUrl, "/graphql"),
              method: "POST",
              body: JSON.stringify({
                query: payload
              }),
              types: [{
                type: req,
                meta: params
              }, {
                type: resp,
                meta: params
              }, {
                type: err,
                meta: params
              }]
            }));
          case 3:
            response = _context.sent;
            if (response.error) {
              dispatch(coreAlert(formatServerError(response.payload)));
            }
            error = (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.errors) === null || _response$payload === void 0 ? void 0 : _response$payload[0];
            if (!(error && isCsrfError(error))) {
              _context.next = 11;
              break;
            }
            _context.next = 9;
            return dispatch(logout());
          case 9:
            requestAnimationFrame(function () {
              window.location.reload();
            });
            return _context.abrupt("return");
          case 11:
            return _context.abrupt("return", response);
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 14]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function graphqlWithVariables(operation, variables) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GRAPHQL_QUERY";
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var customHeaders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var req, resp, err;
  if (Array.isArray(type)) {
    var _type2 = _slicedToArray(type, 3);
    req = _type2[0];
    resp = _type2[1];
    err = _type2[2];
  } else {
    req = type + "_REQ";
    resp = type + "_RESP";
    err = type + "_ERR";
  }
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return dispatch(fetch$1({
              endpoint: "".concat(baseApiUrl, "/graphql"),
              method: "POST",
              body: JSON.stringify({
                query: operation,
                variables: variables
              }),
              headers: _objectSpread$q({}, customHeaders),
              types: [{
                type: req,
                meta: params
              }, {
                type: resp,
                meta: params
              }, {
                type: err,
                meta: params
              }]
            }));
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}
function prepareMutation(operation, input) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!params.clientMutationId) {
    params.clientMutationId = uuid.uuid();
  }
  var variables = {
    input: _objectSpread$q(_objectSpread$q({}, input), params)
  };
  return {
    operation: operation,
    variables: variables,
    clientMutationId: params.clientMutationId
  };
}
function waitForMutation(clientMutationId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var attempts, res, _response$payload$dat, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            attempts = 0;
          case 1:
            if (!res) {
              _context3.next = 4;
              break;
            }
            _context3.next = 4;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100 * attempts);
            });
          case 4:
            _context3.next = 6;
            return dispatch(graphqlWithVariables("\n        query ($clientMutationId: String) {\n          mutationLogs (clientMutationId: $clientMutationId) {\n            edges {\n              node {\n                status\n                clientMutationId\n                jsonContent\n                error\n              }\n            }\n          }\n        }\n      ", {
              clientMutationId: clientMutationId
            }));
          case 6:
            response = _context3.sent;
            if (!response.error) {
              _context3.next = 9;
              break;
            }
            return _context3.abrupt("return", null);
          case 9:
            res = (_response$payload$dat = response.payload.data.mutationLogs) === null || _response$payload$dat === void 0 || (_response$payload$dat = _response$payload$dat.edges[0]) === null || _response$payload$dat === void 0 ? void 0 : _response$payload$dat.node;
          case 10:
            if ((!res || res.status === 0) && attempts++ < 10) {
              _context3.next = 1;
              break;
            }
          case 11:
            if (res && res.status === 1 && res.error) {
              res.error = JSON.parse(res.error);
            }
            return _context3.abrupt("return", res);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function graphqlMutation(mutation, variables) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "CORE_TRIGGER_MUTATION";
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var customHeaders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var clientMutationId;
  if (variables !== null && variables !== void 0 && variables.input) {
    clientMutationId = uuid.uuid();
    variables.input.clientMutationId = clientMutationId;
  }
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var response, _response$payload2;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return dispatch(graphqlWithVariables(mutation, variables, type, params, customHeaders));
          case 2:
            response = _context4.sent;
            if (!clientMutationId) {
              _context4.next = 10;
              break;
            }
            dispatch(fetchMutation(clientMutationId));
            if (!wait) {
              _context4.next = 9;
              break;
            }
            return _context4.abrupt("return", dispatch(waitForMutation(clientMutationId)));
          case 9:
            return _context4.abrupt("return", response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.data);
          case 10:
            return _context4.abrupt("return", response);
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function fetch$1(config) {
  var csrfToken = localStorage.getItem('csrfToken');
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", dispatch(_defineProperty({}, RSAA, _objectSpread$q(_objectSpread$q({}, config), {}, {
              headers: _objectSpread$q({
                "Content-Type": "application/json",
                'X-Requested-With': REQUESTED_WITH,
                "X-CSRFToken": csrfToken
              }, config.headers)
            }))));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
}
function loadUser() {
  return fetch$1({
    endpoint: "".concat(baseApiUrl, "/core/users/current_user/"),
    method: "GET",
    types: ["CORE_USERS_CURRENT_USER_REQ", "CORE_USERS_CURRENT_USER_RESP", "CORE_USERS_CURRENT_USER_ERR"]
  });
}
function login(credentials) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var mutation, _response$payload3, _csrfResponse$payload, _action$payload$respo, _action$payload, response, errorMessage, jwtToken, csrfResponse, csrfToken, action, _action$payload$respo2, _action$payload2, _action;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!credentials) {
              _context6.next = 28;
              break;
            }
            mutation = "mutation authenticate($username: String!, $password: String!) {\n            tokenAuth(username: $username, password: $password) {\n              refreshExpiresIn\n            }\n          }";
            _context6.prev = 2;
            _context6.next = 5;
            return dispatch(graphqlMutation(mutation, credentials, ["CORE_AUTH_LOGIN_REQ", "CORE_AUTH_LOGIN_RESP", "CORE_AUTH_ERR"], {}, false, {
              "X-CSRFToken": csrfToken
            }));
          case 5:
            response = _context6.sent;
            if (!(((_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.errors) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.length) > 0)) {
              _context6.next = 10;
              break;
            }
            errorMessage = response.payload.errors[0].message;
            dispatch(authError({
              message: errorMessage
            }));
            return _context6.abrupt("return", {
              loginStatus: "CORE_AUTH_ERR",
              message: errorMessage
            });
          case 10:
            jwtToken = response.payload.data.tokenAuth.token;
            _context6.next = 13;
            return dispatch(fetchCsrfToken(jwtToken));
          case 13:
            csrfResponse = _context6.sent;
            csrfToken = csrfResponse === null || csrfResponse === void 0 || (_csrfResponse$payload = csrfResponse.payload) === null || _csrfResponse$payload === void 0 || (_csrfResponse$payload = _csrfResponse$payload.data) === null || _csrfResponse$payload === void 0 || (_csrfResponse$payload = _csrfResponse$payload.getCsrfToken) === null || _csrfResponse$payload === void 0 ? void 0 : _csrfResponse$payload.csrfToken;
            if (csrfToken) {
              localStorage.setItem('csrfToken', csrfToken);
            }
            _context6.next = 18;
            return dispatch(loadUser());
          case 18:
            action = _context6.sent;
            return _context6.abrupt("return", {
              loginStatus: action.type,
              message: (_action$payload$respo = action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.response) === null || _action$payload === void 0 ? void 0 : _action$payload.detail) !== null && _action$payload$respo !== void 0 ? _action$payload$respo : ""
            });
          case 22:
            _context6.prev = 22;
            _context6.t0 = _context6["catch"](2);
            dispatch(authError({
              message: _context6.t0.message
            }));
            return _context6.abrupt("return", {
              loginStatus: "CORE_AUTH_ERR",
              message: _context6.t0.message
            });
          case 26:
            _context6.next = 34;
            break;
          case 28:
            _context6.next = 30;
            return dispatch(refreshAuthToken());
          case 30:
            _context6.next = 32;
            return dispatch(loadUser());
          case 32:
            _action = _context6.sent;
            return _context6.abrupt("return", {
              loginStatus: _action.type,
              message: (_action$payload$respo2 = _action === null || _action === void 0 || (_action$payload2 = _action.payload) === null || _action$payload2 === void 0 || (_action$payload2 = _action$payload2.response) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.detail) !== null && _action$payload$respo2 !== void 0 ? _action$payload$respo2 : "Error occurred while loading user."
            });
          case 34:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 22]]);
    }));
    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
}
function fetchCsrfToken(jwtToken) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var csrfQuery;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            csrfQuery = "mutation {\n      getCsrfToken {\n        csrfToken\n      }\n    }";
            return _context7.abrupt("return", dispatch(graphqlMutation(csrfQuery, {}, ["CORE_AUTH_CSRTOKEN_REQ", "CORE_AUTH_CSRTOKEN_RESP", "CORE_AUTH_ERR"], {}, false, {
              "Authorization": "JWT ".concat(jwtToken)
            })));
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
}
function refreshAuthToken() {
  return function (dispatch) {
    var mutation = "\n    mutation refreshAuthToken {\n      refreshToken {\n        refreshExpiresIn\n      }\n    }\n  ";
    return dispatch(graphqlMutation(mutation, {}, "CORE_AUTH_REFRESH_TOKEN"));
  };
}
function initialize() {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return dispatch(login());
          case 2:
            return _context8.abrupt("return", dispatch({
              type: "CORE_INITIALIZED"
            }));
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
}
function authError(error) {
  return {
    type: "CORE_AUTH_ERR",
    payload: error
  };
}
function logout() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch, getState) {
      var mutation;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            mutation = "\n      mutation logout {\n        deleteTokenCookie {\n          deleted\n        }\n        deleteRefreshTokenCookie {\n          deleted\n        }\n      }\n    ";
            _context9.next = 3;
            return dispatch(graphqlMutation(mutation, {}));
          case 3:
            return _context9.abrupt("return", dispatch({
              type: "CORE_AUTH_LOGOUT"
            }));
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x9, _x10) {
      return _ref9.apply(this, arguments);
    };
  }();
}
function fetchPasswordPolicy() {
  var payload = "query {\n    passwordPolicy\n  }";
  return graphql(payload, "PASSWORD_POLICY_FIELDS");
}
function fetchMutation(clientMutationId) {
  var payload = formatPageQuery("mutationLogs", ["clientMutationId: \"".concat(clientMutationId, "\"")], ["id", "status", "error", "clientMutationId", "clientMutationLabel", "clientMutationDetails", "requestDateTime", "jsonExt", "autogeneratedCode"]);
  return graphql(payload, "CORE_MUTATION");
}
function fetchHistoricalMutations(pageSize, afterCursor) {
  var filters = ["first: ".concat(pageSize)];
  if (!!afterCursor) {
    filters.push("after: \"".concat(afterCursor, "\""));
  }
  filters.push("orderBy: \"-request_date_time\"");
  var payload = formatPageQuery("mutationLogs", filters, ["id", "status", "error", "clientMutationId", "clientMutationLabel", "clientMutationDetails", "requestDateTime", "jsonExt"]);
  return graphql(payload, "CORE_HISTORICAL_MUTATIONS");
}
function coreAlert(titleOrObject, message, detail) {
  var payload;
  if (_$1.isObject(titleOrObject)) {
    payload = titleOrObject;
  } else {
    payload = {
      title: titleOrObject,
      message: message,
      detail: detail
    };
  }
  return function (dispatch) {
    dispatch({
      type: "CORE_ALERT",
      payload: payload
    });
  };
}
function clearAlert() {
  return function (dispatch) {
    dispatch({
      type: "CORE_ALERT_CLEAR"
    });
  };
}
function coreConfirm(title, message) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CONFIRM",
      payload: {
        title: title,
        message: message
      }
    });
  };
}
function clearConfirm(confirmed) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CONFIRM_CLEAR",
      payload: confirmed
    });
  };
}
function openExportConfigDialog() {
  return function (dispatch) {
    dispatch({
      type: "CORE_OPEN_EXPORT_CONFIG_DIALOG"
    });
  };
}
function closeExportConfigDialog() {
  return function (dispatch) {
    dispatch({
      type: "CORE_CLOSE_EXPORT_CONFIG_DIALOG"
    });
  };
}
function fetchRoles(params) {
  var payload = formatPageQueryWithCount("role", params, ROLE_FULL_PROJECTION());
  return graphql(payload, "CORE_ROLES");
}
function fetchRole(params) {
  var payload = formatPageQuery("role", params, ROLE_FULL_PROJECTION());
  return graphql(payload, "CORE_ROLE");
}
function fetchRoleRights(params) {
  var payload = formatPageQuery("roleRight", params, ROLERIGHT_FULL_PROJECTION());
  return graphql(payload, "CORE_ROLERIGHTS");
}
function fetchModulesPermissions() {
  var payload = formatQuery("modulesPermissions", null, MODULEPERMISSION_FULL_PROJECTION());
  return graphql(payload, "CORE_MODULEPERMISSIONS");
}
function fetchLanguages() {
  var payload = formatQuery("languages", null, LANGUAGE_FULL_PROJECTION());
  return graphql(payload, "CORE_LANGUAGES");
}
function formatRoleGQL(role) {
  return "\n        ".concat(!!role.uuid ? "uuid: \"".concat(role.uuid, "\"") : "", "\n        ").concat(!!role.name ? "name: \"".concat(formatGQLString(role.name), "\"") : "", "\n        ").concat(!!role.altLanguage ? "altLanguage: \"".concat(formatGQLString(role.altLanguage), "\"") : "", "\n        ").concat(role.isSystem !== null ? "isSystem: ".concat(role.isSystem) : "", "\n        ").concat(role.isBlocked !== null ? "isBlocked: ".concat(role.isBlocked) : "", "\n        ").concat(!!role.roleRights ? "rightsId: [".concat(role.roleRights.join(","), "]") : "", "\n    ");
}
function createRole(role, clientMutationLabel) {
  var mutation = formatMutation("createRole", formatRoleGQL(role), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["CORE_ROLE_MUTATION_REQ", "CORE_CREATE_ROLE_RESP", "CORE_ROLE_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateRole(role, clientMutationLabel) {
  var mutation = formatMutation("updateRole", formatRoleGQL(role), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["CORE_ROLE_MUTATION_REQ", "CORE_UPDATE_ROLE_RESP", "CORE_ROLE_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function deleteRole(role, clientMutationLabel) {
  var clientMutationDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var roleUuids = "uuids: [\"".concat(role.uuid, "\"]");
  var mutation = formatMutation("deleteRole", roleUuids, clientMutationLabel, clientMutationDetails);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["CORE_ROLE_MUTATION_REQ", "CORE_DELETE_ROLE_RESP", "CORE_ROLE_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function roleNameValidationCheck(mm, variables) {
  return graphqlWithVariables("\n      query ($roleName: String!) {\n        isValid: validateRoleName(roleName: $roleName)\n      }\n    ", variables, "CORE_ROLE_NAME_VALIDATION_FIELDS");
}
function roleNameValidationClear() {
  return function (dispatch) {
    dispatch({
      type: "CORE_ROLE_NAME_VALIDATION_FIELDS_CLEAR"
    });
  };
}
function roleNameSetValid() {
  return function (dispatch) {
    dispatch({
      type: "CORE_ROLE_NAME_VALIDATION_FIELDS_SET_VALID"
    });
  };
}
function saveCurrentPaginationPage(page, afterCursor, beforeCursor, module) {
  return function (dispatch) {
    dispatch({
      type: "CORE_PAGINATION_PAGE",
      payload: {
        page: page,
        afterCursor: afterCursor,
        beforeCursor: beforeCursor,
        module: module
      }
    });
  };
}
function clearCurrentPaginationPage() {
  return function (dispatch) {
    dispatch({
      type: "CORE_PAGINATION_PAGE_CLEAR"
    });
  };
}
function toggleCurrentCalendarType(isSecondaryCalendarEnabled) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CALENDAR_TYPE_TOGGLE",
      payload: {
        isSecondaryCalendarEnabled: isSecondaryCalendarEnabled
      }
    });
  };
}
function changeUserLanguage(language, clientMutationLabel) {
  var mutation = formatMutation("changeUserLanguage", "languageId: \"".concat(language, "\""), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["CORE_MUTATION_REQ", "CHANGE_USER_LANGUAGE_RESP", "CORE_MUTATION_ERR"], {
    actionType: "CHANGE_USER_LANGUAGE_RESP",
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}

function ownKeys$p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$p(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ensureArray = function ensureArray(maybeArray) {
  if (Array.isArray(maybeArray)) {
    return maybeArray;
  } else if (maybeArray !== null && maybeArray !== undefined) {
    return [maybeArray];
  } else {
    return [];
  }
};
var prepareForComparison = function prepareForComparison(stateRole, propsRole, roleRights) {
  var tempStateRole = _objectSpread$p({}, stateRole);
  delete tempStateRole.roleRights;
  var tempPropsRole = _objectSpread$p(_objectSpread$p({}, propsRole), {}, {
    isSystem: !!(propsRole !== null && propsRole !== void 0 && propsRole.isSystem)
  });
  var tempRoleRights = roleRights === null || roleRights === void 0 ? void 0 : roleRights.map(function (right) {
    return right === null || right === void 0 ? void 0 : right.rightId;
  });
  return {
    stateRole: tempStateRole,
    propsRole: tempPropsRole,
    convertedRoleRights: tempRoleRights || []
  };
};
function getTimeDifferenceInDays(_firstDate, _secondDate) {
  var firstDate = new Date(_firstDate);
  var secondDate = new Date(_secondDate);
  var timeDelta = firstDate.getTime() - secondDate.getTime();
  var timeInDays = Math.ceil(timeDelta / (1000 * 60 * 60 * 24));
  return timeInDays;
}
function getTimeDifferenceInDaysFromToday(dateToCheck) {
  var currentDate = new Date();
  return getTimeDifferenceInDays(dateToCheck, currentDate);
}
var onLogout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          localStorage.clear();
          _context.next = 3;
          return dispatch(logout());
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function onLogout(_x) {
    return _ref.apply(this, arguments);
  };
}();
var redirectToSamlLogout = function redirectToSamlLogout(e) {
  e.preventDefault();
  localStorage.clear();
  var redirectToURL = new URL("".concat(window.location.origin).concat(baseApiUrl).concat(SAML_LOGOUT_PATH));
  window.location.href = redirectToURL.href;
};
var getLanguageNameByCode = function getLanguageNameByCode(languages, languageCode) {
  var _languages$find;
  return (_languages$find = languages.find(function (language) {
    return language.code === languageCode;
  })) === null || _languages$find === void 0 ? void 0 : _languages$find.name;
};
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function formatDateFromISO$2(mm, intl, date) {
  if (!date) return "";
  return moment(date).format(mm.getConf("fe-core", "dateFormat", "YYYY-MM-DD"));
}

function formatDateTimeFromISO$1(mm, intl, date) {
  if (!date) return "";
  var momentDate = moment(date);
  if (momentDate.isValid()) {
    return momentDate.format(mm.getConf("fe-core", "dateTimeFormat", "YYYY-MM-DD HH:mm:ss"));
  } else {
    return moment(date).format(mm.getConf("fe-core", "dateTimeFormat", "YYYY-MM-DD HH:mm:ss"));
  }
}

function formatDateFromISO$1(date, intl, formattingOptions) {
  if (!date) return "";
  // this nepali-date-converter only supports dates up to this date, it will crash whole site if this date is exceeded
  // added as a safeguard, other solution is probably needed
  // TODO remove after nepal component change
  if (date > new Date("2090/12/30")) {
    date = new Date("2090/12/30");
  }
  try {
    var _NepaliDate;
    return (_NepaliDate = new NepaliDate(new Date(date))).format.apply(_NepaliDate, _toConsumableArray(formattingOptions));
  } catch (error) {
    console.warn("[FORMAT DATE ERROR]: ", error);
    return formatMessage(intl, MODULE_NAME, "core.NeDateFormatter.dateOutOfRange");
  }
}

//formatting with values is expansive.. so let's have separated methods
function formatMessage(intl, module, id) {
  if (!!intl.messages["".concat(module, ".").concat(id)]) {
    return intl.formatMessage({
      id: "".concat(module, ".").concat(id)
    });
  } else {
    return intl.formatMessage({
      id: "".concat(id)
    });
  }
}
function formatMessageWithValues(intl, module, id, values) {
  if (!!intl.messages["".concat(module, ".").concat(id)]) {
    return intl.formatMessage({
      id: "".concat(module, ".").concat(id)
    }, values);
  } else {
    return intl.formatMessage({
      id: "".concat(id)
    }, values);
  }
}
function formatAmount(intl, amount) {
  return "".concat(intl.formatMessage({
    id: "currency"
  }), " ").concat(amount || 0);
}
function formatDateFromISO(mm, intl, date) {
  var isSecondaryCalendar = JSON.parse(localStorage.getItem(STORAGE_KEY_SECONDARY_CALENDAR));
  if (isSecondaryCalendar) {
    var secondCalendarFormatting = mm.getConf("fe-core", "secondCalendarFormatting", DEFAULT_SETTINGS.SECOND_CALENDAR_FORMAT);
    var secondCalendarFormattingLang = mm.getConf("fe-core", "secondCalendarFormattingLang", DEFAULT_SETTINGS.SECOND_CALENDAR_LANG);
    return formatDateFromISO$1(date, intl, [secondCalendarFormatting, secondCalendarFormattingLang]);
  }
  return formatDateFromISO$2(mm, intl, date);
}
function formatDateTimeFromISO(mm, intl, date) {
  return formatDateTimeFromISO$1(mm, intl, date);
}
function toISODate(d) {
  if (!d) return null;
  return moment(d).format().slice(0, 10);
}
function toISODateTime(d) {
  if (!d) return null;
  return moment(d).toISOString().slice(0, 19);
}
function withTooltip(c, t) {
  var placement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "bottom";
  return !!t ? /*#__PURE__*/React.createElement(Tooltip, {
    title: t,
    placement: placement
  }, c) : c;
}
function useTranslations(moduleName, modulesManager) {
  // TODO: Take modulesManager from the context (once it has been refactored in @openimis/fe)
  var intl = useIntl();
  return {
    formatDateFromISO: formatDateFromISO.bind(null, modulesManager, intl),
    formatDateTimeFromISO: formatDateTimeFromISO.bind(null, modulesManager, intl),
    formatAmount: formatAmount.bind(null, intl),
    formatMessage: moduleName ? formatMessage.bind(null, intl, moduleName) : formatMessage.bind(null, intl),
    formatMessageWithValues: moduleName ? formatMessageWithValues.bind(null, intl, moduleName) : formatMessageWithValues.bind(null, intl)
  };
}

var useStyles$7 = makeStyles(function (theme) {
  return {
    button: {
      margin: theme.spacing(2),
      color: theme.palette.secondary.main
    }
  };
});
var LogoutButton = function LogoutButton() {
  var history = useHistory();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations(MODULE_NAME, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var mPassLogout = modulesManager.getConf("fe-core", "LogoutButton.showMPassProvider", false);
  var onClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!mPassLogout) {
              _context.next = 4;
              break;
            }
            redirectToSamlLogout(e);
            _context.next = 6;
            break;
          case 4:
            _context.next = 6;
            return redirectToImisLogout();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var redirectToImisLogout = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return onLogout(dispatch);
          case 2:
            history.push("/");
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function redirectToImisLogout() {
      return _ref2.apply(this, arguments);
    };
  }();
  var classes = useStyles$7();
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: formatMessage("core.tooltip.logout")
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ExitToApp, null)));
};

var styles$t = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(2),
      color: theme.palette.secondary.main
    }
  };
};
var Help = function Help(_ref) {
  var classes = _ref.classes;
  var modulesManager = useModulesManager$1();
  var _useTranslations = useTranslations(MODULE_NAME, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var isCoreMISHelp = modulesManager.getConf("fe-core", "redirectToCoreMISConfluenceUrl", false);
  var url = isCoreMISHelp ? CORE_MIS_CONFLUENCE_URL : DEFAULT_URL;
  var onClick = function onClick() {
    window.open(url);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: formatMessage("core.tooltip.help")
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(HelpOutline, null)));
};
var Help$1 = withStyles(styles$t)(Help);

var _excluded$e = ["children", "contributionKey", "reverse"];
function getComponents(modulesManager, key) {
  var contributions = modulesManager.getContribs(key);
  return contributions.map(function (contrib) {
    return typeof contrib === "string" ? modulesManager.getRef(contrib) : contrib;
  }).filter(Boolean);
}
var Contributions = function Contributions(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    contributionKey = _ref.contributionKey,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    delegated = _objectWithoutProperties(_ref, _excluded$e);
  var modulesManager = useModulesManager();
  var components = useMemo(function () {
    var components = getComponents(modulesManager, contributionKey);
    if (reverse) {
      components.reverse();
    }
    return components;
  }, [contributionKey, reverse]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, components.map(function (Comp, idx) {
    return /*#__PURE__*/React.createElement(Comp, _extends({
      key: "".concat(contributionKey, "_").concat(idx),
      modulesManager: modulesManager
    }, delegated));
  }));
};

function _callSuper$z(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$z() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$z() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$z = function _isNativeReflectConstruct() { return !!t; })(); }
var FormattedMessage = /*#__PURE__*/function (_Component) {
  function FormattedMessage() {
    _classCallCheck(this, FormattedMessage);
    return _callSuper$z(this, FormattedMessage, arguments);
  }
  _inherits(FormattedMessage, _Component);
  return _createClass(FormattedMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        module = _this$props.module,
        id = _this$props.id,
        values = _this$props.values;
      if (!!intl.messages["".concat(module, ".").concat(id)]) {
        return /*#__PURE__*/React.createElement(FormattedMessage$2, {
          id: "".concat(module, ".").concat(id),
          values: values
        }, this.props.children);
      } else {
        return /*#__PURE__*/React.createElement(FormattedMessage$2, {
          id: "".concat(id),
          values: values
        }, this.props.children);
      }
    }
  }]);
}(Component);
var FormattedMessage$1 = injectIntl(FormattedMessage);

function _callSuper$y(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$y() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$y() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$y = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$o(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$s = function styles(theme) {
  return {
    panel: {
      margin: "0 !important",
      padding: 0
    },
    drawerHeading: {
      fontSize: theme.menu.drawer.fontSize,
      fontWeight: theme.menu.drawer.fontWeight,
      color: theme.menu.drawer.textColor
    },
    drawerDivider: {
      // width: 100
    },
    menuHeading: {
      fontSize: theme.menu.appBar.fontSize,
      color: theme.palette.text.second,
      paddingTop: theme.menu.appBar.fontSize / 2,
      textTransform: "none"
    },
    appBarMenuPaper: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    popper: {
      zIndex: 1200
    }
  };
};
var Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiAccordion);
var AccordionSummary = withStyles(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      minHeight: 56,
      "&$expanded": {
        minHeight: 56
      }
    },
    content: {
      margin: "0",
      padding: "0",
      alignItems: 'center',
      justifyContent: 'start',
      "&$expanded": {
        margin: "0"
      },
      color: theme.palette.secondary.main
    },
    expanded: {}
  };
})(MuiAccordionSummary);
var AccordionDetails = withStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(2),
      display: "block"
    }
  };
})(MuiAccordionDetails);
var getIconComponent = function getIconComponent(iconName) {
  var IconComponent = Icons[iconName];
  if (IconComponent) {
    return /*#__PURE__*/React.createElement(IconComponent, null);
  }
  return null;
};
function fetchSubmenuConfig(modulesManager, allEntries, entries, menuId, rights) {
  var menuConfig = modulesManager.getConf("fe-core", "menus", []);
  var isMenuConfigEmpty = !(menuConfig !== null && menuConfig !== void 0 && menuConfig.length);
  var submenuMapping = {};
  var menuIcons = {};
  var copyOfEntries = entries;
  if (!isMenuConfigEmpty) {
    menuConfig.filter(function (menu) {
      return menu.id == menuId;
    }).forEach(function (menu) {
      (menu.submenus || []).forEach(function (submenu) {
        submenuMapping[submenu.id] = submenu.position;
        if (submenu.icon) {
          menuIcons[submenu.id] = submenu.icon;
        }
      });
    });
    var updatedEntries = allEntries.map(function (entry) {
      var customIcon = menuIcons[entry.id];
      return _objectSpread$o(_objectSpread$o({}, entry), {}, {
        position: submenuMapping[entry.id] || null,
        icon: customIcon ? getIconComponent(customIcon) : entry.icon
      });
    }).filter(function (entry) {
      return entry.position !== null;
    }).sort(function (a, b) {
      return a.position - b.position;
    });
    var uniqueEntries = new Map();
    updatedEntries.forEach(function (entry) {
      if (!uniqueEntries.has(entry.id)) {
        uniqueEntries.set(entry.id, entry);
      }
    });
    return Array.from(uniqueEntries.values()).filter(function (entry) {
      return !entry.filter || entry.filter(rights);
    });
  }
  var uniqueEntriesFallback = new Map();
  copyOfEntries.forEach(function (entry) {
    if (!uniqueEntriesFallback.has(entry.id)) {
      uniqueEntriesFallback.set(entry.id, entry);
    }
  });
  return Array.from(uniqueEntriesFallback.values());
}
var MainMenuContribution = /*#__PURE__*/function (_Component) {
  function MainMenuContribution() {
    var _this;
    _classCallCheck(this, MainMenuContribution);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$y(this, MainMenuContribution, [].concat(args));
    _defineProperty(_this, "state", {
      expanded: false,
      anchorRef: /*#__PURE__*/React.createRef()
    });
    _defineProperty(_this, "toggleExpanded", function (event) {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });
    _defineProperty(_this, "handleMenuClose", function (event) {
      if (_this.state.anchorRef.current && _this.state.anchorRef.current.contains(event.target)) {
        return;
      }
      _this.toggleExpanded(event);
    });
    _defineProperty(_this, "handleMenuSelect", function (e, route) {
      // block normal href only for left click
      if (e.type === 'click') {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.toggleExpanded(e);
      _this.redirect(route);
    });
    _defineProperty(_this, "appBarMenu", function (entries) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
        ref: _this.state.anchorRef,
        onClick: _this.toggleExpanded,
        className: _this.props.classes.menuHeading
      }, _this.props.header, /*#__PURE__*/React.createElement(ExpandMoreIcon, null)), /*#__PURE__*/React.createElement(Popper, {
        className: _this.props.classes.popper,
        open: _this.state.expanded,
        anchorEl: _this.state.anchorRef.current,
        transition: true
      }, function (_ref) {
        var TransitionProps = _ref.TransitionProps,
          placement = _ref.placement;
        return /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
          style: {
            transformOrigin: placement === "bottom" ? "center top" : "center bottom"
          }
        }), /*#__PURE__*/React.createElement(Paper, {
          className: _this.props.classes.appBarMenuPaper,
          id: "".concat(_this.props.header, "-menu-list")
        }, /*#__PURE__*/React.createElement(ClickAwayListener, {
          onClickAway: _this.handleMenuClose
        }, /*#__PURE__*/React.createElement(MenuList, null, entries.map(function (entry, idx) {
          return /*#__PURE__*/React.createElement("div", {
            key: "".concat(_this.props.header, "_").concat(idx, "_menuItem")
          }, /*#__PURE__*/React.createElement(MenuItem, {
            onClick: function onClick(e) {
              return _this.handleMenuSelect(e, entry.route);
            },
            component: "a",
            href: "".concat(process.env.PUBLIC_URL || "").concat(entry.route),
            passHref: true
          }, /*#__PURE__*/React.createElement(ListItemIcon, null, entry.icon), /*#__PURE__*/React.createElement(ListItemText, {
            primary: entry.text
          })), entry.withDivider && /*#__PURE__*/React.createElement(Divider, {
            key: "".concat(_this.props.header, "_").concat(idx, "_divider"),
            className: _this.props.classes.drawerDivider
          }));
        })))));
      }));
    });
    _defineProperty(_this, "drawerMenu", function (entries) {
      return /*#__PURE__*/React.createElement(Accordion, {
        className: _this.props.classes.panel,
        expanded: _this.state.expanded,
        onChange: _this.toggleExpanded
      }, /*#__PURE__*/React.createElement(AccordionSummary, {
        expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
        id: "".concat(_this.props.header, "-header")
      }, /*#__PURE__*/React.createElement(IconButton, null, _this.props.icon), /*#__PURE__*/React.createElement(Typography, {
        className: _this.props.classes.drawerHeading
      }, _this.props.header)), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(List, {
        component: "nav"
      }, entries.map(function (entry, idx) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: "".concat(_this.props.header, "_").concat(idx)
        }, /*#__PURE__*/React.createElement(ListItem, {
          button: true,
          key: "".concat(_this.props.header, "_").concat(idx, "_item"),
          onClick: function onClick(e) {
            _this.redirect(entry.route);
          }
        }, entry.icon && /*#__PURE__*/React.createElement(ListItemIcon, null, entry.icon), /*#__PURE__*/React.createElement(ListItemText, {
          primary: entry.text
        })), entry.withDivider && /*#__PURE__*/React.createElement(Divider, {
          key: "".concat(_this.props.header, "_").concat(idx, "_divider"),
          className: _this.props.classes.drawerDivider
        }));
      }))));
    });
    return _this;
  }
  _inherits(MainMenuContribution, _Component);
  return _createClass(MainMenuContribution, [{
    key: "redirect",
    value: function redirect(route) {
      var _this$props = this.props,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history;
      _historyPush(modulesManager, history, route);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        menuVariant = _this$props2.menuVariant,
        modulesManager = _this$props2.modulesManager;
      var allEntries = modulesManager.getMenuEntries();
      var updatedEntries = fetchSubmenuConfig(modulesManager, allEntries, this.props.entries, this.props.menuId, this.props.rights);
      if (menuVariant === "AppBar") {
        return this.appBarMenu(updatedEntries);
      } else {
        return this.drawerMenu(updatedEntries);
      }
    }
  }]);
}(Component);
MainMenuContribution.propTypes = {
  header: PropTypes.string.isRequired,
  entries: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  menuId: PropTypes.object.isRequired
};
var MainMenuContribution$1 = withModulesManager(withTheme(withStyles(styles$s)(MainMenuContribution)));

var _excluded$d = ["children", "contributionKey", "reverse", "menuVariant"];
function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getMenus(modulesManager, key, rights, menuVariant) {
  var menus = modulesManager.getContribs(key);
  var menuConfig = modulesManager.getConf("fe-core", "menus", []);
  if (menuConfig !== null && menuConfig !== void 0 && menuConfig.length) {
    var unmatchedMenus = getUnmatchedMenus(menuConfig, menus, rights, modulesManager, menuVariant);
    var menuToProcess = [].concat(_toConsumableArray(menus), _toConsumableArray(unmatchedMenus));
    menuToProcess = attachIcons(menuToProcess, menuConfig);
    var sortedMenus = sortMenus(menuToProcess, menuConfig);
    return processMenu(sortedMenus);
  }
  return processMenu(menus);
}
function attachIcons(menus, menuConfig) {
  return menus.map(function (menu) {
    var configMatch = menuConfig.find(function (config) {
      return config.id === menu.name;
    });
    if (configMatch !== null && configMatch !== void 0 && configMatch.icon) {
      var IconComponent = Icons[configMatch.icon] ? Icons[configMatch.icon] : null;
      if (IconComponent) {
        return _objectSpread$n(_objectSpread$n({}, menu), {}, {
          component: function component(props) {
            return /*#__PURE__*/React.createElement(menu.component, _extends({}, props, {
              icon: /*#__PURE__*/React.createElement(IconComponent, null)
            }));
          }
        });
      }
    }
    return menu;
  });
}
function getUnmatchedMenus(menuConfig, menus, rights, modulesManager, menuVariant) {
  var existingIds = menus.filter(function (menu) {
    return _typeof(menu) === 'object';
  }).map(function (menu) {
    return menu.name;
  });
  var history = useHistory$1();
  var unmatchedConfigs = menuConfig.filter(function (config) {
    return !existingIds.includes(config.id);
  });
  return unmatchedConfigs.map(function (config) {
    if (config.filter && !config.filter(rights)) {
      return null;
    }
    var IconComponent = config.icon && Icons[config.icon] ? Icons[config.icon] : null;
    return {
      name: config.id,
      component: function component() {
        return /*#__PURE__*/React.createElement(MainMenuContribution$1, {
          menuVariant: menuVariant,
          header: config.name,
          menuId: config.id,
          modulesManager: modulesManager,
          rights: rights,
          history: history,
          entries: [],
          icon: IconComponent ? /*#__PURE__*/React.createElement(IconComponent, null) : null
        });
      }
    };
  }).filter(Boolean);
}
function processMenu(menus) {
  return menus.map(function (menu) {
    return (menu === null || menu === void 0 ? void 0 : menu.component) || menu;
  }).filter(Boolean);
}
function sortMenus(menus, menuConfig) {
  var filteredMenus = menus.filter(function (menu) {
    var menuId = _typeof(menu) === 'object' ? menu.name : menu;
    return menuConfig.some(function (config) {
      return config.id === menuId;
    });
  });
  var updatedMenus = filteredMenus.map(function (menu) {
    var menuId = _typeof(menu) === 'object' ? menu.name : menu;
    var configMatch = menuConfig.find(function (config) {
      return config.id === menuId;
    });
    if (configMatch && _typeof(menu) === 'object') {
      return _objectSpread$n(_objectSpread$n({}, menu), configMatch);
    }
    return menu;
  });
  return updatedMenus.sort(function (a, b) {
    return a.position - b.position;
  });
}
var MainMenuBar = function MainMenuBar(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    contributionKey = _ref.contributionKey,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    menuVariant = _ref.menuVariant,
    delegated = _objectWithoutProperties(_ref, _excluded$d);
  var modulesManager = useModulesManager();
  var rights = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.rights) || [];
  });
  var components = useMemo(function () {
    var components = getMenus(modulesManager, contributionKey, rights, menuVariant);
    if (reverse) {
      components.reverse();
    }
    return components;
  }, [contributionKey, reverse, rights, menuVariant]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, components.map(function (Comp, idx) {
    return /*#__PURE__*/React.createElement(Comp, _extends({
      key: "".concat(contributionKey, "_").concat(idx),
      modulesManager: modulesManager,
      menuVariant: menuVariant
    }, delegated));
  }));
};

function _callSuper$x(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$x() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$x() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$x = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$r = function styles(theme) {
  return {
    toolbar: {
      minHeight: 80
    },
    drawer: {
      width: theme.jrnlDrawer.width,
      flexShrink: 0,
      whiteSpace: "nowrap"
    },
    drawerOpen: {
      width: theme.jrnlDrawer.open.width,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerClose: _defineProperty({
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: "hidden",
      width: theme.jrnlDrawer.close.width
    }, theme.breakpoints.up("sm"), {
      width: theme.spacing(9) + 1
    }),
    jrnlItem: theme.jrnlDrawer.item,
    jrnlItemDetail: theme.jrnlDrawer.itemDetail,
    jrnlItemDetailsError: _objectSpread$m(_objectSpread$m({}, theme.jrnlDrawer.itemDetail), {}, {
      color: theme.palette.error.main,
      whiteSpace: 'normal',
      overflowWrap: 'break-word'
    }),
    jrnlItemDetailText: theme.jrnlDrawer.itemDetailText,
    jrnlIconClickable: {
      cursor: "pointer"
    },
    jrnlIcon: {
      paddingLeft: theme.spacing(1)
    },
    jrnlErrorItem: {
      color: theme.palette.error.main
    },
    jrnlErrorIcon: {
      paddingLeft: theme.spacing(1),
      color: theme.palette.error.main
    },
    messagePopover: {
      width: 350
    },
    groupMessagePanel: {
      width: "100%",
      margin: 0,
      padding: 0
    },
    errorPanel: {
      width: "100%",
      color: theme.palette.error.main
    },
    messagePanel: {
      width: "100%",
      margin: theme.spacing(1)
    },
    centerText: {
      textAlign: 'center'
    },
    boldCenterText: {
      textAlign: 'center',
      fontWeight: 'bold'
    }
  };
};
var Messages = /*#__PURE__*/function (_Component) {
  function Messages() {
    var _this;
    _classCallCheck(this, Messages);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$x(this, Messages, [].concat(args));
    _defineProperty(_this, "state", {
      groupExpanded: false,
      expanded: false
    });
    _defineProperty(_this, "handleGroupChange", function (panel) {
      return function (event, newExpanded) {
        event.stopPropagation();
        _this.setState({
          groupExpanded: newExpanded ? panel : false
        });
      };
    });
    _defineProperty(_this, "handleChange", function (panel) {
      return function (event, newExpanded) {
        event.stopPropagation();
        _this.setState({
          expanded: newExpanded ? panel : false
        });
      };
    });
    _defineProperty(_this, "formatSingleMessage", function (message, idx) {
      if (message.hasOwnProperty("message")) {
        return /*#__PURE__*/React.createElement(Accordion$1, {
          key: "message-".concat(idx, "-panel"),
          expanded: message.hasOwnProperty("detail") && _this.state.expanded === "message-".concat(idx),
          onChange: _this.handleChange("message-".concat(idx)),
          className: _this.props.classes.errorPanel
        }, /*#__PURE__*/React.createElement(AccordionSummary$1, {
          id: "message-".concat(idx, "-header"),
          expandIcon: message.hasOwnProperty("detail") && /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
        }, /*#__PURE__*/React.createElement(Typography$1, {
          variant: "caption"
        }, message.hasOwnProperty("code") ? "[".concat(message.code, "] ") : "", message.message)), message.hasOwnProperty("detail") && /*#__PURE__*/React.createElement(AccordionDetails$1, null, /*#__PURE__*/React.createElement(Typography$1, {
          variant: "caption"
        }, message.detail)));
      } else if (message.hasOwnProperty("clientMutationLabel")) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: "message-".concat(idx, "-panel"),
          item: true,
          className: _this.props.classes.messagePanel
        }, message.clientMutationLabel);
      } else {
        return /*#__PURE__*/React.createElement(Grid, {
          key: "message-".concat(idx, "-panel"),
          item: true
        }, JSON.stringify(message));
      }
    });
    _defineProperty(_this, "formatMessage", function (message, idx) {
      if (message.hasOwnProperty("title")) {
        return /*#__PURE__*/React.createElement(Accordion$1, {
          key: "groupMessage-".concat(idx, "-panel"),
          expanded: _this.state.groupExpanded === "groupMessage-".concat(idx),
          onChange: _this.handleGroupChange("groupMessage-".concat(idx)),
          className: _this.props.classes.groupMessagePanel
        }, /*#__PURE__*/React.createElement(AccordionSummary$1, {
          id: "groupMessage-".concat(idx, "-header"),
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
        }, /*#__PURE__*/React.createElement(Typography$1, {
          variant: "caption"
        }, message.title)), /*#__PURE__*/React.createElement(AccordionDetails$1, {
          className: _this.props.classes.groupMessagePanel
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 0
        }, message.list.map(function (m, i) {
          return /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12
          }, _this.formatSingleMessage(m, "".concat(idx, ".").concat(i)));
        }))));
      } else {
        return _this.formatSingleMessage(message, idx);
      }
    });
    return _this;
  }
  _inherits(Messages, _Component);
  return _createClass(Messages, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        anchorEl = _this$props.anchorEl,
        onClick = _this$props.onClick,
        messages = _this$props.messages;
      if (!messages) return null;
      var stats = messages !== null && messages !== void 0 && messages.jsonExt ? JSON.parse(messages.jsonExt) : {};
      var msgs = [(messages === null || messages === void 0 ? void 0 : messages.error) || messages];
      try {
        msgs = JSON.parse((messages === null || messages === void 0 ? void 0 : messages.error) || messages);
        if (!Array.isArray(msgs)) {
          msgs = [msgs];
        }
      } catch (err) {
        //let's keep the raw message then
      }
      return /*#__PURE__*/React.createElement(ClickAwayListener, {
        onClickAway: onClick
      }, /*#__PURE__*/React.createElement(Popover, {
        open: !!anchorEl,
        anchorEl: anchorEl,
        anchorOrigin: {
          vertical: "center",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "center",
          horizontal: "right"
        },
        onClick: onClick,
        PaperProps: {
          className: classes.messagePopover
        }
      }, (stats === null || stats === void 0 ? void 0 : stats.claim_stats) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.boldCenterText
      }, stats.claim_stats["header"]), CLAIM_STATS_ORDER.map(function (key) {
        return stats.claim_stats.hasOwnProperty(key) && /*#__PURE__*/React.createElement(Typography$1, {
          className: classes.centerText,
          key: key
        }, "".concat(key.replace(GLOBAL_UNDERSCORE, WHITE_SPACE), ": ").concat(stats.claim_stats[key]));
      })), /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, msgs.map(function (msg, idx) {
        return _this2.formatMessage(msg, idx);
      }))));
    }
  }]);
}(Component);
var StyledMessages = withTheme(withStyles(styles$r)(Messages));
var JournalDrawer = /*#__PURE__*/function (_Component2) {
  function JournalDrawer(props) {
    var _this3;
    _classCallCheck(this, JournalDrawer);
    _this3 = _callSuper$x(this, JournalDrawer, [props]);
    _defineProperty(_this3, "checkProcessing", function () {
      var clientMutationIds = _this3.state.displayedMutations.filter(function (m) {
        return m.status === 0;
      }).map(function (m) {
        return m.clientMutationId;
      });
      //TODO: change for a "fetchMutationS(ids)"  > requires id_In backend implementation
      if (_this3.state.limitMutationLogsQuery) {
        var mutationLogs = localStorage.getItem('arrayMutations');
        if (mutationLogs == null) {
          mutationLogs = {};
          mutationLogs.arrayMutations = [];
          clientMutationIds.map(function (id) {
            mutationLogs.arrayMutations.push({
              id: id,
              count: 0,
              time: 0
            });
          });
          localStorage.setItem('arrayMutations', JSON.stringify(mutationLogs));
        } else {
          var parsedJson = JSON.parse(mutationLogs);
          var _loop = function _loop() {
            var mutationLog = parsedJson.arrayMutations[i];
            if (!clientMutationIds.includes(mutationLog.id)) {
              //remove success mutationLogs in localStorage
              parsedJson.arrayMutations = parsedJson.arrayMutations.filter(function (f) {
                return f.id != mutationLog.id;
              });
            } else {
              if (mutationLog.count < REQUEST_LIMIT) {
                _this3.props.fetchMutation(mutationLog.id);
                mutationLog.count = mutationLog.count + 1;
                if (mutationLog.count == 5) {
                  mutationLog.time = mutationLog.count;
                  mutationLog.duration = 1;
                }
              } else {
                if (mutationLog.count == mutationLog.time) {
                  _this3.props.fetchMutation(mutationLog.id);
                  mutationLog.duration = mutationLog.duration * 2;
                  mutationLog.time = mutationLog.count + mutationLog.duration;
                }
                mutationLog.count = mutationLog.count + 1;
              }
              parsedJson.arrayMutations[i] = mutationLog;
            }
          };
          for (var i = 0; i < parsedJson.arrayMutations.length; i++) {
            _loop();
          }
          for (var j = 0; j < clientMutationIds.length; j++) {
            if (!parsedJson.arrayMutations.map(function (m) {
              return m.id;
            }).includes(clientMutationIds[j])) {
              parsedJson.arrayMutations.push({
                id: clientMutationIds[j],
                count: 0,
                time: 0
              });
            }
          }
          localStorage.setItem('arrayMutations', JSON.stringify(parsedJson));
        }
      } else {
        clientMutationIds.forEach(function (id) {
          return _this3.props.fetchMutation(id);
        });
      }
    });
    _defineProperty(_this3, "more", function (e) {
      _this3.props.fetchHistoricalMutations(_this3.state.pageSize, _this3.state.afterCursor);
    });
    _defineProperty(_this3, "showMessages", function (e, m) {
      if (_this3.props.open) {
        return;
      }
      _this3.setState({
        messagesAnchor: e.currentTarget,
        messages: m
      });
    });
    _defineProperty(_this3, "hideMessages", function (e) {
      _this3.setState({
        messagesAnchor: null,
        messages: null
      });
    });
    _defineProperty(_this3, "handleChange", function (event, newExpanded) {
      event.stopPropagation();
      _this3.setState({
        expanded: newExpanded
      });
    });
    _this3.state = {
      pageSize: props.modulesManager.getConf("fe-core", "journalDrawer.pageSize", 5),
      afterCursor: null,
      hasNextPage: false,
      displayedMutations: [],
      messagesAnchor: null,
      expanded: false,
      limitMutationLogsQuery: props.modulesManager.getConf("fe-core", "journalDrawer.limitMutationLogsQuery", false)
    };
    return _this3;
  }
  _inherits(JournalDrawer, _Component2);
  return _createClass(JournalDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      if (!this.props.fetchedHistoricalMutations) {
        this.props.fetchHistoricalMutations(this.state.pageSize, this.state.afterCursor);
      }
      this.setState(function (state, props) {
        return {
          timeoutId: setInterval(_this4.checkProcessing, props.modulesManager.getRef("core.JournalDrawer.pollInterval")),
          displayedMutations: _toConsumableArray(props.mutations)
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchingHistoricalMutations && !this.props.fetchingHistoricalMutations) {
        this.setState(function (state, props) {
          return {
            displayedMutations: [].concat(_toConsumableArray(state.displayedMutations), _toConsumableArray(props.mutations)),
            afterCursor: props.mutationsPageInfo.endCursor,
            hasNextPage: props.mutationsPageInfo.hasNextPage
          };
        });
      } else if (!_$1.isEqual(prevProps.mutations, this.props.mutations)) {
        this.setState({
          displayedMutations: _toConsumableArray(this.props.mutations)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.state.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props2 = this.props,
        theme = _this$props2.theme,
        classes = _this$props2.classes,
        open = _this$props2.open,
        handleDrawer = _this$props2.handleDrawer;
      return /*#__PURE__*/React.createElement(ClickAwayListener, {
        onClickAway: function onClickAway(e) {
          return open && handleDrawer();
        }
      }, /*#__PURE__*/React.createElement("nav", {
        className: classes.drawer
      }, /*#__PURE__*/React.createElement(StyledMessages, {
        anchorEl: this.state.messagesAnchor,
        messages: this.state.messages,
        onClick: this.hideMessages
      }), /*#__PURE__*/React.createElement(Drawer, {
        variant: "permanent",
        anchor: "right",
        className: clsx(classes.drawer, _defineProperty(_defineProperty({}, classes.drawerOpen, open), classes.drawerClose, !open)),
        classes: {
          paper: clsx(_defineProperty(_defineProperty({}, classes.drawerOpen, open), classes.drawerClose, !open))
        },
        open: open
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.toolbar,
        justify: "center",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: handleDrawer
      }, open ? /*#__PURE__*/React.createElement(ChevronRightIcon, null) : /*#__PURE__*/React.createElement(ChevronLeftIcon, null)))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(List, null, this.state.displayedMutations.map(function (m, idx) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: "mutation".concat(idx)
        }, /*#__PURE__*/React.createElement(ListItem$1, {
          key: "mutation-label".concat(idx),
          className: classes.jrnlItem
        }, m.status == 0 && /*#__PURE__*/React.createElement(ListItemIcon$1, {
          className: classes.jrnlIcon
        }, /*#__PURE__*/React.createElement(CircularProgress, {
          size: theme.jrnlDrawer.iconSize
        })), /*#__PURE__*/React.createElement(ListItemIcon$1, {
          className: clsx(m.status === 1 ? classes.jrnlErrorIcon : classes.jrnlIcon, _defineProperty({}, classes.jrnlIconClickable, !open)),
          onClick: function onClick(e) {
            return _this5.showMessages(e, m);
          }
        }, m.status === 1 ? /*#__PURE__*/React.createElement(ErrorIcon, null) : /*#__PURE__*/React.createElement(CheckIcon, null)), /*#__PURE__*/React.createElement(ListItemText$1, {
          className: m.status === 1 ? classes.jrnlErrorItem : classes.jrnlItem,
          primary: m.clientMutationLabel,
          secondary: moment(m.requestDateTime).format("YYYY-MM-DD HH:mm")
        }), !!m.clientMutationDetails && _this5.state.expanded === "detail-".concat(idx) && /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick(e) {
            return _this5.handleChange(e, false);
          }
        }, /*#__PURE__*/React.createElement(SortAscIcon, null)), !!m.clientMutationDetails && _this5.state.expanded !== "detail-".concat(idx) && /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick(e) {
            return _this5.handleChange(e, "detail-".concat(idx));
          }
        }, /*#__PURE__*/React.createElement(ExpandMoreIcon, null))), !!m.clientMutationDetails && /*#__PURE__*/React.createElement(Collapse, {
          key: "mutation-detail".concat(idx),
          "in": !!m.clientMutationDetails && _this5.state.expanded === "detail-".concat(idx),
          timeout: "auto",
          unmountOnExit: true
        }, /*#__PURE__*/React.createElement(List, {
          component: "div",
          disablePadding: true
        }, function () {
          try {
            var details = JSON.parse(m.clientMutationDetails);
            return details.map(function (detail, detailIndex) {
              return /*#__PURE__*/React.createElement(ListItemText$1, {
                className: classes.jrnlItemDetail,
                key: "mdet-".concat(detailIndex),
                primary: detail,
                primaryTypographyProps: {
                  "class": classes.jrnlItemDetailText
                }
              });
            });
          } catch (error) {
            return /*#__PURE__*/React.createElement(ListItemText$1, {
              className: classes.jrnlItemDetailsError,
              primaryTypographyProps: {
                "class": classes.jrnlItemDetailText
              },
              primary: "Mutation details not available. ".concat(error)
            });
          }
        }())));
      }), !!this.state.hasNextPage && /*#__PURE__*/React.createElement(ListItem$1, {
        key: "more",
        className: classes.jrnlItem
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.more,
        className: classes.jrnlIcon
      }, /*#__PURE__*/React.createElement(MoreIcon, null)))))));
    }
  }]);
}(Component);
var mapStateToProps$a = function mapStateToProps(state, props) {
  return {
    fetchingMutations: state.core.fetchingMutations,
    fetchingHistoricalMutations: state.core.fetchingHistoricalMutations,
    fetchedHistoricalMutations: state.core.fetchedHistoricalMutations,
    mutations: state.core.mutations,
    mutationsPageInfo: state.core.mutationsPageInfo
  };
};
var mapDispatchToProps$a = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchMutation: fetchMutation,
    fetchHistoricalMutations: fetchHistoricalMutations
  }, dispatch);
};
var JournalDrawer$1 = withModulesManager(withTheme(withStyles(styles$r)(connect(mapStateToProps$a, mapDispatchToProps$a)(JournalDrawer))));

function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useDebounceCb = function useDebounceCb(cb) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    payload = _useState2[0],
    setPayload = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    enabled = _useState4[0],
    setEnabled = _useState4[1];
  var timeoutRef = useRef();
  useEffect(function () {
    if (enabled) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(function () {
        return cb.apply(void 0, _toConsumableArray(payload));
      }, duration);
    }
    return function () {
      return clearTimeout(timeoutRef.current);
    };
  }, [payload]);
  return function () {
    setEnabled(true);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    setPayload(args);
  };
};

// Ref: https://usehooks.com/usePrevious/
var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = useRef();

  // Store current value in ref
  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
};
var DEFAULT_CONFIG$1 = {
  type: "GRAPHQL_QUERY",
  skip: false,
  keepStale: false
};
var useGraphqlQuery = function useGraphqlQuery(operation, variables) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  config = _objectSpread$l(_objectSpread$l({}, DEFAULT_CONFIG$1), config);
  var dispatch = useDispatch();
  var _useState5 = useState({
      isLoading: !config.skip,
      data: null,
      error: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    queryState = _useState6[0],
    setQueryState = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isMounted = _useState8[0],
    setMounted = _useState8[1];
  var prevVariables = usePrevious(variables !== null && variables !== void 0 ? variables : {});
  var prevOperation = usePrevious(operation);
  function fetchQuery() {
    return _fetchQuery.apply(this, arguments);
  }
  function _fetchQuery() {
    _fetchQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var action;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setQueryState({
              isLoading: true,
              data: config.keepStale ? queryState.data : null,
              error: null
            });
            _context.next = 4;
            return dispatch(graphqlWithVariables(operation, variables, config.type, {
              operation: operation,
              variables: variables
            }));
          case 4:
            action = _context.sent;
            if (action.error) {
              setQueryState({
                error: action.payload,
                isLoading: false,
                data: null
              });
            } else {
              setQueryState({
                error: null,
                isLoading: false,
                data: action.payload.data
              });
            }
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            setQueryState({
              error: _context.t0,
              isLoading: false,
              data: null
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return _fetchQuery.apply(this, arguments);
  }
  useEffect(function () {
    if (!isMounted) return;
    if (operation !== prevOperation || !_.isEqual(variables, prevVariables)) {
      fetchQuery();
    }
  }, [operation, variables]);
  useEffect(function () {
    if (!config.skip) {
      fetchQuery();
    }
    setMounted(true);
  }, []);
  return _objectSpread$l(_objectSpread$l({}, queryState), {}, {
    refetch: fetchQuery
  });
};
var DEFAULT_GRAPHQL_MUTATION_CONFIG = {
  wait: true
};
var useGraphqlMutation = function useGraphqlMutation(operation, config) {
  config = _objectSpread$l(_objectSpread$l({}, DEFAULT_GRAPHQL_MUTATION_CONFIG), config);
  var dispatch = useDispatch();
  var _useState9 = useState({
      isLoading: false,
      error: null
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    state = _useState10[0],
    setState = _useState10[1];
  function mutate(input) {
    if (state.isLoading) {
      console.warn("A mutation is already in progress");
      return;
    }
    setState({
      isLoading: true,
      error: null
    });
    return new Promise(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
        var _result$error, variables, result, error;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              variables = {
                input: input
              };
              _context2.next = 4;
              return dispatch(graphqlMutation(operation, variables, config.type, {
                operation: operation,
                input: input
              }, config.wait));
            case 4:
              result = _context2.sent;
              // Handle graphql errors
              error = result === null || result === void 0 || (_result$error = result.error) === null || _result$error === void 0 ? void 0 : _result$error.map(function (err) {
                return err.detail;
              }).join("; ");
              if (!error) {
                _context2.next = 8;
                break;
              }
              throw new Error(error);
            case 8:
              setState({
                isLoading: false,
                error: error
              });
              if (config.onSuccess) {
                resolve(config.onSuccess(result));
              } else {
                resolve(result);
              }
              _context2.next = 16;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              setState({
                isLoading: false,
                error: _context2.t0
              });
              if (config.onError) {
                reject(config.onError(_context2.t0));
              } else {
                reject(_context2.t0);
              }
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 12]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return {
    isLoading: state.isLoading,
    error: state.error,
    mutate: mutate
  };
};
var useAuthentication = function useAuthentication() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.core.user;
  });
  var isInitialized = useSelector(function (state) {
    return state.core.isInitialized;
  });
  var error = useSelector(function (state) {
    return state.core.authError;
  });
  var refresh = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return dispatch(refreshAuthToken());
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function refresh() {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    user: user,
    error: error,
    isAuthenticated: Boolean(user),
    isInitialized: isInitialized,
    initialize: function initialize$1() {
      return dispatch(initialize());
    },
    login: function login$1(credentials) {
      return dispatch(login(credentials));
    },
    refresh: refresh,
    logout: function logout$1() {
      return dispatch(logout());
    }
  };
};
var useUserQuery = function useUserQuery() {
  var modulesManager = useModulesManager$1();
  var _useGraphqlQuery = useGraphqlQuery("\n    query useUserQuery {\n      user {\n        healthFacility ".concat(modulesManager.getProjection("location.HealthFacilityPicker.projection"), "\n        id\n        username\n        rights\n        email\n        lastName\n        otherNames\n        phone\n        iUser {\n          id\n          uuid\n          language {\n            code\n            name\n          }\n        }\n        claimAdmin {\n          id\n          code\n          uuid\n        }\n        officer {\n          id\n          uuid\n          code\n          dob\n          address\n          location {\n            id\n            uuid\n            code\n            name\n            parent {\n              id\n              uuid\n              code\n              name\n            }\n          }\n        }\n      }\n    }\n  ")),
    data = _useGraphqlQuery.data,
    isLoading = _useGraphqlQuery.isLoading;
  return {
    user: data === null || data === void 0 ? void 0 : data.user,
    isLoading: isLoading
  };
};
var useBoolean = function useBoolean() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState11 = useState(defaultValue),
    _useState12 = _slicedToArray(_useState11, 2),
    bool = _useState12[0],
    setBool = _useState12[1];
  var toggle = useCallback(function () {
    return setBool(!bool);
  }, [bool]);
  var on = useCallback(function () {
    return setBool(true);
  }, []);
  var off = useCallback(function () {
    return setBool(false);
  }, []);
  return [bool, {
    toggle: toggle,
    on: on,
    off: off
  }];
};

var LanguageQuickPicker = function LanguageQuickPicker() {
  var dispatch = useDispatch();
  var anchorRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showConfirmDialog = _useState4[0],
    setShowConfirmDialog = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    chosenLanguage = _useState6[0],
    setChosenLanguage = _useState6[1];
  var _useSelector = useSelector(function (state) {
      return state.core;
    }),
    user = _useSelector.user,
    availableLanguages = _useSelector.languages,
    fetchingLanguages = _useSelector.fetchingLanguages,
    fetchedLanguages = _useSelector.fetchedLanguages;
  var userLanguage = user.i_user.language;
  useEffect(function () {
    if (!fetchingLanguages && !fetchedLanguages) {
      dispatch(fetchLanguages());
    }
  }, [dispatch, fetchingLanguages, fetchedLanguages]);
  var memoizedAvailableLanguages = useMemo(function () {
    return availableLanguages;
  }, [availableLanguages]);
  var handleToggle = function handleToggle() {
    return setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };
  var handleClose = function handleClose(event) {
    var _anchorRef$current;
    if ((_anchorRef$current = anchorRef.current) !== null && _anchorRef$current !== void 0 && _anchorRef$current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  var handleMenuItemClick = function handleMenuItemClick(lang) {
    setOpen(false);
    setShowConfirmDialog(true);
    setChosenLanguage(lang);
  };
  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };
  var prevOpen = useRef(open);
  useEffect(function () {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);
  var onDialogConfirm = function onDialogConfirm() {
    try {
      dispatch(changeUserLanguage(chosenLanguage, "Change User Language"));
      window.location.reload();
    } catch (error) {
      throw new Error("[LANGUAGE_QUICK_PICKER]: Error occurred. ".concat(error));
    } finally {
      setShowConfirmDialog(false);
    }
  };
  var onDialogClose = function onDialogClose() {
    return setShowConfirmDialog(false);
  };
  var renderMenuItems = function renderMenuItems() {
    return memoizedAvailableLanguages.filter(function (_ref) {
      var code = _ref.code;
      return code !== userLanguage;
    }).map(function (_ref2) {
      var name = _ref2.name,
        code = _ref2.code;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: code,
        onClick: function onClick() {
          return handleMenuItemClick(code);
        }
      }, /*#__PURE__*/React.createElement(Typography$1, {
        variant: "inherit",
        noWrap: true
      }, name));
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectDialog$2, {
    confirmState: showConfirmDialog,
    onConfirm: onDialogConfirm,
    onClose: onDialogClose,
    module: "core",
    confirmTitle: "core.LanguageQuickPicker.dialog.title",
    confirmMessageWithValues: "core.LanguageQuickPicker.dialog.message",
    translationVariables: {
      language: getLanguageNameByCode(memoizedAvailableLanguages, chosenLanguage)
    },
    confirmationButton: "core.LanguageQuickPicker.dialog.confirm",
    rejectionButton: "core.LanguageQuickPicker.dialog.cancel"
  }), availableLanguages && availableLanguages.length !== 0 && availableLanguages.length !== 1 && /*#__PURE__*/React.createElement(Button, {
    ref: anchorRef,
    "aria-controls": open ? "menu-list-grow" : undefined,
    "aria-haspopup": "true",
    color: "inherit",
    onClick: handleToggle,
    startIcon: /*#__PURE__*/React.createElement(Public, null),
    endIcon: /*#__PURE__*/React.createElement(ExpandMore, null),
    disabled: !availableLanguages.length || fetchingLanguages
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "button"
  }, getLanguageNameByCode(memoizedAvailableLanguages, userLanguage))), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref3) {
    var TransitionProps = _ref3.TransitionProps,
      placement = _ref3.placement;
    return /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
      style: {
        transformOrigin: placement === "bottom" ? "center top" : "center bottom"
      }
    }), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/React.createElement(MenuList, {
      autoFocusItem: open,
      id: "menu-list-grow",
      onKeyDown: handleListKeyDown
    }, renderMenuItems()))));
  }));
};

var _excluded$c = ["children", "logo", "disableTextLogo", "redirectTo", "isSecondaryCalendar", "setSecondaryCalendar", "onEconomicDialogOpen"];
function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var APP_BAR_CONTRIBUTION_KEY = "core.AppBar";
var MAIN_MENU_CONTRIBUTION_KEY = "core.MainMenu";
var ECONOMIC_UNIT_BUTTON_CONTRIBUTION_KEY = "policyholder.EconomicUnitChangeButton";
var USER_INFO_CONTRIBUTION_KEY = "core.userInfo";
var useStyles$6 = makeStyles(function (theme) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    root: {
      display: "flex"
    },
    grow: {
      flexGrow: 1
    },
    logo: {
      verticalAlign: "middle",
      margin: theme.typography.title.fontSize / 2,
      maxHeight: theme.typography.title.fontSize * 2
    },
    appBar: {
      paddingRight: theme.jrnlDrawer.close.width,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarDrawer: {
      margin: theme.spacing(-1, 0, -1, 0),
      paddingRight: theme.jrnlDrawer.close.width,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      backgroundColor: theme.palette.secondary.second,
      color: theme.palette.text.primary
    },
    toolbarDrawerLogout: {
      color: theme.palette.text.primary,
      button: {
        margin: theme.spacing(2),
        color: theme.palette.text.primary
      }
    },
    appBarShift: {
      width: "calc(100% - ".concat(theme.menu.drawer.width, ")"),
      marginLeft: theme.menu.drawer.width,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      margin: theme.spacing(0, 1, 0, 1),
      padding: 0
    },
    autoHideMenuButton: _defineProperty({}, theme.breakpoints.up("md"), {
      display: "none"
    }),
    toolbar: _objectSpread$k(_objectSpread$k({}, theme.mixins.toolbar), {}, {
      marginTop: theme.spacing(2)
    }),
    drawer: _defineProperty(_defineProperty({}, theme.breakpoints.up("sm"), {
      width: theme.menu.drawer.width,
      flexShrink: 0
    }), "backgroundColor", theme.menu.drawer.backgroundColor),
    drawerHeader: _objectSpread$k(_objectSpread$k({}, theme.mixins.toolbar), {}, {
      margin: theme.spacing(1, 0, 1, 0),
      backgroundColor: theme.menu.drawer.backgroundColor
    }),
    drawerPaper: {
      width: theme.menu.drawer.width,
      backgroundColor: theme.menu.drawer.backgroundColor
    },
    content: {
      flexGrow: 1,
      paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: theme.menu.drawer.width
    },
    appName: {
      color: theme.palette.secondary.main,
      textTransform: "none",
      fontSize: theme.typography.title.fontSize
    },
    appVersionsBox: {
      padding: 0,
      margin: 0,
      minWidth: theme.typography.title.fontSize / 2
    },
    appVersions: {
      color: theme.palette.secondary.main,
      fontSize: theme.typography.title.fontSize / 2,
      verticalAlign: "text-bottom",
      marginRight: theme.spacing(2)
    },
    search: _defineProperty({
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 0.25)
      },
      marginLeft: 0,
      width: "100%"
    }, theme.breakpoints.up("sm"), {
      marginLeft: theme.spacing(1),
      width: "auto"
    }),
    searchIcon: {
      width: theme.spacing(9),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    inputRoot: {
      color: "inherit",
      width: "100%"
    },
    inputInput: _defineProperty({
      padding: theme.spacing(1, 1, 1, 10),
      transition: theme.transitions.create("width"),
      width: "100%"
    }, theme.breakpoints.up("sm"), {
      width: 120,
      "&:focus": {
        width: 200
      }
    })
  }, "drawer", _objectSpread$k(_objectSpread$k({}, theme.mixins.toolbar), {}, {
    width: theme.menu.drawer.width,
    flexShrink: 0
  })), "drawerPaper", {
    width: theme.menu.drawer.width,
    backgroundColor: theme.menu.drawer.backgroundColor
  }), "drawerContainer", {
    overflow: 'auto'
  }), "contentShiftLeftSideMenu", {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: theme.menu.drawer.width,
    marginRight: theme.jrnlDrawer.close.width
  });
});
var RequireAuth = function RequireAuth(props) {
  var _cfg$openimisFeCore;
  var children = props.children;
    props.logo;
    var disableTextLogo = props.disableTextLogo,
    redirectTo = props.redirectTo,
    isSecondaryCalendar = props.isSecondaryCalendar,
    setSecondaryCalendar = props.setSecondaryCalendar,
    onEconomicDialogOpen = props.onEconomicDialogOpen,
    others = _objectWithoutProperties(props, _excluded$c);
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    isOpen = _useBoolean2[0],
    setOpen = _useBoolean2[1];
  var _useBoolean3 = useBoolean(),
    _useBoolean4 = _slicedToArray(_useBoolean3, 2),
    isDrawerOpen = _useBoolean4[0],
    setDrawerOpen = _useBoolean4[1];
  var theme = useTheme();
  var classes = useStyles$6();
  var history = useHistory();
  var modulesManager = useModulesManager();
  var auth = useAuthentication();
  var cfg = children.props.modulesManager.cfg;
  var calendarSwitch = modulesManager.getConf("fe-core", "allowSecondCalendar", false);
  var isWorker = modulesManager.getConf("fe-core", "isWorker", DEFAULT.IS_WORKER);
  var showJournalSidebar = modulesManager.getConf("fe-core", "showJournalSidebar", DEFAULT.SHOW_JOURNAL_SIDEBAR);
  var isAppBarMenu = useMemo(function () {
    return theme.menu.variant.toUpperCase() === "APPBAR";
  }, [theme.menu.variant]);
  if (!auth.isAuthenticated) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirectTo
    });
  }
  if (((_cfg$openimisFeCore = cfg['openimis-fe-core_js']) === null || _cfg$openimisFeCore === void 0 ? void 0 : _cfg$openimisFeCore.menuLeft) === true) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBar, {
      position: "fixed",
      className: classes.appBarDrawer
    }, /*#__PURE__*/React.createElement(Toolbar, {
      className: classes.toolbarDrawer
    }, /*#__PURE__*/React.createElement(Contributions, _extends({}, others, {
      contributionKey: APP_BAR_CONTRIBUTION_KEY
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.grow
    })), /*#__PURE__*/React.createElement(LogoutButton, {
      className: classes.toolbarDrawerLogout
    }), /*#__PURE__*/React.createElement(Help$1, null))), /*#__PURE__*/React.createElement(Drawer, {
      className: classes.drawer,
      variant: "permanent",
      classes: {
        paper: classes.drawerPaper
      },
      anchor: "left"
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.appName,
      onClick: function onClick(e) {
        return window.location.href = "/front";
      }
    }, isAppBarMenu && /*#__PURE__*/React.createElement(Hidden, {
      smDown: true,
      implementation: "css"
    }), !disableTextLogo && /*#__PURE__*/React.createElement(FormattedMessage$1, {
      module: "core",
      id: "appName",
      defaultMessage: /*#__PURE__*/React.createElement(FormattedMessage$1, {
        id: "root.appName"
      })
    }), /*#__PURE__*/React.createElement(Hidden, {
      smDown: true,
      implementation: "css"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: modulesManager.getModulesVersions().join(", ")
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: "caption",
      className: classes.appVersions
    }, modulesManager.getOpenIMISVersion())))), /*#__PURE__*/React.createElement("div", {
      className: classes.drawerContainer
    }), /*#__PURE__*/React.createElement(MainMenuBar, _extends({}, others, {
      menuVariant: "Drawer",
      contributionKey: MAIN_MENU_CONTRIBUTION_KEY
    }), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(JournalDrawer$1, {
      open: isDrawerOpen,
      handleDrawer: setDrawerOpen.toggle
    }), /*#__PURE__*/React.createElement("main", {
      className: classes.contentShiftLeftSideMenu
    }, children));
  }
  var _useTranslations = useTranslations(module, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBar, {
    position: "fixed",
    className: clsx(_defineProperty(_defineProperty({}, classes.appBarShift, isOpen && theme.breakpoints.up("md")), classes.appBar, showJournalSidebar))
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    onClick: setOpen.toggle,
    className: clsx(classes.menuButton, isAppBarMenu && classes.autoHideMenuButton, isOpen && classes.hide)
  }, /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement(Button, {
    className: classes.appName,
    onClick: function onClick(e) {
      return history.push("/");
    }
  }, isAppBarMenu && /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }), !disableTextLogo && /*#__PURE__*/React.createElement(FormattedMessage$1, {
    module: "core",
    id: "appName",
    defaultMessage: /*#__PURE__*/React.createElement(FormattedMessage$1, {
      id: "root.appName"
    })
  })), /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: modulesManager.getModulesVersions().join(", ")
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "caption",
    className: classes.appVersions
  }, modulesManager.getOpenIMISVersion()))), isAppBarMenu && /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(MainMenuBar, _extends({}, others, {
    menuVariant: "AppBar",
    contributionKey: MAIN_MENU_CONTRIBUTION_KEY
  }), /*#__PURE__*/React.createElement("div", {
    onClick: setOpen.off
  }))), isWorker ? /*#__PURE__*/React.createElement("div", {
    className: classes.grow
  }) : /*#__PURE__*/React.createElement(Contributions, _extends({}, others, {
    contributionKey: APP_BAR_CONTRIBUTION_KEY
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.grow
  })), !!calendarSwitch && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, {
      color: "secondary",
      checked: isSecondaryCalendar,
      onChange: setSecondaryCalendar.toggle
    }),
    label: formatMessage("core.calendarSwitcher"),
    labelPlacement: "start"
  }), /*#__PURE__*/React.createElement(LanguageQuickPicker, null), /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: ECONOMIC_UNIT_BUTTON_CONTRIBUTION_KEY,
    onEconomicDialogOpen: onEconomicDialogOpen
  }), /*#__PURE__*/React.createElement(LogoutButton, null), /*#__PURE__*/React.createElement(Help$1, null), /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: USER_INFO_CONTRIBUTION_KEY
  }))), isOpen && /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: setOpen.off
  }, /*#__PURE__*/React.createElement("nav", {
    className: classes.drawer
  }, /*#__PURE__*/React.createElement(Drawer, {
    className: classes.drawer,
    variant: "persistent",
    anchor: "left",
    open: isOpen,
    classes: {
      paper: classes.drawerPaper
    }
  }, /*#__PURE__*/React.createElement(MainMenuBar, _extends({}, others, {
    menuVariant: "Drawer",
    contributionKey: MAIN_MENU_CONTRIBUTION_KEY
  }), /*#__PURE__*/React.createElement(Divider, null))))), showJournalSidebar && /*#__PURE__*/React.createElement(JournalDrawer$1, {
    open: isDrawerOpen,
    handleDrawer: setDrawerOpen.toggle
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }), /*#__PURE__*/React.createElement("main", {
    className: clsx(_defineProperty(_defineProperty({}, classes.jrnlContentShift, isDrawerOpen), classes.content, showJournalSidebar))
  }, children));
};
var RequireAuth$1 = withWidth()(RequireAuth);

var useStyles$5 = makeStyles(function (theme) {
  return {
    container: {
      textAlign: "center",
      height: "70vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    logo: {
      verticalAlign: "middle",
      margin: theme.spacing(2),
      maxHeight: theme.spacing(16)
    },
    title: {
      margin: theme.spacing(2),
      textTransform: "uppercase",
      fontWeight: "bold"
    },
    description: {
      margin: theme.spacing(2),
      fontSize: "18px"
    },
    button: {
      marginTop: theme.spacing(2)
    }
  };
});
var ErrorPage = function ErrorPage(_ref) {
  var status = _ref.status,
    title = _ref.title,
    description = _ref.description,
    logo = _ref.logo,
    back = _ref.back;
  var history = useHistory();
  var classes = useStyles$5();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, logo && /*#__PURE__*/React.createElement("img", {
    className: classes.logo,
    src: logo,
    alt: "Logo of openIMIS"
  }), status && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "h1",
    className: classes.title
  }, status), /*#__PURE__*/React.createElement(Typography$1, {
    variant: "h2",
    className: classes.title
  }, title), /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body1",
    className: classes.description
  }, description), back && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    size: "large",
    className: classes.button,
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon, null),
    onClick: function onClick() {
      return history.push("/");
    }
  }, back));
};

var FatalErrorPage = function FatalErrorPage(props) {
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;
  var error = props.error;
  var title, description;
  if (error && error.code === 429) {
    title = formatMessage("core.FatalError.RateLimitExceeded.title");
    description = formatMessage("core.FatalError.RateLimitExceeded.description");
  } else {
    title = formatMessage("core.FatalError.GenericError.title");
    description = error && error.message || formatMessage("core.FatalError.GenericError.description");
  }
  return /*#__PURE__*/React.createElement(ErrorPage, _extends({
    status: (error === null || error === void 0 ? void 0 : error.code) || "Unknown",
    title: title,
    description: description
  }, props));
};

function _callSuper$w(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$w() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$w() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$w = function _isNativeReflectConstruct() { return !!t; })(); }
var AlertDialog = /*#__PURE__*/function (_Component) {
  function AlertDialog() {
    var _this;
    _classCallCheck(this, AlertDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$w(this, AlertDialog, [].concat(args));
    _defineProperty(_this, "state", {
      expanded: false
    });
    _defineProperty(_this, "toggleOpen", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });
    return _this;
  }
  _inherits(AlertDialog, _Component);
  return _createClass(AlertDialog, [{
    key: "render",
    value: function render() {
      var _alert$title, _alert$message;
      var _this$props = this.props,
        intl = _this$props.intl,
        alert = _this$props.alert,
        clearAlert = _this$props.clearAlert;
      return /*#__PURE__*/React.createElement(Dialog, {
        open: Boolean(alert),
        onClose: function onClose() {
          return clearAlert();
        }
      }, alert && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogTitle, null, (_alert$title = alert.title) !== null && _alert$title !== void 0 ? _alert$title : formatMessage(intl, "core", "FatalError.title")), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        onClick: this.toggleOpen
      }, alert.detail && this.state.expanded && /*#__PURE__*/React.createElement(ArrowDropDownIcon, null), alert.detail && !this.state.expanded && /*#__PURE__*/React.createElement(ArrowRightIcon, null)), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        onClick: this.toggleOpen
      }, ensureArray((_alert$message = alert.message) !== null && _alert$message !== void 0 ? _alert$message : formatMessage(intl, "core", "FatalError.message")).map(function (message, i) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: "message-".concat(i),
          item: true
        }, /*#__PURE__*/React.createElement(DialogContentText, null, message));
      })), alert.detail && /*#__PURE__*/React.createElement(Typography$1, {
        style: {
          visibility: this.state.expanded ? "visible" : "hidden"
        }
      }, alert.detail))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return clearAlert();
        },
        color: "primary",
        autoFocus: true
      }, formatMessage(intl, "core", "close"))));
    }
  }]);
}(Component);
var mapDispatchToProps$9 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    clearAlert: clearAlert
  }, dispatch);
};
var AlertDialog$1 = injectIntl(connect(function (state) {
  return {
    alert: state.core.alert
  };
}, mapDispatchToProps$9)(AlertDialog));

var styles$q = function styles(theme) {
  return {
    primaryButton: theme.dialog.primaryButton,
    secondaryButton: theme.dialog.secondaryButton
  };
};
var ConfirmDialog = function ConfirmDialog(props) {
  var intl = props.intl,
    classes = props.classes,
    confirm = props.confirm,
    onConfirm = props.onConfirm;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    open: !!confirm,
    onClose: function onClose() {
      return onConfirm(false);
    }
  }, (confirm === null || confirm === void 0 ? void 0 : confirm.title) && /*#__PURE__*/React.createElement(DialogTitle, null, confirm.title), (confirm === null || confirm === void 0 ? void 0 : confirm.message) && /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, confirm.message)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onConfirm(true);
    },
    autoFocus: true,
    className: classes.primaryButton
  }, formatMessage(intl, "core", "ok")), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onConfirm(false);
    },
    className: classes.secondaryButton
  }, formatMessage(intl, "core", "cancel")))));
};
var ConfirmDialog$1 = withTheme(withStyles(styles$q)(injectIntl(ConfirmDialog)));

var _excluded$b = ["intl", "classes", "module", "label", "readOnly", "error", "startAdornment", "endAdornment", "inputProps", "formatInput", "helperText", "type"];
function _callSuper$v(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$v() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$v() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$v = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$p = function styles(theme) {
  return {
    label: {
      color: theme.palette.primary.main
    },
    // NOTE: This is used to hide the increment/decrement arrows from the number input
    numberInput: {
      "& input[type=number]": {
        "-moz-appearance": "textfield"
      },
      "& input[type=number]::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
      }
    },
    disabledStateVisibilityBoost: {
      "& .Mui-disabled": {
        color: '#5E5B50'
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px dotted #5E5B50"
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: "#181716"
      }
    }
  };
};
var TextInput = /*#__PURE__*/function (_Component) {
  function TextInput(props) {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _callSuper$v(this, TextInput, [props]);
    _defineProperty(_this, "state", {
      value: ""
    });
    _defineProperty(_this, "_onChange", function (e) {
      var value = e.target.value;
      if (_this.props.formatInput) {
        value = _this.props.formatInput(value);
      }
      if (value !== _this.state.value) {
        _this.setState({
          value: value
        }, function () {
          return _this.props.onChange && _this.props.onChange(_this.state.value);
        });
      }
    });
    _this.disabledVisibilityBoost = props.modulesManager.getConf("fe-core", "Input.disabledVisibilityBoost", DEFAULT.DISABLED_VISIBILITY_BOOST);
    return _this;
  }
  _inherits(TextInput, _Component);
  return _createClass(TextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;
      if (!!this.props.formatInput) {
        value = this.props.formatInput(value);
      }
      if (value !== this.state.value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.reset !== this.props.reset || prevProps.value !== this.props.value) {
        var value = this.props.value;
        if (!!this.props.formatInput) {
          value = this.props.formatInput(value);
        }
        if (value !== this.state.value) {
          this.setState({
            value: value
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        classes = _this$props.classes,
        module = _this$props.module,
        label = _this$props.label,
        _this$props$readOnly = _this$props.readOnly,
        readOnly = _this$props$readOnly === void 0 ? false : _this$props$readOnly,
        _this$props$error = _this$props.error,
        error = _this$props$error === void 0 ? null : _this$props$error,
        _this$props$startAdor = _this$props.startAdornment,
        startAdornment = _this$props$startAdor === void 0 ? null : _this$props$startAdor,
        _this$props$endAdornm = _this$props.endAdornment,
        endAdornment = _this$props$endAdornm === void 0 ? null : _this$props$endAdornm,
        _this$props$inputProp = _this$props.inputProps,
        inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp;
        _this$props.formatInput;
        var helperText = _this$props.helperText,
        type = _this$props.type,
        others = _objectWithoutProperties(_this$props, _excluded$b);
      return /*#__PURE__*/React.createElement(TextField, _extends({}, others, {
        className: clsx(_defineProperty(_defineProperty({}, classes.numberInput, true), classes.disabledStateVisibilityBoost, this.disabledVisibilityBoost && readOnly)),
        fullWidth: true,
        disabled: readOnly,
        label: !!label && formatMessage(intl, module, label),
        InputLabelProps: {
          className: classes.label
        },
        InputProps: {
          inputProps: inputProps,
          startAdornment: startAdornment,
          endAdornment: endAdornment
        },
        onChange: this._onChange,
        value: this.state.value,
        error: Boolean(error),
        helperText: error !== null && error !== void 0 ? error : helperText,
        type: type
      }));
    }
  }]);
}(Component);
var TextInput$1 = withModulesManager(injectIntl(withTheme(withStyles(styles$p)(TextInput))));

function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$4 = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: theme.paper.paper,
    logo: {
      width: "100%",
      padding: theme.spacing(2)
    }
  };
});
var LOGIN_PAGE_CONTRIBUTION_KEY = "core.LoginPage";
var LOGIN_PAGE_LOGO_CONTRIBUTION_KEY = "core.LoginPageLogo";
var LOGIN_PAGE_FORM_CONTRIBUTION_KEY = "core.LoginPageForm";
var LOGIN_PAGE_MPASS_CONTRIBUTION_KEY = "workerVoucher.MPassLoginButton";
var LoginPage = function LoginPage(_ref) {
  var logo = _ref.logo;
  var classes = useStyles$4();
  var history = useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.LoginPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    credentials = _useState2[0],
    setCredentials = _useState2[1];
  var _useState3 = useState({
      loginStatus: "",
      message: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    serverResponse = _useState4[0],
    setServerResponse = _useState4[1];
  var auth = useAuthentication();
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAuthenticating = _useState6[0],
    setAuthenticating = _useState6[1];
  var showMPassProvider = modulesManager.getConf("fe-core", "LoginPage.showMPassProvider", false);
  var linkToUserGuide = modulesManager.getConf("fe-core", "LoginPage.linkToUserGuide", "https://docs.openimis.org/");
  var isWorker = modulesManager.getConf("fe-core", "isWorker", DEFAULT.IS_WORKER);
  var enablePublicPage = modulesManager.getConf("fe-core", "App.enablePublicPage", DEFAULT.ENABLE_PUBLIC_PAGE);
  var login_page_logo_contributions = modulesManager.getContribs(LOGIN_PAGE_LOGO_CONTRIBUTION_KEY);
  var login_page_form_contributions = modulesManager.getContribs(LOGIN_PAGE_FORM_CONTRIBUTION_KEY);
  var has_login_page_logo_contribution = Array.isArray(login_page_logo_contributions) && login_page_logo_contributions.length > 0;
  var has_login_page_form_contributions = Array.isArray(login_page_form_contributions) && login_page_form_contributions.length > 0;
  useEffect(function () {
    if (auth.isAuthenticated) {
      history.push("/");
    }
  }, []);
  var handleLoginError = function handleLoginError(errorMessage) {
    setServerResponse({
      loginStatus: "CORE_AUTH_ERR",
      message: errorMessage
    });
    setAuthenticating(false);
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var _response$payload, response, loginStatus, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setAuthenticating(true);
            _context.prev = 2;
            _context.next = 5;
            return auth.login(credentials);
          case 5:
            response = _context.sent;
            if (!((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.errors) !== null && _response$payload !== void 0 && _response$payload.length)) {
              _context.next = 9;
              break;
            }
            handleLoginError(response.payload.errors[0].message);
            return _context.abrupt("return");
          case 9:
            loginStatus = response.loginStatus, message = response.message;
            setServerResponse({
              loginStatus: loginStatus,
              message: message
            });
            if (loginStatus === "CORE_AUTH_ERR") {
              setAuthenticating(false);
            } else {
              history.push("/");
            }
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            setAuthenticating(false);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14]]);
    }));
    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var redirectToForgotPassword = function redirectToForgotPassword(e) {
    e.preventDefault();
    history.push("/forgot_password");
  };
  var errorMessages = {
    INCORRECT_CREDENTIALS: formatMessage("core.LoginPage.authError"),
    HF_CONTRACT_INVALID: formatMessage("core.LoginPage.authErrorHealthFacilityContractInvalid"),
    GENERAL: formatMessage("core.LoginPage.authErrorGeneral")
  };
  var getErrorMessage = function getErrorMessage(messageKey) {
    return errorMessages[messageKey] || messageKey;
  };
  var redirectToMPassLogin = function redirectToMPassLogin(e) {
    e.preventDefault();
    var redirectToURL = new URL("".concat(window.location.origin).concat(baseApiUrl).concat(SAML_LOGIN_PATH));
    window.location.href = redirectToURL.href;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAuthenticating && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    className: "bootstrap"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_Helmet, {
    title: formatMessage("pageTitle")
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 2
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    p: 6,
    width: 500
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "stretch"
  }, enablePublicPage && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return history.push("/");
    },
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon, null),
    color: "primary",
    variant: "text"
  }, formatMessage("backButton"))), /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: LOGIN_PAGE_LOGO_CONTRIBUTION_KEY
  }), !has_login_page_logo_contribution && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.logo,
    src: logo
  }), !isWorker && /*#__PURE__*/React.createElement(Box, {
    pl: 2,
    fontWeight: "fontWeightMedium",
    fontSize: "h4.fontSize"
  }, formatMessage("appName"))), showMPassProvider ? /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    my: 2
  }, /*#__PURE__*/React.createElement(Typography$1, {
    style: {
      textTransform: "uppercase"
    },
    variant: "body2"
  }, formatMessage("loginCaption"))), /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: LOGIN_PAGE_MPASS_CONTRIBUTION_KEY,
    onClick: redirectToMPassLogin
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    mt: 4,
    mb: 2
  }, /*#__PURE__*/React.createElement(Divider, {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement(Link, {
    href: linkToUserGuide,
    underline: "hover",
    style: {
      margin: "0 12px",
      cursor: "pointer"
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Typography$1, {
    style: {
      textTransform: "uppercase"
    },
    variant: "body1"
  }, formatMessage("howToUse"))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      flex: 1
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: LOGIN_PAGE_FORM_CONTRIBUTION_KEY
  }), !has_login_page_form_contributions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    required: true,
    readOnly: isAuthenticating,
    label: formatMessage("username.label"),
    fullWidth: true,
    defaultValue: credentials.username,
    onChange: function onChange(username) {
      return setCredentials(_objectSpread$j(_objectSpread$j({}, credentials), {}, {
        username: username
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    required: true,
    readOnly: isAuthenticating,
    type: "password",
    label: formatMessage("password.label"),
    fullWidth: true,
    onChange: function onChange(password) {
      return setCredentials(_objectSpread$j(_objectSpread$j({}, credentials), {}, {
        password: password
      }));
    }
  })), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.message) && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    color: "error.main"
  }, getErrorMessage(serverResponse.message))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    type: "submit",
    disabled: isAuthenticating || !(credentials.username && credentials.password),
    color: "primary",
    variant: "contained"
  }, formatMessage("loginBtn")))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: redirectToForgotPassword
  }, formatMessage("forgotPassword")), /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: LOGIN_PAGE_CONTRIBUTION_KEY
  })))))))));
};

var useStyles$3 = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: "30%",
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center"
    },
    paper: theme.paper.paper,
    logo: {
      maxHeight: 100
    }
  };
});
var ForgotPasswordPage = function ForgotPasswordPage(props) {
  var classes = useStyles$3();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.ForgotPasswordPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    username = _useState2[0],
    setUsername = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDone = _useState4[0],
    setDone = _useState4[1];
  var _useGraphqlMutation = useGraphqlMutation("\n    mutation resetPassword($input: ResetPasswordMutationInput!) {\n      resetPassword(input: $input) {\n        clientMutationId\n        success\n        error\n      }\n    }\n  ", {
      wait: false
    }),
    isLoading = _useGraphqlMutation.isLoading,
    mutate = _useGraphqlMutation.mutate;
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            _context.next = 3;
            return mutate({
              username: username
            });
          case 3:
            _context.next = 5;
            return setDone(true);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_Helmet, {
    title: formatMessage("pageTitle")
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 2
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    p: 3,
    width: 500
  }, !isDone && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement("h1", null, formatMessage("recoverTitle"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography$1, null, formatMessage("explanationMessage"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography$1, null, formatMessage("contactAdministrator"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    required: true,
    readOnly: isLoading,
    label: formatMessage("username.label"),
    fullWidth: true,
    onChange: function onChange(username) {
      return setUsername(username);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    type: "submit",
    disabled: !username || isLoading,
    color: "primary",
    variant: "contained"
  }, formatMessage("submitBtn")))), isDone && /*#__PURE__*/React.createElement("h1", null, formatMessage("done")))))));
};

var addSuggestion = function addSuggestion(suggestions, condition, message) {
  if (condition) {
    suggestions.push(message);
  }
};
var generateFeedback = function generateFeedback(suggestions, formatMessageWithValues) {
  if (suggestions.length > 0) {
    var requirements = suggestions.join(', ');
    var formattedMessage = formatMessageWithValues("admin.password.requirements", {
      requirements: requirements
    });
    return {
      feedback: formattedMessage,
      score: 0
    };
  }
  return null;
};
var validatePassword = function validatePassword(password, passwordPolicy, formatMessage, formatMessageWithValues) {
  if (!passwordPolicy || !password) {
    return {
      feedback: "",
      score: 0
    };
  }
  var jsonPasswordPolicy = JSON.parse(passwordPolicy);
  var suggestions = [];
  var _ref = jsonPasswordPolicy || {},
    min_length = _ref.min_length,
    require_lower_case = _ref.require_lower_case,
    require_upper_case = _ref.require_upper_case,
    require_numbers = _ref.require_numbers,
    require_special_characters = _ref.require_special_characters;
  addSuggestion(suggestions, password.length < min_length, formatMessageWithValues("admin.password.minLength", {
    count: min_length
  }));
  addSuggestion(suggestions, require_lower_case && !/[a-z]/.test(password), formatMessageWithValues("admin.password.lowerCase", {
    count: require_lower_case
  }));
  addSuggestion(suggestions, require_upper_case && !/[A-Z]/.test(password), formatMessageWithValues("admin.password.upperCase", {
    count: require_upper_case
  }));
  addSuggestion(suggestions, require_numbers && !/\d/.test(password), formatMessageWithValues("admin.password.numbers", {
    count: require_numbers
  }));
  addSuggestion(suggestions, require_special_characters && !/[^a-zA-Z0-9]/.test(password), formatMessageWithValues("admin.password.specialCharacters", {
    count: require_special_characters
  }));
  var feedbackResult = generateFeedback(suggestions, formatMessageWithValues);
  if (feedbackResult) {
    return feedbackResult;
  }
  var result = zxcvbn(password);
  var feedback = result.feedback.suggestions.join(" ") || formatMessage("admin.password.strong");
  var score = result.score;
  var scoreDescription;
  switch (score) {
    case 1:
      scoreDescription = "".concat(formatMessage("admin.password.weak"), ". ").concat(feedback);
      break;
    case 2:
      scoreDescription = "".concat(formatMessage("admin.password.medium"), ". ").concat(feedback);
      break;
    case 3:
      scoreDescription = "".concat(formatMessage("admin.password.strong"));
      break;
    case 4:
      scoreDescription = "".concat(formatMessage("admin.password.veryStrong"));
      break;
    default:
      scoreDescription = formatMessage("admin.password.unknownScore");
  }
  return {
    feedback: scoreDescription,
    score: score
  };
};

var passwordGenerator = function passwordGenerator(options) {
  var _options$length, _options$isNumberRequ, _options$isLowerCaseR, _options$isUpperCaseR, _options$isSpecialSym;
  // This method should not be used to create safe/permament passwords for users
  // Passwords should be generated by browsers or password managers
  // Only justifiable use-case is creating temporary passwords valid until first login
  var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var lowercase = uppercase.toLowerCase();
  var numbers = "0123456789";
  var specialCharacters = "!@#$%^&*()_+-=[]{}|;:,.<>?";
  var length = (_options$length = options === null || options === void 0 ? void 0 : options.length) !== null && _options$length !== void 0 ? _options$length : 10;
  var isNumberRequired = (_options$isNumberRequ = options === null || options === void 0 ? void 0 : options.isNumberRequired) !== null && _options$isNumberRequ !== void 0 ? _options$isNumberRequ : true;
  var isLowerCaseRequired = (_options$isLowerCaseR = options === null || options === void 0 ? void 0 : options.isLowerCaseRequired) !== null && _options$isLowerCaseR !== void 0 ? _options$isLowerCaseR : true;
  var isUpperCaseRequired = (_options$isUpperCaseR = options === null || options === void 0 ? void 0 : options.isUpperCaseRequired) !== null && _options$isUpperCaseR !== void 0 ? _options$isUpperCaseR : true;
  var isSpecialSymbolRequired = (_options$isSpecialSym = options === null || options === void 0 ? void 0 : options.isSpecialSymbolRequired) !== null && _options$isSpecialSym !== void 0 ? _options$isSpecialSym : true;
  var password = "";
  var getCategoriesArray = function getCategoriesArray() {
    var availableCategories = [];
    if (isLowerCaseRequired) availableCategories.push(lowercase);
    if (isUpperCaseRequired) availableCategories.push(uppercase);
    if (isNumberRequired) availableCategories.push(numbers);
    if (isSpecialSymbolRequired) availableCategories.push(specialCharacters);
    return availableCategories;
  };
  var categoriesArray = getCategoriesArray();
  getSafeRandomNumberArray(length, categoriesArray.length).forEach(function (category) {
    password += getRandomOfType(categoriesArray[category]);
  });
  return password;
};
function getSafeRandomNumberArray(length, modulo) {
  // crypto.getRandomValues is coded in a way that is cryptographically secure
  // do not use Math.Random to generate password
  var seedArray = self.crypto.getRandomValues(new Uint32Array(length));
  return Array.from(seedArray, function (value) {
    return value % modulo;
  });
}
function getRandomOfType(charset) {
  return charset.charAt(getSafeRandomNumberArray(1, charset.length));
}

function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$2 = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: "30%",
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center"
    },
    paper: theme.paper.paper,
    logo: {
      maxHeight: 100
    },
    passwordFeedback: {
      marginTop: theme.spacing(1)
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "space-between"
    }
  };
});
var SetPasswordPage = function SetPasswordPage(_ref) {
  var fetchPasswordPolicy = _ref.fetchPasswordPolicy,
    passwordPolicy = _ref.passwordPolicy;
  var classes = useStyles$2();
  var history = useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.SetPasswordPage", modulesManager),
    formatMessage = _useTranslations.formatMessage,
    formatMessageWithValues = _useTranslations.formatMessageWithValues;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    credentials = _useState2[0],
    setCredentials = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPassword = _useState6[0],
    setShowPassword = _useState6[1];
  var _useGraphqlMutation = useGraphqlMutation("\n      mutation setPassword($input: SetPasswordMutationInput!) {\n        setPassword(input: $input) {\n          clientMutationId\n          success\n          error\n        }\n      }\n    ", {
      wait: false
    }),
    mutate = _useGraphqlMutation.mutate;
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    passwordFeedback = _useState8[0],
    setPasswordFeedback = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    passwordScore = _useState10[0],
    setPasswordScore = _useState10[1];
  var IS_PASSWORD_SECURED = passwordScore >= 2;
  useEffect(function () {
    var search = new URLSearchParams(location.search);
    setCredentials({
      token: search.get("token")
    });
    fetchPasswordPolicy();
  }, [fetchPasswordPolicy]);
  var handlePasswordChange = function handlePasswordChange(password) {
    var _validatePassword = validatePassword(password, passwordPolicy, formatMessage, formatMessageWithValues),
      feedback = _validatePassword.feedback,
      score = _validatePassword.score;
    setPasswordFeedback(feedback);
    setPasswordScore(score);
    setCredentials(_objectSpread$i(_objectSpread$i({}, credentials), {}, {
      password: password
    }));
  };
  var handleSetPasswordError = function handleSetPasswordError(errorMessage) {
    setError(errorMessage);
  };
  var generatePassword = function generatePassword() {
    var newPassword = passwordGenerator({
      length: 12,
      isNumberRequired: true,
      isLowerCaseRequired: true,
      isUpperCaseRequired: true,
      isSpecialSymbolRequired: true
    });
    handlePasswordChange(newPassword);
    setCredentials(_objectSpread$i(_objectSpread$i({}, credentials), {}, {
      password: newPassword,
      confirmPassword: newPassword
    }));
  };
  var togglePasswordVisibility = function togglePasswordVisibility() {
    setShowPassword(!showPassword);
  };
  var clearPassword = function clearPassword() {
    handlePasswordChange("");
    setCredentials(_objectSpread$i(_objectSpread$i({}, credentials), {}, {
      password: "",
      confirmPassword: ""
    }));
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            if (!isValid) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return mutate({
              username: credentials.username,
              token: credentials.token,
              newPassword: credentials.password
            });
          case 4:
            result = _context.sent;
            if (result !== null && result !== void 0 && result.setPassword.success) {
              history.push("/");
            } else {
              handleSetPasswordError((result === null || result === void 0 ? void 0 : result.setPassword.error) || formatMessage("error"));
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isValid = useMemo(function () {
    return credentials.confirmPassword && credentials.password && credentials.password === credentials.confirmPassword && credentials.username && credentials.token;
  }, [credentials]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_Helmet, {
    title: formatMessage("pageTitle")
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 2
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    p: 6,
    width: 450
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    required: true,
    type: "text",
    label: formatMessage("username.label"),
    fullWidth: true,
    onChange: function onChange(username) {
      return setCredentials(_objectSpread$i(_objectSpread$i({}, credentials), {}, {
        username: username
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    required: true,
    type: showPassword ? "text" : "password",
    label: formatMessage("password.label"),
    fullWidth: true,
    onChange: function onChange(password) {
      return handlePasswordChange(password);
    },
    value: credentials.password || "",
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: togglePasswordVisibility,
      edge: "end"
    }, showPassword ? /*#__PURE__*/React.createElement(VisibilityOffIcon, null) : /*#__PURE__*/React.createElement(VisibilityIcon, null)), /*#__PURE__*/React.createElement(IconButton, {
      onClick: clearPassword,
      edge: "end"
    }, /*#__PURE__*/React.createElement(ClearIcon, null)))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    required: true,
    type: showPassword ? "text" : "password",
    label: formatMessage("confirmPassword.label"),
    fullWidth: true,
    onChange: function onChange(confirmPassword) {
      return setCredentials(_objectSpread$i(_objectSpread$i({}, credentials), {}, {
        confirmPassword: confirmPassword
      }));
    },
    value: credentials.confirmPassword || ""
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: generatePassword,
    variant: "contained"
  }, formatMessage("core.SetPasswordPage.generatePassword"))), passwordFeedback && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography$1, {
    color: IS_PASSWORD_SECURED ? "primary" : "error",
    className: classes.passwordFeedback
  }, passwordFeedback)), error && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    color: "error.main"
  }, error)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    type: "submit",
    disabled: !isValid,
    color: "primary",
    variant: "contained"
  }, formatMessage("submitBtn")))))))));
};
var mapStateToProps$9 = function mapStateToProps(state) {
  return {
    passwordPolicy: state.core.passwordPolicy // Adjust based on your state structure
  };
};
var mapDispatchToProps$8 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPasswordPolicy: fetchPasswordPolicy
  }, dispatch);
};
var SetPasswordPage$1 = connect(mapStateToProps$9, mapDispatchToProps$8)(SetPasswordPage);

var NotFoundPage = function NotFoundPage(props) {
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(ErrorPage, _extends({
    status: 404,
    title: formatMessage("core.NotFoundPage.title"),
    description: formatMessage("core.NotFoundPage.description"),
    back: formatMessage("core.ErrorPage.back")
  }, props));
};

var ForbiddenPage = function ForbiddenPage(props) {
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(ErrorPage, _extends({
    status: 401,
    title: formatMessage("core.ForbiddenPage.title"),
    description: formatMessage("core.ForbiddenPage.description"),
    back: formatMessage("core.ErrorPage.back")
  }, props));
};

var _excluded$a = ["userRights", "requiredRights", "children"];
var PermissionCheck = function PermissionCheck(_ref) {
  var userRights = _ref.userRights,
    requiredRights = _ref.requiredRights,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$a);
  var hasAccess = function hasAccess() {
    // NOTE: Currently, the route is accessible to all users if 'requiredRights' are not specified.
    // This default behavior is subject to change in future iterations.

    // TODO: Implement a more restrictive access policy where, by default, a route will require
    // specific rights to be accessible. This will ensure tighter security.

    if (!Array.isArray(requiredRights)) {
      return true;
    }
    if (requiredRights.length === 0) {
      return false;
    }
    return requiredRights.some(function (right) {
      return userRights === null || userRights === void 0 ? void 0 : userRights.includes(right);
    });
  };
  return hasAccess() ? children : /*#__PURE__*/React.createElement(ForbiddenPage, props);
};

var _excluded$9 = ["modulesManager", "id", "pubRef"];
function _callSuper$u(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$u() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$u() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$u = function _isNativeReflectConstruct() { return !!t; })(); }
var PublishedComponent = /*#__PURE__*/function (_Component) {
  function PublishedComponent() {
    _classCallCheck(this, PublishedComponent);
    return _callSuper$u(this, PublishedComponent, arguments);
  }
  _inherits(PublishedComponent, _Component);
  return _createClass(PublishedComponent, [{
    key: "render",
    value: function render() {
      // id kept for backward (< 1.2) compatibility,
      // but prefer using pubRef to prevent any conflict with React default id property
      var _this$props = this.props,
        modulesManager = _this$props.modulesManager,
        id = _this$props.id,
        pubRef = _this$props.pubRef,
        others = _objectWithoutProperties(_this$props, _excluded$9);
      var C = modulesManager.getRef(id || pubRef);
      return !!C ? /*#__PURE__*/React.createElement(C, others) : null;
    }
  }]);
}(Component);
var PublishedComponent$1 = withModulesManager(PublishedComponent);

/**
 * @name PublicPageMiddleware
 * @param {boolean} props.isAuthenticated
 * @returns {React.Component}
 *
 * @description
 * This component is a middleware that checks if the user is authenticated and if the public page is enabled.
 * If the user is not authenticated, it redirects to the login page.
 * If the user is authenticated, it redirects to the home page.
 * If the public page is not enabled, it redirects to the home page (if the user is authenticated, otherwise to the login page).
 * If the user is not authenticated and the public page is enabled, it renders the public page.
 * To enable the public page, set the "App.enablePublicPage" configuration to true and
 * add the "core.PublicPage" contribution from any module.
 */

var PUBLIC_PAGE_CONTRIBUTION_KEY = "core.PublicPage";
var PublicPageMiddleware = function PublicPageMiddleware(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
    logo = _ref.logo;
  var modulesManager = useModulesManager();
  var enablePublicPage = modulesManager.getConf("fe-core", "App.enablePublicPage", DEFAULT.ENABLE_PUBLIC_PAGE);
  if (isAuthenticated || !enablePublicPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/home"
    });
  }
  return /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: PUBLIC_PAGE_CONTRIBUTION_KEY,
    isAuthenticated: isAuthenticated,
    logo: logo
  });
};

var CONFIG = {
  AUTOHIDE_DURATION: 5000,
  ANCHOR_ORIGIN: {
    vertical: "bottom",
    horizontal: "left"
  },
  SEVERITY_LEVELS: {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info"
  }
};
function Alert(props) {
  return /*#__PURE__*/React.createElement(MuiAlert, _extends({
    elevation: 4,
    variant: "filled"
  }, props));
}
var ToastContext = /*#__PURE__*/createContext();
function ToastProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    message = _useState4[0],
    setMessage = _useState4[1];
  var _useState5 = useState(CONFIG.SEVERITY_LEVELS.INFO),
    _useState6 = _slicedToArray(_useState5, 2),
    severity = _useState6[0],
    setSeverity = _useState6[1];
  var showToast = useCallback(function (message, severity) {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);
  }, []);
  var hideToast = useCallback(function () {
    setOpen(false);
  }, []);
  var contextValue = useMemo(function () {
    return {
      showSuccess: function showSuccess(message) {
        return showToast(message, CONFIG.SEVERITY_LEVELS.SUCCESS);
      },
      showError: function showError(message) {
        return showToast(message, CONFIG.SEVERITY_LEVELS.ERROR);
      },
      showWarning: function showWarning(message) {
        return showToast(message, CONFIG.SEVERITY_LEVELS.WARNING);
      },
      showInfo: function showInfo(message) {
        return showToast(message, CONFIG.SEVERITY_LEVELS.INFO);
      }
    };
  }, [showToast]);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement(Snackbar, {
    open: open,
    anchorOrigin: CONFIG.ANCHOR_ORIGIN,
    autoHideDuration: CONFIG.AUTOHIDE_DURATION,
    onClose: hideToast
  }, /*#__PURE__*/React.createElement(Alert, {
    onClose: hideToast,
    severity: severity,
    style: {
      maxWidth: 500,
      minWidth: 300
    }
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body1"
  }, " ", message, " "))));
}
var useToast = function useToast() {
  var context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

function setCookie(name, value) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;
  var expires = days ? "; expires=".concat(new Date(Date.now() + days * 864e5).toUTCString()) : "";
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(value)).concat(expires, "; path=/");
}
function getCookie(name) {
  return document.cookie.split("; ").reduce(function (prev, current) {
    var _current$split = current.split("="),
      _current$split2 = _slicedToArray(_current$split, 2),
      key = _current$split2[0],
      value = _current$split2[1];
    return key === name ? decodeURIComponent(value) : prev;
  }, null);
}

var PublicPageLanguageContext = /*#__PURE__*/createContext();
var PublicPageLanguageProvider = function PublicPageLanguageProvider(_ref) {
  var children = _ref.children;
  var modulesManager = useModulesManager();
  var enablePublicPage = modulesManager.getConf("fe-core", "App.enablePublicPage", DEFAULT.ENABLE_PUBLIC_PAGE);
  var _useState = useState(function () {
      var _getCookie;
      return (_getCookie = getCookie(PUBLIC_PAGE_LANGUAGE_COOKIE_KEY)) !== null && _getCookie !== void 0 ? _getCookie : "fr";
    }),
    _useState2 = _slicedToArray(_useState, 2),
    publicPageLang = _useState2[0],
    setPublicPageLang = _useState2[1];
  useEffect(function () {
    if (publicPageLang) {
      setCookie(PUBLIC_PAGE_LANGUAGE_COOKIE_KEY, publicPageLang);
    }
  }, [publicPageLang]);
  var onPublicPageLangChange = function onPublicPageLangChange(lang) {
    setPublicPageLang(lang);
  };
  var memoizedValue = React.useMemo(function () {
    return {
      publicPageLang: publicPageLang,
      onPublicPageLangChange: onPublicPageLangChange
    };
  }, [publicPageLang]);
  if (!enablePublicPage) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, " ", children, " ");
  }
  return /*#__PURE__*/React.createElement(PublicPageLanguageContext.Provider, {
    value: memoizedValue
  }, children);
};
var usePublicPageLanguage = function usePublicPageLanguage() {
  var context = useContext(PublicPageLanguageContext);
  if (!context) {
    throw new Error("usePublicPageLanguage must be used within a PublicPageLanguageProvider");
  }
  return context;
};

var _excluded$8 = ["history", "classes", "error", "confirm", "user", "messages", "clearConfirm", "localesManager", "modulesManager", "basename", "toggleCurrentCalendarType", "rights"];
function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ROUTER_CONTRIBUTION_KEY = "core.Router";
var UNAUTHENTICATED_ROUTER_CONTRIBUTION_KEY = "core.UnauthenticatedRouter";
var APP_BOOT_CONTRIBUTION_KEY = "core.Boot";
var TRANSLATION_CONTRIBUTION_KEY = "translations";
var ECONOMIC_UNIT_DIALOG_CONTRIBUTION_KEY = "policyholder.EconomicUnitDialog";
var ECONOMIC_UNIT_STORAGE_KEY = "userEconomicUnit";
var PUBLIC_PAGE_LANGUAGE_STORAGE_KEY = "publicPageLanguage";
var styles$o = function styles() {
  return {
    fetching: {
      margin: 0,
      position: "absolute",
      top: "50%",
      left: "50%"
    }
  };
};
var App = function App(props) {
  props.history;
    props.classes;
    var error = props.error,
    confirm = props.confirm,
    user = props.user,
    messages = props.messages,
    clearConfirm = props.clearConfirm,
    localesManager = props.localesManager,
    modulesManager = props.modulesManager,
    _props$basename = props.basename,
    basename = _props$basename === void 0 ? process.env.PUBLIC_URL : _props$basename,
    toggleCurrentCalendarType = props.toggleCurrentCalendarType,
    rights = props.rights,
    others = _objectWithoutProperties(props, _excluded$8);
  var economicUnitConfig = modulesManager.getConf("fe-core", "App.economicUnitConfig", false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    economicUnitDialogOpen = _useState2[0],
    setEconomicUnitDialogOpen = _useState2[1];
  var _useBoolean = useBoolean(true),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    isSecondaryCalendar = _useBoolean2[0],
    setSecondaryCalendar = _useBoolean2[1];
  var auth = useAuthentication();
  var routes = useMemo(function () {
    return modulesManager.getContribs(ROUTER_CONTRIBUTION_KEY);
  }, []);
  var unauthenticatedRoutes = useMemo(function () {
    return modulesManager.getContribs(UNAUTHENTICATED_ROUTER_CONTRIBUTION_KEY);
  }, []);
  var locale = useMemo(function () {
    if (user) {
      localesManager.getLocale(user.language);
    }
  }, [user === null || user === void 0 ? void 0 : user.language]);
  var allMessages = useMemo(function () {
    var lang;
    if (user) {
      lang = localesManager.getFileNameByLang(user.language);
    } else {
      var _localesManager$getFi;
      var cookieLang = getCookie(PUBLIC_PAGE_LANGUAGE_STORAGE_KEY);
      lang = cookieLang ? cookieLang : (_localesManager$getFi = localesManager.getFileNameByLang(navigator.language)) !== null && _localesManager$getFi !== void 0 ? _localesManager$getFi : "en";
    }
    var msgs = modulesManager.getContribs(TRANSLATION_CONTRIBUTION_KEY).filter(function (msgs) {
      return msgs.key === lang;
    }).reduce(function (allmsgs, msgs) {
      return Object.assign(allmsgs, msgs.messages);
    }, {});
    return _objectSpread$h(_objectSpread$h({}, messages), msgs);
  }, [user === null || user === void 0 ? void 0 : user.language, messages]);
  useEffect(function () {
    auth.initialize();
    if (process.env.NODE_ENV == "development") {
      // In development, redirect the browser to the basename if
      // the location is currently the root path
      if (location.pathname === "/") {
        location.replace(basename);
      }
    }
  }, []);
  useEffect(function () {
    var userHasModalRight = user !== null && user !== void 0 && user.rights ? user.rights.includes(RIGHT_VIEW_EU_MODAL) : false;
    if (economicUnitConfig && userHasModalRight && auth.isAuthenticated && !localStorage.getItem(ECONOMIC_UNIT_STORAGE_KEY)) {
      setEconomicUnitDialogOpen(true);
    }
    if (!economicUnitConfig || economicUnitConfig && !auth.isAuthenticated) {
      setEconomicUnitDialogOpen(false);
    }
  }, [auth, economicUnitDialogOpen, user]);
  useEffect(function () {
    localStorage.setItem("isSecondaryCalendarEnabled", JSON.stringify(!isSecondaryCalendar));
    toggleCurrentCalendarType(!isSecondaryCalendar);
  }, [isSecondaryCalendar]);
  if (error) {
    return /*#__PURE__*/React.createElement(IntlProvider, {
      locale: locale,
      messages: allMessages
    }, /*#__PURE__*/React.createElement(FatalErrorPage, {
      error: error
    }));
  }
  if (!auth.isInitialized) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Helmet, {
    titleTemplate: "%s - openIMIS",
    defaultTitle: "openIMIS"
  }), /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(ModulesManagerProvider, {
    value: modulesManager
  }, /*#__PURE__*/React.createElement(PublicPageLanguageProvider, null, /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: allMessages
  }, /*#__PURE__*/React.createElement(ToastProvider, null, /*#__PURE__*/React.createElement(AlertDialog$1, null), /*#__PURE__*/React.createElement(ConfirmDialog$1, {
    confirm: confirm,
    onConfirm: clearConfirm
  }), economicUnitConfig ? /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: ECONOMIC_UNIT_DIALOG_CONTRIBUTION_KEY,
    open: economicUnitDialogOpen,
    setEconomicUnitDialogOpen: setEconomicUnitDialogOpen,
    onLogout: onLogout
  }) : null, /*#__PURE__*/React.createElement(PublishedComponent$1, {
    pubRef: "grievanceSocialProtection.GrievanceConfigurationDialog",
    rights: rights
  }), /*#__PURE__*/React.createElement("div", {
    className: "App"
  }, auth.isAuthenticated && /*#__PURE__*/React.createElement(Contributions, {
    contributionKey: APP_BOOT_CONTRIBUTION_KEY
  }), /*#__PURE__*/React.createElement(BrowserRouter, {
    basename: basename
  }, /*#__PURE__*/React.createElement(Switch$1, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    render: function render() {
      return /*#__PURE__*/React.createElement(PublicPageMiddleware, _extends({
        isAuthenticated: auth.isAuthenticated
      }, others));
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    render: function render() {
      return /*#__PURE__*/React.createElement(LoginPage, others);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/forgot_password",
    render: function render() {
      return /*#__PURE__*/React.createElement(ForgotPasswordPage, others);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/set_password",
    render: function render() {
      return /*#__PURE__*/React.createElement(SetPasswordPage$1, others);
    }
  }), unauthenticatedRoutes.map(function (route) {
    return /*#__PURE__*/React.createElement(Route, {
      exact: true,
      key: route.path,
      path: "/" + route.path,
      render: function render(props) {
        return /*#__PURE__*/React.createElement(ErrorBoundary$1, null, /*#__PURE__*/React.createElement(route.component, _extends({
          modulesManager: modulesManager
        }, props, others)));
      }
    });
  }), routes.map(function (route) {
    return /*#__PURE__*/React.createElement(Route, {
      exact: true,
      key: route.path,
      path: "/" + route.path,
      render: function render(props) {
        return /*#__PURE__*/React.createElement(ErrorBoundary$1, null, /*#__PURE__*/React.createElement(RequireAuth$1, _extends({}, props, others, {
          redirectTo: "/login",
          onEconomicDialogOpen: function onEconomicDialogOpen() {
            return setEconomicUnitDialogOpen(true);
          },
          isSecondaryCalendar: isSecondaryCalendar,
          setSecondaryCalendar: setSecondaryCalendar
        }), /*#__PURE__*/React.createElement(PermissionCheck, _extends({
          modulesManager: modulesManager,
          userRights: rights,
          requiredRights: route.requiredRights
        }, others), /*#__PURE__*/React.createElement(route.component, _extends({
          modulesManager: modulesManager
        }, props, others)))));
      }
    });
  }), /*#__PURE__*/React.createElement(Route, {
    render: function render() {
      return /*#__PURE__*/React.createElement(NotFoundPage, others);
    }
  })))))))));
};
var mapStateToProps$8 = function mapStateToProps(state) {
  var _state$core$user$i_us, _state$core$user, _state$core$user2;
  return {
    rights: (_state$core$user$i_us = (_state$core$user = state.core.user) === null || _state$core$user === void 0 || (_state$core$user = _state$core$user.i_user) === null || _state$core$user === void 0 ? void 0 : _state$core$user.rights) !== null && _state$core$user$i_us !== void 0 ? _state$core$user$i_us : [],
    user: (_state$core$user2 = state.core.user) === null || _state$core$user2 === void 0 ? void 0 : _state$core$user2.i_user,
    error: state.core.error,
    confirm: state.core.confirm
  };
};
var mapDispatchToProps$7 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    clearConfirm: clearConfirm,
    toggleCurrentCalendarType: toggleCurrentCalendarType
  }, dispatch);
};
var App$1 = connect(mapStateToProps$8, mapDispatchToProps$7)(withTheme(withStyles(styles$o)(withModulesManager(App))));

var messages_en = {
	"core.roleManagement.label": "Roles Management",
	"core.roleManagement.searcher.results.title": "{rolesTotalCount} Roles Found",
	"core.roleManagement.roleName": "Role Name",
	"core.roleManagement.altLanguage": "Alternative Language",
	"core.roleManagement.isSystem": "System",
	"core.roleManagement.isBlocked": "Blocked",
	"core.roleManagement.showHistory": "Show Historical",
	"core.roleManagement.dateValidFrom": "Valid from",
	"core.roleManagement.dateValidTo": "Valid to",
	"core.roleManagement.emptyLabel": " ",
	"core.roleManagement.null": "Any",
	"core.roleManagement.true": "True",
	"core.roleManagement.false": "False",
	"core.roleManagement.createButton.tooltip": "Create new Role",
	"core.roleManagement.role.page.title": "Role Details {label}",
	"core.roleManagement.requiredFieldsEmptyError": "* These fields are required",
	"core.roleManagement.saveButton.tooltip.enabled": "Save changes",
	"core.roleManagement.saveButton.tooltip.disabled": "Please fill required fields first",
	"core.roleManagement.role.availableRights": "Available permissions",
	"core.roleManagement.role.addAllFilteredPerms": "Add all filtered permissions",
	"core.roleManagement.role.removeAllPerms": "Remove all filtered permissions",
	"core.roleManagement.role.chosenRights": "Chosen permissions",
	"core.roleManagement.role.rightsFilter": "Filter",
	"core.roleManagement.CreateRole.mutationLabel": "Create Role {label}",
	"core.roleManagement.DeleteRole.mutationLabel": "Delete Role {label}",
	"core.roleManagement.deleteButton.tooltip": "Delete",
	"core.roleManagement.deleteRole.confirm.title": "Are you sure you want to delete {label}?",
	"core.roleManagement.deleteRole.confirm.message": "Deleting data does not mean erasing it from openIMIS database. The data will only be deactivated from the viewed list.",
	"core.roleManagement.UpdateRole.mutationLabel": "Update Role {label}",
	"core.roleManagement.editButton.tooltip": "Edit",
	"core.roleManagement.updateRole.confirm.title": "Save changes in {label}?",
	"core.roleManagement.updateRole.confirm.message": "Are you sure you want to save changes in {label}?",
	"core.roleManagement.DuplicateRole.mutationLabel": "Duplicate Role {label}",
	"core.roleManagement.duplicateButton.tooltip": "Duplicate",
	"core.Autocomplete.loadingText": "Loading...",
	"core.Autocomplete.clearText": "Clear",
	"core.Autocomplete.openText": "Open",
	"core.Autocomplete.closeText": "Close",
	"core.Autocomplete.placeholder": "Search...",
	"core.LoginPage.username.label": "Username",
	"core.LoginPage.password.label": "Password",
	"core.LoginPage.loginBtn": "Log In",
	"core.LoginPage.authError": "The password or the username you've entered is incorrect.",
	"core.LoginPage.authErrorHealthFacilityContractInvalid": "Your contract has expired.",
	"core.LoginPage.authErrorGeneral": "Unknown error.",
	"core.LoginPage.pageTitle": "Log In",
	"core.LoginPage.forgotPassword": "Forgot Password ?",
	"core.ForgotPasswordPage.pageTitle": "Forgot Password ?",
	"core.ForgotPasswordPage.submitBtn": "Submit",
	"core.ForgotPasswordPage.username.label": "Username",
	"core.ForgotPasswordPage.recoverTitle": "Recover your account",
	"core.ForgotPasswordPage.explanationMessage": "Enter your username to be able to recover your account. En e-mail with the instructions will be sent to your e-mail address.",
	"core.ForgotPasswordPage.contactAdministrator": "If you do not receive an e-mail, please check with your administrator.",
	"core.ForgotPasswordPage.done": "Done ! Check your inbox and click on the verification link to reset your password.",
	"core.SetPasswordPage.pageTitle": "Set a new Password",
	"core.SetPasswordPage.username.label": "Username",
	"core.SetPasswordPage.password.label": "Password",
	"core.SetPasswordPage.confirmPassword.label": "Confirm Password",
	"core.SetPasswordPage.error": "Unknown error",
	"core.SetPasswordPage.submitBtn": "Submit",
	"core.SetPasswordPage.generatePassword": "Generate Password",
	"core.SetPasswordPage.clearPassword": "Clear Password",
	"core.SetPasswordPage.showPassword": "Show Passowrd",
	"core.SetPasswordPage.hidePassword": "Show Passowrd",
	"core.table.resultsLoading": "Loading...",
	"core.exportSearchResult": "Export search result",
	"core.exportSearchResult.tooltip": "Export result",
	"LanguagePicker.label": "Language",
	"core.Language.null": "",
	"core.NumberInput.notApplicable": "N/A",
	"core.UserActivityReport.dateFrom": "From",
	"core.UserActivityReport.dateTo": "To",
	"core.UserActivityReport.action": "Action",
	"core.UserActivityReport.action.null": "All actions",
	"core.UserActivityReport.action.I": "Insert",
	"core.UserActivityReport.action.U": "Update",
	"core.UserActivityReport.action.D": "Delete",
	"core.UserActivityReport.entity": "Entity",
	"core.UserActivityReport.entity.null": "All entities",
	"core.UserActivityReport.entity.Claim": "Claim",
	"core.UserActivityReport.entity.BatchRun": "Batch Run",
	"core.UserActivityReport.entity.ClaimAdmin": "Claim Admin",
	"core.UserActivityReport.entity.Location": "Location",
	"core.UserActivityReport.entity.Extract": "Extract",
	"core.UserActivityReport.entity.Family": "Family",
	"core.UserActivityReport.entity.Feedback": "Feedback",
	"core.UserActivityReport.entity.HealthFacility": "Health Facility",
	"core.UserActivityReport.entity.Insuree": "Insuree",
	"core.UserActivityReport.entity.Item": "Item",
	"core.UserActivityReport.entity.Officer": "Officer",
	"core.UserActivityReport.entity.Payer": "Payer",
	"core.UserActivityReport.entity.InsureePhoto": "Insuree Photo",
	"core.UserActivityReport.entity.ItemsPricelist": "Items Pricelist",
	"core.UserActivityReport.entity.ServicesPricelist": "Services Pricelist",
	"core.UserActivityReport.entity.ItemsPricelistDetail": "Items Pricelist Detail",
	"core.UserActivityReport.entity.ServicesPricelistDetail": "Services Pricelist Detail",
	"core.UserActivityReport.entity.Policy": "Policy",
	"core.UserActivityReport.entity.Premium": "Premium",
	"core.UserActivityReport.entity.Product": "Product",
	"core.UserActivityReport.entity.ProductItem": "Product Item",
	"core.UserActivityReport.entity.ProductService": "Product Service",
	"core.UserActivityReport.entity.RelativeDistribution": "Relative Distribution",
	"core.UserActivityReport.entity.Service": "Service",
	"core.UserActivityReport.entity.InteractiveUser": "User",
	"core.UserActivityReport.entity.UserDistrict": "User District",
	"core.UserActivityReport.user": "User",
	"core.UserActivityReport.user.null": "All users",
	"core.advancedFilters": "Advanced Filters",
	"core.advancedFilters.field": "Field",
	"core.advancedFilters.filter": "Filter",
	"core.advancedFilters.value": "Value",
	"core.advancedFilters.button.AdvancedFilters": "Advanced Filters",
	"core.advancedFilters.button.addFilters": "Add filter",
	"core.advancedFilters.button.clearAllFilters": "Clear All Filters",
	"core.advancedFilters.button.cancel": "Cancel",
	"core.advancedFilters.button.filter": "Filter",
	"core.advancedFilters.exact": "Exact",
	"core.advancedFilters.iexact": "Exact",
	"core.advancedFilters.istartswith": "Starts with",
	"core.advancedFilters.icontains": "Contains",
	"core.advancedFilters.lt": "Less than",
	"core.advancedFilters.lte": "Less than or equal to",
	"core.advancedFilters.gt": "Greater than",
	"core.advancedFilters.gte": "Greater than or equal to",
	"core.advancedFilters.email": "Email",
	"core.advancedFilters.able_bodied": "Able bodied",
	"core.advancedFilters.national_id": "National ID",
	"core.advancedFilters.educated_level": "Educated level",
	"core.advancedFilters.chronic_illness": "Chronic illness",
	"core.advancedFilters.national_id_type": "National ID type",
	"core.advancedFilters.number_of_elderly": "Number of elderly",
	"core.advancedFilters.number_of_children": "Number of children",
	"core.advancedFilters.beneficiary_data_source": " Beneficiary data source",
	"core.RegistersStatusReport.region": "Region",
	"core.RegistersStatusReport.district": "District",
	"core.Table.ordinalNumberHeader": "Number",
	"core.calendarSwitcher": "BS/AD",
	"core.calendar.clearButton": "Clear date",
	"core.calendar.okButton": "Accept",
	"core.calendar.cancelButton": "Cancel",
	"core.exportConfigDialog.confirmButton": "Ok",
	"core.exportConfigDialog.cancelButton": "Cancel",
	"core.exportConfigDialog.clearAllColsButton": "Unselect all columns",
	"core.exportConfigDialog.title": "Export configuration",
	"core.exportConfigDialog.selectColumns": "Select columns you want to export: ",
	"core.exportConfigDialog.selectFormat": "Select file format:",
	"core.NotFoundPage.title": "Page not found",
	"core.NotFoundPage.description": "The requested URL was not found on this server.",
	"core.ErrorPage.back": "Move back to the home page",
	"core.ForbiddenPage.title": "Access Denied",
	"core.ForbiddenPage.description": "Sorry, you are not authorized to access this page.",
	"core.InternalServerErrorPage.title": "Internal Server Error",
	"core.InternalServerErrorPage.description": "The server encountered an internal error or misconfiguration and was unable to complete your request.",
	"core.tooltip.logout": "Log out",
	"core.tooltip.help": "Documentation",
	"core.NeDateFormatter.dateOutOfRange": "DATE_OUT_OF_RANGE",
	"core.AuthorityPicker.label": "Authority",
	"core.AuthorityPicker.placeholder": "Search...",
	"core.FatalError.RateLimitExceeded.description": "You have exceeded the number of allowed requests. Please try again later.",
	"core.FatalError.RateLimitExceeded.title": "Rate Limit Exceeded",
	"core.FatalError.GenericError.description": "Error",
	"core.FatalError.GenericError.title": "An unexpected error occurred",
	"core.LanguageQuickPicker.dialog.title": "Confirm Language",
	"core.LanguageQuickPicker.dialog.message": "You are about to change the language to {language}. Do you want to proceed?",
	"core.LanguageQuickPicker.dialog.confirm": "Confirm",
	"core.LanguageQuickPicker.dialog.cancel": "Cancel",
	"core.LoginPage.backButton": "Back",
	"core.LoginPage.loginCaption": "Authentication by",
	"core.LoginPage.howToUse": "User guide",
	"core.InfoButton.tooltip": "More Information",
	"core.Table.nextPage": "Next page",
	"core.Table.previousPage": "Previous page",
	"core.gql_query_users_perms": "Core | Query Users",
	"core.gql_mutation_create_users_perms": "Core | Mutation Create Users",
	"core.gql_mutation_update_users_perms": "Core | Mutation Update Users",
	"core.gql_mutation_delete_users_perms": "Core | Mutation Delete Users",
	"core.gql_query_roles_perms": "Core | Query Roles",
	"core.gql_mutation_create_roles_perms": "Core | Mutation Create Roles",
	"core.gql_mutation_update_roles_perms": "Core | Mutation Update Roles",
	"core.gql_mutation_replace_roles_perms": "Core | Mutation Replace Roles",
	"core.gql_mutation_duplicate_roles_perms": "Core | Mutation Duplicate Roles",
	"core.gql_mutation_delete_roles_perms": "Core | Mutation Delete Roles",
	"core.gql_query_enrolment_officers_perms": "Core | Query Enrolment Officers",
	"core.gql_mutation_create_enrolment_officers_perms": "Core | Mutation Create Enrolment Officers",
	"core.gql_mutation_update_enrolment_officers_perms": "Core | Mutation Update Enrolment Officers",
	"core.gql_mutation_delete_enrolment_officers_perms": "Core | Mutation Delete Enrolment Officers",
	"core.gql_query_claim_administrator_perms": "Core | Query Claim Administrator",
	"core.gql_mutation_create_claim_administrator_perms": "Core | Mutation Create Claim Administrator",
	"core.gql_mutation_update_claim_administrator_perms": "Core | Mutation Update Claim Administrator",
	"core.gql_mutation_delete_claim_administrator_perms": "Core | Mutation Delete Claim Administrator",
	"core.gql_query_enable_viewing_masked_data_perms": "Core | Query Enable Viewing Masked Data",
	"report.gql_query_report_perms": "Report | Query Report",
	"report.gql_reports_primary_operational_indicator_policies_perms": "Report | Primary Operational Indicator Policies",
	"report.gql_reports_primary_operational_indicators_claims_perms": "Report | Primary Operational Indicators Claims",
	"report.gql_reports_derived_operational_indicators_perms": "Report | Derived Operational Indicators",
	"report.gql_reports_contribution_collection_perms": "Report | Contribution Collection",
	"report.gql_reports_product_sales_perms": "Report | Product Sales",
	"report.gql_reports_contribution_distribution_perms": "Report | Contribution Distribution",
	"report.gql_reports_user_activity_perms": "Report | User Activity",
	"report.gql_reports_enrolment_performance_indicators_perms": "Report | Enrolment Performance Indicators",
	"report.gql_reports_status_of_register_perms": "Report | Status Of Register",
	"report.gql_reports_insuree_without_photos_perms": "Report | Insuree Without Photos",
	"report.gql_reports_payment_category_overview_perms": "Report | Payment Category Overview",
	"report.gql_reports_matching_funds_perms": "Report | Matching Funds",
	"report.gql_reports_claim_overview_report_perms": "Report | Claim Overview Report",
	"report.gql_reports_percentage_referrals_perms": "Report | Percentage Referrals",
	"report.gql_reports_families_insurees_overview_perms": "Report | Families Insurees Overview",
	"report.gql_reports_pending_insurees_perms": "Report | Pending Insurees",
	"report.gql_reports_renewals_perms": "Report | Renewals",
	"report.gql_reports_capitation_payment_perms": "Report | Capitation Payment",
	"report.gql_reports_rejected_photo_perms": "Report | Rejected Photo",
	"report.gql_reports_contribution_payment_perms": "Report | Contribution Payment",
	"report.gql_reports_control_number_assignment_perms": "Report | Control Number Assignment",
	"report.gql_reports_overview_of_commissions_perms": "Report | Overview Of Commissions",
	"report.gql_reports_claim_history_report_perms": "Report | Claim History Report",
	"report.gql_mutation_report_add_perms": "Report | Mutation Report Add",
	"report.gql_mutation_report_edit_perms": "Report | Mutation Report Edit",
	"report.gql_mutation_report_delete_perms": "Report | Mutation Report Delete",
	"api_fhir_r4.R4_fhir_subscription_config_fhir_sub_search_perms": "Api Fhir R4 | Subscription Config Fhir Sub Search",
	"api_fhir_r4.R4_fhir_subscription_config_fhir_sub_create_perms": "Api Fhir R4 | Subscription Config Fhir Sub Create",
	"api_fhir_r4.R4_fhir_subscription_config_fhir_sub_update_perms": "Api Fhir R4 | Subscription Config Fhir Sub Update",
	"api_fhir_r4.R4_fhir_subscription_config_fhir_sub_delete_perms": "Api Fhir R4 | Subscription Config Fhir Sub Delete",
	"api_etl.gql_query_api_etl_rule_perms": "Api Etl | Query Api Etl Rule",
	"api_etl.gql_mutation_execute_api_etl_rule_perms": "Api Etl | Mutation Execute Api Etl Rule"
};

function _callSuper$t(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$t() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$t() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$t = function _isNativeReflectConstruct() { return !!t; })(); }
var KeepLegacyAlive = /*#__PURE__*/function (_Component) {
  function KeepLegacyAlive() {
    var _this;
    _classCallCheck(this, KeepLegacyAlive);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$t(this, KeepLegacyAlive, [].concat(args));
    _defineProperty(_this, "keepLegacyAlive", function () {
      fetch("".concat(window.location.origin, "/keepLegacyAlive"));
    });
    return _this;
  }
  _inherits(KeepLegacyAlive, _Component);
  return _createClass(KeepLegacyAlive, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setState(function (state, props) {
        return {
          timeoutId: setInterval(_this2.keepLegacyAlive, props.modulesManager.getRef("core.KeepLegacyAlive.pollInterval"))
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!!this.state && !!this.state.timeoutId) {
        clearTimeout(this.state.timeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(Component);
var KeepLegacyAlive$1 = withModulesManager(KeepLegacyAlive);

function _callSuper$s(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$s() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$s() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$s = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$n = function styles(theme) {
  return {
    label: {
      color: theme.palette.primary.main
    },
    formControl: {
      position: "relative"
    },
    iconButton: {
      position: "absolute",
      right: 0,
      padding: "8px"
    }
  };
};
function EmptyComponent() {
  return /*#__PURE__*/React.createElement("div", null);
}
var SelectInput = /*#__PURE__*/function (_Component) {
  function SelectInput() {
    var _this;
    _classCallCheck(this, SelectInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$s(this, SelectInput, [].concat(args));
    _defineProperty(_this, "_onChange", function (e) {
      if (_this.props.value !== e.target.value) {
        _this.props.onChange(JSON.parse(e.target.value));
      }
    });
    _defineProperty(_this, "handleClear", function () {
      _this.props.onChange("");
    });
    // When there is a value, we pass a dummy div to effectively hide the default dropdown icon.
    // This allows us to make room for the clear icon without having two icons visible at the same time.
    _defineProperty(_this, "renderIconComponent", function () {
      var value = _this.props.value;
      return value ? EmptyComponent : undefined;
    });
    // If there's a value, we render the clear icon. Clicking it calls handleClear, which resets the Select's value.
    _defineProperty(_this, "renderEndAdornment", function () {
      var _this$props = _this.props,
        value = _this$props.value,
        classes = _this$props.classes;
      return value ? /*#__PURE__*/React.createElement(IconButton, {
        onClick: _this.handleClear,
        className: classes.iconButton
      }, /*#__PURE__*/React.createElement(ClearIcon, null)) : undefined;
    });
    return _this;
  }
  _inherits(SelectInput, _Component);
  return _createClass(SelectInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        module = _this$props2.module,
        label = _this$props2.label,
        _this$props2$strLabel = _this$props2.strLabel,
        strLabel = _this$props2$strLabel === void 0 ? null : _this$props2$strLabel,
        _this$props2$withLabe = _this$props2.withLabel,
        withLabel = _this$props2$withLabe === void 0 ? true : _this$props2$withLabe,
        name = _this$props2.name,
        options = _this$props2.options,
        value = _this$props2.value,
        _this$props2$disabled = _this$props2.disabled,
        disabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled,
        _this$props2$readOnly = _this$props2.readOnly,
        readOnly = _this$props2$readOnly === void 0 ? false : _this$props2$readOnly,
        _this$props2$required = _this$props2.required,
        required = _this$props2$required === void 0 ? false : _this$props2$required,
        placeholder = _this$props2.placeholder,
        _this$props2$title = _this$props2.title,
        title = _this$props2$title === void 0 ? '' : _this$props2$title;
      if (!options) return null;
      var valueStr = null;
      if (!!readOnly) {
        valueStr = options.filter(function (o) {
          return JSON.stringify(o.value) === JSON.stringify(value);
        }).map(function (o) {
          return o.label;
        });
      }
      return /*#__PURE__*/React.createElement(Fragment, null, !readOnly && /*#__PURE__*/React.createElement(FormControl, {
        required: required,
        fullWidth: true,
        className: classes.formControl
      }, /*#__PURE__*/React.createElement(InputLabel, {
        shrink: true,
        className: classes.label
      }, strLabel !== null && strLabel !== void 0 ? strLabel : /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: label
      })), /*#__PURE__*/React.createElement(Select, _extends({
        readOnly: readOnly,
        inputProps: {
          name: name,
          id: "".concat(uuid.uuid(), "-input"),
          title: title
        },
        value: !!value ? JSON.stringify(value) : null,
        onChange: this._onChange,
        IconComponent: this.renderIconComponent(),
        disabled: disabled,
        endAdornment: this.renderEndAdornment(),
        displayEmpty: true
        //NOTE: We want to get rid of default styling (marginTop) if label is not rendered
      }, withLabel ? null : {
        style: {
          marginTop: "0px"
        }
      }), placeholder && /*#__PURE__*/React.createElement(MenuItem, {
        disabled: true,
        value: ""
      }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: placeholder
      })), options.map(function (option, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: "".concat(module, "-").concat(name, "-option-").concat(idx),
          value: JSON.stringify(option.value)
        }, option.label);
      }))), !!readOnly && /*#__PURE__*/React.createElement(TextInput$1
      //NOTE: We want to get rid of default styling (marginTop) if label is not rendered
      , _extends({}, withLabel ? {
        label: label
      } : null, {
        fullWidth: true,
        module: module,
        value: valueStr,
        readOnly: true,
        title: title
      })));
    }
  }]);
}(Component);
var SelectInput$1 = injectIntl(withTheme(withStyles(styles$n)(SelectInput)));

function _callSuper$r(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$r() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$r() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$r = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$m = function styles(theme) {
  return {
    paper: {
      margin: theme.spacing(1),
      marginLeft: 0
    },
    header: theme.table.title,
    label: {
      color: theme.palette.primary.main
    },
    textField: {
      width: "100%"
    },
    suggestionContainer: {
      flexGrow: 1,
      position: "relative"
    },
    suggestionInputField: {
      margin: 0,
      border: 0
    },
    suggestionsContainerOpen: {
      position: "absolute",
      top: 42,
      padding: 0,
      margin: 0,
      width: "100%",
      backgroundColor: theme.palette.text.second,
      border: "solid 1px grey",
      zIndex: theme.zIndex.modal
    },
    suggestion: {
      display: "block",
      cursor: "pointer",
      padding: "10px 20px"
    },
    suggestionsList: {
      listStyleType: "none",
      margin: 0,
      padding: 0
    },
    suggestionHighlighted: {
      color: theme.palette.text.second,
      backgroundColor: theme.palette.text.primary
    }
  };
};
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var INIT_STATE$1 = {
  value: "",
  suggestions: [],
  selected: null
};
var MORE = "__THE_MORE_FAKE_OPTION__";
var AutoSuggestion = /*#__PURE__*/function (_Component) {
  function AutoSuggestion(_props) {
    var _this;
    _classCallCheck(this, AutoSuggestion);
    _this = _callSuper$r(this, AutoSuggestion, [_props]);
    _defineProperty(_this, "state", INIT_STATE$1);
    _defineProperty(_this, "_allItems", function () {
      var _this$props = _this.props,
        preValues = _this$props.preValues,
        items = _this$props.items;
      return [].concat(_toConsumableArray(preValues !== null && preValues !== void 0 ? preValues : []), _toConsumableArray(items !== null && items !== void 0 ? items : []));
    });
    _defineProperty(_this, "onClear", function (e) {
      _this.setState({
        value: null,
        selected: null
      }, function (e) {
        return !!_this.props.onClear ? _this.props.onClear() : _this.props.onSuggestionSelected(null);
      });
    });
    _defineProperty(_this, "_onAutoselectChange", function (event, _ref) {
      var newValue = _ref.newValue;
        _ref.method;
      _this.setState({
        value: newValue
      });
    });
    _defineProperty(_this, "onSuggestionsFetchRequested", function (_ref2) {
      var value = _ref2.value;
      if (!!_this.props.getSuggestions) {
        _this.props.getSuggestions(value);
      } else {
        _this.setState({
          suggestions: _this._getSuggestions(value)
        });
      }
    });
    _defineProperty(_this, "onSuggestionsClearRequested", function () {
      _this.setState({
        suggestions: _this._truncate(_this._allItems())
      });
    });
    _defineProperty(_this, "_truncate", function (suggestions) {
      if (_this.limitDisplay > 0 && suggestions.length > _this.limitDisplay) {
        suggestions = suggestions.slice(0, _this.limitDisplay);
        suggestions.push(MORE);
      }
      return suggestions;
    });
    _defineProperty(_this, "_getSuggestions", function (value) {
      if (!value || !value.trim()) {
        return _this._truncate(_this._allItems());
      }
      var escapedValue = escapeRegexCharacters(value.trim());
      if (escapedValue === "") {
        return [];
      }
      var regex = new RegExp(escapedValue, "i");
      var lookup = _this.props.lookup;
      if (!lookup) {
        lookup = function lookup(i) {
          return _this.props.getSuggestionValue(i);
        };
      }
      return _this._truncate(_this._allItems().filter(function (i) {
        return regex.test(lookup(i));
      }));
    });
    _defineProperty(_this, "renderInputComponent", function (inputProps) {
      var classes = _this.props.classes;
      return /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true
      }, /*#__PURE__*/React.createElement(TextField, _extends({
        InputLabelProps: {
          className: classes.label
        }
      }, inputProps, {
        InputProps: {
          startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, /*#__PURE__*/React.createElement(SearchIcon, null)),
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement(IconButton, {
            onClick: _this.onClear
          }, /*#__PURE__*/React.createElement(ClearIcon, null)))
        }
      })));
    });
    _defineProperty(_this, "_shouldRenderSuggestions", function () {
      return _this.state.value !== _this.state.selected;
    });
    _defineProperty(_this, "_onSuggestionSelected", function (e, i) {
      _this.setState(function (state, props) {
        return {
          selected: props.getSuggestionValue(i.suggestion)
        };
      }, function (e) {
        return _this.props.onSuggestionSelected(i.suggestion);
      });
    });
    _defineProperty(_this, "_onOptionSelected", function (selected) {
      _this.setState({
        selected: selected
      }, function (e) {
        return _this.props.onSuggestionSelected(selected);
      });
    });
    _defineProperty(_this, "_render", function (s) {
      var styleCover = {
        marginTop: "-10px",
        marginBottom: "-10px",
        marginLeft: "-20px",
        marginRight: "-20px"
      };
      var styleRevert = {
        marginTop: "10px",
        marginBottom: "10px",
        marginLeft: "20px",
        marginRight: "20px"
      };
      if (s === MORE) {
        return /*#__PURE__*/React.createElement("div", {
          style: styleCover,
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, /*#__PURE__*/React.createElement("span", {
          style: styleRevert,
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, _this.props.intl.formatMessage({
          id: "autosuggest.more"
        })));
      }
      var render = _this.props.renderSuggestion;
      if (!render) {
        render = function render(s) {
          return /*#__PURE__*/React.createElement("span", null, _this.props.getSuggestionValue(s));
        };
      }
      return render(s);
    });
    _defineProperty(_this, "renderSelect", function () {
      var _this$props2 = _this.props,
        module = _this$props2.module,
        withNull = _this$props2.withNull,
        nullLabel = _this$props2.nullLabel,
        label = _this$props2.label,
        _this$props2$required = _this$props2.required,
        required = _this$props2$required === void 0 ? false : _this$props2$required,
        getSuggestionValue = _this$props2.getSuggestionValue,
        title = _this$props2.title;
      var _this$state = _this.state,
        suggestions = _this$state.suggestions,
        selected = _this$state.selected;
      var options = suggestions.map(function (r) {
        return {
          value: r,
          label: getSuggestionValue(r)
        };
      });
      if (withNull) {
        options.unshift({
          value: null,
          label: nullLabel
        });
      }
      return /*#__PURE__*/React.createElement(SelectInput$1, {
        module: module,
        strLabel: label,
        options: options,
        value: selected,
        onChange: _this._onOptionSelected,
        required: required,
        title: title
      });
    });
    _defineProperty(_this, "renderAutoselect", function () {
      var _this$props3 = _this.props,
        classes = _this$props3.classes,
        label = _this$props3.label,
        _this$props3$disabled = _this$props3.disabled,
        disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled,
        _this$props3$required = _this$props3.required,
        required = _this$props3$required === void 0 ? false : _this$props3$required,
        placeholder = _this$props3.placeholder,
        getSuggestionValue = _this$props3.getSuggestionValue,
        _this$props3$title = _this$props3.title,
        title = _this$props3$title === void 0 ? '' : _this$props3$title;
      var _this$state2 = _this.state,
        suggestions = _this$state2.suggestions,
        value = _this$state2.value;
      var inputProps = {
        className: classes.suggestionInputField,
        placeholder: placeholder,
        // Value has to be a string
        value: value !== null && value !== void 0 ? value : "",
        label: label,
        disabled: disabled,
        onChange: _this._onAutoselectChange,
        required: required,
        title: title
      };
      return /*#__PURE__*/React.createElement(Autosuggest, {
        theme: {
          container: classes.suggestionContainer,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
          suggestionHighlighted: classes.suggestionHighlighted
        },
        renderInputComponent: _this.renderInputComponent,
        inputProps: inputProps,
        suggestions: suggestions,
        onSuggestionSelected: _this._onSuggestionSelected,
        onSuggestionsFetchRequested: _this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: _this.onSuggestionsClearRequested,
        getSuggestionValue: getSuggestionValue,
        renderSuggestion: _this._render,
        shouldRenderSuggestions: _this._shouldRenderSuggestions
      });
    });
    _this.limitDisplay = _props.modulesManager.getConf("fe-core", "AutoSuggestion.limitDisplay", 100);
    return _this;
  }
  _inherits(AutoSuggestion, _Component);
  return _createClass(AutoSuggestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!!this.props.value) {
        this.setState(function (state, props) {
          return {
            value: props.getSuggestionValue(props.value),
            selected: props.getSuggestionValue(props.value),
            suggestions: _this2._truncate(_this2._allItems())
          };
        });
      }
      if (!!this.props.items) {
        this.setState({
          suggestions: this._truncate(this._allItems())
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;
      if (prevProps.reset !== this.props.reset) {
        this.setState(function (state, props) {
          return {
            suggestions: _this3._truncate(_this3._allItems()),
            value: props.value ? props.getSuggestionValue(props.value) : null,
            selected: props.value ? props.getSuggestionValue(props.value) : null
          };
        });
      } else {
        if (!_$1.isEqual(prevProps.value, this.props.value)) {
          this.setState(function (state, props) {
            return {
              suggestions: _this3._truncate(_this3._allItems()),
              value: props.value ? props.getSuggestionValue(props.value) : null,
              selected: props.value ? props.getSuggestionValue(props.value) : null
            };
          });
        } else if (!_$1.isEqual(prevProps.items, this.props.items)) {
          this.setState({
            suggestions: this._truncate(this._allItems())
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        label = _this$props4.label,
        _this$props4$readOnly = _this$props4.readOnly,
        readOnly = _this$props4$readOnly === void 0 ? false : _this$props4$readOnly,
        _this$props4$selectTh = _this$props4.selectThreshold,
        selectThreshold = _this$props4$selectTh === void 0 ? null : _this$props4$selectTh,
        _this$props4$title = _this$props4.title,
        title = _this$props4$title === void 0 ? '' : _this$props4$title;
      var _this$state3 = this.state,
        value = _this$state3.value,
        suggestions = _this$state3.suggestions;
      if (!!readOnly) {
        return /*#__PURE__*/React.createElement(TextField, {
          label: label,
          className: classes.textField,
          disabled: true,
          value: value,
          title: title
        });
      }
      if (!value && !!selectThreshold && !!suggestions && suggestions.length > 0 && suggestions.length < selectThreshold) {
        return this.renderSelect();
      } else {
        return this.renderAutoselect();
      }
    }
  }]);
}(Component);
var AutoSuggestion$1 = injectIntl(withModulesManager(withTheme(withStyles(styles$m)(AutoSuggestion))));

var _excluded$7 = ["onChange", "readOnly", "required", "withLabel", "withPlaceholder", "autoHighlight", "value", "className", "minWidth", "fullWidth", "options", "isLoading", "label", "filterOptions", "getOptionLabel", "getOptionSelected", "filterSelectedOptions", "placeholder", "onInputChange", "setCurrentString", "multiple", "renderInput", "noOptionsText", "limitTags"];
var styles$l = function styles(theme) {
  return {
    label: {
      color: theme.palette.primary.main
    }
  };
};
var defaultGetOptionSelected = function defaultGetOptionSelected(option, v) {
  return option.id === (v === null || v === void 0 ? void 0 : v.id);
};
var Autocomplete = function Autocomplete(props) {
  var onChange = props.onChange,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$withLabel = props.withLabel,
    withLabel = _props$withLabel === void 0 ? true : _props$withLabel,
    _props$withPlaceholde = props.withPlaceholder,
    withPlaceholder = _props$withPlaceholde === void 0 ? true : _props$withPlaceholde,
    _props$autoHighlight = props.autoHighlight,
    autoHighlight = _props$autoHighlight === void 0 ? true : _props$autoHighlight,
    value = props.value,
    className = props.className,
    minWidth = props.minWidth,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth,
    options = props.options,
    isLoading = props.isLoading,
    label = props.label,
    filterOptions = props.filterOptions,
    getOptionLabel = props.getOptionLabel,
    _props$getOptionSelec = props.getOptionSelected,
    getOptionSelected = _props$getOptionSelec === void 0 ? defaultGetOptionSelected : _props$getOptionSelec,
    filterSelectedOptions = props.filterSelectedOptions,
    placeholder = props.placeholder,
    onInputChange = props.onInputChange,
    setCurrentString = props.setCurrentString,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    renderInput = props.renderInput,
    noOptionsText = props.noOptionsText,
    limitTags = props.limitTags,
    otherProps = _objectWithoutProperties(props, _excluded$7);
  var modulesManager = useModulesManager();
  var minCharLookup = modulesManager.getConf("fe-admin", "usersMinCharLookup", 2);
  var _useTranslations = useTranslations("core.Autocomplete", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(Date.now()),
    _useState4 = _slicedToArray(_useState3, 2),
    resetKey = _useState4[0],
    setResetKey = _useState4[1];
  var handleInputChange = useDebounceCb(function (searchString) {
    setCurrentString && setCurrentString(searchString);
    if (open && (!searchString || searchString.length > minCharLookup)) {
      onInputChange(searchString);
    }
  }, modulesManager.getConf("fe-admin", "debounceTime", 400));

  // eslint-disable-next-line no-shadow
  var handleChange = function handleChange(__, value) {
    onChange(value);
  };
  useEffect(function () {
    if (open) {
      onInputChange();
    }
  }, [open]);
  useEffect(function () {
    setResetKey(Date.now());
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete$2, _extends({
    key: resetKey,
    fullWidth: fullWidth,
    noOptionsText: noOptionsText,
    className: className,
    style: {
      minWidth: minWidth
    },
    loadingText: formatMessage("loadingText"),
    openText: formatMessage("openText"),
    closeText: formatMessage("closeText"),
    clearText: formatMessage("clearText"),
    openOnFocus: true,
    blurOnSelect: !multiple,
    multiple: multiple,
    disabled: readOnly,
    options: options,
    loading: isLoading,
    autoHighlight: autoHighlight,
    open: open,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    limitTags: limitTags ? limitTags : Infinity,
    autoComplete: true,
    value: value,
    getOptionLabel: getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : function (option) {
      return option.label;
    },
    getOptionSelected: getOptionSelected,
    onChange: handleChange,
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: function onInputChange(__, query) {
      return handleInputChange(query);
    }
  }, otherProps, {
    renderInput: !!renderInput ? renderInput : function (inputProps) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
        variant: "standard",
        required: required,
        InputLabelProps: {
          shrink: value !== undefined
        },
        label: withLabel && (label || formatMessage("label")),
        placeholder: !readOnly && withPlaceholder && (placeholder || formatMessage("placeholder"))
      }));
    }
  }));
};
var Autocomplete$1 = withTheme(withStyles(styles$l)(Autocomplete));

function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useBlockStyles = makeStyles$1(function (theme) {
  return {
    block: _objectSpread$g(_objectSpread$g({}, theme.paper.paper), {}, {
      margin: 0
    }),
    header: _objectSpread$g(_objectSpread$g({}, theme.paper.header), theme.paper.title)
  };
});
var Block = function Block(props) {
  var title = props.title,
    className = props.className,
    _props$titleVariant = props.titleVariant,
    titleVariant = _props$titleVariant === void 0 ? "h5" : _props$titleVariant,
    children = props.children;
  var classes = useBlockStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    className: clsx(classes.block, className)
  }, title && /*#__PURE__*/React.createElement(Box, {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: titleVariant
  }, title)), /*#__PURE__*/React.createElement(Box, {
    overflow: "auto"
  }, /*#__PURE__*/React.createElement(Box, {
    m: "10px"
  }, children)));
};

function _callSuper$q(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$q() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$q() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$q = function _isNativeReflectConstruct() { return !!t; })(); }
var ControlledField = /*#__PURE__*/function (_Component) {
  function ControlledField() {
    _classCallCheck(this, ControlledField);
    return _callSuper$q(this, ControlledField, arguments);
  }
  _inherits(ControlledField, _Component);
  return _createClass(ControlledField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        modulesManager = _this$props.modulesManager,
        module = _this$props.module,
        id = _this$props.id,
        field = _this$props.field;
      if (modulesManager.hideField(module, id)) {
        return null;
      }
      return field;
    }
  }]);
}(Component);
var ControlledField$1 = withModulesManager(ControlledField);

var styles$k = function styles(theme) {
  return {
    error: {
      padding: theme.spacing(2)
    },
    errorHeader: {
      color: theme.palette.error.main
    },
    errorDetail: {
      color: theme.palette.error.main
    }
  };
};
function Error$1(props) {
  var classes = props.classes,
    error = props.error;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "h6",
    className: classes.errorHeader
  }, error.code, " ", error.code && ": ", " ", error.message), !!error.detail && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body1",
    className: classes.errorDetail
  }, error.detail)));
}
var Error$2 = withStyles$1(styles$k)(Error$1);

function _callSuper$p(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$p() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$p() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$p = function _isNativeReflectConstruct() { return !!t; })(); }
var AlertForwarder = /*#__PURE__*/function (_Component) {
  function AlertForwarder() {
    _classCallCheck(this, AlertForwarder);
    return _callSuper$p(this, AlertForwarder, arguments);
  }
  _inherits(AlertForwarder, _Component);
  return _createClass(AlertForwarder, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.alert !== this.props.alert && !!this.props.alert) {
        this.props.coreAlert(formatMessage(this.props.intl, "core", "FatalError.title"), formatMessage(this.props.intl, "core", "FatalError.message"), this.props.alert);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(Component);
var mapDispatchToProps$6 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    coreAlert: coreAlert
  }, dispatch);
};
var AlertForwarder$1 = injectIntl(connect(null, mapDispatchToProps$6)(AlertForwarder));

function _callSuper$o(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$o() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$o() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$o = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$j = function styles(theme) {
  return {
    label: theme.typography.label
  };
};
var FieldLabel = /*#__PURE__*/function (_Component) {
  function FieldLabel() {
    _classCallCheck(this, FieldLabel);
    return _callSuper$o(this, FieldLabel, arguments);
  }
  _inherits(FieldLabel, _Component);
  return _createClass(FieldLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        module = _this$props.module,
        id = _this$props.id;
      return /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.label,
        variant: "caption"
      }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: id
      }));
    }
  }]);
}(Component);
var FieldLabel$1 = injectIntl(withTheme(withStyles(styles$j)(FieldLabel)));

var _excluded$6 = ["classes", "module", "back", "add", "addTooltip", "openDirty", "save", "canSave", "saveTooltip", "actions", "fab", "fabAction", "fabTooltip", "title", "titleParams", "HeadPanel", "headPanelContributionsKey", "Panels", "contributedPanelsKey", "additionalTooltips", "enableActionButtons"];
function _callSuper$n(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$n() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$n() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$n = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$i = function styles(theme) {
  return {
    paper: theme.paper.paper,
    paperHeader: theme.paper.header,
    paperHeaderAction: theme.paper.action,
    tooltipContainer: theme.tooltipContainer,
    flexTooltip: theme.flexTooltip
  };
};
var Form = /*#__PURE__*/function (_Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$n(this, Form, [].concat(args));
    _defineProperty(_this, "state", {
      dirty: false,
      saving: false
    });
    _defineProperty(_this, "onEditedChanged", function (data) {
      _this.setState({
        dirty: true
      }, function (e) {
        return _this.props.onEditedChanged(data);
      });
    });
    _defineProperty(_this, "save", function (data) {
      _this.setState({
        saving: true
      }, _this.props.save(data));
    });
    return _this;
  }
  _inherits(Form, _Component);
  return _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!!this.props.forcedDirty) {
        this.setState(function (state, props) {
          return {
            dirty: true
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.reset !== this.props.reset || prevProps.edited_id !== this.props.edited_id) {
        this.setState({
          dirty: false,
          saving: false
        });
      } else if (!this.state.dirty && !!this.props.forcedDirty) {
        this.setState({
          dirty: true
        });
      } else if (prevProps.update !== this.props.update) {
        this.setState({
          saving: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        module = _this$props.module,
        back = _this$props.back,
        add = _this$props.add,
        addTooltip = _this$props.addTooltip,
        _this$props$openDirty = _this$props.openDirty,
        openDirty = _this$props$openDirty === void 0 ? false : _this$props$openDirty,
        save = _this$props.save,
        canSave = _this$props.canSave,
        saveTooltip = _this$props.saveTooltip,
        _this$props$actions = _this$props.actions,
        actions = _this$props$actions === void 0 ? [] : _this$props$actions,
        _this$props$fab = _this$props.fab,
        fab = _this$props$fab === void 0 ? null : _this$props$fab,
        _this$props$fabAction = _this$props.fabAction,
        fabAction = _this$props$fabAction === void 0 ? null : _this$props$fabAction,
        _this$props$fabToolti = _this$props.fabTooltip,
        fabTooltip = _this$props$fabToolti === void 0 ? null : _this$props$fabToolti,
        title = _this$props.title,
        _this$props$titlePara = _this$props.titleParams,
        titleParams = _this$props$titlePara === void 0 ? [] : _this$props$titlePara,
        HeadPanel = _this$props.HeadPanel,
        headPanelContributionsKey = _this$props.headPanelContributionsKey,
        Panels = _this$props.Panels,
        _this$props$contribut = _this$props.contributedPanelsKey,
        contributedPanelsKey = _this$props$contribut === void 0 ? null : _this$props$contribut,
        _this$props$additiona = _this$props.additionalTooltips,
        additionalTooltips = _this$props$additiona === void 0 ? null : _this$props$additiona,
        _this$props$enableAct = _this$props.enableActionButtons,
        enableActionButtons = _this$props$enableAct === void 0 ? false : _this$props$enableAct,
        others = _objectWithoutProperties(_this$props, _excluded$6);
      var defaultTooltips = [{
        condition: !this.state.dirty && !!add && !save,
        content: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Fab, {
          color: "primary",
          onClick: add
        }, /*#__PURE__*/React.createElement(AddIcon, null))),
        tooltip: addTooltip || formatMessage(this.props.intl, module, "addTooltip")
      }, {
        condition: (!!this.state.dirty || !!openDirty) && !!save,
        content: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Fab, {
          color: "primary",
          disabled: !!this.state.saving || !!canSave && !canSave(),
          onClick: function onClick(e) {
            return _this2.save(_this2.props.edited);
          }
        }, /*#__PURE__*/React.createElement(SaveIcon, null))),
        tooltip: saveTooltip || formatMessage(this.props.intl, module, "saveTooltip")
      }, {
        condition: (!!this.state.dirty || !!openDirty) && !!fab,
        content: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Fab, {
          color: "primary",
          onClick: function onClick(e) {
            return fabAction(_this2.props.edited);
          }
        }, fab)),
        tooltip: fabTooltip
      }];
      var allTooltips = [].concat(_toConsumableArray(additionalTooltips || []), defaultTooltips);
      var filteredTooltips = allTooltips.filter(function (tooltip) {
        return tooltip.condition;
      });
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
        noValidate: true,
        autoComplete: "off"
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        direction: "row",
        className: classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 8
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, !!back && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: back
      }, /*#__PURE__*/React.createElement(ChevronLeftIcon, null))), !!title && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography$1, {
        variant: "h6"
      }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: title,
        values: titleParams
      }))))), !!actions && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        justify: "flex-end"
      }, actions.map(function (a, idx) {
        if (!!a.onlyIfDirty && !_this2.state.dirty) return null;
        if (!!a.onlyIfNotDirty && !!_this2.state.dirty) return null;
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          key: "form-action-".concat(idx),
          className: classes.paperHeaderAction
        }, withTooltip(!!a.button ? a.button : /*#__PURE__*/React.createElement(IconButton, {
          onClick: a.doIt,
          disabled: a === null || a === void 0 ? void 0 : a.disabled
        }, a.icon), a.tooltip));
      })))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Divider, null)), (HeadPanel || headPanelContributionsKey) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, !!HeadPanel && /*#__PURE__*/React.createElement(HeadPanel, _extends({
        edited: this.props.edited,
        edited_id: this.props.edited_id
      }, others, {
        onEditedChanged: this.onEditedChanged
      })), !!headPanelContributionsKey && /*#__PURE__*/React.createElement(Contributions, _extends({}, others, {
        contributionKey: headPanelContributionsKey
      })))))), !!Panels && Panels.map(function (P, idx) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: "form_panel_".concat(idx),
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(P, _extends({}, others, {
          edited: _this2.props.edited,
          edited_id: _this2.props.edited_id,
          save: _this2.save,
          isSaving: _this2.state.saving,
          canSave: _this2.props.canSave,
          onEditedChanged: _this2.onEditedChanged
        })));
      }), !!contributedPanelsKey && /*#__PURE__*/React.createElement(Contributions, _extends({}, this.props, {
        onEditedChanged: this.onEditedChanged,
        contributionKey: contributedPanelsKey
      }))), !enableActionButtons && /*#__PURE__*/React.createElement("div", {
        className: classes.tooltipContainer
      }, filteredTooltips.map(function (item, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: classes.flexTooltip,
          key: index
        }, withTooltip(item.content, item.tooltip, index === 0 ? "top" : "left"));
      })));
    }
  }]);
}(Component);
var Form$1 = withHistory(injectIntl(withTheme(withStyles(styles$i)(Form))));

function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$m(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$m() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$m() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$m = function _isNativeReflectConstruct() { return !!t; })(); }
var FormPanel = /*#__PURE__*/function (_Component) {
  function FormPanel() {
    var _this;
    _classCallCheck(this, FormPanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$m(this, FormPanel, [].concat(args));
    _defineProperty(_this, "state", {
      data: {}
    });
    _defineProperty(_this, "updateAttributes", function (updates) {
      var data = _objectSpread$f(_objectSpread$f({}, _this.state.data), updates);
      _this.props.onEditedChanged(data);
    });
    _defineProperty(_this, "updateAttribute", function (attr, v) {
      return _this.updateAttributes(_defineProperty({}, attr, v));
    });
    _defineProperty(_this, "getAttributes", function () {
      return _this.state.data;
    });
    _defineProperty(_this, "getAttribute", function (attr) {
      return !!_this.state.data[attr] ? _this.state.data[attr] : null;
    });
    _defineProperty(_this, "updateExts", function (updates) {
      var data = _objectSpread$f({}, _this.state.data);
      updates.forEach(function (update) {
        data["jsonExt"][update.attr] = update.v;
      });
      _this.props.onEditedChanged(data);
    });
    _defineProperty(_this, "updateExt", function (attr, v) {
      return _this.updateExts([{
        attr: [attr],
        v: v
      }]);
    });
    return _this;
  }
  _inherits(FormPanel, _Component);
  return _createClass(FormPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(function (state, props) {
        return {
          data: props.edited
        };
      });
    }
  }, {
    key: "_componentDidUpdate",
    value: function _componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.edited_id && !this.props.edited_id || prevProps.reset !== this.props.reset || !_$1.isEqual(prevProps.edited, this.props.edited)) {
        this.setState(function (state, props) {
          return {
            data: props.edited
          };
        });
        return true;
      }
      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this._componentDidUpdate(prevProps, prevState, snapshot);
    }
  }]);
}(Component);

function _callSuper$l(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$l() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$l() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$l = function _isNativeReflectConstruct() { return !!t; })(); }
var PagedDataHandler = /*#__PURE__*/function (_Component) {
  function PagedDataHandler() {
    var _this;
    _classCallCheck(this, PagedDataHandler);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$l(this, PagedDataHandler, [].concat(args));
    _defineProperty(_this, "state", {
      page: 0,
      pageSize: _this.props.modulesManager.getConf("fe-core", "core.defaultPageSize", 5),
      afterCursor: null,
      beforeCursor: null
    });
    _defineProperty(_this, "query", function () {
      var prms = _this.queryPrms();
      if (!_this.state.pageSize || !prms) return;
      prms.push("first: ".concat(_this.state.pageSize));
      if (!!_this.state.afterCursor) {
        prms.push("after: \"".concat(_this.state.afterCursor, "\""));
      }
      if (!!_this.state.beforeCursor) {
        prms.push("before: \"".concat(_this.state.beforeCursor, "\""));
      }
      _this.props.fetch(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "currentPage", function () {
      return _this.state.page;
    });
    _defineProperty(_this, "currentPageSize", function () {
      return _this.state.pageSize;
    });
    _defineProperty(_this, "onChangeRowsPerPage", function (cnt) {
      _this.setState({
        pageSize: cnt,
        page: 0,
        afterCursor: null,
        beforeCursor: null
      }, function (e) {
        return _this.query();
      });
    });
    _defineProperty(_this, "onChangePage", function (page, nbr) {
      if (nbr > _this.state.page) {
        _this.setState(function (state, props) {
          return {
            page: state.page + 1,
            beforeCursor: null,
            afterCursor: props.pageInfo.endCursor
          };
        }, function (e) {
          return _this.query();
        });
      } else if (nbr < _this.state.page) {
        _this.setState(function (state, props) {
          return {
            page: state.page - 1,
            beforeCursor: props.pageInfo.startCursor,
            afterCursor: null
          };
        }, function (e) {
          return _this.query();
        });
      }
    });
    return _this;
  }
  _inherits(PagedDataHandler, _Component);
  return _createClass(PagedDataHandler, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(Component);

var useStyles$1 = makeStyles$1(function (theme) {
  return {
    validIcon: {
      color: "green"
    },
    invalidIcon: {
      color: theme.palette.error.main
    }
  };
});

var ValidatedTextInput = function ValidatedTextInput(_ref) {
  var action = _ref.action,
    additionalQueryArgs = _ref.additionalQueryArgs,
    autoFocus = _ref.autoFocus,
    className = _ref.className,
    clearAction = _ref.clearAction,
    codeTakenLabel = _ref.codeTakenLabel,
    inputProps = _ref.inputProps,
    isValid = _ref.isValid,
    isValidating = _ref.isValidating,
    itemQueryIdentifier = _ref.itemQueryIdentifier,
    label = _ref.label,
    module = _ref.module,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    required = _ref.required,
    setValidAction = _ref.setValidAction,
    shouldValidate = _ref.shouldValidate,
    type = _ref.type,
    validationError = _ref.validationError,
    value = _ref.value,
    invalidValueFormatLabel = _ref.invalidValueFormatLabel,
    invalidValueFormat = _ref.invalidValueFormat;
  var modulesManager = useModulesManager$1();
  var classes = useStyles$1();
  var dispatch = useDispatch();
  var _useTranslations = useTranslations$1(module, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var shouldBeValidated = shouldValidate(value);
  var queryVariables = {};
  var checkValidity = function checkValidity(queryVariables) {
    return dispatch(action(modulesManager, queryVariables));
  };
  var checkError = function checkError() {
    if (validationError || !isValidating && !isValid && value) {
      return formatMessage(codeTakenLabel);
    }
    if (invalidValueFormat) {
      return formatMessage(invalidValueFormatLabel);
    }
    return null;
  };
  var error = checkError();
  useEffect(function () {
    if (shouldBeValidated) {
      queryVariables[itemQueryIdentifier] = value;
      if (additionalQueryArgs) Object.entries(additionalQueryArgs).map(function (arg) {
        return queryVariables[arg === null || arg === void 0 ? void 0 : arg[0]] = arg === null || arg === void 0 ? void 0 : arg[1];
      });
      if (value) checkValidity(queryVariables);
      return function () {
        return (!value || isValid) && dispatch(clearAction());
      };
    } else {
      !!setValidAction && dispatch(setValidAction());
      return function () {
        return (!value || isValid) && dispatch(clearAction());
      };
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldBeValidated ? /*#__PURE__*/React.createElement(TextInput$2, {
    module: module,
    autoFocus: autoFocus,
    className: className,
    readOnly: readOnly,
    required: required,
    label: label,
    placeholder: placeholder,
    type: type,
    error: error,
    value: value,
    inputProps: inputProps,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      className: clsx(!error && classes.validIcon, error && classes.invalidIcon)
    }, /*#__PURE__*/React.createElement(React.Fragment, null, isValidating && value && /*#__PURE__*/React.createElement(Box, {
      mr: 1
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    })), value && !error && /*#__PURE__*/React.createElement(CheckOutlinedIcon, {
      size: 20
    }), value && error && /*#__PURE__*/React.createElement(ErrorOutlineOutlinedIcon, {
      size: 20
    }))),
    onChange: debounce(onChange, DEFAULT_DEBOUNCE_TIME)
  }) : /*#__PURE__*/React.createElement(TextInput$2, {
    module: module,
    label: label,
    autoFocus: autoFocus,
    value: value,
    readOnly: readOnly,
    error: error,
    required: required,
    type: type,
    onChange: debounce(onChange, DEFAULT_DEBOUNCE_TIME),
    inputProps: inputProps,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      className: clsx(!error && classes.validIcon, error && classes.invalidIcon)
    }, /*#__PURE__*/React.createElement(React.Fragment, null, isValidating && value && /*#__PURE__*/React.createElement(Box, {
      mr: 1
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    })), value && !error && /*#__PURE__*/React.createElement(CheckOutlinedIcon, {
      size: 20
    }), value && error && /*#__PURE__*/React.createElement(ErrorOutlineOutlinedIcon, {
      size: 20
    })))
  }));
};

var ValidatedTextAreaInput = function ValidatedTextAreaInput(_ref) {
  var action = _ref.action,
    additionalQueryArgs = _ref.additionalQueryArgs,
    autoFocus = _ref.autoFocus,
    className = _ref.className,
    clearAction = _ref.clearAction,
    codeTakenLabel = _ref.codeTakenLabel,
    inputProps = _ref.inputProps,
    isValid = _ref.isValid,
    isValidating = _ref.isValidating,
    itemQueryIdentifier = _ref.itemQueryIdentifier,
    label = _ref.label,
    module = _ref.module,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    required = _ref.required,
    setValidAction = _ref.setValidAction,
    shouldValidate = _ref.shouldValidate,
    type = _ref.type,
    validationError = _ref.validationError,
    value = _ref.value,
    invalidValueFormatLabel = _ref.invalidValueFormatLabel,
    invalidValueFormat = _ref.invalidValueFormat;
  var modulesManager = useModulesManager$1();
  var classes = useStyles$1();
  var dispatch = useDispatch();
  var _useTranslations = useTranslations$1(module, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var shouldBeValidated = shouldValidate(value);
  var queryVariables = {};
  var checkValidity = function checkValidity(queryVariables) {
    return dispatch(action(modulesManager, queryVariables));
  };
  var checkError = function checkError() {
    if (validationError || !isValidating && !isValid && value) {
      return formatMessage(codeTakenLabel);
    }
    if (invalidValueFormat) {
      return formatMessage(invalidValueFormatLabel);
    }
    return null;
  };
  var error = checkError();
  useEffect(function () {
    if (shouldBeValidated) {
      queryVariables[itemQueryIdentifier] = value;
      if (additionalQueryArgs) Object.entries(additionalQueryArgs).map(function (arg) {
        return queryVariables[arg === null || arg === void 0 ? void 0 : arg[0]] = arg === null || arg === void 0 ? void 0 : arg[1];
      });
      if (value) checkValidity(queryVariables);
      return function () {
        return (!value || isValid) && dispatch(clearAction());
      };
    } else {
      !!setValidAction && dispatch(setValidAction());
      return function () {
        return (!value || isValid) && dispatch(clearAction());
      };
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldBeValidated ? /*#__PURE__*/React.createElement(TextAreaInput$1, {
    module: module,
    autoFocus: autoFocus,
    className: className,
    readOnly: readOnly,
    required: required,
    label: label,
    placeholder: placeholder,
    type: type,
    error: error,
    value: value,
    inputProps: inputProps,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      className: clsx(!error && classes.validIcon, error && classes.invalidIcon)
    }, /*#__PURE__*/React.createElement(React.Fragment, null, isValidating && value && /*#__PURE__*/React.createElement(Box, {
      mr: 1
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    })), value && !error && /*#__PURE__*/React.createElement(CheckOutlinedIcon, {
      size: 20
    }), value && error && /*#__PURE__*/React.createElement(ErrorOutlineOutlinedIcon, {
      size: 20
    }))),
    onChange: debounce(onChange, DEFAULT_DEBOUNCE_TIME)
  }) : /*#__PURE__*/React.createElement(TextAreaInput$1, {
    module: module,
    label: label,
    autoFocus: autoFocus,
    value: value,
    readOnly: readOnly,
    error: error,
    required: required,
    type: type,
    onChange: debounce(onChange, DEFAULT_DEBOUNCE_TIME),
    inputProps: inputProps,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      className: clsx(!error && classes.validIcon, error && classes.invalidIcon)
    }, /*#__PURE__*/React.createElement(React.Fragment, null, isValidating && value && /*#__PURE__*/React.createElement(Box, {
      mr: 1
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    })), value && !error && /*#__PURE__*/React.createElement(CheckOutlinedIcon, {
      size: 20
    }), value && error && /*#__PURE__*/React.createElement(ErrorOutlineOutlinedIcon, {
      size: 20
    })))
  }));
};

function _callSuper$k(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$k() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$k() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$k = function _isNativeReflectConstruct() { return !!t; })(); }
var TextAreaInput = /*#__PURE__*/function (_Component) {
  function TextAreaInput() {
    _classCallCheck(this, TextAreaInput);
    return _callSuper$k(this, TextAreaInput, arguments);
  }
  _inherits(TextAreaInput, _Component);
  return _createClass(TextAreaInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TextInput$1, _extends({
        multiline: true
      }, this.props));
    }
  }]);
}(Component);

var _excluded$5 = ["intl", "module", "min", "max", "value", "error", "displayZero", "displayNa", "allowDecimals"];
function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$j(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct() { return !!t; })(); }
var NumberInput = /*#__PURE__*/function (_Component) {
  function NumberInput(props) {
    var _this;
    _classCallCheck(this, NumberInput);
    _this = _callSuper$j(this, NumberInput, [props]);
    _defineProperty(_this, "handleKeyPress", function (event) {
      var _this$props$allowDeci = _this.props.allowDecimals,
        allowDecimals = _this$props$allowDeci === void 0 ? true : _this$props$allowDeci;
      if (event.key === "." && !allowDecimals) {
        event.preventDefault();
      }
    });
    _defineProperty(_this, "formatInput", function (value, displayZero, displayNa, decimal) {
      if (!value) {
        if (displayNa && !_this.state.isEdited) {
          return formatMessage(_this.props.intl, _this.props.module, "core.NumberInput.notApplicable");
        }
        return displayZero && value === 0 ? "0" : "";
      }
      var numericValue = Number(value);
      if (isNaN(numericValue)) return "";
      if (decimal) {
        if (typeof value === "string" && value.includes(".") && value.split(".")[1].length > 2) {
          return parseFloat(value).toFixed(2);
        }
        return value;
      }
      return parseFloat(value);
    });
    _defineProperty(_this, "handleNaBlur", function () {
      if ((isNaN(_this.props.value) || _this.props.value === "") && _this.state.isEdited) {
        _this.props.onChange(undefined);
      }
      _this.setState({
        isEdited: false
      });
    });
    _this.state = {
      isEdited: false
    };
    return _this;
  }
  _inherits(NumberInput, _Component);
  return _createClass(NumberInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        intl = _this$props.intl,
        _this$props$module = _this$props.module,
        module = _this$props$module === void 0 ? "core" : _this$props$module,
        _this$props$min = _this$props.min,
        min = _this$props$min === void 0 ? null : _this$props$min,
        _this$props$max = _this$props.max,
        max = _this$props$max === void 0 ? null : _this$props$max,
        value = _this$props.value,
        error = _this$props.error,
        _this$props$displayZe = _this$props.displayZero,
        displayZero = _this$props$displayZe === void 0 ? false : _this$props$displayZe,
        _this$props$displayNa = _this$props.displayNa,
        displayNa = _this$props$displayNa === void 0 ? false : _this$props$displayNa,
        _this$props$allowDeci2 = _this$props.allowDecimals,
        allowDecimals = _this$props$allowDeci2 === void 0 ? true : _this$props$allowDeci2,
        others = _objectWithoutProperties(_this$props, _excluded$5);
      var inputProps = _objectSpread$e(_objectSpread$e({}, this.props.inputProps), {}, {
        type: "number",
        onKeyPress: this.handleKeyPress
      });
      var err = error;
      if (min !== null) {
        inputProps.min = min;
        if (value < min) err = formatMessageWithValues(intl, module, "validation.minValue", {
          value: value,
          min: min
        });
      }
      if (max !== null) {
        inputProps.max = max;
        if (value > max) err = formatMessageWithValues(intl, module, "validation.maxValue", {
          value: value,
          max: max
        });
      }
      return /*#__PURE__*/React.createElement(TextInput$1, _extends({}, others, {
        module: module,
        value: value,
        error: err,
        inputProps: inputProps,
        formatInput: function formatInput(v) {
          return _this2.formatInput(v, displayZero, displayNa, allowDecimals);
        },
        onFocus: function onFocus() {
          return _this2.setState({
            isEdited: true
          });
        },
        onBlur: function onBlur() {
          return _this2.handleNaBlur();
        }
      }));
    }
  }]);
}(Component);
var NumberInput$1 = injectIntl(NumberInput);

var _excluded$4 = ["intl", "inputMinValue"];
var AmountInput = function AmountInput(_ref) {
  var intl = _ref.intl,
    _ref$inputMinValue = _ref.inputMinValue,
    inputMinValue = _ref$inputMinValue === void 0 ? 0 : _ref$inputMinValue,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var modulesManager = useModulesManager();
  var position = modulesManager.getConf("fe-core", "AmountInput.currencyPosition", "start");
  if (!["start", "end"].includes(position)) {
    throw new Error("Position ".concat(position, " is not accepted. Only 'start' and 'end' are valid options."));
  }
  var extraProps = _defineProperty(_defineProperty({}, "".concat(position, "Adornment"), /*#__PURE__*/React.createElement(InputAdornment, {
    position: position
  }, intl.formatMessage({
    id: "currency"
  }))), "min", inputMinValue);
  return /*#__PURE__*/React.createElement(NumberInput$1, _extends({}, props, extraProps));
};
var AmountInput$1 = injectIntl(AmountInput);

var _excluded$3 = ["classes", "onSelect"];
function _callSuper$i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$h = function styles(theme) {
  return {
    fakeInput: theme.fakeInput
  };
};
var FakeInput = /*#__PURE__*/function (_Component) {
  function FakeInput() {
    var _this;
    _classCallCheck(this, FakeInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$i(this, FakeInput, [].concat(args));
    _defineProperty(_this, "_onKeyDown", function (e) {
      if (e.keyCode === 13 && !!_this.props.onSelect) {
        _this.props.onSelect();
        e.stopPropagation();
      }
    });
    return _this;
  }
  _inherits(FakeInput, _Component);
  return _createClass(FakeInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes;
        _this$props.onSelect;
        var others = _objectWithoutProperties(_this$props, _excluded$3);
      return /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(InputBase, _extends({
        className: classes.fakeInput,
        inputProps: {
          onKeyDown: function onKeyDown(e) {
            return _this2._onKeyDown(e);
          },
          readOnly: true
        }
      }, others)));
    }
  }]);
}(Component);
var FakeInput$1 = withTheme(withStyles(styles$h)(FakeInput));

function _callSuper$h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$g = function styles(theme) {
  return {
    progress: {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      align: "center"
    }
  };
};
var ProgressOrError = /*#__PURE__*/function (_Component) {
  function ProgressOrError() {
    _classCallCheck(this, ProgressOrError);
    return _callSuper$h(this, ProgressOrError, arguments);
  }
  _inherits(ProgressOrError, _Component);
  return _createClass(ProgressOrError, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        progress = _this$props.progress,
        error = _this$props.error,
        size = _this$props.size;
      return /*#__PURE__*/React.createElement(Fragment, null, !!progress && /*#__PURE__*/React.createElement(CircularProgress, {
        size: size,
        className: classes.progress
      }), !progress && !!error && /*#__PURE__*/React.createElement(Error$2, {
        error: error
      }));
    }
  }]);
}(Component);
var ProgressOrError$1 = withTheme(withStyles(styles$g)(ProgressOrError));

function _callSuper$g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
var ProxyPage = /*#__PURE__*/function (_Component) {
  function ProxyPage() {
    _classCallCheck(this, ProxyPage);
    return _callSuper$g(this, ProxyPage, arguments);
  }
  _inherits(ProxyPage, _Component);
  return _createClass(ProxyPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        url = _this$props.url,
        marginTop = _this$props.marginTop,
        marginBottom = _this$props.marginBottom,
        marginLeft = _this$props.marginLeft,
        marginRight = _this$props.marginRight;
      var styles = {
        width: "1px",
        minWidth: "100%",
        height: "100vh",
        marginTop: marginTop || "-68px",
        marginBottom: marginBottom || "0px",
        marginLeft: marginLeft || "0px",
        marginRight: marginRight || "0px"
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("iframe", {
        title: url,
        src: url,
        style: styles
      }));
    }
  }]);
}(Component);

function _callSuper$f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$f = function styles(theme) {
  var _ref;
  return _ref = {
    table: theme.table,
    tableTitle: theme.table.title,
    tableHeader: theme.table.header
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "tableHeader", {
    paddingTop: "10px",
    paddingBottom: "10px",
    fontWeight: 'bold'
    // fontSize: 'medium',
  }), "tableRow", theme.table.row), "tableRow", {
    backgroundColor: '#edf6f6'
  }), "tableLockedRow", theme.table.lockedRow), "tableLockedCell", theme.table.lockedCell), "tableHighlightedRow", theme.table.highlightedRow), "tableHighlightedCell", theme.table.highlightedCell), "tableHighlightedAltRow", theme.table.highlightedAltRow), "tableSecondaryHighlightedRow", theme.table.secondaryHighlightedRow), "tableSecondaryHighlightedCell", theme.table.secondaryHighlightedCell), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "tableHighlightedAltCell", theme.table.highlightedAltCell), "tableDisabledRow", theme.table.disabledRow), "tableDisabledCell", theme.table.disabledCell), "tableFooter", theme.table.footer), "pager", theme.table.pager), "left", {
    textAlign: "left"
  }), "right", {
    textAlign: "right"
  }), "center", {
    textAlign: "center"
  }), "clickable", {
    cursor: "pointer"
  }), "loader", {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(0, 0, 0, 0.12)"
  });
};
var Table$2 = /*#__PURE__*/function (_Component) {
  function Table() {
    var _this;
    _classCallCheck(this, Table);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$f(this, Table, [].concat(args));
    _defineProperty(_this, "state", {
      selection: {},
      ordinalNumberFrom: null
    });
    _defineProperty(_this, "_atom", function (a) {
      return !!a && a.reduce(function (m, i) {
        m[_this.itemIdentifier(i)] = i;
        return m;
      }, {});
    });
    _defineProperty(_this, "itemIdentifier", function (i) {
      if (!!_this.props.itemIdentifier) {
        return _this.props.itemIdentifier(i);
      } else {
        return i.uuid;
      }
    });
    _defineProperty(_this, "isSelected", function (i) {
      return !!_this.props.withSelection && !!_this.state.selection[_this.itemIdentifier(i)];
    });
    _defineProperty(_this, "select", function (i, e) {
      // block normal href only for left click
      if (e.type === "click" || _this.props.selectWithCheckbox) {
        if (!_this.props.withSelection) return;
        var s = _this.state.selection;
        var id = _this.itemIdentifier(i);
        if (!!s[id]) {
          delete s[id];
        } else if (_this.props.withSelection === "multiple") {
          s[id] = i;
        } else {
          s = _defineProperty({}, id, i);
        }
        _this.setState({
          selection: s
        }, function (e) {
          return !!_this.props.onChangeSelection && _this.props.onChangeSelection(Object.values(_this.state.selection));
        });
      }
    });
    _defineProperty(_this, "selectAll", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, withSelection, onChangeSelection, items, selection, newSelection;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, withSelection = _this$props.withSelection, onChangeSelection = _this$props.onChangeSelection, items = _this$props.items;
            selection = _this.state.selection;
            if (withSelection) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            newSelection = {};
            if (!Object.keys(selection).length) {
              newSelection = _this._atom(items);
            }
            _this.setState({
              selection: newSelection
            }, function () {
              onChangeSelection === null || onChangeSelection === void 0 || onChangeSelection(Object.values(_this.state.selection));
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "headerAction", function (a) {
      return /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        justifyContent: "flex-end"
      }, a()));
    });
    _defineProperty(_this, "calculateOrdinalNumber", function (iidx, isPaginationEnabled, arrayLength) {
      var ordinalNumberFrom = _this.state.ordinalNumberFrom;
      var currentIndex = 0;
      if (isPaginationEnabled) {
        if (isNaN(ordinalNumberFrom)) {
          currentIndex = 0;
        }
        currentIndex = iidx + ordinalNumberFrom;
      } else {
        currentIndex = iidx + 1;
      }
      return currentIndex;
    });
    return _this;
  }
  _inherits(Table, _Component);
  return _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.withSelection) {
        this.setState(function (state, props) {
          return {
            selection: _this2._atom(props.selection || [])
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;
      if (this.props.withSelection && prevProps.selectAll !== this.props.selectAll) {
        this.setState(function (state, props) {
          return {
            selection: _$1.merge(state.selection, _this3._atom(props.items))
          };
        }, function (e) {
          return !!_this3.props.onChangeSelection && _this3.props.onChangeSelection(Object.values(_this3.state.selection));
        });
      }
      if (this.props.withSelection && prevProps.clearAll !== this.props.clearAll) {
        this.setState({
          selection: {}
        }, function (e) {
          return !!_this3.props.onChangeSelection && _this3.props.onChangeSelection(Object.values(_this3.state.selection));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        intl = _this$props2.intl,
        modulesManager = _this$props2.modulesManager,
        classes = _this$props2.classes,
        module = _this$props2.module,
        header = _this$props2.header,
        preHeaders = _this$props2.preHeaders,
        headers = _this$props2.headers,
        _this$props2$aligns = _this$props2.aligns,
        aligns = _this$props2$aligns === void 0 ? [] : _this$props2$aligns,
        _this$props2$headerSp = _this$props2.headerSpans,
        headerSpans = _this$props2$headerSp === void 0 ? [] : _this$props2$headerSp,
        _this$props2$headerAc = _this$props2.headerActions,
        headerActions = _this$props2$headerAc === void 0 ? [] : _this$props2$headerAc,
        _this$props2$colSpans = _this$props2.colSpans,
        colSpans = _this$props2$colSpans === void 0 ? [] : _this$props2$colSpans,
        items = _this$props2.items,
        itemFormatters = _this$props2.itemFormatters,
        _this$props2$rowHighl = _this$props2.rowHighlighted,
        rowHighlighted = _this$props2$rowHighl === void 0 ? null : _this$props2$rowHighl,
        _this$props2$rowHighl2 = _this$props2.rowHighlightedAlt,
        rowHighlightedAlt = _this$props2$rowHighl2 === void 0 ? null : _this$props2$rowHighl2,
        _this$props2$rowSecon = _this$props2.rowSecondaryHighlighted,
        rowSecondaryHighlighted = _this$props2$rowSecon === void 0 ? null : _this$props2$rowSecon,
        _this$props2$rowDisab = _this$props2.rowDisabled,
        rowDisabled = _this$props2$rowDisab === void 0 ? null : _this$props2$rowDisab,
        _this$props2$rowLocke = _this$props2.rowLocked,
        rowLocked = _this$props2$rowLocke === void 0 ? null : _this$props2$rowLocke,
        _this$props2$withPagi = _this$props2.withPagination,
        withPagination = _this$props2$withPagi === void 0 ? false : _this$props2$withPagi,
        _this$props2$page = _this$props2.page,
        page = _this$props2$page === void 0 ? 0 : _this$props2$page,
        pageSize = _this$props2.pageSize,
        count = _this$props2.count,
        size = _this$props2.size,
        _this$props2$rowsPerP = _this$props2.rowsPerPageOptions,
        rowsPerPageOptions = _this$props2$rowsPerP === void 0 ? [10, 20, 50] : _this$props2$rowsPerP,
        onChangeRowsPerPage = _this$props2.onChangeRowsPerPage,
        onChangePage = _this$props2.onChangePage,
        onDoubleClick = _this$props2.onDoubleClick,
        _this$props2$onDelete = _this$props2.onDelete,
        onDelete = _this$props2$onDelete === void 0 ? null : _this$props2$onDelete,
        _this$props2$fetching = _this$props2.fetching,
        fetching = _this$props2$fetching === void 0 ? null : _this$props2$fetching,
        _this$props2$error = _this$props2.error,
        error = _this$props2$error === void 0 ? null : _this$props2$error,
        _this$props2$showOrdi = _this$props2.showOrdinalNumber,
        showOrdinalNumber = _this$props2$showOrdi === void 0 ? false : _this$props2$showOrdi,
        extendHeader = _this$props2.extendHeader,
        _this$props2$disableD = _this$props2.disableDeleteOnEmptyRow,
        disableDeleteOnEmptyRow = _this$props2$disableD === void 0 ? false : _this$props2$disableD,
        _this$props2$selectWi = _this$props2.selectWithCheckbox,
        selectWithCheckbox = _this$props2$selectWi === void 0 ? false : _this$props2$selectWi,
        _this$props2$withSele = _this$props2.withSelection,
        withSelection = _this$props2$withSele === void 0 ? false : _this$props2$withSele;
      this.state.ordinalNumberFrom;
      var localHeaders = _toConsumableArray(headers || []);
      var localPreHeaders = !!preHeaders ? _toConsumableArray(preHeaders) : null;
      var localItemFormatters = _toConsumableArray(itemFormatters);
      var i = !!headers && headers.length;
      while (localHeaders && i--) {
        if (modulesManager !== null && modulesManager !== void 0 && modulesManager.hideField(module, localHeaders[i])) {
          if (!!localPreHeaders) localPreHeaders.splice(i, 1);
          if (!!aligns && aligns.length > i) aligns.splice(i, 1);
          if (!!headerSpans && headerSpans.length > i) headerSpans.splice(i, 1);
          if (!!headerActions && headerActions.length > i) headerActions.splice(i, 1);
          if (!!colSpans && colSpans.length > i) colSpans.splice(i, 1);
          localHeaders.splice(i, 1);
          localItemFormatters.splice(i, 1);
        }
      }
      if (!!onDelete) {
        if (localPreHeaders) localPreHeaders.push("");
        localHeaders.push("");
        localItemFormatters.push(function (i, idx) {
          var isEmpty = disableDeleteOnEmptyRow ? _$1.isEmpty(i) : false;
          return /*#__PURE__*/React.createElement(IconButton, {
            disabled: isEmpty,
            onClick: function onClick(e) {
              return onDelete(idx);
            }
          }, /*#__PURE__*/React.createElement(DeleteIcon, null));
        });
      }
      var rowsPerPage = pageSize || rowsPerPageOptions[0];
      var numSelected = Object.keys(this.state.selection || {}).length;
      if (showOrdinalNumber) {
        localHeaders.unshift("core.Table.ordinalNumberHeader");
      }
      return /*#__PURE__*/React.createElement(Box, {
        position: "relative",
        overflow: "auto"
      }, header && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        justify: "space-between",
        className: classes.tableTitle
      }, extendHeader ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Typography$1, {
        variant: "h6"
      }, header)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        container: true,
        direction: "row",
        alignItems: "center",
        justify: "space-between",
        xs: 6
      }, extendHeader && extendHeader())) : /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography$1, {
        variant: "h6"
      }, header))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Table$4, {
        className: classes.table,
        size: size
      }, !!localPreHeaders && localPreHeaders.length > 0 && /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, localPreHeaders.map(function (h, idx) {
        if (headerSpans.length > idx && !headerSpans[idx]) return null;
        return /*#__PURE__*/React.createElement(TableCell, {
          colSpan: headerSpans.length > idx ? headerSpans[idx] : 1,
          className: clsx(classes.tableHeader, aligns.length > idx && classes[aligns[idx]]),
          key: "preh-".concat(idx)
        }, !!h && h);
      }))), !!localHeaders && localHeaders.length > 0 && /*#__PURE__*/React.createElement(TableHead, {
        style: {
          backgroundColor: '#d7eceb'
        }
      }, /*#__PURE__*/React.createElement(TableRow, null, selectWithCheckbox && withSelection && /*#__PURE__*/React.createElement(TableCell, {
        padding: "checkbox"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        color: "primary",
        indeterminate: numSelected > 0 && numSelected < count,
        checked: count > 0 && numSelected === count,
        onChange: function onChange(e) {
          return _this4.selectAll(e);
        }
      })), localHeaders.map(function (h, idx) {
        if (headerSpans.length > idx && !headerSpans[idx]) return null;
        return /*#__PURE__*/React.createElement(TableCell, {
          colSpan: headerSpans.length > idx ? headerSpans[idx] : 1,
          key: "h-".concat(idx)
        }, !!h && /*#__PURE__*/React.createElement(Box, {
          style: {
            width: "100%",
            cursor: headerActions.length > idx && !!headerActions[idx][0] ? "pointer" : ""
          },
          onClick: headerActions.length > idx ? headerActions[idx][0] : null,
          display: "flex",
          className: classes.tableHeader,
          alignItems: "center",
          justifyContent: aligns.length > idx ? aligns[idx] : "left"
        }, /*#__PURE__*/React.createElement(Box, null, typeof h === "function" ? /*#__PURE__*/React.createElement(Box, null, function () {
          return h(_this4.state, _this4.props);
        }) : /*#__PURE__*/React.createElement(FormattedMessage$1, {
          module: module,
          id: h
        })), headerActions.length > idx ? _this4.headerAction(headerActions[idx][1]) : null));
      }))), /*#__PURE__*/React.createElement(TableBody, null, items && items.length > 0 && items.map(function (i, iidx) {
        return /*#__PURE__*/React.createElement(TableRow, {
          key: iidx,
          selected: _this4.isSelected(i),
          onClick: function onClick(e) {
            return !selectWithCheckbox && _this4.select(i, e);
          },
          onContextMenu: onDoubleClick ? function () {
            return onDoubleClick(i, true);
          } : undefined,
          onDoubleClick: onDoubleClick ? function () {
            return onDoubleClick(i);
          } : undefined,
          className: clsx(classes.tableRow, !!rowLocked && rowLocked(i) ? classes.tableLockedRow : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedRow : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltRow : null, !!rowSecondaryHighlighted && rowSecondaryHighlighted(i) ? classes.tableSecondaryHighlightedRow : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledRow : null, !!onDoubleClick && classes.clickable)
        }, selectWithCheckbox && withSelection && /*#__PURE__*/React.createElement(TableCell, {
          padding: "checkbox"
        }, /*#__PURE__*/React.createElement(Checkbox, {
          checked: _this4.isSelected(i),
          onChange: function onChange(e) {
            return _this4.select(i, e);
          },
          color: "primary"
        })), showOrdinalNumber && /*#__PURE__*/React.createElement(TableCell, {
          className: clsx(!!rowLocked && rowLocked(i) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltCell : null, !!rowSecondaryHighlighted && rowSecondaryHighlighted(i) ? classes.tableSecondaryHighlightedCell : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledCell : null, aligns.length > 0 && classes[aligns[0]]),
          key: "v-".concat(_this4.calculateOrdinalNumber(iidx, withPagination, items.length), "-0")
        }, /*#__PURE__*/React.createElement("span", null, _this4.calculateOrdinalNumber(iidx, withPagination, items.length))), localItemFormatters && localItemFormatters.map(function (f, fidx) {
          if (colSpans.length > fidx && !colSpans[fidx]) return null;
          // NOTE: The 'f' function can explicitly be set to null, enabling the option to omit
          // a column  and suppress its display under specific conditions.
          if (f === null) return null;
          return /*#__PURE__*/React.createElement(TableCell, {
            colSpan: colSpans.length > fidx ? colSpans[fidx] : 1,
            className: clsx(!!rowLocked && rowLocked(i) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltCell : null, !!rowSecondaryHighlighted && rowSecondaryHighlighted(i) ? classes.tableSecondaryHighlightedCell : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledCell : null, aligns.length > fidx && classes[aligns[fidx]]),
            key: "v-".concat(iidx, "-").concat(fidx)
          }, f(i, iidx));
        }));
      })), !!withPagination && !!count && /*#__PURE__*/React.createElement(TableFooter, {
        className: classes.tableFooter
      }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TablePagination, {
        className: classes.pager,
        colSpan: localItemFormatters.length + (selectWithCheckbox ? 1 : 0),
        labelRowsPerPage: formatMessage(intl, "core", "rowsPerPage"),
        labelDisplayedRows: function labelDisplayedRows(_ref3) {
          var from = _ref3.from,
            to = _ref3.to,
            count = _ref3.count;
          if (_this4.state.ordinalNumberFrom !== from) _this4.setState({
            ordinalNumberFrom: from
          });
          return "".concat(from, "-").concat(to, " ").concat(formatMessageWithValues(intl, "core", "ofPages"), " ").concat(count);
        },
        count: count,
        page: page,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: rowsPerPageOptions,
        onRowsPerPageChange: function onRowsPerPageChange(e) {
          return onChangeRowsPerPage(e.target.value);
        },
        onPageChange: onChangePage,
        nextIconButtonText: formatMessage(intl, "core", "Table.nextPage"),
        backIconButtonText: formatMessage(intl, "core", "Table.previousPage")
      })))), (fetching || error) && /*#__PURE__*/React.createElement(Grid, {
        className: classes.loader,
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(ProgressOrError$1, {
        progress: (items === null || items === void 0 ? void 0 : items.length) && fetching,
        error: error
      }), " "));
    }
  }]);
}(Component);
var Table$3 = withModulesManager(injectIntl(withTheme(withStyles(styles$f)(Table$2))));

function _callSuper$e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$e = function styles(theme) {
  return {
    table: theme.table,
    tableTitle: theme.table.title,
    tableHeader: theme.table.header,
    tableRow: theme.table.row,
    tableLockedRow: theme.table.lockedRow,
    tableLockedCell: theme.table.lockedCell,
    tableHighlightedRow: theme.table.highlightedRow,
    tableHighlightedCell: theme.table.highlightedCell,
    tableHighlightedAltRow: theme.table.highlightedAltRow,
    tableHighlightedAltCell: theme.table.highlightedAltCell,
    tableDisabledRow: theme.table.disabledRow,
    tableDisabledCell: theme.table.disabledCell,
    tableFooter: theme.table.footer,
    pager: theme.table.pager,
    left: {
      textAlign: "left"
    },
    right: {
      textAlign: "right"
    },
    center: {
      textAlign: "center"
    },
    clickable: {
      cursor: "pointer"
    },
    loader: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: "rgba(0, 0, 0, 0.12)"
    }
  };
};
var Table$1 = /*#__PURE__*/function (_Component) {
  function Table() {
    var _this;
    _classCallCheck(this, Table);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$e(this, Table, [].concat(args));
    _defineProperty(_this, "state", {
      selection: {}
    });
    _defineProperty(_this, "_atom", function (a) {
      return !!a && a.reduce(function (m, i) {
        m[_this.itemIdentifier(i)] = i;
        return m;
      }, {});
    });
    _defineProperty(_this, "itemIdentifier", function (i) {
      if (!!_this.props.itemIdentifier) {
        return _this.props.itemIdentifier(i);
      } else {
        return i.uuid;
      }
    });
    _defineProperty(_this, "isSelected", function (i) {
      return !!_this.props.withSelection && !!_this.state.selection[_this.itemIdentifier(i)];
    });
    _defineProperty(_this, "select", function (i) {
      if (!_this.props.withSelection) return;
      var s = _this.state.selection;
      var id = _this.itemIdentifier(i);
      if (!!s[id]) {
        delete s[id];
      } else if (_this.props.withSelection === "multiple") {
        s[id] = i;
      } else {
        s = _defineProperty({}, id, i);
      }
      _this.setState({
        selection: s
      }, function (e) {
        return !!_this.props.onChangeSelection && _this.props.onChangeSelection(Object.values(_this.state.selection));
      });
    });
    _defineProperty(_this, "headerAction", function (a) {
      return /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        justifyContent: "flex-end"
      }, a()));
    });
    return _this;
  }
  _inherits(Table, _Component);
  return _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.withSelection) {
        this.setState(function (state, props) {
          return {
            selection: _this2._atom(props.selection || [])
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;
      if (this.props.withSelection && prevProps.selectAll !== this.props.selectAll) {
        this.setState(function (state, props) {
          return {
            selection: _$1.merge(state.selection, _this3._atom(props.items))
          };
        }, function (e) {
          return !!_this3.props.onChangeSelection && _this3.props.onChangeSelection(Object.values(_this3.state.selection));
        });
      }
      if (this.props.withSelection && prevProps.clearAll !== this.props.clearAll) {
        this.setState({
          selection: {}
        }, function (e) {
          return !!_this3.props.onChangeSelection && _this3.props.onChangeSelection(Object.values(_this3.state.selection));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        modulesManager = _this$props.modulesManager,
        classes = _this$props.classes,
        module = _this$props.module,
        header = _this$props.header,
        preHeaders = _this$props.preHeaders,
        headers = _this$props.headers,
        _this$props$aligns = _this$props.aligns,
        aligns = _this$props$aligns === void 0 ? [] : _this$props$aligns,
        _this$props$headerSpa = _this$props.headerSpans,
        headerSpans = _this$props$headerSpa === void 0 ? [] : _this$props$headerSpa,
        _this$props$headerAct = _this$props.headerActions,
        headerActions = _this$props$headerAct === void 0 ? [] : _this$props$headerAct,
        _this$props$colSpans = _this$props.colSpans,
        colSpans = _this$props$colSpans === void 0 ? [] : _this$props$colSpans,
        items = _this$props.items,
        itemFormatters = _this$props.itemFormatters,
        _this$props$rowHighli = _this$props.rowHighlighted,
        rowHighlighted = _this$props$rowHighli === void 0 ? null : _this$props$rowHighli,
        _this$props$rowHighli2 = _this$props.rowHighlightedAlt,
        rowHighlightedAlt = _this$props$rowHighli2 === void 0 ? null : _this$props$rowHighli2,
        _this$props$rowDisabl = _this$props.rowDisabled,
        rowDisabled = _this$props$rowDisabl === void 0 ? null : _this$props$rowDisabl,
        _this$props$rowLocked = _this$props.rowLocked,
        rowLocked = _this$props$rowLocked === void 0 ? null : _this$props$rowLocked,
        _this$props$withPagin = _this$props.withPagination,
        withPagination = _this$props$withPagin === void 0 ? false : _this$props$withPagin,
        _this$props$page = _this$props.page,
        page = _this$props$page === void 0 ? 0 : _this$props$page,
        pageSize = _this$props.pageSize,
        count = _this$props.count,
        size = _this$props.size,
        _this$props$rowsPerPa = _this$props.rowsPerPageOptions,
        rowsPerPageOptions = _this$props$rowsPerPa === void 0 ? [10, 20, 50] : _this$props$rowsPerPa,
        onChangeRowsPerPage = _this$props.onChangeRowsPerPage,
        onChangePage = _this$props.onChangePage;
        _this$props.onDoubleClick;
        var _this$props$onDelete = _this$props.onDelete,
        onDelete = _this$props$onDelete === void 0 ? null : _this$props$onDelete,
        _this$props$fetching = _this$props.fetching,
        fetching = _this$props$fetching === void 0 ? null : _this$props$fetching,
        _this$props$error = _this$props.error,
        error = _this$props$error === void 0 ? null : _this$props$error;
        _this$props.forReview;
        var subServicesItemsFormatters = _this$props.subServicesItemsFormatters,
        subServicesItemsFormattersReview = _this$props.subServicesItemsFormattersReview,
        subServiceHeaders = _this$props.subServiceHeaders;
      var localHeaders = _toConsumableArray(headers || []);
      var localSubServiceHeaders = _toConsumableArray(subServiceHeaders || []);
      var localPreHeaders = !!preHeaders ? _toConsumableArray(preHeaders) : null;
      var localItemFormatters = _toConsumableArray(itemFormatters);
      var localSubServicesItemsFormatters = _toConsumableArray(subServicesItemsFormatters);
      var localsubServicesItemsFormattersReview = _toConsumableArray(subServicesItemsFormattersReview);
      var i = !!headers && headers.length;
      while (localHeaders && i--) {
        if (modulesManager !== null && modulesManager !== void 0 && modulesManager.hideField(module, localHeaders[i])) {
          if (!!localPreHeaders) localPreHeaders.splice(i, 1);
          if (!!aligns && aligns.length > i) aligns.splice(i, 1);
          if (!!headerSpans && headerSpans.length > i) headerSpans.splice(i, 1);
          if (!!headerActions && headerActions.length > i) headerActions.splice(i, 1);
          if (!!colSpans && colSpans.length > i) colSpans.splice(i, 1);
          localHeaders.splice(i, 1);
          localItemFormatters.splice(i, 1);
        }
      }
      if (!!onDelete) {
        if (localPreHeaders) localPreHeaders.push("");
        localHeaders.push("");
        localItemFormatters.push(function (i, idx) {
          return /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick(e) {
              return onDelete(idx);
            }
          }, /*#__PURE__*/React.createElement(DeleteIcon, null));
        });
      }
      var rowsPerPage = pageSize || rowsPerPageOptions[0];
      return /*#__PURE__*/React.createElement(Box, {
        position: "relative",
        overflow: "auto"
      }, header && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.tableTitle
      }, header), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Table$4, {
        className: classes.table,
        size: size
      }, !!localPreHeaders && localPreHeaders.length > 0 && /*#__PURE__*/React.createElement("table", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("tr", null, localPreHeaders.map(function (h, idx) {
        if (headerSpans.length > idx && !headerSpans[idx]) return null;
        return /*#__PURE__*/React.createElement(TableCell, {
          colSpan: headerSpans.length > idx ? headerSpans[idx] : 1,
          className: clsx(classes.tableHeader, aligns.length > idx && classes[aligns[idx]]),
          key: "preh-".concat(idx)
        }, !!h && h);
      }))), /*#__PURE__*/React.createElement(TableBody, null, items && items.length > 0 && items.map(function (i, iidx) {
        if (i.claimlinkedService != undefined) {
          console.log(i);
          return /*#__PURE__*/React.createElement(Box, {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement("table", {
            style: {
              width: "100%"
            }
          }, items.length - iidx == items.length && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[0]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[1]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[2]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[3]
          }))), /*#__PURE__*/React.createElement("tr", null, localItemFormatters && localItemFormatters.map(function (f, fidx) {
            if (colSpans.length > fidx && !colSpans[fidx]) return null;
            return /*#__PURE__*/React.createElement(TableCell, {
              colSpan: colSpans.length > fidx ? colSpans[fidx] : 1,
              className: clsx(!!rowLocked && rowLocked(i) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltCell : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledCell : null, aligns.length > fidx && classes[aligns[fidx]]),
              key: "v-".concat(iidx, "-").concat(fidx)
            }, f(i, iidx));
          }))), localItemFormatters[0](i, iidx).props.children.props.value != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype !== "S" && /*#__PURE__*/React.createElement("table", {
            style: {
              marginTop: 10,
              width: "90%"
            }
          }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[0]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[1]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[2]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[3]
          }))), localsubServicesItemsFormattersReview && localsubServicesItemsFormattersReview.map(function (s, sfidx) {
            return s(i, iidx);
          })));
        } else {
          var cleanedHeaders = localHeaders.filter(Boolean);
          return /*#__PURE__*/React.createElement(Box, {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement("table", {
            style: {
              width: "100%"
            }
          }, items.length - iidx == items.length && /*#__PURE__*/React.createElement("tr", null, cleanedHeaders.map(function (header, index) {
            return /*#__PURE__*/React.createElement(TableCell, {
              key: index
            }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
              module: module,
              id: header
            }));
          })), /*#__PURE__*/React.createElement("tr", null, localItemFormatters && localItemFormatters.map(function (f, fidx) {
            if (colSpans.length > fidx && !colSpans[fidx]) return null;
            return /*#__PURE__*/React.createElement(TableCell, {
              colSpan: colSpans.length > fidx ? colSpans[fidx] : 1,
              className: clsx(!!rowLocked && rowLocked(i) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltCell : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledCell : null, aligns.length > fidx && classes[aligns[fidx]]),
              key: "v-".concat(iidx, "-").concat(fidx)
            }, f(i, iidx));
          }))), localItemFormatters[0](i, iidx).props.children.props.value != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype !== "S" && /*#__PURE__*/React.createElement("table", {
            style: {
              marginTop: 10,
              width: "90%"
            }
          }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[0]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[1]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[2]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[3]
          }))), localSubServicesItemsFormatters && localSubServicesItemsFormatters.map(function (s, sfidx) {
            return s(i, iidx);
          })));
        }
      })), !!withPagination && !!count && /*#__PURE__*/React.createElement(TableFooter, {
        className: classes.tableFooter
      }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TablePagination, {
        className: classes.pager,
        colSpan: localItemFormatters.length,
        labelRowsPerPage: formatMessage(intl, "core", "rowsPerPage"),
        labelDisplayedRows: function labelDisplayedRows(_ref) {
          var from = _ref.from,
            to = _ref.to,
            count = _ref.count;
          return "".concat(from, "-").concat(to, " ").concat(formatMessageWithValues(intl, "core", "ofPages"), " ").concat(count);
        },
        count: count,
        page: page,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: rowsPerPageOptions,
        onRowsPerPageChange: function onRowsPerPageChange(e) {
          return onChangeRowsPerPage(e.target.value);
        },
        onPageChange: onChangePage
      })))), (fetching || error) && /*#__PURE__*/React.createElement(Grid, {
        className: classes.loader,
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(ProgressOrError$1, {
        progress: (items === null || items === void 0 ? void 0 : items.length) && fetching,
        error: error
      }), " "));
    }
  }]);
}(Component);
var TableService = withModulesManager(injectIntl(withTheme(withStyles(styles$e)(Table$1))));

function _callSuper$d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$d = function styles(theme) {
  return {
    table: theme.table,
    tableTitle: theme.table.title,
    tableHeader: theme.table.header,
    tableRow: theme.table.row,
    tableLockedRow: theme.table.lockedRow,
    tableLockedCell: theme.table.lockedCell,
    tableHighlightedRow: theme.table.highlightedRow,
    tableHighlightedCell: theme.table.highlightedCell,
    tableHighlightedAltRow: theme.table.highlightedAltRow,
    tableHighlightedAltCell: theme.table.highlightedAltCell,
    tableDisabledRow: theme.table.disabledRow,
    tableDisabledCell: theme.table.disabledCell,
    tableFooter: theme.table.footer,
    pager: theme.table.pager,
    left: {
      textAlign: "left"
    },
    right: {
      textAlign: "right"
    },
    center: {
      textAlign: "center"
    },
    clickable: {
      cursor: "pointer"
    },
    loader: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: "rgba(0, 0, 0, 0.12)"
    }
  };
};
var Table = /*#__PURE__*/function (_Component) {
  function Table() {
    var _this;
    _classCallCheck(this, Table);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$d(this, Table, [].concat(args));
    _defineProperty(_this, "state", {
      selection: {}
    });
    _defineProperty(_this, "_atom", function (a) {
      return !!a && a.reduce(function (m, i) {
        m[_this.itemIdentifier(i)] = i;
        return m;
      }, {});
    });
    _defineProperty(_this, "itemIdentifier", function (i) {
      if (!!_this.props.itemIdentifier) {
        return _this.props.itemIdentifier(i);
      } else {
        return i.uuid;
      }
    });
    _defineProperty(_this, "isSelected", function (i) {
      return !!_this.props.withSelection && !!_this.state.selection[_this.itemIdentifier(i)];
    });
    _defineProperty(_this, "select", function (i) {
      if (!_this.props.withSelection) return;
      var s = _this.state.selection;
      var id = _this.itemIdentifier(i);
      if (!!s[id]) {
        delete s[id];
      } else if (_this.props.withSelection === "multiple") {
        s[id] = i;
      } else {
        s = _defineProperty({}, id, i);
      }
      _this.setState({
        selection: s
      }, function (e) {
        return !!_this.props.onChangeSelection && _this.props.onChangeSelection(Object.values(_this.state.selection));
      });
    });
    _defineProperty(_this, "headerAction", function (a) {
      return /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        justifyContent: "flex-end"
      }, a()));
    });
    return _this;
  }
  _inherits(Table, _Component);
  return _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.withSelection) {
        this.setState(function (state, props) {
          return {
            selection: _this2._atom(props.selection || [])
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;
      if (this.props.withSelection && prevProps.selectAll !== this.props.selectAll) {
        this.setState(function (state, props) {
          return {
            selection: _$1.merge(state.selection, _this3._atom(props.items))
          };
        }, function (e) {
          return !!_this3.props.onChangeSelection && _this3.props.onChangeSelection(Object.values(_this3.state.selection));
        });
      }
      if (this.props.withSelection && prevProps.clearAll !== this.props.clearAll) {
        this.setState({
          selection: {}
        }, function (e) {
          return !!_this3.props.onChangeSelection && _this3.props.onChangeSelection(Object.values(_this3.state.selection));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        modulesManager = _this$props.modulesManager,
        classes = _this$props.classes,
        module = _this$props.module,
        header = _this$props.header,
        preHeaders = _this$props.preHeaders,
        headers = _this$props.headers,
        _this$props$aligns = _this$props.aligns,
        aligns = _this$props$aligns === void 0 ? [] : _this$props$aligns,
        _this$props$headerSpa = _this$props.headerSpans,
        headerSpans = _this$props$headerSpa === void 0 ? [] : _this$props$headerSpa,
        _this$props$headerAct = _this$props.headerActions,
        headerActions = _this$props$headerAct === void 0 ? [] : _this$props$headerAct,
        _this$props$colSpans = _this$props.colSpans,
        colSpans = _this$props$colSpans === void 0 ? [] : _this$props$colSpans,
        items = _this$props.items,
        itemFormatters = _this$props.itemFormatters,
        _this$props$rowHighli = _this$props.rowHighlighted,
        rowHighlighted = _this$props$rowHighli === void 0 ? null : _this$props$rowHighli,
        _this$props$rowHighli2 = _this$props.rowHighlightedAlt,
        rowHighlightedAlt = _this$props$rowHighli2 === void 0 ? null : _this$props$rowHighli2,
        _this$props$rowDisabl = _this$props.rowDisabled,
        rowDisabled = _this$props$rowDisabl === void 0 ? null : _this$props$rowDisabl,
        _this$props$rowLocked = _this$props.rowLocked,
        rowLocked = _this$props$rowLocked === void 0 ? null : _this$props$rowLocked,
        _this$props$withPagin = _this$props.withPagination,
        withPagination = _this$props$withPagin === void 0 ? false : _this$props$withPagin,
        _this$props$page = _this$props.page,
        page = _this$props$page === void 0 ? 0 : _this$props$page,
        pageSize = _this$props.pageSize,
        count = _this$props.count,
        size = _this$props.size,
        _this$props$rowsPerPa = _this$props.rowsPerPageOptions,
        rowsPerPageOptions = _this$props$rowsPerPa === void 0 ? [10, 20, 50] : _this$props$rowsPerPa,
        onChangeRowsPerPage = _this$props.onChangeRowsPerPage,
        onChangePage = _this$props.onChangePage;
        _this$props.onDoubleClick;
        var _this$props$onDelete = _this$props.onDelete,
        onDelete = _this$props$onDelete === void 0 ? null : _this$props$onDelete,
        _this$props$fetching = _this$props.fetching,
        fetching = _this$props$fetching === void 0 ? null : _this$props$fetching,
        _this$props$error = _this$props.error,
        error = _this$props$error === void 0 ? null : _this$props$error,
        subServicesItemsFormattersReview = _this$props.subServicesItemsFormattersReview,
        subServiceHeaders = _this$props.subServiceHeaders;
      var localHeaders = _toConsumableArray(headers || []);
      var localSubServiceHeaders = _toConsumableArray(subServiceHeaders || []);
      var localPreHeaders = !!preHeaders ? _toConsumableArray(preHeaders) : null;
      var localItemFormatters = _toConsumableArray(itemFormatters);
      var localsubServicesItemsFormattersReview = _toConsumableArray(subServicesItemsFormattersReview);
      var i = !!headers && headers.length;
      while (localHeaders && i--) {
        if (modulesManager !== null && modulesManager !== void 0 && modulesManager.hideField(module, localHeaders[i])) {
          if (!!localPreHeaders) localPreHeaders.splice(i, 1);
          if (!!aligns && aligns.length > i) aligns.splice(i, 1);
          if (!!headerSpans && headerSpans.length > i) headerSpans.splice(i, 1);
          if (!!headerActions && headerActions.length > i) headerActions.splice(i, 1);
          if (!!colSpans && colSpans.length > i) colSpans.splice(i, 1);
          localHeaders.splice(i, 1);
          localItemFormatters.splice(i, 1);
        }
      }
      if (!!onDelete) {
        if (localPreHeaders) localPreHeaders.push("");
        localHeaders.push("");
        localItemFormatters.push(function (i, idx) {
          return /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick(e) {
              return onDelete(idx);
            }
          }, /*#__PURE__*/React.createElement(DeleteIcon, null));
        });
      }
      var rowsPerPage = pageSize || rowsPerPageOptions[0];
      return /*#__PURE__*/React.createElement(Box, {
        position: "relative",
        overflow: "auto"
      }, header && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.tableTitle
      }, header), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Table$4, {
        className: classes.table,
        size: size
      }, !!localPreHeaders && localPreHeaders.length > 0 && /*#__PURE__*/React.createElement("table", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("tr", null, localPreHeaders.map(function (h, idx) {
        if (headerSpans.length > idx && !headerSpans[idx]) return null;
        return /*#__PURE__*/React.createElement(TableCell, {
          colSpan: headerSpans.length > idx ? headerSpans[idx] : 1,
          className: clsx(classes.tableHeader, aligns.length > idx && classes[aligns[idx]]),
          key: "preh-".concat(idx)
        }, !!h && h);
      }))), /*#__PURE__*/React.createElement(TableBody, null, items && items.length > 0 && items.map(function (i, iidx) {
        if (i.claimlinkedService != undefined) {
          console.log(i);
          return /*#__PURE__*/React.createElement(Box, {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement("table", {
            style: {
              width: "100%"
            }
          }, items.length - iidx == items.length && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[0]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[1]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[2]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[3]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[4]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[5]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localHeaders[6]
          }))), /*#__PURE__*/React.createElement("tr", null, localItemFormatters && localItemFormatters.map(function (f, fidx) {
            if (colSpans.length > fidx && !colSpans[fidx]) return null;
            return /*#__PURE__*/React.createElement(TableCell, {
              colSpan: colSpans.length > fidx ? colSpans[fidx] : 1,
              className: clsx(!!rowLocked && rowLocked(i) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltCell : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledCell : null, aligns.length > fidx && classes[aligns[fidx]]),
              key: "v-".concat(iidx, "-").concat(fidx)
            }, f(i, iidx));
          }))), localItemFormatters[0](i, iidx).props.children.props.value != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype !== "S" && /*#__PURE__*/React.createElement("table", {
            style: {
              marginTop: 10,
              width: "90%"
            }
          }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[0]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[1]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[2]
          })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
            module: module,
            id: localSubServiceHeaders[3]
          }))), localsubServicesItemsFormattersReview && localsubServicesItemsFormattersReview.map(function (s, sfidx) {
            return s(i, iidx);
          })));
        } else {
          return /*#__PURE__*/React.createElement(Box, {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement("table", {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement("tr", null, localItemFormatters && localItemFormatters.map(function (f, fidx) {
            if (colSpans.length > fidx && !colSpans[fidx]) return null;
            return /*#__PURE__*/React.createElement(TableCell, {
              colSpan: colSpans.length > fidx ? colSpans[fidx] : 1,
              className: clsx(!!rowLocked && rowLocked(i) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(i) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(i) ? classes.tableHighlightedAltCell : null, !!rowDisabled && rowDisabled(i) ? classes.tableDisabledCell : null, aligns.length > fidx && classes[aligns[fidx]]),
              key: "v-".concat(iidx, "-").concat(fidx)
            }, f(i, iidx));
          }))), localItemFormatters[0](i, iidx).props.children.props.value != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype != undefined && localItemFormatters[0](i, iidx).props.children.props.value.packagetype !== "S" && /*#__PURE__*/React.createElement("table", {
            style: {
              marginTop: 10,
              width: "90%"
            }
          }));
        }
      })), !!withPagination && !!count && /*#__PURE__*/React.createElement(TableFooter, {
        className: classes.tableFooter
      }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TablePagination, {
        className: classes.pager,
        colSpan: localItemFormatters.length,
        labelRowsPerPage: formatMessage(intl, "core", "rowsPerPage"),
        labelDisplayedRows: function labelDisplayedRows(_ref) {
          var from = _ref.from,
            to = _ref.to,
            count = _ref.count;
          return "".concat(from, "-").concat(to, " ").concat(formatMessageWithValues(intl, "core", "ofPages"), " ").concat(count);
        },
        count: count,
        page: page,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: rowsPerPageOptions,
        onRowsPerPageChange: function onRowsPerPageChange(e) {
          return onChangeRowsPerPage(e.target.value);
        },
        onPageChange: onChangePage
      })))), (fetching || error) && /*#__PURE__*/React.createElement(Grid, {
        className: classes.loader,
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(ProgressOrError$1, {
        progress: (items === null || items === void 0 ? void 0 : items.length) && fetching,
        error: error
      }), " "));
    }
  }]);
}(Component);
var TableServiceReview = withModulesManager(injectIntl(withTheme(withStyles(styles$d)(Table))));

function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$c = function styles(theme) {
  return {
    primaryButton: theme.dialog.primaryButton,
    secondaryButton: theme.dialog.secondaryButton
  };
};
var ExportConfigDialog = function ExportConfigDialog(_ref) {
  var classes = _ref.classes,
    module = _ref.module,
    confirmState = _ref.confirmState,
    getFilteredFieldsAndColumn = _ref.getFilteredFieldsAndColumn,
    chooseExportableColumns = _ref.chooseExportableColumns,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    columns = _ref.columns,
    exportFileFormat = _ref.exportFileFormat,
    setExportFileFormat = _ref.setExportFileFormat,
    exportFileFormats = _ref.exportFileFormats,
    chooseFileFormat = _ref.chooseFileFormat,
    _ref$displayClearAllC = _ref.displayClearAllColsButton,
    displayClearAllColsButton = _ref$displayClearAllC === void 0 ? true : _ref$displayClearAllC;
  var modulesManager = useModulesManager$1();
  var _useTranslations = useTranslations$1(module, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    columnBoolValues = _useState2[0],
    setColumnBoolValues = _useState2[1];
  useEffect(function () {
    if (Object.keys(columnBoolValues).length === 0) {
      var newColumnBoolValues = Object.fromEntries(Object.keys(columns).map(function (key) {
        return [key, true];
      }));
      setColumnBoolValues(newColumnBoolValues);
    }
  }, [columnBoolValues, columns]);
  var handleCheckboxChange = function handleCheckboxChange(key, checked) {
    setColumnBoolValues(_objectSpread$d(_objectSpread$d({}, columnBoolValues), {}, _defineProperty({}, key, checked)));
  };
  var fillCheckboxesWithValue = function fillCheckboxesWithValue(value) {
    var newColumnBoolValues = Object.fromEntries(Object.keys(columnBoolValues).map(function (key) {
      return [key, value];
    }));
    setColumnBoolValues(newColumnBoolValues);
  };
  var getFilteredColumns = function getFilteredColumns() {
    return Object.fromEntries(Object.entries(columnBoolValues).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2);
        _ref3[0];
        var checked = _ref3[1];
      return checked;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        key = _ref5[0];
      return [key, columns[key]];
    }));
  };
  var handleConfirm = function handleConfirm() {
    var filteredColumns = getFilteredColumns();
    var filteredFields = Object.keys(filteredColumns);
    getFilteredFieldsAndColumn(filteredFields, filteredColumns);
    onConfirm();
    fillCheckboxesWithValue(true);
  };
  var handleCancel = function handleCancel() {
    onClose();
    fillCheckboxesWithValue(true);
  };
  var showColumns = chooseExportableColumns && !isEmptyObject(columns);
  var showFileFormats = chooseFileFormat && !isEmptyObject(exportFileFormats);
  return /*#__PURE__*/React.createElement(Dialog, {
    open: confirmState,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, null, formatMessage("exportConfigDialog.title")), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent, null, showColumns && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography$1, null, " ", formatMessage("core.exportConfigDialog.selectColumns"), " "), columns && Object.entries(columns).map(function (_ref6, idx) {
    var _ref7 = _slicedToArray(_ref6, 2),
      key = _ref7[0],
      value = _ref7[1];
    return /*#__PURE__*/React.createElement(FormControlLabel$1, {
      key: idx,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        color: "primary",
        checked: columnBoolValues[key],
        onChange: function onChange(event) {
          return handleCheckboxChange(key, event.target.checked);
        }
      }),
      label: value
    });
  })), showFileFormats && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography$1, null, " ", formatMessage("core.exportConfigDialog.selectFormat"), " "), Object.entries(exportFileFormats).map(function (_ref8, idx) {
    var _ref9 = _slicedToArray(_ref8, 2),
      key = _ref9[0],
      value = _ref9[1];
    return /*#__PURE__*/React.createElement(FormControlLabel$1, {
      key: idx,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        icon: /*#__PURE__*/React.createElement(RadioButtonUncheckedIcon, null),
        checkedIcon: /*#__PURE__*/React.createElement(RadioButtonCheckedIcon, null),
        color: "primary",
        checked: exportFileFormat === key,
        onChange: function onChange() {
          return setExportFileFormat(key);
        }
      }),
      label: value
    });
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions, null, displayClearAllColsButton && showColumns && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return fillCheckboxesWithValue(false);
    },
    className: classes.secondaryButton
  }, formatMessage("exportConfigDialog.clearAllColsButton")), /*#__PURE__*/React.createElement(Button, {
    onClick: handleConfirm,
    autoFocus: true,
    className: classes.primaryButton
  }, formatMessage("exportConfigDialog.confirmButton")), /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancel,
    className: classes.secondaryButton
  }, formatMessage("exportConfigDialog.cancelButton"))));
};
var ExportConfigDialog$1 = injectIntl(withTheme(withStyles(styles$c)(ExportConfigDialog)));

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$b = function styles(theme) {
  return {
    error: {
      padding: theme.spacing(2)
    },
    errorHeader: {
      color: theme.palette.error.main
    },
    errorDetail: {
      color: theme.palette.error.main
    }
  };
};
function SearcherExport(props) {
  var intl = props.intl,
    selection = props.selection,
    filters = props.filters,
    exportFetch = props.exportFetch,
    exportFields = props.exportFields,
    exportFieldsColumns = props.exportFieldsColumns,
    chooseExportableColumns = props.chooseExportableColumns,
    additionalExportFields = props.additionalExportFields,
    chooseFileFormat = props.chooseFileFormat,
    exportFileFormats = props.exportFileFormats,
    _props$exportFileForm = props.exportFileFormat,
    exportFileFormat = _props$exportFileForm === void 0 ? EXPORT_FILE_FORMATS.csv : _props$exportFileForm,
    setExportFileFormat = props.setExportFileFormat,
    _props$label = props.label,
    label = _props$label === void 0 ? null : _props$label,
    selectWithCheckbox = props.selectWithCheckbox,
    downloadWithIconButton = props.downloadWithIconButton,
    displayClearAllColsButton = props.displayClearAllColsButton;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    exportStatus = _useState2[0];
    _useState2[1];
  var dispatch = useDispatch();
  var isExportConfigDialogOpen = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 ? void 0 : _state$core.isExportConfigDialogOpen;
  });
  var enabled = function enabled(selection) {
    return selectWithCheckbox ? !(selection !== null && selection !== void 0 && selection.length) && exportStatus === 0 : exportStatus === 0;
  };
  var exportData = function exportData() {
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exportFields;
    var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exportFieldsColumns;
    var additionalFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : additionalExportFields;
    var defaultFilters = Object.keys(filters).filter(function (f) {
      return !!filters[f]["filter"];
    }).map(function (f) {
      return filters[f]["filter"];
    });
    var additionalFilters = Object.entries(additionalFields || {}).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return "".concat(key, ": \"").concat(value, "\"");
    });
    var parameters = [].concat(_toConsumableArray(defaultFilters), _toConsumableArray(additionalFilters));
    parameters.push("fileFormat: \"".concat(exportFileFormat, "\""));
    parameters.push("fields: ".concat(JSON.stringify(fields)));
    parameters.push("fieldsColumns: \"".concat(JSON.stringify(columns).replace(/\"/g, '\\"'), "\""));
    exportFetch(parameters);
  };
  var handleExportData = function handleExportData() {
    if (chooseExportableColumns || chooseFileFormat) {
      dispatch(openExportConfigDialog());
    } else {
      exportData();
    }
  };
  var handleColumnFiltering = function handleColumnFiltering(fields, columns) {
    exportData(fields, columns);
  };
  var parseToDialogColumns = function parseToDialogColumns(columns, fields) {
    return fields.reduce(function (dialogColumns, field) {
      if (!(field in dialogColumns)) {
        dialogColumns[field] = field.startsWith("json_ext__") ? field.replace(/^json_ext__/, "") : field;
      }
      return dialogColumns;
    }, _objectSpread$c({}, columns));
  };
  var entries = [{
    text: label || formatMessage(intl, "core", "exportSearchResult"),
    icon: /*#__PURE__*/React.createElement(GetAppIcon, null),
    action: handleExportData
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, (chooseExportableColumns || chooseFileFormat) && /*#__PURE__*/React.createElement(ExportConfigDialog$1, {
    confirmState: isExportConfigDialogOpen,
    onConfirm: function onConfirm() {
      return dispatch(closeExportConfigDialog());
    },
    onClose: function onClose() {
      return dispatch(closeExportConfigDialog());
    },
    module: "core",
    getFilteredFieldsAndColumn: handleColumnFiltering,
    columns: parseToDialogColumns(exportFieldsColumns, exportFields),
    exportFileFormat: exportFileFormat,
    setExportFileFormat: setExportFileFormat,
    exportFileFormats: exportFileFormats,
    chooseFileFormat: chooseFileFormat,
    chooseExportableColumns: chooseExportableColumns,
    displayClearAllColsButton: displayClearAllColsButton
  }), /*#__PURE__*/React.createElement("div", null, entries.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: formatMessage(intl, "core", "exportSearchResult.tooltip")
    }, /*#__PURE__*/React.createElement("div", {
      key: "selectionsMenu-export-".concat(idx)
    }, downloadWithIconButton ? /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick(e) {
        return item.action();
      },
      disabled: !enabled(selection),
      variant: "contained",
      color: "primary",
      startIcon: item.icon
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: "body2"
    }, " ", item.text, " ")) : /*#__PURE__*/React.createElement(MenuItem, {
      onClick: function onClick(e) {
        return item.action();
      },
      disabled: !enabled(selection)
    }, item.text)));
  })));
}
var SearcherExport$1 = injectIntl(withStyles$1(styles$b)(SearcherExport));

var CustomFilterFieldStatusPicker = function CustomFilterFieldStatusPicker(_ref) {
  var value = _ref.value,
    label = _ref.label,
    onChange = _ref.onChange,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$withNull = _ref.withNull,
    withNull = _ref$withNull === void 0 ? false : _ref$withNull,
    _ref$nullLabel = _ref.nullLabel,
    nullLabel = _ref$nullLabel === void 0 ? null : _ref$nullLabel,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    customFilters = _ref.customFilters;
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;
  var options = Array.isArray(customFilters) && customFilters !== undefined ? _toConsumableArray(customFilters.map(function (customFilter) {
    return {
      value: {
        field: customFilter.field,
        type: customFilter.type
      },
      label: formatMessage("advancedFilters.".concat(customFilter.field))
    };
  })) : [];
  if (withNull) {
    options.unshift({
      value: null,
      label: nullLabel || ""
    });
  }
  return /*#__PURE__*/React.createElement(SelectInput$1, {
    module: "core",
    label: withLabel && label,
    options: options,
    value: value,
    onChange: onChange,
    readOnly: readOnly,
    required: required
  });
};

var CustomFilterTypeStatusPicker = function CustomFilterTypeStatusPicker(_ref) {
  _ref.intl;
    var value = _ref.value,
    label = _ref.label,
    onChange = _ref.onChange,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$withNull = _ref.withNull,
    withNull = _ref$withNull === void 0 ? false : _ref$withNull,
    _ref$nullLabel = _ref.nullLabel,
    nullLabel = _ref$nullLabel === void 0 ? null : _ref$nullLabel,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    customFilters = _ref.customFilters,
    customFilterField = _ref.customFilterField;
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;

  // Filter the available options based on the selected field
  var filterTypes = customFilters ? customFilters.filter(function (filter) {
    return filter.field === customFilterField;
  }).map(function (filter) {
    return filter.filter;
  }).flat() : [];
  var filteredOptions = filterTypes.map(function (filter) {
    return {
      value: filter,
      label: formatMessage("advancedFilters.".concat(filter))
    };
  });
  if (withNull) {
    filteredOptions.unshift({
      value: null,
      label: nullLabel || ""
    });
  }
  return /*#__PURE__*/React.createElement(SelectInput$1, {
    module: "core",
    label: withLabel && label,
    options: filteredOptions,
    value: value,
    onChange: onChange,
    readOnly: readOnly,
    required: required
  });
};
var CustomFilterTypeStatusPicker$1 = injectIntl(CustomFilterTypeStatusPicker);

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$a = function styles(theme) {
  return {
    item: theme.paper.item
  };
};
var AdvancedFilterRowValue = function AdvancedFilterRowValue(_ref) {
  _ref.intl;
    var classes = _ref.classes,
    customFilters = _ref.customFilters,
    currentFilter = _ref.currentFilter,
    setCurrentFilter = _ref.setCurrentFilter,
    index = _ref.index,
    filters = _ref.filters,
    setFilters = _ref.setFilters;
  var onAttributeChange = function onAttributeChange(attribute) {
    return function (value) {
      var updatedFilter = _objectSpread$b({}, currentFilter);
      if (attribute === 'field') {
        updatedFilter = _objectSpread$b({}, {
          filter: '',
          value: '',
          type: value.type
        });
      }
      var attributeValue = attribute === 'field' ? value.field : value;
      updatedFilter = _objectSpread$b(_objectSpread$b({}, updatedFilter), {}, _defineProperty({}, attribute, attributeValue), attribute === 'filter' && {
        value: ''
      });
      setCurrentFilter(updatedFilter);
      setFilters(function (prevFilters) {
        var updatedRows = _toConsumableArray(prevFilters);
        updatedRows[index] = _objectSpread$b({}, updatedFilter);
        return updatedRows;
      });
    };
  };
  var removeFilter = function removeFilter() {
    var newArray = _toConsumableArray(filters);
    newArray.splice(index, 1);
    setFilters(newArray.length === 0 ? [CLEARED_STATE_FILTER] : newArray);
  };
  var renderInputBasedOnType = function renderInputBasedOnType(type) {
    var commonProps = {
      module: "core",
      label: "core.advancedFilters.value",
      value: currentFilter.value,
      onChange: onAttributeChange("value")
    };
    switch (type) {
      case BOOLEAN:
        return /*#__PURE__*/React.createElement(SelectInput$2, _extends({
          options: BOOL_OPTIONS
        }, commonProps));
      case INTEGER:
        return /*#__PURE__*/React.createElement(NumberInput$2, _extends({
          min: 0,
          displayZero: true
        }, commonProps));
      case STRING:
      default:
        if (currentFilter.field.toLowerCase().includes(DATE)) {
          return /*#__PURE__*/React.createElement(PublishedComponent$2, _extends({
            pubRef: "core.DatePicker"
          }, commonProps));
        } else {
          return /*#__PURE__*/React.createElement(TextInput$2, commonProps);
        }
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    className: classes.item,
    style: {
      backgroundColor: "#DFEDEF"
    }
  }, filters.length > 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#DFEDEF',
      width: '25px',
      height: '25px',
      marginTop: '25px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      transform: 'translate(-50%, -50%)',
      fontSize: '16px',
      color: '#006273'
    },
    onClick: removeFilter
  }, "\u2716")) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomFilterFieldStatusPicker, {
    module: "core",
    label: "core.advancedFilters.field",
    value: {
      field: currentFilter.field,
      type: currentFilter.type
    },
    onChange: onAttributeChange("field"),
    customFilters: customFilters
  })), currentFilter.field !== "" ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomFilterTypeStatusPicker$1, {
    module: "core",
    label: "core.advancedFilters.filter",
    value: currentFilter.filter,
    onChange: onAttributeChange("filter"),
    customFilters: customFilters,
    customFilterField: currentFilter.field
  })) : /*#__PURE__*/React.createElement(React.Fragment, null), currentFilter.field !== "" && currentFilter.filter !== "" ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    className: classes.item
  }, renderInputBasedOnType(currentFilter.type)) : /*#__PURE__*/React.createElement(React.Fragment, null));
};
var AdvancedFilterRowValue$1 = injectIntl(withTheme(withStyles(styles$a)(connect(null, null)(AdvancedFilterRowValue))));

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$9 = function styles(theme) {
  return {
    item: theme.paper.item,
    paperHeaderAction: _objectSpread$a(_objectSpread$a({}, theme.paper.action), {}, {
      display: "flex",
      justifyContent: "center",
      itemAlign: "center"
    })
  };
};
var AdvancedFiltersDialog = function AdvancedFiltersDialog(_ref) {
  var intl = _ref.intl,
    classes = _ref.classes,
    object = _ref.object,
    additionalParams = _ref.additionalParams,
    fetchCustomFilter = _ref.fetchCustomFilter,
    customFilters = _ref.customFilters,
    moduleName = _ref.moduleName,
    objectType = _ref.objectType;
    _ref.appliedCustomFilters;
    var setAppliedCustomFilters = _ref.setAppliedCustomFilters,
    onChangeFilters = _ref.onChangeFilters,
    appliedFiltersRowStructure = _ref.appliedFiltersRowStructure,
    setAppliedFiltersRowStructure = _ref.setAppliedFiltersRowStructure,
    applyNumberCircle = _ref.applyNumberCircle,
    searchCriteria = _ref.searchCriteria,
    deleteFilter = _ref.deleteFilter;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState({
      field: "",
      filter: "",
      type: "",
      value: ""
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    currentFilter = _useState4[0],
    setCurrentFilter = _useState4[1];
  var _useState5 = useState([currentFilter]),
    _useState6 = _slicedToArray(_useState5, 2),
    filters = _useState6[0],
    setFilters = _useState6[1];
  var searchCriteriaToArray = function searchCriteriaToArray() {
    var _searchCriteria$CUSTO;
    return hasCustomFilters() ? JSON.parse((_searchCriteria$CUSTO = searchCriteria[CUSTOM_FILTERS]) === null || _searchCriteria$CUSTO === void 0 ? void 0 : _searchCriteria$CUSTO.filter.split(WHITE_SPACE)[1]) : appliedFiltersRowStructure;
  };
  var jsonFiltersToRowFilters = function jsonFiltersToRowFilters() {
    var arrayFilters = searchCriteriaToArray();
    return arrayFilters.map(function (filterString) {
      var _filterString$split = filterString.split(DOUBLE_UNDERSCORE),
        _filterString$split2 = _slicedToArray(_filterString$split, 3),
        field = _filterString$split2[0],
        filter = _filterString$split2[1],
        typeValue = _filterString$split2[2];
      var _typeValue$split = typeValue.split(EQUALS_SIGN),
        _typeValue$split2 = _slicedToArray(_typeValue$split, 2),
        type = _typeValue$split2[0],
        value = _typeValue$split2[1];
      return {
        field: field,
        filter: filter,
        type: type,
        value: JSON.parse(value)
      };
    });
  };
  var createParams = function createParams(moduleName, objectTypeName) {
    var uuidOfObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var additionalParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var params = ["moduleName: \"".concat(moduleName, "\""), "objectTypeName: \"".concat(objectTypeName, "\"")];
    if (uuidOfObject) {
      params.push("uuidOfObject: \"".concat(uuidOfObject, "\""));
    }
    if (additionalParams) {
      params.push("additionalParams: ".concat(JSON.stringify(JSON.stringify(additionalParams))));
    }
    return params;
  };
  var fetchFilters = function fetchFilters(params) {
    return fetchCustomFilter(params);
  };
  var handleOpen = function handleOpen() {
    hasCustomFilters() && isAppliedFiltersRowStructureEmpty() ? setFilters(jsonFiltersToRowFilters()) : setFilters(appliedFiltersRowStructure);
    setIsOpen(true);
  };
  var isAppliedFiltersRowStructureEmpty = function isAppliedFiltersRowStructureEmpty() {
    var _appliedFiltersRowStr = _slicedToArray(appliedFiltersRowStructure, 1),
      _appliedFiltersRowStr2 = _appliedFiltersRowStr[0],
      firstFilter = _appliedFiltersRowStr2 === void 0 ? {} : _appliedFiltersRowStr2;
    return !(firstFilter.filter && firstFilter.field && firstFilter.type);
  };
  var handleClose = function handleClose() {
    setCurrentFilter(CLEARED_STATE_FILTER);
    setIsOpen(false);
  };
  var handleRemoveFilter = function handleRemoveFilter() {
    setCurrentFilter(CLEARED_STATE_FILTER);
    setAppliedFiltersRowStructure([CLEARED_STATE_FILTER]);
    setFilters([CLEARED_STATE_FILTER]);
  };
  var handleAddFilter = function handleAddFilter() {
    setCurrentFilter(CLEARED_STATE_FILTER);
    setFilters([].concat(_toConsumableArray(filters), [CLEARED_STATE_FILTER]));
  };
  var applyFilter = function applyFilter() {
    setAppliedFiltersRowStructure(filters);
    var outputFilters = JSON.stringify(filters.map(function (_ref2) {
      var filter = _ref2.filter,
        value = _ref2.value,
        field = _ref2.field,
        type = _ref2.type;
      if (type === 'integer') {
        return "".concat(field, "__").concat(filter, "__").concat(type, "=").concat(value);
      } else {
        return "".concat(field, "__").concat(filter, "__").concat(type, "=").concat(JSON.stringify(value));
      }
    }));
    if (checkArrayFilterStructure() === false) {
      onChangeFilters([{
        id: 'customFilters',
        outputFilters: outputFilters,
        filter: "customFilters: ".concat(outputFilters)
      }]);
      setAppliedCustomFilters(outputFilters);
    } else {
      deleteFilter('customFilters');
    }
    handleClose();
  };
  function checkArrayFilterStructure() {
    if (filters.length === 1) {
      var firstObj = filters[0];
      if (checkFilterFields(firstObj)) {
        return true;
      }
    }
    return false;
  }
  function checkFilterFields(dict) {
    return Object.entries(dict).some(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return key !== 'value' && (value === null || value === '');
    });
  }
  function hasCustomFilters() {
    return CUSTOM_FILTERS in searchCriteria;
  }
  useEffect(function () {
    if (objectType) {
      // Update the state with new parameters
      var paramsToFetchFilters = [];
      paramsToFetchFilters = createParams(moduleName, objectType, object ? object === null || object === void 0 ? void 0 : object.id : null, additionalParams);
      fetchFilters(paramsToFetchFilters);
    }
  }, [objectType]);

  // refresh component when list of filters is changed
  useEffect(function () {}, [filters]);
  useEffect(function () {
    if (hasCustomFilters() === false) {
      handleRemoveFilter();
    }
  }, [searchCriteria]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    className: classes.paperHeaderAction
  }, /*#__PURE__*/React.createElement(SearcherActionButton$1, {
    startIcon: /*#__PURE__*/React.createElement(FilterListIcon, null),
    label: formatMessage$1(intl, "core", "advancedFilters"),
    onClick: handleOpen
  })), appliedFiltersRowStructure.length > 0 && hasCustomFilters() ? applyNumberCircle(searchCriteriaToArray().length) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Dialog$1, {
    open: isOpen,
    onClose: handleClose,
    PaperProps: {
      style: {
        width: 900,
        maxWidth: 900
      }
    }
  }, /*#__PURE__*/React.createElement(DialogTitle$1, {
    style: {
      marginTop: "10px"
    }
  }, formatMessage$1(intl, "core", "advancedFilters.button.AdvancedFilters")), /*#__PURE__*/React.createElement(DialogContent$1, null, filters.map(function (filter, index) {
    return /*#__PURE__*/React.createElement(AdvancedFilterRowValue$1, {
      customFilters: customFilters,
      currentFilter: filter,
      setCurrentFilter: setCurrentFilter,
      index: index,
      filters: filters,
      setFilters: setFilters
    });
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "#DFEDEF",
      paddingLeft: "10px",
      paddingBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(AddIcon, {
    style: {
      border: "thin solid",
      borderRadius: "40px",
      width: "16px",
      height: "16px"
    },
    onClick: handleAddFilter
  }), /*#__PURE__*/React.createElement(Button$1, {
    onClick: handleAddFilter,
    variant: "outlined",
    style: {
      border: "0px",
      "marginBottom": "6px",
      fontSize: "0.8rem"
    }
  }, formatMessage$1(intl, "core", "core.advancedFilters.button.addFilters")))), /*#__PURE__*/React.createElement(DialogActions$1, {
    style: {
      display: "inline",
      paddingLeft: "10px",
      marginTop: "25px",
      marginBottom: "15px"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      "float": "left"
    }
  }, /*#__PURE__*/React.createElement(Button$1, {
    onClick: handleRemoveFilter,
    variant: "outlined",
    style: {
      border: "0px"
    }
  }, formatMessage$1(intl, "core", "core.advancedFilters.button.clearAllFilters"))), /*#__PURE__*/React.createElement("div", {
    style: {
      "float": "right",
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React.createElement(Button$1, {
    onClick: handleClose,
    variant: "outlined",
    autoFocus: true,
    style: {
      margin: "0 16px"
    }
  }, formatMessage$1(intl, "core", "core.advancedFilters.button.cancel")), /*#__PURE__*/React.createElement(Button$1, {
    onClick: applyFilter,
    variant: "contained",
    color: "primary",
    autoFocus: true
  }, formatMessage$1(intl, "core", "core.advancedFilters.button.filter")))))));
};
var mapStateToProps$7 = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    confirmed: state.core.confirmed,
    fetchingCustomFilters: state.core.fetchingCustomFilters,
    errorCustomFilters: state.core.errorCustomFilters,
    fetchedCustomFilters: state.core.fetchedCustomFilters,
    customFilters: state.core.customFilters
  };
};
var mapDispatchToProps$5 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCustomFilter: fetchCustomFilter
  }, dispatch);
};
var AdvancedFiltersDialog$1 = injectIntl(withTheme(withStyles(styles$9)(connect(mapStateToProps$7, mapDispatchToProps$5)(AdvancedFiltersDialog))));

function _callSuper$c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$8 = function styles(theme) {
  return {
    paper: theme.paper.body,
    paperHeader: _objectSpread$9(_objectSpread$9({}, theme.paper.header), {}, {
      display: "flex",
      justifyContent: "flex-end",
      itemAlign: "center"
    }),
    paperHeaderTitle: theme.paper.title,
    paperHeaderAction: _objectSpread$9(_objectSpread$9({}, theme.paper.action), {}, {
      display: "flex",
      justifyContent: "center",
      itemAlign: "center"
    }),
    paperDivider: theme.paper.divider
  };
};
var SearcherPane = /*#__PURE__*/function (_Component) {
  function SearcherPane(props) {
    var _this;
    _classCallCheck(this, SearcherPane);
    _this = _callSuper$c(this, SearcherPane, [props]);
    _defineProperty(_this, "handleKeyDown", function (event) {
      if (event.key === ENTER_KEY) {
        _this.debouncedRefresh();
      }
    });
    var _this$props = _this.props,
      _this$props$refresh = _this$props.refresh,
      refresh = _this$props$refresh === void 0 ? function () {} : _this$props$refresh,
      _this$props$reset = _this$props.reset,
      reset = _this$props$reset === void 0 ? function () {} : _this$props$reset;
    _this.debouncedRefresh = _debounce(refresh, DEFAULT_DEBOUNCE_TIME);
    _this.debouncedReset = _debounce(reset, DEFAULT_DEBOUNCE_TIME);
    return _this;
  }
  _inherits(SearcherPane, _Component);
  return _createClass(SearcherPane, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        module = _this$props2.module,
        del = _this$props2.del,
        _this$props2$title = _this$props2.title,
        title = _this$props2$title === void 0 ? "search.title" : _this$props2$title,
        _this$props2$split = _this$props2.split,
        split = _this$props2$split === void 0 ? 8 : _this$props2$split,
        filterPane = _this$props2.filterPane,
        filters = _this$props2.filters,
        _this$props2$resultsP = _this$props2.resultsPane,
        resultsPane = _this$props2$resultsP === void 0 ? null : _this$props2$resultsP,
        reset = _this$props2.reset,
        refresh = _this$props2.refresh,
        actions = _this$props2.actions,
        _this$props2$isCustom = _this$props2.isCustomFiltering,
        isCustomFiltering = _this$props2$isCustom === void 0 ? false : _this$props2$isCustom,
        _this$props2$objectFo = _this$props2.objectForCustomFiltering,
        objectForCustomFiltering = _this$props2$objectFo === void 0 ? null : _this$props2$objectFo,
        _this$props2$addition = _this$props2.additionalCustomFilterParams,
        additionalCustomFilterParams = _this$props2$addition === void 0 ? null : _this$props2$addition,
        _this$props2$moduleNa = _this$props2.moduleName,
        moduleName = _this$props2$moduleNa === void 0 ? null : _this$props2$moduleNa,
        _this$props2$objectTy = _this$props2.objectType,
        objectType = _this$props2$objectTy === void 0 ? null : _this$props2$objectTy,
        _this$props2$setAppli = _this$props2.setAppliedCustomFilters,
        setAppliedCustomFilters = _this$props2$setAppli === void 0 ? null : _this$props2$setAppli,
        _this$props2$appliedC = _this$props2.appliedCustomFilters,
        appliedCustomFilters = _this$props2$appliedC === void 0 ? null : _this$props2$appliedC,
        onChangeFilters = _this$props2.onChangeFilters,
        _this$props2$appliedF = _this$props2.appliedFiltersRowStructure,
        appliedFiltersRowStructure = _this$props2$appliedF === void 0 ? null : _this$props2$appliedF,
        _this$props2$setAppli2 = _this$props2.setAppliedFiltersRowStructure,
        setAppliedFiltersRowStructure = _this$props2$setAppli2 === void 0 ? null : _this$props2$setAppli2,
        _this$props2$applyNum = _this$props2.applyNumberCircle,
        applyNumberCircle = _this$props2$applyNum === void 0 ? null : _this$props2$applyNum;
      return /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: split,
        className: classes.paperHeaderTitle
      }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: title
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12 - split,
        className: classes.paperHeader
      }, (!!actions || !!refresh) && /*#__PURE__*/React.createElement(React.Fragment, null, isCustomFiltering === true ? /*#__PURE__*/React.createElement(AdvancedFiltersDialog$1, {
        object: objectForCustomFiltering,
        additionalParams: additionalCustomFilterParams,
        moduleName: moduleName,
        objectType: objectType,
        setAppliedCustomFilters: setAppliedCustomFilters,
        appliedCustomFilters: appliedCustomFilters,
        onChangeFilters: onChangeFilters,
        appliedFiltersRowStructure: appliedFiltersRowStructure,
        setAppliedFiltersRowStructure: setAppliedFiltersRowStructure,
        applyNumberCircle: applyNumberCircle,
        searchCriteria: filters,
        deleteFilter: del
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), !!actions && actions.map(function (a, idx) {
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          key: "action-".concat(idx),
          className: classes.paperHeaderAction
        }, /*#__PURE__*/React.createElement(SearcherActionButton$1, {
          onClick: a.action,
          startIcon: a.icon,
          label: a.label || ''
        }));
      }), !!reset && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        key: "action-reset",
        className: classes.paperHeaderAction
      }, /*#__PURE__*/React.createElement(SearcherActionButton$1, {
        startIcon: /*#__PURE__*/React.createElement(YoutubeSearchedFor, null),
        onClick: this.debouncedReset,
        label: formatMessage(this.props.intl, module, "resetFilterTooltip")
      })), !!refresh && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        key: "action-refresh",
        className: classes.paperHeaderAction
      }, /*#__PURE__*/React.createElement(SearcherActionButton$1, {
        startIcon: /*#__PURE__*/React.createElement(Search, null),
        onClick: this.debouncedRefresh,
        label: formatMessage(this.props.intl, module, "refreshFilterTooltip")
      })))), !!filterPane && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.paperDivider
      }, /*#__PURE__*/React.createElement(Divider, null)), filterPane), !!resultsPane && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.paperDivider
      }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, resultsPane))));
    }
  }]);
}(Component);
var SearcherPane$1 = injectIntl(withTheme(withStyles(styles$8)(SearcherPane)));

var useStyles = makeStyles$1(function (theme) {
  return {
    popoverContent: {
      padding: theme.spacing(1)
    },
    iconSmall: {
      fontSize: 16
    },
    iconMedium: {
      fontSize: 24
    },
    iconLarge: {
      fontSize: 32
    },
    maxWidthSmall: {
      maxWidth: 300
    },
    maxWidthMedium: {
      maxWidth: 450
    },
    maxWidthLarge: {
      maxWidth: 600
    }
  };
});
function InfoButton(_ref) {
  var _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? "medium" : _ref$iconSize,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? "primary" : _ref$iconColor,
    _ref$iconButtonSize = _ref.iconButtonSize,
    iconButtonSize = _ref$iconButtonSize === void 0 ? "medium" : _ref$iconButtonSize,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? "medium" : _ref$maxWidth,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? "" : _ref$content,
    _ref$anchorOrigin = _ref.anchorOrigin,
    anchorOrigin = _ref$anchorOrigin === void 0 ? {
      vertical: "bottom",
      horizontal: "center"
    } : _ref$anchorOrigin,
    _ref$transformOrigin = _ref.transformOrigin,
    transformOrigin = _ref$transformOrigin === void 0 ? {
      vertical: "top",
      horizontal: "right"
    } : _ref$transformOrigin;
  var classes = useStyles();
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var handleClick = useCallback(function (event) {
    setAnchorEl(event.currentTarget);
  }, []);
  var handleClose = useCallback(function () {
    setAnchorEl(null);
  }, []);
  var open = Boolean(anchorEl);
  var id = open ? "info-popover" : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: formatMessage("InfoButton.tooltip")
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: iconButtonSize,
    onClick: handleClick,
    "aria-describedby": id
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    color: iconColor,
    className: clsx(_defineProperty(_defineProperty(_defineProperty({}, classes.iconSmall, iconSize === "small"), classes.iconMedium, iconSize === "medium"), classes.iconLarge, iconSize === "large"))
  }))), /*#__PURE__*/React.createElement(Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2",
    className: clsx(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.popoverContent, true), classes.maxWidthSmall, maxWidth === "small"), classes.maxWidthMedium, maxWidth === "medium"), classes.maxWidthLarge, maxWidth === "large"))
  }, content)));
}

function _callSuper$b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$7 = function styles(theme) {
  return {
    root: {
      width: "100%"
    },
    paper: _objectSpread$8(_objectSpread$8({}, theme.paper.body), {}, {
      boxShadow: "none"
    }),
    paperHeader: theme.paper.header,
    paperHeaderTitle: theme.paper.title,
    paperHeaderMessage: theme.paper.message,
    paperHeaderAction: {
      paddingInline: 5
    },
    tableHeaderAction: theme.table.headerAction,
    processing: {
      margin: theme.spacing(1)
    },
    searcherActions: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      gap: theme.spacing(1),
      backgroundColor: theme.palette.background["default"],
      border: 0
    },
    tableContainer: _objectSpread$8(_objectSpread$8({}, theme.table.container), {}, {
      boxShadow: theme.shadows[2]
    }),
    infoSection: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      gap: theme.spacing(1)
    }
  };
};
var SelectionPane = /*#__PURE__*/function (_Component) {
  function SelectionPane() {
    _classCallCheck(this, SelectionPane);
    return _callSuper$b(this, SelectionPane, arguments);
  }
  _inherits(SelectionPane, _Component);
  return _createClass(SelectionPane, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        module = _this$props.module,
        selectionMessage = _this$props.selectionMessage,
        selection = _this$props.selection;
      if (!selectionMessage || !selection || !selection.length) return null;
      return /*#__PURE__*/React.createElement(Typography$1, null, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: selectionMessage,
        values: {
          count: /*#__PURE__*/React.createElement("b", null, selection.length)
        }
      }));
    }
  }]);
}(Component);
var SelectionMenu = /*#__PURE__*/function (_Component2) {
  function SelectionMenu() {
    var _this;
    _classCallCheck(this, SelectionMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$b(this, SelectionMenu, [].concat(args));
    _defineProperty(_this, "state", {
      anchorEl: null
    });
    _defineProperty(_this, "openMenu", function (e) {
      return _this.setState({
        anchorEl: e.currentTarget
      });
    });
    _defineProperty(_this, "closeMenu", function (e) {
      return _this.setState({
        anchorEl: null
      });
    });
    _defineProperty(_this, "action", function (a) {
      _this.setState({
        anchorEl: null
      }, function (e) {
        return _this.props.triggerAction(a);
      });
    });
    _defineProperty(_this, "renderButtons", function (entries, contributionKey) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: _this.props.classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        className: _this.props.classes.paperHeaderAction
      }, entries.map(function (i, idx) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: "selectionsButtons-".concat(idx),
          item: true,
          className: _this.props.classes.paperHeaderAction
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: function onClick(e) {
            return _this.action(i.action);
          }
        }, i.text));
      }), _this.props.exportable && /*#__PURE__*/React.createElement(SearcherExport$1, {
        selection: _this.props.selection,
        selectWithCheckbox: _this.props.selectWithCheckbox,
        filters: _this.props.filters,
        exportFetch: _this.props.exportFetch,
        additionalExportFields: _this.props.additionalExportFields,
        exportFields: _this.props.exportFields,
        exportFieldsColumns: _this.props.exportFieldsColumns,
        chooseExportableColumns: _this.props.chooseExportableColumns,
        label: _this.props.exportFieldLabel,
        chooseFileFormat: _this.props.chooseFileFormat,
        exportFileFormats: _this.props.exportFileFormats,
        exportFileFormat: _this.props.exportFileFormat,
        setExportFileFormat: _this.props.setExportFileFormat,
        downloadWithIconButton: _this.props.downloadWithIconButton,
        displayClearAllColsButton: _this.props.displayClearAllColsButton
      }), !!contributionKey && /*#__PURE__*/React.createElement(Contributions, {
        actionHandler: _this.action,
        refetch: _this.props.refetch,
        clearSelected: _this.props.clearSelected,
        withSelection: _this.props.withSelection,
        selection: _this.props.selection,
        contributionKey: contributionKey,
        downloadWithIconButton: _this.props.downloadWithIconButton
      })));
    });
    _defineProperty(_this, "renderMenu", function (entries, contributionKey) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: _this.props.classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: _this.props.classes.paperHeaderAction
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: _this.openMenu
      }, /*#__PURE__*/React.createElement(MoreHoriz, null)))), /*#__PURE__*/React.createElement(Menu, {
        open: !!_this.state.anchorEl,
        anchorEl: _this.state.anchorEl,
        onClose: _this.closeMenu,
        keepMounted: true
      }, entries.map(function (i, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: "selectionsMenu-".concat(idx),
          onClick: function onClick(e) {
            return _this.action(i.action);
          }
        }, i.text);
      }), _this.props.exportable && /*#__PURE__*/React.createElement(SearcherExport$1, {
        selection: _this.props.selection,
        selectWithCheckbox: _this.props.selectWithCheckbox,
        filters: _this.props.filters,
        exportFetch: _this.props.exportFetch,
        exportFields: _this.props.exportFields,
        exportFieldsColumns: _this.props.exportFieldsColumns,
        chooseExportableColumns: _this.props.chooseExportableColumns,
        additionalExportFields: _this.props.additionalExportFields,
        chooseFileFormat: _this.props.chooseFileFormat,
        exportFileFormats: _this.props.exportFileFormats,
        downloadWithIconButton: _this.props.downloadWithIconButton,
        displayClearAllColsButton: _this.props.displayClearAllColsButton
      }), !!contributionKey && /*#__PURE__*/React.createElement(Contributions, {
        actionHandler: _this.action,
        selection: _this.props.selection,
        contributionKey: contributionKey
      })));
    });
    return _this;
  }
  _inherits(SelectionMenu, _Component2);
  return _createClass(SelectionMenu, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        modulesManager = _this$props2.modulesManager,
        intl = _this$props2.intl,
        classes = _this$props2.classes,
        canSelectAll = _this$props2.canSelectAll,
        selection = _this$props2.selection,
        clearSelected = _this$props2.clearSelected,
        selectAll = _this$props2.selectAll,
        _this$props2$actions = _this$props2.actions,
        actions = _this$props2$actions === void 0 ? [] : _this$props2$actions,
        processing = _this$props2.processing,
        _this$props2$actionsC = _this$props2.actionsContributionKey,
        actionsContributionKey = _this$props2$actionsC === void 0 ? null : _this$props2$actionsC;
      var contributed_entries = modulesManager.getContribs(actionsContributionKey);
      if (!actions.length && !contributed_entries) return null;
      if (processing) {
        return /*#__PURE__*/React.createElement(CircularProgress, {
          className: classes.processing,
          size: 24
        });
      }
      var entries = [];
      var selectionCount = selection.length;
      if (!!selectionCount) {
        entries.push({
          text: formatMessage(intl, "claim", "clearSelected"),
          action: clearSelected
        });
      }
      if (!!canSelectAll && canSelectAll(this.props.selection)) {
        entries.push({
          text: formatMessage(intl, "claim", "selectAll"),
          action: selectAll
        });
      }
      actions.forEach(function (a) {
        if (a.enabled(selection)) {
          entries.push({
            text: formatMessage(intl, "claim", a.label),
            action: a.action
          });
        }
      });
      if (this.props.selectWithCheckbox) {
        return this.renderButtons([], actionsContributionKey);
      }
      if (entries.length > 2 || this.props.exportable && entries.length >= 1) {
        return this.renderMenu(entries, actionsContributionKey);
      }
      return this.renderButtons(entries, actionsContributionKey);
    }
  }]);
}(Component);
var StyledSelectionMenu = injectIntl(withModulesManager(withTheme(withStyles(styles$7)(SelectionMenu))));
var Searcher = /*#__PURE__*/function (_Component3) {
  function Searcher(_props) {
    var _this2;
    _classCallCheck(this, Searcher);
    _this2 = _callSuper$b(this, Searcher, [_props]);
    _defineProperty(_this2, "state", {
      filters: {},
      orderBy: null,
      page: 0,
      pageSize: _this2.props.defaultPageSize || 10,
      afterCursor: null,
      beforeCursor: null,
      selection: [],
      selectAll: 0,
      clearAll: 0,
      menuAnchor: null
    });
    _defineProperty(_this2, "filtersToQueryParams", function () {
      var _this2$state = _this2.state,
        page = _this2$state.page,
        afterCursor = _this2$state.afterCursor,
        beforeCursor = _this2$state.beforeCursor;
      var _this2$props = _this2.props,
        module = _this2$props.module,
        saveCurrentPaginationPage = _this2$props.saveCurrentPaginationPage;
      saveCurrentPaginationPage(page, afterCursor, beforeCursor, module);
      if (_this2.props.filtersToQueryParams) return _this2.props.filtersToQueryParams(_this2.state);
      var prms = Object.keys(_this2.state.filters).filter(function (f) {
        return !!_this2.state.filters[f]["filter"];
      }).map(function (f) {
        return _this2.state.filters[f]["filter"];
      });
      if (!_this2.state.beforeCursor && !_this2.state.afterCursor) {
        prms.push("first: ".concat(_this2.state.pageSize));
      }
      if (!!_this2.state.afterCursor) {
        prms.push("after: \"".concat(_this2.state.afterCursor, "\""));
        prms.push("first: ".concat(_this2.state.pageSize));
      }
      if (!!_this2.state.beforeCursor) {
        prms.push("before: \"".concat(_this2.state.beforeCursor, "\""));
        prms.push("last: ".concat(_this2.state.pageSize));
      }
      if (!!_this2.state.orderBy) {
        prms.push("orderBy: [\"".concat(_this2.state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this2, "resetFilters", function () {
      _this2.setState(function (state, props) {
        return {
          filters: _objectSpread$8({}, _this2.props.defaultFilters),
          orderBy: props.defaultOrderBy
        };
      }, function (e) {
        return _this2.applyFilters();
      });
    });
    _defineProperty(_this2, "onChangeFilters", function (fltrs) {
      var filters = _objectSpread$8({}, _this2.state.filters);
      fltrs.forEach(function (filter) {
        if (filter.value === null) {
          delete filters[filter.id];
        } else {
          filters[filter.id] = {
            value: filter.value,
            filter: filter.filter
          };
        }
      });
      _this2.setState({
        filters: filters
      });
    });
    _defineProperty(_this2, "_notifyFiltersApplied", function () {
      if (_this2.props.onFiltersApplied) {
        _this2.props.onFiltersApplied(_this2.state.filters);
      }
    });
    _defineProperty(_this2, "_cacheAndApply", function () {
      var filters = _this2.filtersToQueryParams();
      if (!!_this2.props.cacheFiltersKey) {
        var cacheKey = _this2._getCacheKey();
        _this2.props.cacheFilters(cacheKey, _this2.state.filters);
        _this2.props.fetch(filters);
      } else {
        _this2.props.fetch(filters);
      }
      _this2._notifyFiltersApplied();
    });
    _defineProperty(_this2, "applyFilters", function () {
      _this2.setState(function (state, props) {
        return {
          page: 0,
          afterCursor: null,
          beforeCursor: null,
          clearAll: state.clearAll + 1
        };
      }, _this2._cacheAndApply);
    });
    _defineProperty(_this2, "deleteFilter", function (filter) {
      var fltrs = _this2.state.filters;
      delete fltrs[filter];
      _this2.setState({
        filters: fltrs,
        page: 0,
        afterCursor: null,
        beforeCursor: null
      }, _this2._cacheAndApply);
    });
    _defineProperty(_this2, "clearSelected", function (e) {
      _this2.setState(function (state, props) {
        return {
          clearAll: state.clearAll + 1
        };
      });
    });
    _defineProperty(_this2, "selectAll", function (e) {
      _this2.setState({
        selectAll: _this2.state.selectAll + 1
      });
    });
    _defineProperty(_this2, "onChangeSelection", function (selection) {
      _this2.setState({
        selection: selection
      });
    });
    _defineProperty(_this2, "onChangeRowsPerPage", function (cnt) {
      _this2.setState({
        pageSize: cnt,
        page: 0,
        afterCursor: null,
        beforeCursor: null
      }, function (e) {
        return _this2.props.fetch(_this2.filtersToQueryParams());
      });
    });
    _defineProperty(_this2, "onChangePage", function (page, nbr) {
      if (nbr > _this2.state.page) {
        _this2.setState(function (state, props) {
          return {
            page: state.page + 1,
            beforeCursor: null,
            afterCursor: props.itemsPageInfo.endCursor
          };
        }, function (e) {
          return _this2.props.fetch(_this2.filtersToQueryParams());
        });
      } else if (nbr < _this2.state.page) {
        _this2.setState(function (state, props) {
          return {
            page: state.page - 1,
            beforeCursor: props.itemsPageInfo.startCursor,
            afterCursor: null
          };
        }, function (e) {
          return _this2.props.fetch(_this2.filtersToQueryParams());
        });
      }
    });
    _defineProperty(_this2, "openMenu", function (event) {
      _this2.setState({
        menuAnchor: event.currentTarget
      });
    });
    _defineProperty(_this2, "closeMenu", function () {
      _this2.setState({
        menuAnchor: null
      });
    });
    _defineProperty(_this2, "triggerAction", function (a) {
      var s = _toConsumableArray(_this2.state.selection);
      _this2.setState(function (state, props) {
        return {
          selection: [],
          clearAll: state.clearAll + 1
        };
      }, function (e) {
        return a(s);
      });
    });
    _defineProperty(_this2, "headerActions", function (filters) {
      if (!!_this2.props.headerActions) return _this2.props.headerActions(filters);
      if (!!_this2.props.sorts) {
        return _this2.props.sorts(filters).map(function (s) {
          return !!s ? [function () {
            return _this2.setState(function (state, props) {
              return {
                orderBy: sort(state.orderBy, s[0], s[1])
              };
            }, function (e) {
              return _this2.props.fetch(_this2.filtersToQueryParams());
            });
          }, function () {
            return formatSorter(_this2.state.orderBy, s[0], s[1]);
          }] : [null, function () {
            return null;
          }];
        });
      }
      return [];
    });
    _defineProperty(_this2, "renderSearcherActions", function () {
      var _this2$props2 = _this2.props,
        searcherActions = _this2$props2.searcherActions,
        classes = _this2$props2.classes;
      return searcherActions.map(function (action, idx) {
        return action.authorized && /*#__PURE__*/React.createElement(Grid, {
          item: true,
          key: "searcher-action-".concat(idx)
        }, /*#__PURE__*/React.createElement(Button, {
          key: action.label,
          onClick: action.onClick,
          startIcon: action.icon,
          variant: "contained",
          color: "primary",
          className: classes.actionButton
        }, /*#__PURE__*/React.createElement(Typography$1, {
          variant: "body2"
        }, action.label)));
      });
    });
    _this2.fetchEnabled = _props.modulesManager.getConf("fe-core", "shouldFetchInitially", true);
    _this2.isWorker = _props.modulesManager.getConf("fe-core", "isWorker", DEFAULT.IS_WORKER);
    return _this2;
  }
  _inherits(Searcher, _Component3);
  return _createClass(Searcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      var cacheKey = this._getCacheKey();
      var filters = this.props.filtersCache[cacheKey] || this.props.defaultFilters || {};
      this.setState(function (state, props) {
        return {
          filters: filters,
          pageSize: props.defaultPageSize || 10,
          orderBy: props.defaultOrderBy
        };
      }, function (e) {
        if (_this3.fetchEnabled) {
          _this3.applyFilters();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.resetFiltersOnUnmount) {
        var cacheKey = this._getCacheKey();
        this.props.resetCacheFilters(cacheKey);
        this.resetFilters();
      }
    }
  }, {
    key: "_getCacheKey",
    value: function _getCacheKey() {
      var _this$props3 = this.props,
        cachePerTab = _this$props3.cachePerTab,
        cacheTabName = _this$props3.cacheTabName,
        cacheFiltersKey = _this$props3.cacheFiltersKey;
      return cachePerTab && cacheTabName ? "".concat(cacheFiltersKey, "-").concat(cacheTabName) : cacheFiltersKey;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        module = _this$props4.module,
        _this$props4$canSelec = _this$props4.canSelectAll,
        canSelectAll = _this$props4$canSelec === void 0 ? null : _this$props4$canSelec,
        _this$props4$contribu = _this$props4.contributionKey,
        contributionKey = _this$props4$contribu === void 0 ? null : _this$props4$contribu,
        FilterPane = _this$props4.FilterPane,
        FilterExt = _this$props4.FilterExt,
        _this$props4$filterPa = _this$props4.filterPaneContributionsKey,
        filterPaneContributionsKey = _this$props4$filterPa === void 0 ? null : _this$props4$filterPa,
        tableTitle = _this$props4.tableTitle,
        rowIdentifier = _this$props4.rowIdentifier,
        rowsPerPageOptions = _this$props4.rowsPerPageOptions,
        _this$props4$rowLocke = _this$props4.rowLocked,
        _rowLocked = _this$props4$rowLocke === void 0 ? function () {
          return false;
        } : _this$props4$rowLocke,
        _this$props4$rowHighl = _this$props4.rowHighlighted,
        _rowHighlighted = _this$props4$rowHighl === void 0 ? function () {
          return false;
        } : _this$props4$rowHighl,
        _this$props4$rowHighl2 = _this$props4.rowHighlightedAlt,
        _rowHighlightedAlt = _this$props4$rowHighl2 === void 0 ? function () {
          return false;
        } : _this$props4$rowHighl2,
        _this$props4$rowSecon = _this$props4.rowSecondaryHighlighted,
        _rowSecondaryHighlighted = _this$props4$rowSecon === void 0 ? function () {
          return false;
        } : _this$props4$rowSecon,
        _this$props4$rowDisab = _this$props4.rowDisabled,
        _rowDisabled = _this$props4$rowDisab === void 0 ? function () {
          return false;
        } : _this$props4$rowDisab,
        _this$props4$selectio = _this$props4.selectionMessage,
        selectionMessage = _this$props4$selectio === void 0 ? null : _this$props4$selectio,
        _this$props4$preHeade = _this$props4.preHeaders,
        preHeaders = _this$props4$preHeade === void 0 ? null : _this$props4$preHeade,
        _this$props4$headers = _this$props4.headers,
        headers = _this$props4$headers === void 0 ? null : _this$props4$headers,
        _this$props4$aligns = _this$props4.aligns,
        aligns = _this$props4$aligns === void 0 ? null : _this$props4$aligns,
        items = _this$props4.items,
        itemsPageInfo = _this$props4.itemsPageInfo,
        fetchingItems = _this$props4.fetchingItems,
        fetchedItems = _this$props4.fetchedItems,
        errorItems = _this$props4.errorItems,
        itemFormatters = _this$props4.itemFormatters,
        onDoubleClick = _this$props4.onDoubleClick,
        actions = _this$props4.actions,
        _this$props4$processi = _this$props4.processing,
        processing = _this$props4$processi === void 0 ? false : _this$props4$processi,
        _this$props4$withSele = _this$props4.withSelection,
        withSelection = _this$props4$withSele === void 0 ? null : _this$props4$withSele,
        _this$props4$actionsC = _this$props4.actionsContributionKey,
        actionsContributionKey = _this$props4$actionsC === void 0 ? null : _this$props4$actionsC,
        _this$props4$withPagi = _this$props4.withPagination,
        withPagination = _this$props4$withPagi === void 0 ? true : _this$props4$withPagi,
        _this$props4$exportab = _this$props4.exportable,
        exportable = _this$props4$exportab === void 0 ? false : _this$props4$exportab,
        _this$props4$exportFe = _this$props4.exportFetch,
        exportFetch = _this$props4$exportFe === void 0 ? null : _this$props4$exportFe,
        _this$props4$exportFi = _this$props4.exportFields,
        exportFields = _this$props4$exportFi === void 0 ? ['id'] : _this$props4$exportFi,
        exportFieldsColumns = _this$props4.exportFieldsColumns,
        intl = _this$props4.intl,
        _this$props4$isCustom = _this$props4.isCustomFiltering,
        isCustomFiltering = _this$props4$isCustom === void 0 ? false : _this$props4$isCustom,
        _this$props4$objectFo = _this$props4.objectForCustomFiltering,
        objectForCustomFiltering = _this$props4$objectFo === void 0 ? null : _this$props4$objectFo,
        _this$props4$addition = _this$props4.additionalCustomFilterParams,
        additionalCustomFilterParams = _this$props4$addition === void 0 ? null : _this$props4$addition,
        _this$props4$moduleNa = _this$props4.moduleName,
        moduleName = _this$props4$moduleNa === void 0 ? null : _this$props4$moduleNa,
        _this$props4$objectTy = _this$props4.objectType,
        objectType = _this$props4$objectTy === void 0 ? null : _this$props4$objectTy,
        _this$props4$appliedC = _this$props4.appliedCustomFilters,
        appliedCustomFilters = _this$props4$appliedC === void 0 ? null : _this$props4$appliedC,
        _this$props4$setAppli = _this$props4.setAppliedCustomFilters,
        setAppliedCustomFilters = _this$props4$setAppli === void 0 ? null : _this$props4$setAppli,
        _this$props4$appliedF = _this$props4.appliedFiltersRowStructure,
        appliedFiltersRowStructure = _this$props4$appliedF === void 0 ? null : _this$props4$appliedF,
        _this$props4$setAppli2 = _this$props4.setAppliedFiltersRowStructure,
        setAppliedFiltersRowStructure = _this$props4$setAppli2 === void 0 ? null : _this$props4$setAppli2,
        _this$props4$applyNum = _this$props4.applyNumberCircle,
        applyNumberCircle = _this$props4$applyNum === void 0 ? null : _this$props4$applyNum,
        _this$props4$exportFi2 = _this$props4.exportFieldLabel,
        exportFieldLabel = _this$props4$exportFi2 === void 0 ? null : _this$props4$exportFi2,
        _this$props4$showOrdi = _this$props4.showOrdinalNumber,
        showOrdinalNumber = _this$props4$showOrdi === void 0 ? false : _this$props4$showOrdi,
        _this$props4$chooseEx = _this$props4.chooseExportableColumns,
        chooseExportableColumns = _this$props4$chooseEx === void 0 ? false : _this$props4$chooseEx,
        additionalExportFields = _this$props4.additionalExportFields,
        _this$props4$chooseFi = _this$props4.chooseFileFormat,
        chooseFileFormat = _this$props4$chooseFi === void 0 ? false : _this$props4$chooseFi,
        _this$props4$exportFi3 = _this$props4.exportFileFormats,
        exportFileFormats = _this$props4$exportFi3 === void 0 ? {} : _this$props4$exportFi3,
        exportFileFormat = _this$props4.exportFileFormat,
        setExportFileFormat = _this$props4.setExportFileFormat,
        _this$props4$selectWi = _this$props4.selectWithCheckbox,
        selectWithCheckbox = _this$props4$selectWi === void 0 ? false : _this$props4$selectWi,
        _this$props4$enableAc = _this$props4.enableActionButtons,
        enableActionButtons = _this$props4$enableAc === void 0 ? false : _this$props4$enableAc;
        _this$props4.searcherActions;
        var _this$props4$download = _this$props4.downloadWithIconButton,
        downloadWithIconButton = _this$props4$download === void 0 ? false : _this$props4$download,
        displayClearAllColsButton = _this$props4.displayClearAllColsButton,
        _this$props4$infoButt = _this$props4.infoButtonContent,
        infoButtonContent = _this$props4$infoButt === void 0 ? '' : _this$props4$infoButt,
        onCheckBoxSelect = _this$props4.onCheckBoxSelect,
        _this$props4$searcher2 = _this$props4.searcherActionsPosition,
        searcherActionsPosition = _this$props4$searcher2 === void 0 ? 'top-right' : _this$props4$searcher2;
      return /*#__PURE__*/React.createElement(Fragment, null, !!FilterPane && /*#__PURE__*/React.createElement(SearcherPane$1, {
        module: module,
        reset: this.resetFilters,
        refresh: this.applyFilters,
        del: this.deleteFilter,
        filters: this.state.filters,
        filterPane: /*#__PURE__*/React.createElement(FilterPane, {
          filters: this.state.filters,
          onChangeFilters: this.onChangeFilters,
          FilterExt: FilterExt,
          filterPaneContributionsKey: filterPaneContributionsKey
        }),
        isCustomFiltering: isCustomFiltering,
        objectForCustomFiltering: objectForCustomFiltering,
        additionalCustomFilterParams: additionalCustomFilterParams,
        moduleName: moduleName,
        objectType: objectType,
        setAppliedCustomFilters: setAppliedCustomFilters,
        appliedCustomFilters: appliedCustomFilters,
        onChangeFilters: this.onChangeFilters,
        appliedFiltersRowStructure: appliedFiltersRowStructure,
        setAppliedFiltersRowStructure: setAppliedFiltersRowStructure,
        applyNumberCircle: applyNumberCircle
      }), !!contributionKey && /*#__PURE__*/React.createElement(Contributions, {
        contributionKey: contributionKey
      }), /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, enableActionButtons && searcherActionsPosition !== "header-right" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        justifyContent: "flex-end",
        className: classes.searcherActions
      }, this.renderSearcherActions()), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableContainer
      }, errorItems ? /*#__PURE__*/React.createElement(ProgressOrError$1, {
        error: errorItems
      }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        item: true,
        alignItems: "center",
        xs: this.isWorker ? 7 : 8,
        className: classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 8,
        className: classes.paperHeaderTitle
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.infoSection
      }, infoButtonContent && /*#__PURE__*/React.createElement(InfoButton, {
        content: infoButtonContent
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, !fetchingItems ? tableTitle : formatMessage(intl, "core", "table.resultsLoading")))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4,
        className: classes.paperHeaderMessage
      }, /*#__PURE__*/React.createElement(SelectionPane, {
        module: module,
        selectionMessage: selectionMessage,
        selection: this.state.selection
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        item: true,
        xs: this.isWorker ? 5 : 4,
        className: classes.paperHeader
      }, fetchedItems && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        justify: "flex-end",
        className: classes.paperHeaderAction
      }, searcherActionsPosition === "header-right" && this.renderSearcherActions(), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(StyledSelectionMenu, {
        selectWithCheckbox: selectWithCheckbox,
        refetch: this.applyFilters,
        withSelection: withSelection,
        canSelectAll: canSelectAll,
        selection: this.state.selection,
        items: items,
        clearSelected: this.clearSelected,
        selectAll: this.selectAll,
        triggerAction: this.triggerAction,
        actions: actions,
        processing: processing,
        actionsContributionKey: actionsContributionKey,
        filters: this.state.filters,
        exportable: exportable,
        exportFetch: exportFetch,
        exportFields: exportFields,
        exportFieldsColumns: exportFieldsColumns,
        exportFieldLabel: exportFieldLabel,
        chooseExportableColumns: chooseExportableColumns,
        additionalExportFields: additionalExportFields,
        chooseFileFormat: chooseFileFormat,
        exportFileFormats: exportFileFormats,
        exportFileFormat: exportFileFormat,
        setExportFileFormat: setExportFileFormat,
        downloadWithIconButton: downloadWithIconButton,
        displayClearAllColsButton: displayClearAllColsButton
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Table$3, {
        size: "small",
        module: module,
        selectWithCheckbox: selectWithCheckbox,
        fetching: fetchingItems,
        preHeaders: !!preHeaders && preHeaders(this.state.selection),
        headers: headers(this.state.filters),
        headerActions: this.headerActions(this.state.filters),
        aligns: !!aligns && aligns(),
        itemFormatters: itemFormatters(this.state.filters),
        rowLocked: function rowLocked(i) {
          return _rowLocked(_this4.state.selection, i);
        },
        rowHighlighted: function rowHighlighted(i) {
          return _rowHighlighted(_this4.state.selection, i);
        },
        rowHighlightedAlt: function rowHighlightedAlt(i) {
          return _rowHighlightedAlt(_this4.state.selection, i);
        },
        rowSecondaryHighlighted: function rowSecondaryHighlighted(i) {
          return _rowSecondaryHighlighted(i);
        },
        rowDisabled: function rowDisabled(i) {
          return _rowDisabled(_this4.state.selection, i);
        },
        items: items,
        withPagination: withPagination,
        withSelection: withSelection,
        itemIdentifier: rowIdentifier,
        selection: this.state.selection,
        selectAll: this.state.selectAll,
        clearAll: this.state.clearAll,
        onChangeSelection: onCheckBoxSelect ? onCheckBoxSelect : this.onChangeSelection,
        onDoubleClick: onDoubleClick,
        page: this.state.page,
        pageSize: this.state.pageSize,
        count: itemsPageInfo.totalCount,
        onChangePage: this.onChangePage,
        rowsPerPageOptions: rowsPerPageOptions,
        onChangeRowsPerPage: this.onChangeRowsPerPage,
        showOrdinalNumber: showOrdinalNumber
      }))))));
    }
  }]);
}(Component);
var mapStateToProps$6 = function mapStateToProps(state) {
  var _state$core, _state$core2, _state$core3, _state$core$isSeconda;
  return {
    filtersCache: !!state.core && state.core.filtersCache,
    paginationPage: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.savedPagination) === null || _state$core === void 0 ? void 0 : _state$core.paginationPage,
    afterCursor: (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.savedPagination) === null || _state$core2 === void 0 ? void 0 : _state$core2.afterCursor,
    beforeCursor: (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.savedPagination) === null || _state$core3 === void 0 ? void 0 : _state$core3.beforeCursor,
    // This is not used directly, but is needed for Searcher component to be rerendered on change of calendar type
    isSecondaryCalendarEnabled: (_state$core$isSeconda = state.core.isSecondaryCalendarEnabled) !== null && _state$core$isSeconda !== void 0 ? _state$core$isSeconda : false
  };
};
var mapDispatchToProps$4 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    cacheFilters: cacheFilters,
    resetCacheFilters: resetCacheFilters,
    saveCurrentPaginationPage: saveCurrentPaginationPage
  }, dispatch);
};
var Searcher$1 = withModulesManager(injectIntl(withTheme(withStyles(styles$7)(connect(mapStateToProps$6, mapDispatchToProps$4)(Searcher)))));

var useFilterChangeHandler = function useFilterChangeHandler(onChangeFilters) {
  var debouncedOnChangeFilters = _debounce(onChangeFilters, 300);
  var onChangeStringFilter = function onChangeStringFilter(filterName) {
    var lookup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function (value) {
      var filterValue = lookup ? "".concat(filterName, "_").concat(lookup, ": \"").concat(value, "\"") : "".concat(filterName, ": \"").concat(value, "\"");
      debouncedOnChangeFilters([{
        id: filterName,
        value: value,
        filter: filterValue
      }]);
    };
  };
  var onChangeFilter = function onChangeFilter(k, v) {
    var gqlQuery = "".concat(k, ": ").concat(v);
    if (v && _typeof(v) === "object" && "id" in v) {
      gqlQuery = v.id ? "".concat(k, "_Id: \"").concat(v.id, "\"") : '';
    }
    onChangeFilters([{
      id: k,
      value: v,
      filter: gqlQuery
    }]);
  };
  return {
    onChangeStringFilter: onChangeStringFilter,
    onChangeFilter: onChangeFilter
  };
};
function FilterTextInput(_ref) {
  var classes = _ref.classes,
    module = _ref.module,
    label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput$2, {
    module: module,
    label: label,
    value: value,
    onChange: onChange
  }));
}
function FilterCheckbox(_ref2) {
  var classes = _ref2.classes,
    module = _ref2.module,
    checked = _ref2.checked,
    onChange = _ref2.onChange,
    label = _ref2.label,
    intl = _ref2.intl,
    filterName = _ref2.filterName;
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: checked,
      onChange: onChange,
      name: filterName
    }),
    label: formatMessage$1(intl, module, label)
  }));
}
function Filter(_ref3) {
  var moduleName = _ref3.moduleName,
    intl = _ref3.intl,
    classes = _ref3.classes,
    filters = _ref3.filters,
    onChangeFilters = _ref3.onChangeFilters,
    filterFields = _ref3.filterFields,
    pickerFields = _ref3.pickerFields,
    checkboxFields = _ref3.checkboxFields,
    withLocationFilter = _ref3.withLocationFilter;
  var _useFilterChangeHandl = useFilterChangeHandler(onChangeFilters),
    onChangeStringFilter = _useFilterChangeHandl.onChangeStringFilter,
    onChangeFilter = _useFilterChangeHandl.onChangeFilter;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.form
  }, filterFields.map(function (field) {
    var _filters$field$name$v, _filters$field$name;
    return /*#__PURE__*/React.createElement(FilterTextInput, {
      classes: classes,
      key: field.name,
      module: moduleName,
      label: field.label,
      value: (_filters$field$name$v = filters === null || filters === void 0 || (_filters$field$name = filters[field.name]) === null || _filters$field$name === void 0 ? void 0 : _filters$field$name.value) !== null && _filters$field$name$v !== void 0 ? _filters$field$name$v : '',
      onChange: onChangeStringFilter(field.name, field.lookup)
    });
  }), pickerFields === null || pickerFields === void 0 ? void 0 : pickerFields.map(function (field) {
    var _filters$field$name$v2, _filters$field$name2;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: field.name,
      className: classes.item
    }, /*#__PURE__*/React.createElement(field.component, _extends({
      withLabel: true,
      value: (_filters$field$name$v2 = filters === null || filters === void 0 || (_filters$field$name2 = filters[field.name]) === null || _filters$field$name2 === void 0 ? void 0 : _filters$field$name2.value) !== null && _filters$field$name$v2 !== void 0 ? _filters$field$name$v2 : null,
      onChange: function onChange(v) {
        return onChangeFilter(field.name, v);
      },
      readOnly: false
    }, field.props)));
  }), checkboxFields.map(function (field) {
    var _filters$field$name$v3, _filters$field$name3;
    return /*#__PURE__*/React.createElement(FilterCheckbox, {
      classes: classes,
      key: field.name,
      checked: (_filters$field$name$v3 = filters === null || filters === void 0 || (_filters$field$name3 = filters[field.name]) === null || _filters$field$name3 === void 0 ? void 0 : _filters$field$name3.value) !== null && _filters$field$name$v3 !== void 0 ? _filters$field$name$v3 : false,
      onChange: function onChange(event) {
        return onChangeFilter(field.name, event.target.checked);
      },
      label: field.label,
      intl: intl,
      module: moduleName,
      filterName: field.name
    });
  }), withLocationFilter && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
    pubRef: "location.DetailedLocationFilter",
    withNull: true,
    filters: filters,
    onChangeFilters: onChangeFilters,
    anchor: "parentLocation"
  })));
}
var defaultFilterStyles = function defaultFilterStyles(theme) {
  return {
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var Filter$1 = injectIntl(withTheme$1(withStyles$2(defaultFilterStyles)(Filter)));

var nepali = {
  name: "nepali",
  startYear: 1,
  yearLength: 365,
  epoch: 1701212,
  century: 20,
  weekStartDayIndex: 1,
  getMonthLengths: function getMonthLengths(year) {
    if (year < 1970) return nepaliMonthsDictionary["1970"];else if (year > 2099) return nepaliMonthsDictionary["2099"];else return nepaliMonthsDictionary[parseInt(year)];
  },
  isLeap: function isLeap(year) {
    // workaround needed because of things hardcoded in library
    return year;
  },
  getLeaps: function getLeaps(currentYear) {
    return [];
  },
  getDayOfYear: function getDayOfYear(_ref) {
    var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
    var monthLengths = this.getMonthLengths(year);
    for (var i = 0; i < month.index; i++) {
      day += monthLengths[i];
    }
    return day;
  },
  getAllDays: function getAllDays(date) {
    var year = date.year;
    return this.yearLength * (year - 1) + this.getDayOfYear(date);
  },
  leapsLength: function leapsLength(year) {
    return 0;
  },
  guessYear: function guessYear(days, currentYear) {
    var year = ~~(days / 365.24);
    return year + (currentYear > 0 ? 1 : -1);
  }
};

// based on code from legacy version
var nepaliMonthsDictionary = {
  "1970": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1971": [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
  "1972": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "1973": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  //1973
  "1974": [31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
  "1975": [31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
  "1976": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "1977": [31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
  "1978": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1979": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "1980": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "1981": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "1982": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1983": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "1984": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "1985": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "1986": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1987": [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "1988": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "1989": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "1990": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1991": [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "1992": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "1993": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "1994": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1995": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "1996": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "1997": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1998": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "1999": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2000": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  //2000
  "2001": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  //2001
  "2002": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2003": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2004": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2005": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2006": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2007": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2008": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
  "2009": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2010": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2011": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2012": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "2013": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2014": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2015": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2016": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "2017": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2018": [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2019": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2020": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "2021": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2022": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "2023": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2024": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "2025": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2026": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2027": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2028": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2029": [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
  "2030": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2031": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2032": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2033": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2034": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2035": [30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
  "2036": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2037": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2038": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2039": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "2040": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2041": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2042": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2043": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "2044": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2045": [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2046": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2047": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "2048": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2049": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "2050": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2051": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "2052": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2053": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "2054": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2055": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2056": [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
  "2057": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2058": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2059": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2060": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2061": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2062": [30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
  "2063": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2064": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2065": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2066": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
  "2067": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2068": [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2069": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  "2070": [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
  "2071": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  //2071
  "2072": [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  //2072
  "2073": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
  //2073
  "2074": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "2075": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2076": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "2077": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
  "2078": [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
  "2079": [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
  "2080": [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
  "2081": [31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2082": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2083": [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
  "2084": [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
  "2085": [31, 32, 31, 32, 30, 31, 30, 30, 29, 30, 30, 30],
  "2086": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2087": [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
  "2088": [30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
  "2089": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2090": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  //2090
  "2091": [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
  "2092": [30, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2093": [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2094": [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
  "2095": [31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
  "2096": [30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
  "2097": [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
  "2098": [31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 29, 31],
  "2099": [31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30] //2099
};

var bengali_en = {
  name: "bengali_en",
  months: [["জানুয়ারী", "জানুয়ারী"], ["ফেব্রুয়ারী", "ফেব্রুয়ারী"], ["মার্চ", "মার্চ"], ["এপ্রিল", "এপ্রিল"], ["মে", "মে"], ["জুন", "জুন"], ["জুলাই", "জুলাই"], ["আগস্ট", "আগস্ট"], ["সেপ্টেম্বর", "সেপ্টেম্বর"], ["অক্টোবর", "অক্টোবর"], ["নভেম্বর", "নভেম্বর"], ["ডিসেম্বর", "ডিসেম্বর"]],
  weekDays: [["শনিবার", "শনি"], ["রবিবার", "রবি"], ["সোমবার", "সোম"], ["মঙ্গলবার", "মঙ্গল"], ["বুধবার", "বুধ"], ["বৃহস্পতি", "বৃহঃ"], ["শুক্রবার", "শুক্র"]],
  digits: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
  meridiems: [["AM", "am"], ["PM", "pm"]]
};

var nepali_en = {
  name: "nepali_en",
  months: [["Baishakh", "Baishakh"], ["Jestha", "Jestha"], ["Ashadh", "Ashadh"], ["Shrawan", "Shrawan"], ["Bhadra", "Bhadra"], ["Ashwin", "Ashwin"], ["Kartik", "Kartik"], ["Mangsir", "Mangsir"], ["Poush", "Poush"], ["Magh", "Magh"], ["Falgun", "Falgun"], ["Chaitra", "Chaitra"]],
  weekDays: [["Saturday", "Sat"], ["Sunday", "Sun"], ["Monday", "Mon"], ["Tuesday", "Tue"], ["Wednesday", "Wed"], ["Thursday", "Thu"], ["Friday", "Fri"]],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [["AM", "am"], ["PM", "pm"]]
};

var nepali_np = {
  name: "nepali_np",
  months: [["Baishakh", "Baishakh"], ["Jestha", "Jestha"], ["Ashadh", "Ashadh"], ["Shrawan", "Shrawan"], ["Bhadra", "Bhadra"], ["Ashwin", "Ashwin"], ["Kartik", "Kartik"], ["Mangsir", "Mangsir"], ["Poush", "Poush"], ["Magh", "Magh"], ["Falgun", "Falgun"], ["Chaitra", "Chaitra"]],
  weekDays: [["Saturday", "Sat"], ["Sunday", "Sun"], ["Monday", "Mon"], ["Tuesday", "Tue"], ["Wednesday", "Wed"], ["Thursday", "Thu"], ["Friday", "Fri"]],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [["AM", "am"], ["PM", "pm"]]
};

var _excluded$2 = ["intl", "classes", "disablePast", "module", "label", "readOnly", "required", "fullWidth", "format", "reset", "isSecondaryCalendarEnabled", "modulesManager", "minDate", "maxDate", "secondaryCalendarEnabled", "secondaryCalendarType", "editable", "secondaryCalendarLocale"];
function _callSuper$a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$6 = function styles(theme) {
  return {
    label: {
      color: theme.palette.primary.main
    },
    disabledStateVisibilityBoost: {
      "& .MuiFormLabel-root.Mui-disabled": {
        color: "#181716"
      },
      "& .MuiInputBase-input.Mui-disabled": {
        color: "#5E5B50"
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px dotted #5E5B50"
      }
    }
  };
};
function fromISODate(s) {
  if (!s) return null;
  return moment(s).toDate();
}
var openIMISDatePicker = /*#__PURE__*/function (_Component) {
  function openIMISDatePicker(props) {
    var _this;
    _classCallCheck(this, openIMISDatePicker);
    _this = _callSuper$a(this, openIMISDatePicker, [props]);
    _defineProperty(_this, "state", {
      value: null
    });
    _defineProperty(_this, "dateChange", function (d) {
      _this.setState({
        value: toISODate(d)
      }, function (i) {
        return !!_this.props.onChange ? _this.props.onChange(toISODate(d)) : null;
      });
    });
    _defineProperty(_this, "secondaryCalendarDateChange", function (d) {
      _this.setState({
        value: toISODate(d.toDate())
      }, function (i) {
        return !!_this.props.onChange ? _this.props.onChange(toISODate(d.toDate())) : null;
      });
    });
    _defineProperty(_this, "clearDate", function (e) {
      e.preventDefault();
      _this.setState({
        value: null
      });
    });
    _defineProperty(_this, "setMinDate", function () {
      var _this$props = _this.props,
        disablePast = _this$props.disablePast,
        minDate = _this$props.minDate;
      return {
        minDate: _this.moveByOneDay(disablePast ? new Date() : new Date(minDate))
      };
    });
    _defineProperty(_this, "secondaryCalendarsOptions", {
      "nepali": nepali,
      "default": gregorian
    });
    _defineProperty(_this, "secondaryCalendarsLocaleOptions", {
      "bengali_en": bengali_en,
      "nepali_en": nepali_en,
      "nepali_np": nepali_np,
      "default": gregorian_en
    });
    _defineProperty(_this, "getDictionaryValueOrDefault", function (_dictionary, _key) {
      return _key in _dictionary ? _dictionary[_key] : _dictionary["default"];
    });
    // for some reason multi-date-picker picks incorrect date
    // we need to add one day for it to works correctly
    // it is possible, that future release of library will fix it
    // making this method redundant
    _defineProperty(_this, "moveByOneDay", function (date) {
      date.setDate(date.getDate() + 1);
      return date;
    });
    _this.disabledVisibilityBoost = props.modulesManager.getConf("fe-core", "Input.disabledVisibilityBoost", DEFAULT.DISABLED_VISIBILITY_BOOST);
    return _this;
  }
  _inherits(openIMISDatePicker, _Component);
  return _createClass(openIMISDatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(function (state, props) {
        return {
          value: props.value || null
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevState, prevProps, snapshot) {
      if (prevState.value !== this.props.value) {
        this.setState(function (state, props) {
          return {
            value: fromISODate(props.value)
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        intl = _this$props2.intl,
        classes = _this$props2.classes,
        disablePast = _this$props2.disablePast,
        module = _this$props2.module,
        label = _this$props2.label,
        _this$props2$readOnly = _this$props2.readOnly,
        readOnly = _this$props2$readOnly === void 0 ? false : _this$props2$readOnly,
        _this$props2$required = _this$props2.required,
        required = _this$props2$required === void 0 ? false : _this$props2$required,
        _this$props2$fullWidt = _this$props2.fullWidth,
        fullWidth = _this$props2$fullWidt === void 0 ? true : _this$props2$fullWidt,
        _this$props2$format = _this$props2.format,
        format = _this$props2$format === void 0 ? "DD-MM-YYYY" : _this$props2$format;
        _this$props2.reset;
        var isSecondaryCalendarEnabled = _this$props2.isSecondaryCalendarEnabled,
        modulesManager = _this$props2.modulesManager,
        minDate = _this$props2.minDate,
        maxDate = _this$props2.maxDate;
        _this$props2.secondaryCalendarEnabled;
        _this$props2.secondaryCalendarType;
        var _this$props2$editable = _this$props2.editable,
        editable = _this$props2$editable === void 0 ? true : _this$props2$editable;
        _this$props2.secondaryCalendarLocale;
        var otherProps = _objectWithoutProperties(_this$props2, _excluded$2);
      if (this.props.secondaryCalendarEnabled || isSecondaryCalendarEnabled) {
        var secondCalendarFormatting = modulesManager.getConf("fe-core", "secondCalendarFormatting", format);
        var secondCalendarType = this.props.secondCalendarType || modulesManager.getConf("fe-core", "secondCalendarType", "nepali");
        var secondCalendarLocale = this.props.secondCalendarLocale || modulesManager.getConf("fe-core", "secondCalendarLocale", "nepali_en");
        return /*#__PURE__*/React.createElement(FormControl, {
          fullWidth: fullWidth
        }, /*#__PURE__*/React.createElement("label", {
          className: classes.label
        }, !!label ? formatMessage(intl, module, label).concat(required ? " *" : "") : null), /*#__PURE__*/React.createElement(DatePicker, _extends({
          format: secondCalendarFormatting,
          disabled: readOnly,
          editable: editable,
          value: this.state.value ? this.moveByOneDay(new Date(this.state.value)) : null
        }, (!!minDate || disablePast) && this.setMinDate(), !!maxDate && {
          maxDate: this.moveByOneDay(new Date(maxDate))
        }, {
          onChange: this.secondaryCalendarDateChange,
          highlightToday: false,
          calendar: this.getDictionaryValueOrDefault(this.secondaryCalendarsOptions, secondCalendarType),
          locale: this.getDictionaryValueOrDefault(this.secondaryCalendarsLocaleOptions, secondCalendarLocale),
          inputClass: "MuiInputBase-input",
          style: {
            borderBottom: "1px solid",
            zIndex: 3000
          },
          required: required
        }), /*#__PURE__*/React.createElement("button", {
          style: {
            margin: "5px"
          },
          onClick: function onClick(e) {
            return _this2.clearDate(e);
          }
        }, formatMessage(intl, module, "calendar.clearButton"))));
      } else {
        return /*#__PURE__*/React.createElement(FormControl, {
          fullWidth: fullWidth
        }, /*#__PURE__*/React.createElement(DatePicker$1, _extends({}, otherProps, {
          maxDate: maxDate,
          minDate: minDate,
          format: format,
          disabled: readOnly,
          required: required,
          className: clsx(_defineProperty({}, classes.disabledStateVisibilityBoost, this.disabledVisibilityBoost && readOnly)),
          clearable: true,
          value: this.state.value,
          InputLabelProps: {
            className: classes.label
          },
          label: !!label ? formatMessage(intl, module, label) : null,
          onChange: this.dateChange,
          disablePast: disablePast
        })));
      }
    }
  }]);
}(Component);
var mapStateToProps$5 = function mapStateToProps(state) {
  var _state$core$isSeconda;
  return {
    isSecondaryCalendarEnabled: (_state$core$isSeconda = state.core.isSecondaryCalendarEnabled) !== null && _state$core$isSeconda !== void 0 ? _state$core$isSeconda : false
  };
};
var openIMISDatePicker$1 = injectIntl(withModulesManager$1(withHistory$1(connect(mapStateToProps$5, null)(withTheme(withStyles(styles$6)(openIMISDatePicker))))));

function _callSuper$9(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$5 = function styles(theme) {
  return {
    label: {
      color: theme.palette.primary.main
    },
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content
  };
};
var RawPickerDialog = /*#__PURE__*/function (_Component) {
  function RawPickerDialog() {
    var _this;
    _classCallCheck(this, RawPickerDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$9(this, RawPickerDialog, [].concat(args));
    _defineProperty(_this, "keysFunction", function (event) {
      if (event.keyCode === 27) {
        _this.props.onClose();
      }
    });
    return _this;
  }
  _inherits(RawPickerDialog, _Component);
  return _createClass(RawPickerDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.keysFunction, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.keysFunction, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        open = _this$props.open,
        onClose = _this$props.onClose,
        onSelect = _this$props.onSelect,
        module = _this$props.module,
        title = _this$props.title,
        close = _this$props.close,
        filter = _this$props.filter,
        suggestions = _this$props.suggestions,
        suggestionFormatter = _this$props.suggestionFormatter,
        count = _this$props.count,
        page = _this$props.page,
        pageSize = _this$props.pageSize,
        onChangePage = _this$props.onChangePage,
        onChangeRowsPerPage = _this$props.onChangeRowsPerPage;
      return /*#__PURE__*/React.createElement(Dialog, {
        open: open,
        fullWidth: true,
        maxWidth: "md"
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        className: classes.dialogTitle
      }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: title
      })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent, {
        className: classes.dialogContent
      }, filter, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Table$3, {
        items: suggestions,
        itemFormatters: [suggestionFormatter],
        withPagination: count > pageSize,
        page: page,
        pageSize: pageSize,
        count: count,
        onChangePage: onChangePage,
        onChangeRowsPerPage: onChangeRowsPerPage,
        onDoubleClick: onSelect
      })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
        onClick: onClose,
        color: "primary"
      }, /*#__PURE__*/React.createElement(FormattedMessage$1, {
        module: module,
        id: close || "picker.close"
      }))));
    }
  }]);
}(Component);
var PickerDialog = injectIntl(withTheme(withStyles(styles$5)(RawPickerDialog)));
var Picker = /*#__PURE__*/function (_Component2) {
  function Picker() {
    var _this2;
    _classCallCheck(this, Picker);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper$9(this, Picker, [].concat(args));
    _defineProperty(_this2, "state", {
      open: false
    });
    _defineProperty(_this2, "_onSelect", function (v) {
      _this2.setState({
        open: false
      }, function (e) {
        return _this2.props.onSelect(v);
      });
    });
    _defineProperty(_this2, "onClick", function () {
      var _this2$props = _this2.props,
        _this2$props$check = _this2$props.check,
        check = _this2$props$check === void 0 ? null : _this2$props$check,
        _this2$props$checked = _this2$props.checked,
        checked = _this2$props$checked === void 0 ? true : _this2$props$checked;
      if (!!check && !checked) {
        check();
      } else {
        _this2.setState({
          open: true
        });
      }
    });
    _defineProperty(_this2, "onClose", function (e) {
      return _this2.setState({
        open: false
      });
    });
    _defineProperty(_this2, "onClear", function (e) {
      _this2.props.onSelect(null);
    });
    _defineProperty(_this2, "_suggestionFormatter", function (a) {
      return /*#__PURE__*/React.createElement(FakeInput$1, {
        onSelect: function onSelect(e) {
          return _this2._onSelect(a);
        },
        value: _this2.props.suggestionFormatter(a)
      });
    });
    return _this2;
  }
  _inherits(Picker, _Component2);
  return _createClass(Picker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!prevProps.checked && !!this.props.checked) {
        this.setState({
          open: true
        });
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props2 = this.props,
        IconRender = _this$props2.IconRender,
        title = _this$props2.title;
      return /*#__PURE__*/React.createElement(IconButton, {
        title: title,
        onClick: this.onClick
      }, /*#__PURE__*/React.createElement(IconRender, null));
    }
  }, {
    key: "renderField",
    value: function renderField() {
      var _this3 = this;
      var _this$props3 = this.props,
        intl = _this$props3.intl,
        classes = _this$props3.classes,
        module = _this$props3.module,
        label = _this$props3.label,
        suggestionFormatter = _this$props3.suggestionFormatter,
        value = _this$props3.value,
        _this$props3$readOnly = _this$props3.readOnly,
        readOnly = _this$props3$readOnly === void 0 ? false : _this$props3$readOnly,
        _this$props3$required = _this$props3.required,
        required = _this$props3$required === void 0 ? false : _this$props3$required;
      return /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true
      }, /*#__PURE__*/React.createElement(TextField, {
        className: classes.picker,
        disabled: readOnly,
        required: required,
        label: !!label && formatMessage(intl, module, label),
        onClick: function onClick(e) {
          return _this3.setState({
            open: true
          });
        },
        value: suggestionFormatter(value),
        InputLabelProps: {
          className: classes.label
        },
        InputProps: {
          startAdornment: !readOnly && /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, /*#__PURE__*/React.createElement(SearchIcon, null)),
          endAdornment: !readOnly && /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement(IconButton, {
            onClick: this.onClear
          }, /*#__PURE__*/React.createElement(ClearIcon, null)))
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        module = _this$props4.module,
        dialogTitle = _this$props4.dialogTitle,
        dialogClose = _this$props4.dialogClose,
        dialogSelect = _this$props4.dialogSelect,
        filter = _this$props4.filter,
        suggestions = _this$props4.suggestions,
        count = _this$props4.count,
        page = _this$props4.page,
        pageSize = _this$props4.pageSize,
        onChangeRowsPerPage = _this$props4.onChangeRowsPerPage,
        onChangePage = _this$props4.onChangePage,
        _this$props4$readOnly = _this$props4.readOnly,
        readOnly = _this$props4$readOnly === void 0 ? false : _this$props4$readOnly,
        IconRender = _this$props4.IconRender,
        _this$props4$checked = _this$props4.checked,
        checked = _this$props4$checked === void 0 ? true : _this$props4$checked;
      return /*#__PURE__*/React.createElement(Fragment, null, !readOnly && !!checked && /*#__PURE__*/React.createElement(PickerDialog, {
        open: this.state.open,
        onClose: this.onClose,
        onSelect: this._onSelect,
        module: module,
        title: dialogTitle,
        close: dialogClose,
        select: dialogSelect,
        filter: filter,
        suggestions: suggestions,
        suggestionFormatter: this._suggestionFormatter,
        count: count,
        pageSize: pageSize,
        page: page,
        onChangeRowsPerPage: onChangeRowsPerPage,
        onChangePage: onChangePage
      }), !!IconRender && this.renderIcon(), !IconRender && this.renderField());
    }
  }]);
}(Component);
var Picker$1 = injectIntl(withTheme(withStyles(styles$5)(Picker)));

function _callSuper$8(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
var INIT_STATE = {
  value: null
};
var ConstantBasedPicker = /*#__PURE__*/function (_Component) {
  function ConstantBasedPicker() {
    var _this;
    _classCallCheck(this, ConstantBasedPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$8(this, ConstantBasedPicker, [].concat(args));
    _defineProperty(_this, "state", INIT_STATE);
    _defineProperty(_this, "_formatValue", function (v) {
      var _this$props$nullLabel;
      return v === null ? formatMessage(_this.props.intl, _this.props.module, (_this$props$nullLabel = _this.props.nullLabel) !== null && _this$props$nullLabel !== void 0 ? _this$props$nullLabel : "".concat(_this.props.label, ".null")) : formatMessage(_this.props.intl, _this.props.module, "".concat(_this.props.label, ".").concat(v));
    });
    _defineProperty(_this, "_onChange", function (v) {
      _this.setState({
        value: v
      }, function (e) {
        _this.props.onChange(v, _this._formatValue(v));
      });
    });
    return _this;
  }
  _inherits(ConstantBasedPicker, _Component);
  return _createClass(ConstantBasedPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!!this.props.value) {
        this.setState(function (state, props) {
          return {
            value: props.value
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.reset !== this.props.reset || prevProps.value !== this.props.value) {
        this.setState(function (state, props) {
          return {
            value: props.value
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        module = _this$props.module,
        _this$props$withLabel = _this$props.withLabel,
        withLabel = _this$props$withLabel === void 0 ? true : _this$props$withLabel,
        label = _this$props.label,
        constants = _this$props.constants,
        name = _this$props.name,
        _this$props$filtered = _this$props.filtered,
        filtered = _this$props$filtered === void 0 ? [] : _this$props$filtered,
        _this$props$withNull = _this$props.withNull,
        withNull = _this$props$withNull === void 0 ? true : _this$props$withNull,
        _this$props$readOnly = _this$props.readOnly,
        readOnly = _this$props$readOnly === void 0 ? false : _this$props$readOnly,
        _this$props$required = _this$props.required,
        required = _this$props$required === void 0 ? false : _this$props$required;
      var value = this.state.value;
      if (!withNull && value === null && !!!constants) return null;
      var options = withNull ? [{
        value: null,
        label: this._formatValue(null)
      }] : [];
      options.push.apply(options, _toConsumableArray(constants.filter(function (c) {
        return !filtered.includes(c) || value === c;
      }).map(function (v) {
        return {
          value: v,
          label: _this2._formatValue(v)
        };
      })));
      return /*#__PURE__*/React.createElement(SelectInput$1, {
        module: module,
        label: !!withLabel && label ? label : " ",
        withLabel: withLabel,
        options: options,
        name: name,
        value: value,
        onChange: this._onChange,
        readOnly: readOnly,
        required: required
      });
    }
  }]);
}(Component);
var ConstantBasedPicker$1 = injectIntl(ConstantBasedPicker);

function _callSuper$7(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }
var YearPicker = /*#__PURE__*/function (_Component) {
  function YearPicker() {
    _classCallCheck(this, YearPicker);
    return _callSuper$7(this, YearPicker, arguments);
  }
  _inherits(YearPicker, _Component);
  return _createClass(YearPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        name = _this$props.name,
        value = _this$props.value,
        module = _this$props.module,
        label = _this$props.label,
        _this$props$nullLabel = _this$props.nullLabel,
        nullLabel = _this$props$nullLabel === void 0 ? "year.null" : _this$props$nullLabel,
        onChange = _this$props.onChange,
        readOnly = _this$props.readOnly,
        min = _this$props.min,
        max = _this$props.max,
        required = _this$props.required,
        _this$props$withNull = _this$props.withNull,
        withNull = _this$props$withNull === void 0 ? true : _this$props$withNull;
      var options = withNull ? [{
        value: null,
        label: formatMessage(intl, module, nullLabel)
      }] : [];
      options.push.apply(options, _toConsumableArray(_$1.range(min, max).map(function (v) {
        return {
          value: v,
          label: v
        };
      })));
      return /*#__PURE__*/React.createElement(SelectInput$1, {
        module: module,
        label: label,
        options: options,
        readOnly: readOnly,
        name: name,
        value: value,
        required: required,
        onChange: onChange
      });
    }
  }]);
}(Component);
var YearPicker$1 = injectIntl(YearPicker);

var _excluded$1 = ["intl", "module", "label", "withNull"];
function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
var MonthPicker = /*#__PURE__*/function (_Component) {
  function MonthPicker() {
    _classCallCheck(this, MonthPicker);
    return _callSuper$6(this, MonthPicker, arguments);
  }
  _inherits(MonthPicker, _Component);
  return _createClass(MonthPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var _this$props$module = _this$props.module,
        module = _this$props$module === void 0 ? "core" : _this$props$module,
        _this$props$label = _this$props.label,
        label = _this$props$label === void 0 ? "month" : _this$props$label,
        withNull = _this$props.withNull,
        others = _objectWithoutProperties(_this$props, _excluded$1);
      return /*#__PURE__*/React.createElement(ConstantBasedPicker$1, _extends({
        module: module,
        label: label,
        withNull: withNull,
        constants: _$1.range(1, 13)
      }, others));
    }
  }]);
}(Component);
var MonthPicker$1 = injectIntl(MonthPicker);

function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
var LanguagePicker = /*#__PURE__*/function (_Component) {
  function LanguagePicker() {
    var _this;
    _classCallCheck(this, LanguagePicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$5(this, LanguagePicker, [].concat(args));
    _defineProperty(_this, "nullDisplay", _this.props.nullLabel || formatMessage$1(_this.props.intl, "core", "Language.null"));
    _defineProperty(_this, "formatSuggestion", function (i) {
      return !!i ? i : _this.nullDisplay;
    });
    _defineProperty(_this, "onSuggestionSelected", function (v) {
      _this.props.onChange(v, _this.formatSuggestion(v));
    });
    return _this;
  }
  _inherits(LanguagePicker, _Component);
  return _createClass(LanguagePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$languages,
        _this2 = this;
      if (!((_this$props$languages = this.props.languages) !== null && _this$props$languages !== void 0 && _this$props$languages.length)) {
        // prevent loading multiple times the cache when component is several times on a page
        setTimeout(function () {
          !_this2.props.fetching && !_this2.props.fetched && _this2.props.fetchLanguages();
        }, Math.floor(Math.random() * 300));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        languages = _this$props.languages,
        _this$props$module = _this$props.module,
        module = _this$props$module === void 0 ? "core" : _this$props$module,
        _this$props$withLabel = _this$props.withLabel,
        withLabel = _this$props$withLabel === void 0 ? true : _this$props$withLabel,
        _this$props$label = _this$props.label,
        label = _this$props$label === void 0 ? "LanguagePicker.label" : _this$props$label,
        _this$props$withPlace = _this$props.withPlaceholder,
        withPlaceholder = _this$props$withPlace === void 0 ? false : _this$props$withPlace,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        reset = _this$props.reset,
        _this$props$readOnly = _this$props.readOnly,
        readOnly = _this$props$readOnly === void 0 ? false : _this$props$readOnly,
        _this$props$required = _this$props.required,
        required = _this$props$required === void 0 ? false : _this$props$required,
        _this$props$withNull = _this$props.withNull,
        withNull = _this$props$withNull === void 0 ? false : _this$props$withNull;
      var options = !!languages ? languages.map(function (v) {
        return {
          value: v.code,
          label: v.name
        };
      }) : [];
      if (withNull) {
        options.unshift({
          value: null,
          label: this.formatSuggestion(null)
        });
      }
      return /*#__PURE__*/React.createElement(SelectInput$2, {
        module: module,
        options: options,
        label: !!withLabel ? label : null,
        placeholder: !!withPlaceholder ? placeholder || formatMessage$1(intl, "core", "LanguagePicker.placehoder") : null,
        onChange: this.onSuggestionSelected,
        value: value,
        reset: reset,
        readOnly: readOnly,
        required: required,
        withNull: withNull,
        nullLabel: this.nullDisplay
      });
    }
  }]);
}(Component);
var mapStateToProps$4 = function mapStateToProps(state) {
  return {
    languages: state.core.languages,
    fetching: state.core.fetchingLanguages,
    fetched: state.core.fetchedLanguages
  };
};
var mapDispatchToProps$3 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchLanguages: fetchLanguages
  }, dispatch);
};
var LanguagePicker$1 = injectIntl(connect(mapStateToProps$4, mapDispatchToProps$3)(withModulesManager$1(LanguagePicker)));

var RIGHT_NAME_WORDS_SEPARATOR = "_";
var RIGHT_NAME_OMITTED_WORDS = ["gql", "mutation", "perms"];
var QUERY_STRING = "query";
var SEARCH_STRING = "search";
var WHITESPACE = " ";
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.split(WHITESPACE).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(WHITESPACE);
};
var formatRoleLabel = function formatRoleLabel() {
  var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var permName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var addPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var rightNameWords = permName.split(RIGHT_NAME_WORDS_SEPARATOR).filter(function (word) {
    return !RIGHT_NAME_OMITTED_WORDS.includes(word);
  });
  var rightNameLabel = rightNameWords.map(capitalizeFirstLetter).join(WHITESPACE).replace(QUERY_STRING, SEARCH_STRING);
  var moduleNameLabel = moduleName.split(RIGHT_NAME_WORDS_SEPARATOR).map(capitalizeFirstLetter).join(WHITESPACE);
  return "".concat(addPrefix ? "[No Translation] " : null, " ").concat(moduleNameLabel, " | ").concat(rightNameLabel);
};

function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WHITESPACE_REGEX = /\s/g;
var UNDERSCORE_REGEX = /_/g;
var AuthorityPicker = function AuthorityPicker(_ref) {
  var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    placeholder = _ref.placeholder;
  var modulesManager = useModulesManager$1();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var _useTranslations = useTranslations$1(MODULE_NAME, modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var _useGraphqlQuery = useGraphqlQuery$1("\n    query AuthorityPicker {\n        modulesPermissions  {\n            modulePermsList {\n                moduleName\n                permissions {\n                    permsName\n                    permsValue\n                }\n            }\n        }\n    }\n    "),
    isLoading = _useGraphqlQuery.isLoading,
    data = _useGraphqlQuery.data,
    error = _useGraphqlQuery.error;
  var filteredPerms = useMemo(function () {
    if (!data) return [];
    var concatenatedSearchString = searchString.replace(WHITESPACE_REGEX, "").toLowerCase();
    return data.modulesPermissions.modulePermsList.flatMap(function (module) {
      return module.permissions.filter(function (perm) {
        var concatenatedPermName = (module.moduleName + perm.permsName).replace(UNDERSCORE_REGEX, "").toLowerCase();
        return concatenatedPermName.includes(concatenatedSearchString);
      }).map(function (perm) {
        return _objectSpread$7({
          id: perm.permsValue,
          module: module.moduleName
        }, perm);
      });
    });
  }, [data, searchString]);
  var formatLabel = function formatLabel(perm) {
    return formatRoleLabel(perm.module, perm.permsName);
  };
  return /*#__PURE__*/React.createElement(Autocomplete$3, {
    options: filteredPerms,
    getOptionLabel: formatLabel,
    onChange: function onChange(option) {
      return _onChange(option);
    },
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : formatMessage("core.AuthorityPicker.placeholder"),
    label: label !== null && label !== void 0 ? label : formatMessage("core.AuthorityPicker.label"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: isLoading,
    error: error,
    value: value,
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    setCurrentString: setSearchString,
    onInputChange: function onInputChange() {}
  });
};

function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$4 = function styles(theme) {
  return {
    page: theme.page,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    fab: theme.fab
  };
};
var DEFAULT_ORDER_BY = "name";
var RawRoleFilter = /*#__PURE__*/function (_Component) {
  function RawRoleFilter() {
    var _this;
    _classCallCheck(this, RawRoleFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$4(this, RawRoleFilter, [].concat(args));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_filterTextFieldValue", function (k) {
      var filters = _this.props.filters;
      return !!filters[k] ? filters[k].value : "";
    });
    _defineProperty(_this, "_onChangeFilter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": ").concat(v)
      }]);
    });
    _defineProperty(_this, "_onChangeStringFilter", function (k, v, lookup) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, "_").concat(lookup, ": \"").concat(v, "\"")
      }]);
    });
    _defineProperty(_this, "onChangeRoleRight", function (key, value) {
      _this.props.onChangeFilters([{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value === null || value === void 0 ? void 0 : value.permsValue)
      }]);
    });
    _defineProperty(_this, "booleanOptions", function () {
      var options = [null, "true", "false"];
      return _toConsumableArray(options.map(function (option) {
        return {
          value: option,
          label: formatMessage$1(_this.props.intl, "core", "roleManagement.".concat(option))
        };
      }));
    });
    return _this;
  }
  _inherits(RawRoleFilter, _Component);
  return _createClass(RawRoleFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        intl = _this$props.intl,
        classes = _this$props.classes;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput$2, {
        module: "core",
        label: "roleManagement.roleName",
        value: this._filterTextFieldValue("name"),
        onChange: function onChange(v) {
          return _this2._onChangeStringFilter("name", v, CONTAINS_LOOKUP);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(SelectInput$2, {
        module: "core",
        label: "roleManagement.isSystem",
        options: this.booleanOptions(),
        value: this._filterValue("isSystem"),
        onChange: function onChange(v) {
          return _this2._onChangeFilter("isSystem", v);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(SelectInput$2, {
        module: "core",
        label: "roleManagement.isBlocked",
        options: this.booleanOptions(),
        value: this._filterValue("isBlocked"),
        onChange: function onChange(v) {
          return _this2._onChangeFilter("isBlocked", v);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
        pubRef: "core.AuthorityPicker",
        value: this._filterValue("roleRight"),
        onChange: function onChange(roleRight) {
          return _this2.onChangeRoleRight("roleRight", roleRight);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormControlLabel$1, {
        label: formatMessage$1(intl, "core", "roleManagement.showHistory"),
        control: /*#__PURE__*/React.createElement(Checkbox, {
          checked: !!this._filterValue("showHistory"),
          onChange: function onChange(event) {
            return _this2._onChangeFilter("showHistory", event.target.checked);
          }
        })
      })));
    }
  }]);
}(Component);
var RoleFilter = injectIntl(withTheme(withStyles(styles$4)(RawRoleFilter)));
var Roles = /*#__PURE__*/function (_Component2) {
  function Roles() {
    var _this3;
    _classCallCheck(this, Roles);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _callSuper$4(this, Roles, [].concat(args));
    _defineProperty(_this3, "state", {
      toDelete: null,
      deleted: []
    });
    _defineProperty(_this3, "onAdd", function () {
      return historyPush$1(_this3.props.modulesManager, _this3.props.history, "core.route.role");
    });
    _defineProperty(_this3, "roleUpdatePageUrl", function (role) {
      return "".concat(_this3.props.modulesManager.getRef("core.route.role")).concat("/" + role.uuid);
    });
    _defineProperty(_this3, "roleDuplicatePageUrl", function (role) {
      return "".concat(_this3.roleUpdatePageUrl(role), "?").concat(QUERY_STRING_DUPLICATE);
    });
    _defineProperty(_this3, "onDoubleClick", function (role) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this3$props = _this3.props,
        rights = _this3$props.rights,
        modulesManager = _this3$props.modulesManager,
        history = _this3$props.history;
      if (rights.includes(RIGHT_ROLE_SEARCH) || rights.includes(RIGHT_ROLE_UPDATE)) {
        historyPush$1(modulesManager, history, "core.route.role", [role.uuid], newTab);
      }
    });
    _defineProperty(_this3, "fetch", function (params) {
      return _this3.props.fetchRoles(params);
    });
    _defineProperty(_this3, "headers", function (filters) {
      var _filters$showHistory, _filters$showHistory2;
      var rights = _this3.props.rights;
      var result = ["roleManagement.roleName", "roleManagement.isSystem", "roleManagement.isBlocked", filters !== null && filters !== void 0 && (_filters$showHistory = filters.showHistory) !== null && _filters$showHistory !== void 0 && _filters$showHistory.value ? "roleManagement.dateValidFrom" : null, filters !== null && filters !== void 0 && (_filters$showHistory2 = filters.showHistory) !== null && _filters$showHistory2 !== void 0 && _filters$showHistory2.value ? "roleManagement.dateValidTo" : null];
      [RIGHT_ROLE_UPDATE, RIGHT_ROLE_DUPLICATE, RIGHT_ROLE_DELETE].forEach(function (right) {
        if (rights.includes(right)) {
          result.push("roleManagement.emptyLabel");
        }
      });
      return result;
    });
    _defineProperty(_this3, "itemFormatters", function (filters) {
      var _this3$props2 = _this3.props,
        intl = _this3$props2.intl,
        rights = _this3$props2.rights,
        modulesManager = _this3$props2.modulesManager,
        language = _this3$props2.language;
      var result = [function (role) {
        return language === null ? role.name : language === LANGUAGE_EN ? role.name : role.altLanguage === null ? role.name : role.altLanguage;
      }, function (role) {
        return role.isSystem !== null ? /*#__PURE__*/React.createElement(Checkbox, {
          checked: !!role.isSystem,
          disabled: true
        }) : "";
      }, function (role) {
        return role.isBlocked !== null ? /*#__PURE__*/React.createElement(Checkbox, {
          checked: role.isBlocked,
          disabled: true
        }) : "";
      }, function (role) {
        var _filters$showHistory3;
        return filters !== null && filters !== void 0 && (_filters$showHistory3 = filters.showHistory) !== null && _filters$showHistory3 !== void 0 && _filters$showHistory3.value && role.validityFrom ? formatDateFromISO$3(modulesManager, intl, role.validityFrom) : null;
      }, function (role) {
        var _filters$showHistory4;
        return filters !== null && filters !== void 0 && (_filters$showHistory4 = filters.showHistory) !== null && _filters$showHistory4 !== void 0 && _filters$showHistory4.value && role.validityTo ? formatDateFromISO$3(modulesManager, intl, role.validityTo) : null;
      }];
      if (rights.includes(RIGHT_ROLE_SEARCH) || rights.includes(RIGHT_ROLE_UPDATE)) {
        result.push(function (role) {
          return withTooltip$1(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
            href: _this3.roleUpdatePageUrl(role),
            disabled: _this3.isRowDisabled(null, role)
          }, /*#__PURE__*/React.createElement(EditIcon, null))), formatMessage$1(intl, "core", "roleManagement.editButton.tooltip"));
        });
      }
      if (rights.includes(RIGHT_ROLE_DUPLICATE)) {
        result.push(function (role) {
          return withTooltip$1(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
            href: _this3.roleDuplicatePageUrl(role),
            disabled: _this3.isRowDisabled(null, role)
          }, /*#__PURE__*/React.createElement(SupervisedUserCircleIcon, null))), formatMessage$1(intl, "core", "roleManagement.duplicateButton.tooltip"));
        });
      }
      if (rights.includes(RIGHT_ROLE_DELETE)) {
        result.push(function (role) {
          return withTooltip$1(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick() {
              return _this3.onDelete(role);
            },
            disabled: _this3.isRowDisabled(null, role)
          }, /*#__PURE__*/React.createElement(DeleteIcon, null))), formatMessage$1(intl, "core", "roleManagement.deleteButton.tooltip"));
        });
      }
      return result;
    });
    _defineProperty(_this3, "onDelete", function (role) {
      var _this3$props3 = _this3.props,
        intl = _this3$props3.intl,
        coreConfirm = _this3$props3.coreConfirm,
        deleteRole = _this3$props3.deleteRole;
      var confirm = function confirm() {
        return coreConfirm(formatMessageWithValues$1(intl, "core", "roleManagement.deleteRole.confirm.title", {
          label: role.name
        }), formatMessage$1(intl, "core", "roleManagement.deleteRole.confirm.message"));
      };
      var confirmedAction = function confirmedAction() {
        _this3.setState({
          toDelete: role.id
        }, function () {
          return deleteRole(role, formatMessageWithValues$1(intl, "core", "roleManagement.DeleteRole.mutationLabel", {
            label: role.name
          }));
        });
      };
      _this3.setState({
        confirmedAction: confirmedAction
      }, confirm);
    });
    _defineProperty(_this3, "sorts", function (filters) {
      var _filters$showHistory5, _filters$showHistory6;
      return [["name", true], ["isSystem", true], ["isBlocked", true], filters !== null && filters !== void 0 && (_filters$showHistory5 = filters.showHistory) !== null && _filters$showHistory5 !== void 0 && _filters$showHistory5.value ? ["validityFrom", true] : null, filters !== null && filters !== void 0 && (_filters$showHistory6 = filters.showHistory) !== null && _filters$showHistory6 !== void 0 && _filters$showHistory6.value ? ["validityTo", true] : null];
    });
    _defineProperty(_this3, "isRowDisabled", function (_, role) {
      return _this3.state.deleted.includes(role.id) || !!role.validityTo && role.validityTo < new Date().toISOString();
    });
    _defineProperty(_this3, "isRowLocked", function (_, role) {
      return _this3.state.deleted.includes(role.id);
    });
    _defineProperty(_this3, "isOnDoubleClickEnabled", function (role) {
      return !_this3.isRowDisabled(_, role);
    });
    _defineProperty(_this3, "componentDidMount", function () {
      var module = _this3.props.module;
      if (module !== MODULE_NAME) _this3.props.clearCurrentPaginationPage();
    });
    return _this3;
  }
  _inherits(Roles, _Component2);
  return _createClass(Roles, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            deleted: state.deleted.concat(state.toDelete)
          };
        });
      } else if (prevProps.confirmed !== this.props.confirmed && !!this.props.confirmed && !!this.state.confirmedAction) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        intl = _this$props2.intl,
        rights = _this$props2.rights,
        classes = _this$props2.classes,
        fetchingRoles = _this$props2.fetchingRoles,
        fetchedRoles = _this$props2.fetchedRoles,
        errorRoles = _this$props2.errorRoles,
        roles = _this$props2.roles,
        rolesPageInfo = _this$props2.rolesPageInfo,
        rolesTotalCount = _this$props2.rolesTotalCount;
      return rights.includes(RIGHT_ROLE_SEARCH) && /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: formatMessage$1(this.props.intl, "core", "roleManagement.label")
      }), /*#__PURE__*/React.createElement(Searcher$2, {
        module: "core",
        FilterPane: RoleFilter,
        fetch: this.fetch,
        items: roles,
        itemsPageInfo: rolesPageInfo,
        fetchingItems: fetchingRoles,
        fetchedItems: fetchedRoles,
        errorItems: errorRoles,
        tableTitle: formatMessageWithValues$1(intl, "core", "roleManagement.searcher.results.title", {
          rolesTotalCount: rolesTotalCount
        }),
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
        defaultPageSize: DEFAULT_PAGE_SIZE,
        defaultOrderBy: DEFAULT_ORDER_BY,
        rowLocked: this.isRowLocked,
        rowDisabled: this.isRowDisabled,
        onDoubleClick: function onDoubleClick(role) {
          return _this4.isOnDoubleClickEnabled(role) && _this4.onDoubleClick(role);
        }
      }), rights.includes(RIGHT_ROLE_CREATE) && withTooltip$1(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), formatMessage$1(intl, "core", "roleManagement.createButton.tooltip")));
    }
  }]);
}(Component);
var mapStateToProps$3 = function mapStateToProps(state) {
  var _state$core;
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    language: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.language : null,
    fetchingRoles: state.core.fetchingRoles,
    fetchedRoles: state.core.fetchedRoles,
    errorRoles: state.core.errorRoles,
    roles: state.core.roles,
    rolesPageInfo: state.core.rolesPageInfo,
    rolesTotalCount: state.core.rolesTotalCount,
    confirmed: state.core.confirmed,
    submittingMutation: state.core.submittingMutation,
    mutation: state.core.mutation,
    module: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.savedPagination) === null || _state$core === void 0 ? void 0 : _state$core.module
  };
};
var mapDispatchToProps$2 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchRoles: fetchRoles,
    deleteRole: deleteRole,
    coreConfirm: coreConfirm$1,
    journalize: journalize$1,
    clearCurrentPaginationPage: clearCurrentPaginationPage$1
  }, dispatch);
};
var Roles$1 = withModulesManager$1(injectIntl(withTheme(withStyles(styles$4)(connect(mapStateToProps$3, mapDispatchToProps$2)(Roles)))));

function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$3 = function styles(theme) {
  return {
    item: theme.paper.item
  };
};
var RoleHeadPanel = /*#__PURE__*/function (_FormPanel) {
  function RoleHeadPanel() {
    var _this;
    _classCallCheck(this, RoleHeadPanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$3(this, RoleHeadPanel, [].concat(args));
    _defineProperty(_this, "shouldValidate", function (inputValue) {
      var savedRoleName = _this.props.savedRoleName;
      return inputValue !== savedRoleName;
    });
    return _this;
  }
  _inherits(RoleHeadPanel, _FormPanel);
  return _createClass(RoleHeadPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        intl = _this$props.intl,
        classes = _this$props.classes,
        edited = _this$props.edited,
        isRequiredFieldsEmpty = _this$props.isRequiredFieldsEmpty,
        isReadOnly = _this$props.isReadOnly,
        isRoleNameValid = _this$props.isRoleNameValid,
        roleNameValidationError = _this$props.roleNameValidationError;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Divider, null), isRequiredFieldsEmpty && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormattedMessage$3, {
        module: "core",
        id: "roleManagement.requiredFieldsEmptyError"
      })), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(ValidatedTextInput$1, {
        itemQueryIdentifier: "roleName",
        codeTakenLabel: "core.roleManagement.duplicateButton.tooltip",
        shouldValidate: this.shouldValidate,
        isValid: isRoleNameValid,
        validationError: roleNameValidationError,
        action: roleNameValidationCheck,
        clearAction: roleNameValidationClear,
        setValidAction: roleNameSetValid,
        module: "core",
        label: "roleManagement.roleName",
        value: !!edited && !!edited.name ? edited.name : "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("name", v);
        },
        required: true,
        readOnly: !!isReadOnly
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput$2, {
        module: "core",
        label: "roleManagement.altLanguage",
        value: !!edited && !!edited.altLanguage ? edited.altLanguage : "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("altLanguage", v);
        },
        readOnly: !!isReadOnly
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormControlLabel$1, {
        label: formatMessage$1(intl, "core", "roleManagement.isSystem"),
        control: /*#__PURE__*/React.createElement(Checkbox, {
          checked: !!edited && !!edited.isSystem && edited.isSystem,
          onChange: function onChange(event) {
            return _this2.updateAttribute("isSystem", event.target.checked);
          },
          disabled: true
        })
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormControlLabel$1, {
        label: formatMessage$1(intl, "core", "roleManagement.isBlocked"),
        control: /*#__PURE__*/React.createElement(Checkbox, {
          checked: !!edited && !!edited.isBlocked && edited.isBlocked,
          onChange: function onChange(event) {
            return _this2.updateAttribute("isBlocked", event.target.checked);
          },
          disabled: !!isReadOnly
        })
      }))));
    }
  }]);
}(FormPanel$1);
var mapStateToProps$2 = function mapStateToProps(state) {
  var _state$core$validatio, _state$core$validatio2, _state$core$validatio3, _state$core;
  return {
    isRoleNameValid: (_state$core$validatio = state.core.validationFields) === null || _state$core$validatio === void 0 || (_state$core$validatio = _state$core$validatio.roleName) === null || _state$core$validatio === void 0 ? void 0 : _state$core$validatio.isValid,
    isRoleNameValidating: (_state$core$validatio2 = state.core.validationFields) === null || _state$core$validatio2 === void 0 || (_state$core$validatio2 = _state$core$validatio2.roleName) === null || _state$core$validatio2 === void 0 ? void 0 : _state$core$validatio2.isValidating,
    roleNameValidationError: (_state$core$validatio3 = state.core.validationFields) === null || _state$core$validatio3 === void 0 || (_state$core$validatio3 = _state$core$validatio3.roleName) === null || _state$core$validatio3 === void 0 ? void 0 : _state$core$validatio3.validationError,
    savedRoleName: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.role) === null || _state$core === void 0 ? void 0 : _state$core.name
  };
};
var RoleHeadPanel$1 = withModulesManager$1(connect(mapStateToProps$2)(withTheme(withStyles(styles$3)(RoleHeadPanel))));

var _excluded = ["roleRights"],
  _excluded2 = ["roleRights"],
  _excluded3 = ["roleRights"],
  _excluded4 = ["roleRights"];
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$2 = function styles(theme) {
  return {
    item: theme.paper.item,
    paper: theme.paper.paper,
    paperHeader: theme.paper.paperHeader,
    list: {
      width: "100%",
      height: "500px",
      position: "relative",
      overflow: "auto"
    },
    filter: {
      width: "100%"
    },
    listItemText: {
      textTransform: "capitalize"
    },
    reversedArrow: {
      transform: "rotate(180deg)"
    },
    listTitle: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "5px"
    }
  };
};
var RoleRightsPanel = /*#__PURE__*/function (_FormPanel) {
  function RoleRightsPanel(props) {
    var _this;
    _classCallCheck(this, RoleRightsPanel);
    _this = _callSuper$2(this, RoleRightsPanel, [props]);
    _defineProperty(_this, "selectRight", function (rightId) {
      var _this$props$edited = _this.props.edited,
        roleRights = _this$props$edited.roleRights,
        rest = _objectWithoutProperties(_this$props$edited, _excluded);
      roleRights.push(rightId);
      _this.props.onEditedChanged(_objectSpread$6({
        roleRights: roleRights
      }, rest));
    });
    _defineProperty(_this, "unselectRight", function (rightId) {
      var _this$props$edited2 = _this.props.edited,
        roleRights = _this$props$edited2.roleRights,
        rest = _objectWithoutProperties(_this$props$edited2, _excluded2);
      _this.props.onEditedChanged(_objectSpread$6({
        roleRights: roleRights.filter(function (id) {
          return id !== rightId;
        })
      }, rest));
    });
    _defineProperty(_this, "rightTranslationId", function (moduleName, permsName) {
      return "".concat(moduleName, ".").concat(permsName);
    });
    _defineProperty(_this, "isFilterMatched", function (moduleName, permsName) {
      return _this.rightLabel(moduleName, permsName).includes(_this.state.filterValue.toLowerCase()) || _this.rightTranslationId(moduleName, permsName).includes(_this.state.filterValue.toLowerCase());
    });
    _defineProperty(_this, "rightLabel", function (moduleName, permsName) {
      var translationId = _this.rightTranslationId(moduleName, permsName);
      var translatedMessage = formatMessage$1(_this.props.intl, null, translationId);
      var translationFound = translatedMessage !== translationId;
      if (!translationFound) {
        return formatRoleLabel(moduleName, permsName, true);
      }
      return translatedMessage;
    });
    _defineProperty(_this, "filterPermissions", function () {
      var checkAvailableRights = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props = _this.props,
        modulePermissions = _this$props.modulePermissions,
        edited = _this$props.edited;
      var roleRights = edited.roleRights;
      var sortedModulePermissions = modulePermissions ? modulePermissions.sort(function (module, otherModule) {
        return module.moduleName > otherModule.moduleName;
      }) : [];
      var allFilteredPerms = sortedModulePermissions.map(function (_ref) {
        var permissions = _ref.permissions,
          moduleName = _ref.moduleName;
        return permissions.filter(function (_ref2) {
          var permsValue = _ref2.permsValue,
            permsName = _ref2.permsName;
          if (checkAvailableRights) {
            return !roleRights.includes(permsValue) && _this.isFilterMatched(moduleName, permsName);
          }
          return _this.isFilterMatched(moduleName, permsName);
        }).map(function (_ref3) {
          var permsValue = _ref3.permsValue;
          return permsValue;
        });
      }).flat();
      return allFilteredPerms;
    });
    _defineProperty(_this, "selectAllFilteredPerms", function () {
      var _this$props2 = _this.props,
        edited = _this$props2.edited,
        onEditedChanged = _this$props2.onEditedChanged;
      var roleRights = edited.roleRights,
        restState = _objectWithoutProperties(edited, _excluded3);
      var filteredPerms = _this.filterPermissions();
      onEditedChanged(_objectSpread$6({
        roleRights: [].concat(_toConsumableArray(roleRights), _toConsumableArray(filteredPerms))
      }, restState));
    });
    _defineProperty(_this, "removeAllChosenPerms", function () {
      var _this$props3 = _this.props,
        edited = _this$props3.edited,
        onEditedChanged = _this$props3.onEditedChanged;
      var filterValue = _this.state.filterValue;
      var roleRights = edited.roleRights,
        restState = _objectWithoutProperties(edited, _excluded4);
      if (filterValue) {
        var filteredPerms = _this.filterPermissions(false);
        var restPerms = roleRights.filter(function (right) {
          return !filteredPerms.some(function (filteredRight) {
            return filteredRight === right;
          });
        });
        onEditedChanged(_objectSpread$6({
          roleRights: restPerms
        }, restState));
        return;
      }
      onEditedChanged(_objectSpread$6({
        roleRights: []
      }, restState));
    });
    _this.state = {
      filterValue: ""
    };
    return _this;
  }
  _inherits(RoleRightsPanel, _FormPanel);
  return _createClass(RoleRightsPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.fetchedModulePermissions) {
        this.props.fetchModulesPermissions();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        intl = _this$props4.intl,
        classes = _this$props4.classes,
        edited = _this$props4.edited,
        isReadOnly = _this$props4.isReadOnly,
        fetchingModulePermissions = _this$props4.fetchingModulePermissions,
        fetchedModulePermissions = _this$props4.fetchedModulePermissions,
        modulePermissions = _this$props4.modulePermissions,
        errorModulePermissions = _this$props4.errorModulePermissions,
        fetchingRoleRights = _this$props4.fetchingRoleRights,
        fetchedRoleRights = _this$props4.fetchedRoleRights,
        errorRoleRights = _this$props4.errorRoleRights,
        roleUuid = _this$props4.roleUuid;
      var sortedModulePermissions = !!modulePermissions ? modulePermissions.sort(function (module, otherModule) {
        return module.moduleName > otherModule.moduleName;
      }) : [];
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextField, {
        className: classes.filter,
        variant: "outlined",
        label: formatMessage$1(intl, "core", "roleManagement.role.rightsFilter"),
        InputProps: {
          startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, /*#__PURE__*/React.createElement(SearchIcon, null))
        },
        onChange: function onChange(e) {
          return _this2.setState({
            filterValue: e.target.value
          });
        }
      }))))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        justify: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        className: classes.listTitle
      }, /*#__PURE__*/React.createElement(Typography$1, {
        variant: "h6"
      }, /*#__PURE__*/React.createElement(FormattedMessage$3, {
        module: "core",
        id: "roleManagement.role.availableRights"
      })), /*#__PURE__*/React.createElement(Tooltip, {
        title: /*#__PURE__*/React.createElement(FormattedMessage$3, {
          module: "core",
          id: "roleManagement.role.addAllFilteredPerms"
        })
      }, /*#__PURE__*/React.createElement(IconButton, {
        color: "primary",
        disabled: isReadOnly,
        onClick: this.selectAllFilteredPerms
      }, /*#__PURE__*/React.createElement(DoubleArrowIcon, null))))), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(List, {
        className: classes.list,
        subheader: /*#__PURE__*/React.createElement("li", null)
      }, /*#__PURE__*/React.createElement(ProgressOrError$2, {
        progress: fetchingModulePermissions || fetchingRoleRights,
        error: errorModulePermissions || errorRoleRights
      }), !!fetchedModulePermissions && (!!roleUuid ? !!fetchedRoleRights : true) && !!sortedModulePermissions.length && sortedModulePermissions.map(function (modulePermission) {
        return modulePermission.permissions.filter(function (permission) {
          return !edited.roleRights.includes(permission.permsValue) && _this2.isFilterMatched(modulePermission.moduleName, permission.permsName);
        }).map(function (permission) {
          return /*#__PURE__*/React.createElement(ListItem$1, {
            button: true,
            divider: true
          }, /*#__PURE__*/React.createElement(ListItemText$1, {
            className: classes.listItemText,
            primary: _this2.rightLabel(modulePermission.moduleName, permission.permsName)
          }), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick() {
              return _this2.selectRight(permission.permsValue);
            },
            disabled: !!isReadOnly
          }, /*#__PURE__*/React.createElement(ArrowForwardIcon, null))));
        });
      })))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        className: classes.listTitle
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: /*#__PURE__*/React.createElement(FormattedMessage$3, {
          module: "core",
          id: "roleManagement.role.removeAllPerms"
        })
      }, /*#__PURE__*/React.createElement(IconButton, {
        color: "primary",
        disabled: isReadOnly,
        onClick: this.removeAllChosenPerms
      }, /*#__PURE__*/React.createElement(DoubleArrowIcon, {
        className: classes.reversedArrow
      }))), /*#__PURE__*/React.createElement(Typography$1, {
        variant: "h6"
      }, /*#__PURE__*/React.createElement(FormattedMessage$3, {
        module: "core",
        id: "roleManagement.role.chosenRights"
      })))), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(List, {
        className: classes.list,
        subheader: /*#__PURE__*/React.createElement("li", null)
      }, /*#__PURE__*/React.createElement(ProgressOrError$2, {
        progress: fetchingModulePermissions || fetchingRoleRights,
        error: errorModulePermissions || errorRoleRights
      }), !!fetchedModulePermissions && (!!roleUuid ? !!fetchedRoleRights : true) && !!sortedModulePermissions.length && sortedModulePermissions.map(function (modulePermission) {
        return modulePermission.permissions.filter(function (permission) {
          return edited.roleRights.includes(permission.permsValue) && _this2.isFilterMatched(modulePermission.moduleName, permission.permsName);
        }).map(function (permission) {
          return /*#__PURE__*/React.createElement(ListItem$1, {
            button: true,
            divider: true
          }, /*#__PURE__*/React.createElement(ListItemText$1, {
            className: classes.listItemText,
            primary: _this2.rightLabel(modulePermission.moduleName, permission.permsName)
          }), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick() {
              return _this2.unselectRight(permission.permsValue);
            },
            disabled: !!isReadOnly
          }, /*#__PURE__*/React.createElement(ArrowBackIcon, null))));
        });
      })))))));
    }
  }]);
}(FormPanel$1);
var mapStateToProps$1 = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingModulePermissions: state.core.fetchingModulePermissions,
    fetchedModulePermissions: state.core.fetchedModulePermissions,
    modulePermissions: state.core.modulePermissions,
    errorModulePermissions: state.core.errorModulePermissions,
    fetchingRoleRights: state.core.fetchingRoleRights,
    fetchedRoleRights: state.core.fetchedRoleRights,
    errorRoleRights: state.core.errorRoleRights
  };
};
var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchModulesPermissions: fetchModulesPermissions
  }, dispatch);
};
var RoleRightsPanel$1 = injectIntl(withTheme(withStyles(styles$2)(connect(mapStateToProps$1, mapDispatchToProps$1)(RoleRightsPanel))));

function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1 = function styles(theme) {
  return {
    page: theme.page,
    locked: theme.page.locked
  };
};
var Role = /*#__PURE__*/function (_Component) {
  function Role() {
    var _this;
    _classCallCheck(this, Role);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1(this, Role, [].concat(args));
    _defineProperty(_this, "state", {
      role: {
        isSystem: false,
        isBlocked: false,
        roleRights: []
      },
      reset: 0,
      isLocked: false
    });
    _defineProperty(_this, "save", function (role) {
      var _this$props = _this.props,
        intl = _this$props.intl,
        createRole = _this$props.createRole,
        updateRole = _this$props.updateRole,
        coreConfirm = _this$props.coreConfirm;
      if (!!role.id && !_this.state.isDuplicate) {
        var confirm = function confirm() {
          return coreConfirm(formatMessageWithValues$1(intl, "core", "roleManagement.updateRole.confirm.title", {
            label: role.name
          }), formatMessageWithValues$1(intl, "core", "roleManagement.updateRole.confirm.message", {
            label: role.name
          }));
        };
        var confirmedAction = function confirmedAction() {
          updateRole(role, formatMessageWithValues$1(intl, "core", "roleManagement.UpdateRole.mutationLabel", _this.titleParams(role)));
        };
        _this.setState({
          confirmedAction: confirmedAction
        }, confirm);
      } else if (!!role.id && _this.state.isDuplicate) {
        delete role["id"];
        delete role["uuid"];
        _this.setState(function (state) {
          return _objectSpread$5(_objectSpread$5({}, state), {}, {
            isLocked: true
          });
        });
        createRole(role, formatMessageWithValues$1(intl, "core", "roleManagement.DuplicateRole.mutationLabel", {
          label: _this.props.role.name
        }));
      } else {
        _this.setState(function (state) {
          return _objectSpread$5(_objectSpread$5({}, state), {}, {
            isLocked: true
          });
        });
        createRole(role, formatMessageWithValues$1(intl, "core", "roleManagement.CreateRole.mutationLabel", _this.titleParams(role)));
      }
    });
    _defineProperty(_this, "back", function () {
      return _this.props.history.goBack();
    });
    _defineProperty(_this, "isFormLocked", function () {
      return _this.state.isLocked;
    });
    _defineProperty(_this, "isRequiredFieldsEmpty", function () {
      return !(!!_this.state.role && !!_this.state.role.name);
    });
    _defineProperty(_this, "isFormValid", function () {
      return _this.props.isRoleNameValid && !_this.props.isRoleNameValidating;
    });
    _defineProperty(_this, "doesRoleChange", function () {
      var roleRights = _this.state.role.roleRights;
      var _prepareForComparison = prepareForComparison(_this.state.role, _this.props.role, _this.props.roleRights),
        stateRole = _prepareForComparison.stateRole,
        propsRole = _prepareForComparison.propsRole,
        convertedRoleRights = _prepareForComparison.convertedRoleRights;
      if (!_$1.isEqual(propsRole, stateRole)) return true;
      if (!_$1.isEqual(_$1.sortBy(convertedRoleRights), _$1.sortBy(roleRights))) return true;
      return false;
    });
    _defineProperty(_this, "canSave", function () {
      return !_this.isRequiredFieldsEmpty() && _this.isFormValid() && _this.doesRoleChange() && !_this.isFormLocked();
    });
    _defineProperty(_this, "onEditedChanged", function (role) {
      return _this.setState({
        role: role
      });
    });
    _defineProperty(_this, "titleParams", function (role) {
      return {
        label: !!role && !!role.name ? role.name : null
      };
    });
    return _this;
  }
  _inherits(Role, _Component);
  return _createClass(Role, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!!this.props.roleUuid) {
        this.setState(function (_, props) {
          return {
            isDuplicate: new URLSearchParams(props.location.search).has(QUERY_STRING_DUPLICATE)
          };
        }, function () {
          _this2.props.fetchRole(["uuid: \"".concat(_this2.props.roleUuid, "\"")]);
          _this2.props.fetchRoleRights(["role_Uuid: \"".concat(_this2.props.roleUuid, "\"")]);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;
      if (prevProps.fetchedRole !== this.props.fetchedRole && !!this.props.fetchedRole) {
        this.setState(function (state, props) {
          return {
            role: _objectSpread$5(_objectSpread$5({}, props.role), {}, {
              name: state.isDuplicate ? null : props.role.name,
              altLanguage: state.isDuplicate ? null : props.role.altLanguage,
              isSystem: state.isDuplicate ? false : !!props.role.isSystem,
              isBlocked: state.isDuplicate ? false : !!props.role.isBlocked,
              roleRights: state.role.roleRights
            }),
            reset: state.reset + 1,
            isSystemRole: state.isDuplicate ? false : !!props.role.isSystem
          };
        });
      } else if (prevProps.fetchedRoleRights !== this.props.fetchedRoleRights && !!this.props.fetchedRoleRights) {
        this.setState(function (state, props) {
          return {
            role: _objectSpread$5(_objectSpread$5({}, state.role), {}, {
              roleRights: props.roleRights.map(function (right) {
                return right["rightId"];
              })
            })
          };
        });
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        if (!!this.state.role.uuid && !this.state.isDuplicate) {
          this.props.fetchRole(["uuid: \"".concat(this.state.role.uuid, "\"")]);
          this.props.fetchRoleRights(["role_Uuid: \"".concat(this.props.roleUuid, "\"")]);
        } else {
          this.setState({
            isDuplicate: false
          }, function () {
            return _this3.props.fetchRole(["clientMutationId: \"".concat(_this3.props.mutation.clientMutationId, "\"")]);
          });
        }
      } else if (prevProps.confirmed !== this.props.confirmed && !!this.props.confirmed && !!this.state.confirmedAction) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        intl = _this$props2.intl,
        rights = _this$props2.rights,
        classes = _this$props2.classes,
        roleUuid = _this$props2.roleUuid;
      return rights.includes(RIGHT_ROLE_SEARCH) && rights.includes(RIGHT_ROLE_CREATE) && /*#__PURE__*/React.createElement("div", {
        className: clsx(classes.page, this.state.isLocked && classes.locked)
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: formatMessageWithValues$1(this.props.intl, "core", "roleManagement.role.page.title", this.titleParams(this.state.role))
      }), /*#__PURE__*/React.createElement(Form$2, {
        module: "core",
        title: "roleManagement.role.page.title",
        titleParams: this.titleParams(this.state.role),
        edited: this.state.role,
        back: this.back,
        canSave: this.canSave,
        save: this.save,
        onEditedChanged: this.onEditedChanged,
        HeadPanel: RoleHeadPanel$1,
        Panels: [RoleRightsPanel$1],
        isRequiredFieldsEmpty: this.isRequiredFieldsEmpty(),
        saveTooltip: formatMessage$1(intl, "core", "roleManagement.saveButton.tooltip.".concat(this.canSave() ? "enabled" : "disabled")),
        isReadOnly: !!this.state.isSystemRole || !rights.includes(RIGHT_ROLE_UPDATE) || this.state.isLocked,
        reset: this.state.reset,
        roleUuid: roleUuid,
        openDirty: rights.includes(RIGHT_ROLE_UPDATE) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state, props) {
  var _state$core$validatio, _state$core$validatio2;
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    roleUuid: props.match.params.role_uuid,
    fetchedRole: state.core.fetchedRole,
    role: state.core.role,
    fetchedRoleRights: state.core.fetchedRoleRights,
    roleRights: state.core.roleRights,
    submittingMutation: state.core.submittingMutation,
    mutation: state.core.mutation,
    confirmed: state.core.confirmed,
    isRoleNameValid: (_state$core$validatio = state.core.validationFields) === null || _state$core$validatio === void 0 || (_state$core$validatio = _state$core$validatio.roleName) === null || _state$core$validatio === void 0 ? void 0 : _state$core$validatio.isValid,
    isRoleNameValidating: (_state$core$validatio2 = state.core.validationFields) === null || _state$core$validatio2 === void 0 || (_state$core$validatio2 = _state$core$validatio2.roleName) === null || _state$core$validatio2 === void 0 ? void 0 : _state$core$validatio2.isValidating
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createRole: createRole,
    updateRole: updateRole,
    fetchRole: fetchRole,
    fetchRoleRights: fetchRoleRights,
    journalize: journalize$1,
    coreConfirm: coreConfirm$1
  }, dispatch);
};
var Role$1 = withHistory$1(withModulesManager$1(injectIntl(withTheme(withStyles(styles$1)(connect(mapStateToProps, mapDispatchToProps)(Role))))));

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function reducer() {
  var _action$payload, _action$payload3, _action$payload4, _action$payload5, _action$payload6;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    user: null,
    fatalError: null,
    fetchingHistoricalMutations: false,
    fetchedHistoricalMutations: false,
    fetchingMutations: false,
    mutations: [],
    filtersCache: {},
    fetchingRoles: false,
    fetchedRoles: false,
    roles: [],
    rolesPageInfo: {},
    rolesTotalCount: 0,
    errorRoles: null,
    fetchingModulePermissions: false,
    fetchedModulePermissions: false,
    modulePermissions: [],
    errorModulePermissions: null,
    fetchingRole: false,
    fetchedRole: false,
    role: null,
    errorRole: null,
    fetchingRoleRights: false,
    fetchedRoleRights: false,
    roleRights: [],
    errorRoleRights: null,
    isInitialized: false,
    authError: null,
    paginationPage: 0,
    afterCursor: null,
    beforeCursor: null,
    module: null,
    fetchingCustomFilters: false,
    errorCustomFilters: null,
    fetchedCustomFilters: false,
    customFilters: [],
    isExportConfigDialogOpen: false,
    fetchingLanguages: false,
    fetchedLanguages: false,
    languages: [],
    errorLanguages: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "CORE_ALERT":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        alert: action.payload
      });
    case "CORE_ALERT_CLEAR":
      var s = _objectSpread$4({}, state);
      delete s.alert;
      return s;
    case "CORE_CONFIRM":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        confirm: action.payload,
        confirmed: null
      });
    case "CORE_CONFIRM_CLEAR":
      var s = _objectSpread$4(_objectSpread$4({}, state), {}, {
        confirmed: action.payload
      });
      delete s.confirm;
      return s;
    case "CORE_OPEN_EXPORT_CONFIG_DIALOG":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        isExportConfigDialogOpen: true
      });
    case "CORE_CLOSE_EXPORT_CONFIG_DIALOG":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        isExportConfigDialogOpen: false
      });
    case "CORE_USERS_CURRENT_USER_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        user: action.payload
      });
    case "CORE_USERS_CURRENT_USER_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        error: {
          code: action.payload.status,
          message: action.payload.statusText,
          detail: !!action.payload.response ? action.payload.response.detail : null
        }
      });
    case "PASSWORD_POLICY_FIELDS_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingPasswordPolicy: true,
        fetchedPasswordPolicy: false,
        passwordPolicy: null,
        errorPasswordPolicy: null
      });
    case "PASSWORD_POLICY_FIELDS_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingPasswordPolicy: false,
        fetchedPasswordPolicy: true,
        passwordPolicy: action.payload.data.passwordPolicy,
        errorPasswordPolicy: formatGraphQLError(action.payload)
      });
    case "PASSWORD_POLICY_FIELDS_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingPasswordPolicy: false,
        errorPasswordPolicy: formatServerError(action.payload)
      });
    case "CORE_CACHE_FILTER":
      var filtersCache = _objectSpread$4(_objectSpread$4({}, state.filtersCache), action.payload);
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        filtersCache: filtersCache
      });
    case "CORE_CACHE_FILTER_RESET":
      var key = action.payload;
      var filtersCacheCopy = _objectSpread$4({}, state.filtersCache);
      delete filtersCacheCopy[key];
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        filtersCache: filtersCacheCopy
      });
    case "CORE_MUTATION_ADD":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        mutations: [action.payload].concat(_toConsumableArray(state.mutations))
      });
    case "CORE_MUTATION_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingMutations: true
      });
    case "CORE_MUTATION_RESP":
      {
        var mutations = parseData(action.payload.data.mutationLogs);
        return _objectSpread$4(_objectSpread$4({}, state), {}, {
          fetchingMutations: false,
          mutations: _$1.unionBy(mutations, state.mutations, "clientMutationId")
        });
      }
    case "CORE_MUTATION_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingMutations: false
      });
    case "CORE_HISTORICAL_MUTATIONS_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingHistoricalMutations: true
      });
    case "CORE_HISTORICAL_MUTATIONS_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingHistoricalMutations: false,
        fetchedHistoricalMutations: true,
        mutations: parseData(action.payload.data.mutationLogs).map(function (m) {
          return _objectSpread$4(_objectSpread$4({}, m), {}, {
            id: decodeId(m.id)
          });
        }),
        mutationsPageInfo: pageInfo(action.payload.data.mutationLogs)
      });
    case "CORE_HISTORICAL_MUTATIONS_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingHistoricalMutations: false,
        fetchedHistoricalMutations: true
      });
    case "CORE_ROLES_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRoles: true,
        fetchedRoles: false,
        roles: [],
        rolesPageInfo: {},
        rolesTotalCount: 0,
        errorRoles: null
      });
    case "CORE_ROLES_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRoles: false,
        fetchedRoles: true,
        roles: parseData(action.payload.data.role),
        rolesPageInfo: pageInfo(action.payload.data.role),
        rolesTotalCount: !!action.payload.data.role ? action.payload.data.role.totalCount : null,
        errorRoles: formatGraphQLError(action.payload)
      });
    case "CORE_ROLES_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRoles: false,
        errorRoles: formatServerError(action.payload)
      });
    case "CORE_MODULEPERMISSIONS_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingModulePermissions: true,
        fetchedModulePermissions: false,
        modulePermissions: [],
        errorModulePermissions: null
      });
    case "CORE_MODULEPERMISSIONS_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingModulePermissions: false,
        fetchedModulePermissions: true,
        modulePermissions: !!action.payload.data.modulesPermissions ? action.payload.data.modulesPermissions.modulePermsList : [],
        errorModulePermissions: formatGraphQLError(action.payload)
      });
    case "CORE_MODULEPERMISSIONS_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingModulePermissions: false,
        errorModulePermissions: formatServerError(action.payload)
      });
    case "CORE_LANGUAGES_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingLanguages: true,
        fetchedLanguages: false,
        languages: [],
        errorLanguages: null
      });
    case "CORE_LANGUAGES_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingLanguages: false,
        fetchedLanguages: true,
        languages: !!action.payload.data.languages ? action.payload.data.languages : [],
        errorLanguages: formatGraphQLError(action.payload)
      });
    case "CORE_LANGUAGES_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingLanguages: false,
        errorLanguages: formatServerError(action.payload)
      });
    case "CORE_ROLE_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRole: true,
        fetchedRole: false,
        role: null,
        errorRole: null
      });
    case "CORE_ROLE_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRole: false,
        fetchedRole: true,
        role: parseData(action.payload.data.role).find(function (role) {
          return !!role;
        }),
        errorRole: formatGraphQLError(action.payload)
      });
    case "CORE_ROLE_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRole: false,
        errorRole: formatServerError(action.payload)
      });
    case "CORE_ROLERIGHTS_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRoleRights: true,
        fetchedRoleRights: false,
        roleRights: [],
        errorRoleRights: null
      });
    case "CORE_ROLERIGHTS_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRoleRights: false,
        fetchedRoleRights: true,
        roleRights: parseData(action.payload.data.roleRight),
        errorRoleRights: formatGraphQLError(action.payload)
      });
    case "CORE_ROLERIGHTS_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingRoleRights: false,
        errorRoleRights: formatServerError(action.payload)
      });
    case "CORE_ROLE_NAME_VALIDATION_FIELDS_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        validationFields: _objectSpread$4(_objectSpread$4({}, state.validationFields), {}, {
          roleName: {
            isValidating: true,
            isValid: false,
            validationError: null
          }
        })
      });
    case "CORE_ROLE_NAME_VALIDATION_FIELDS_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        validationFields: _objectSpread$4(_objectSpread$4({}, state.validationFields), {}, {
          roleName: {
            isValidating: false,
            isValid: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data.isValid,
            validationError: formatGraphQLError(action.payload)
          }
        })
      });
    case "CORE_ROLE_NAME_VALIDATION_FIELDS_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        validationFields: _objectSpread$4(_objectSpread$4({}, state.validationFields), {}, {
          roleName: {
            isValidating: false,
            isValid: false,
            validationError: formatServerError(action.payload)
          }
        })
      });
    case "CORE_ROLE_NAME_VALIDATION_FIELDS_CLEAR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        validationFields: _objectSpread$4(_objectSpread$4({}, state.validationFields), {}, {
          roleName: {
            isValidating: true,
            isValid: false,
            validationError: null
          }
        })
      });
    case "CORE_ROLE_NAME_VALIDATION_FIELDS_SET_VALID":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        validationFields: _objectSpread$4(_objectSpread$4({}, state.validationFields), {}, {
          roleName: {
            isValidating: false,
            isValid: true,
            validationError: null
          }
        })
      });
    case "FETCH_CUSTOM_FILTER_REQ":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingCustomFilters: true,
        fetchedCustomFilters: false,
        customFilters: [],
        errorCustomFilters: null
      });
    case "FETCH_CUSTOM_FILTER_RESP":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingCustomFilters: false,
        fetchedCustomFilters: true,
        customFilters: !!action.payload.data.customFilters ? action.payload.data.customFilters.possibleFilters : [],
        errorCustomFilters: formatGraphQLError(action.payload)
      });
    case "FETCH_CUSTOM_FILTER_ERR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        fetchingCustomFilters: false,
        errorCustomFilters: formatServerError(action.payload)
      });
    case "CORE_ROLE_MUTATION_REQ":
      return dispatchMutationReq(state, action);
    case "CORE_ROLE_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "CORE_CREATE_ROLE_RESP":
      return dispatchMutationResp(state, "createRole", action);
    case "CORE_UPDATE_ROLE_RESP":
      return dispatchMutationResp(state, "updateRole", action);
    case "CORE_DELETE_ROLE_RESP":
      return dispatchMutationResp(state, "deleteRole", action);

    // AUTH
    case "CORE_AUTH_LOGIN_RESP":
      {
        var _action$payload2;
        if ((_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && _action$payload2.errors) {
          return _objectSpread$4(_objectSpread$4({}, state), {}, {
            authError: formatGraphQLError(action.payload)
          });
        }
        return _objectSpread$4(_objectSpread$4({}, state), {}, {
          authError: null
        });
      }
    case "CORE_AUTH_ERR":
      {
        return _objectSpread$4(_objectSpread$4({}, state), {}, {
          user: null,
          authError: formatServerError(action.payload)
        });
      }
    case "CORE_INITIALIZED":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        isInitialized: true
      });
    case "CORE_AUTH_LOGOUT":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        user: null,
        mutations: [],
        filtersCache: {},
        roles: [],
        rolesPageInfo: {},
        rolesTotalCount: 0,
        modulePermissions: [],
        role: null,
        roleRights: []
      });
    case "CORE_PAGINATION_PAGE":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        savedPagination: {
          paginationPage: (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.page,
          afterCursor: (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.afterCursor,
          beforeCursor: (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.beforeCursor,
          module: (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.module
        }
      });
    case "CORE_PAGINATION_PAGE_CLEAR":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        savedPagination: {
          paginationPage: 0,
          afterCursor: null,
          beforeCursor: null,
          module: null
        }
      });
    case "CORE_CALENDAR_TYPE_TOGGLE":
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        isSecondaryCalendarEnabled: action.payload.isSecondaryCalendarEnabled
      });
    default:
      return state;
  }
}

var InternalServerErrorPage = function InternalServerErrorPage(props) {
  var _useTranslations = useTranslations(MODULE_NAME),
    formatMessage = _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(ErrorPage, _extends({
    status: 500,
    title: formatMessage("core.InternalServerErrorPage.title"),
    description: formatMessage("core.InternalServerErrorPage.description")
  }, props));
};

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // Just log for now, could be reported elsewhere
      console.error(error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement(InternalServerErrorPage, {
          logo: this.props.children.props.logo
        });
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // update the state to show the failover UI at next render
      return {
        hasError: true
      };
    }
  }]);
}(React.Component);

var styles = function styles(theme) {
  return {
    primaryButton: theme.dialog.primaryButton,
    secondaryButton: theme.dialog.secondaryButton
  };
};
var SelectDialog = function SelectDialog(_ref) {
  var classes = _ref.classes,
    module = _ref.module,
    confirmationButton = _ref.confirmationButton,
    rejectionButton = _ref.rejectionButton,
    confirmMessage = _ref.confirmMessage,
    _ref$confirmMessageWi = _ref.confirmMessageWithValues,
    confirmMessageWithValues = _ref$confirmMessageWi === void 0 ? null : _ref$confirmMessageWi,
    _ref$translationVaria = _ref.translationVariables,
    translationVariables = _ref$translationVaria === void 0 ? {} : _ref$translationVaria,
    confirmState = _ref.confirmState,
    confirmTitle = _ref.confirmTitle,
    confirmMessageComponent = _ref.confirmMessageComponent,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var modulesManager = useModulesManager$1();
  var _useTranslations = useTranslations$1(module, modulesManager),
    formatMessage = _useTranslations.formatMessage,
    formatMessageWithValues = _useTranslations.formatMessageWithValues;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: confirmState,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, null, formatMessage(confirmTitle)), /*#__PURE__*/React.createElement(DialogContent, null, confirmMessage && /*#__PURE__*/React.createElement(DialogContentText, null, formatMessage(confirmMessage)), confirmMessageWithValues && /*#__PURE__*/React.createElement(DialogContentText, null, formatMessageWithValues(confirmMessageWithValues, translationVariables)), /*#__PURE__*/React.createElement(DialogContentText, null, confirmMessageComponent)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.secondaryButton
  }, formatMessage(rejectionButton)), /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    autoFocus: true,
    className: classes.primaryButton
  }, formatMessage(confirmationButton))));
};
var SelectDialog$1 = injectIntl(withTheme(withStyles(styles)(SelectDialog)));

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_STYLES = {
  backgroundColor: "khaki",
  padding: "12px",
  margin: "4px",
  borderLeft: "5px solid #ffa000",
  borderRadius: "10px"
};
var WarningBox = function WarningBox(_ref) {
  var title = _ref.title,
    description = _ref.description,
    styles = _ref.styles,
    xs = _ref.xs;
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: xs || 12
  }, /*#__PURE__*/React.createElement(Box, {
    style: _objectSpread$3(_objectSpread$3({}, DEFAULT_STYLES), styles)
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "subtitle1"
  }, /*#__PURE__*/React.createElement("strong", null, title, ":"), " ", description)));
};
WarningBox.defaultProps = {
  styles: {},
  xs: 12
};
WarningBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  styles: PropTypes.object,
  xs: PropTypes.number
};

function downloadExport(export_file, filename) {
  var fileFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EXPORT_FILE_FORMATS.csv;
  var url = new URL("".concat(window.location.origin).concat(baseApiUrl$1, "/core/fetch_export?export=").concat(export_file));
  return function (dispatch) {
    fetch(url).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      return openBlob(blob, filename, fileFormat);
    })["catch"](function (error) {
      console.error("Export failed, reason: ", error);
    });
  };
}

// Creates additional fields from a JSON string and returns an array of field objects.
// @param { string } json - The JSON string containing additional fields.
// @param { string } stream - If object has some nesting property, it could be declared here.
// @returns { Array } - An array of field objects, each containing the field's type and value.
var createFieldsBasedOnJSON = function createFieldsBasedOnJSON(json) {
  var stream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (!json) return [];
  var additionalFields = JSON.parse(json);
  var fields = stream && !isEmptyObject(additionalFields) ? additionalFields[stream] : additionalFields;
  return Object.entries(fields).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      property = _ref2[0],
      value = _ref2[1];
    var field = _defineProperty({}, property, value);
    var fieldType = _typeof(value);
    return {
      fieldType: fieldType,
      field: field
    };
  });
};

// Renders the appropriate input component based on the field type and value.
// @param { string } module - The name of module.
// @param { object } field - The field object containing the field's label and value.
// @param { string } fieldType - The type of the field.
// @param { boolean } isTranslationLabel - A flag to determine if the label is a translation.
// @returns { JSX.Element } - The rendered input component based on the field type.
// WARNING: Currently, only two types of inputs are supported for readOnly reasons.
var renderInputComponent = function renderInputComponent(module, _ref3) {
  var fieldType = _ref3.fieldType,
    field = _ref3.field;
  var isTranslationLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _Object$entries$ = Object.entries(field)[0],
    label = _Object$entries$[0],
    value = _Object$entries$[1];
  var labelValue = isTranslationLabel ? "".concat(module, ".additionalFields.").concat(label) : label;
  if (fieldType === FIELD_TYPES.INTEGER || fieldType === FIELD_TYPES.NUMBER) {
    return /*#__PURE__*/React.createElement(NumberInput$2, {
      module: module,
      readOnly: true,
      min: 0,
      displayZero: true,
      label: labelValue,
      value: value
    });
  }
  return /*#__PURE__*/React.createElement(TextInput$2, {
    module: module,
    readOnly: true,
    label: labelValue,
    value: value
  });
};

function formatJsonField(json) {
  return "\"".concat(JSON.stringify(json).replace(/\"/g, '\\"'), "\"");
}

function authMiddleware(store) {
  return function wrapDispatch(next) {
    return function handleAction(action) {
      var _action$payload;
      if (action.type !== "CORE_AUTH_ERR" && ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.name) === "ApiError" && action.payload.status === 401) {
        return store.dispatch(authError(action.payload));
      }
      return next(action);
    };
  };
}

var RefreshAuthToken = function RefreshAuthToken() {
  var auth = useAuthentication();
  var intervalRef = useRef();
  useEffect(function () {
    if (auth.isAuthenticated) {
      intervalRef.current = setInterval(auth.refresh, 2 * 60 * 1000); // Refresh the token every 2 minutes
    }
    return function () {
      clearTimeout(intervalRef.current);
    };
  }, [auth.isAuthenticated]);
  return null;
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var UserActivityReport = function UserActivityReport(props) {
  var values = props.values,
    setValues = props.setValues;
  var modulesManager = useModulesManager$1();
  var _useTranslations = useTranslations$1("core", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
    pubRef: "core.DatePicker",
    value: values.dateFrom,
    module: "core",
    required: true,
    label: "UserActivityReport.dateFrom",
    onChange: function onChange(dateFrom) {
      return setValues(_objectSpread$2(_objectSpread$2({}, values), {}, {
        dateFrom: dateFrom
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
    pubRef: "core.DatePicker",
    value: values.dateTo,
    module: "core",
    required: true,
    label: "UserActivityReport.dateTo",
    onChange: function onChange(dateTo) {
      return setValues(_objectSpread$2(_objectSpread$2({}, values), {}, {
        dateTo: dateTo
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
    pubRef: "admin.UserPicker",
    value: values.user,
    module: "core",
    label: formatMessage("UserActivityReport.user"),
    onChange: function onChange(user) {
      return setValues(_objectSpread$2(_objectSpread$2({}, values), {}, {
        user: user
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ConstantBasedPicker$2, {
    module: "core",
    value: values.action,
    label: "UserActivityReport.action",
    constants: USER_ACTIVITY_REPORT_ACTIONS,
    onChange: function onChange(action) {
      return setValues(_objectSpread$2(_objectSpread$2({}, values), {}, {
        action: action
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ConstantBasedPicker$2, {
    module: "core",
    value: values.entity,
    label: "UserActivityReport.entity",
    constants: USER_ACTIVITY_REPORT_ENTITIES,
    onChange: function onChange(entity) {
      return setValues(_objectSpread$2(_objectSpread$2({}, values), {}, {
        entity: entity
      }));
    }
  })));
};

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RegistersStatusReport = function RegistersStatusReport(props) {
  var values = props.values,
    setValues = props.setValues;
  var modulesManager = useModulesManager$1();
  var _useTranslations = useTranslations$1("core", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
    pubRef: "location.LocationPicker",
    onChange: function onChange(region) {
      return setValues(_objectSpread$1(_objectSpread$1({}, values), {}, {
        region: region,
        district: null
      }));
    },
    value: values.region,
    locationLevel: 0,
    label: formatMessage("RegistersStatusReport.region")
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(PublishedComponent$2, {
    pubRef: "location.LocationPicker",
    onChange: function onChange(district) {
      return setValues(_objectSpread$1(_objectSpread$1({}, values), {}, {
        district: district
      }));
    },
    value: values.district,
    parentLocation: values.region,
    locationLevel: 1,
    label: formatMessage("RegistersStatusReport.district")
  })));
};

var SearcherActionButton = function SearcherActionButton(_ref) {
  var onClick = _ref.onClick,
    startIcon = _ref.startIcon,
    label = _ref.label;
  var modulesManager = useModulesManager$1();
  var isWorker = modulesManager.getConf("fe-core", "isWorker", DEFAULT.IS_WORKER);
  return /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    style: {
      border: 0
    },
    onClick: onClick,
    startIcon: startIcon
  }, label && /*#__PURE__*/React.createElement(Typography$1, {
    variant: isWorker ? "body2" : "subtitle1"
  }, label));
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ROUTE_ROLES = "roles";
var ROUTE_ROLE = "roles/role";
var DEFAULT_CONFIG = {
  "translations": [{
    key: "en",
    messages: messages_en
  }],
  "reducers": [{
    key: "core",
    reducer: reducer
  }],
  "reports": [{
    key: "user_activity",
    component: UserActivityReport,
    isValid: function isValid(values) {
      return values.dateFrom && values.dateTo;
    },
    getParams: function getParams(values) {
      var params = {};
      if (values.user) {
        params.requested_user_id = decodeId(values.user.iUser.id);
      }
      if (values.action) {
        params.action = values.action;
      }
      if (values.entity) {
        params.entity = values.entity;
      }
      params.date_start = values.dateFrom;
      params.date_end = values.dateTo;
      return params;
    }
  }, {
    key: "registers_status",
    component: RegistersStatusReport,
    isValid: function isValid(values) {
      return true;
    },
    getParams: function getParams(values) {
      var params = {};
      if (values.region) {
        params.requested_region_id = decodeId(values.region.id);
      }
      if (values.district) {
        params.requested_district_id = decodeId(values.district.id);
      }
      return params;
    }
  }],
  "middlewares": [authMiddleware],
  "refs": [{
    key: "core.JournalDrawer.pollInterval",
    ref: 2000
  }, {
    key: "core.KeepLegacyAlive.pollInterval",
    ref: 300000
  }, {
    key: "core.YearPicker",
    ref: YearPicker$1
  }, {
    key: "core.MonthPicker",
    ref: MonthPicker$1
  }, {
    key: "core.LanguagePicker",
    ref: LanguagePicker$1
  }, {
    key: "core.AuthorityPicker",
    ref: AuthorityPicker
  }, {
    key: "core.route.role",
    ref: ROUTE_ROLE
  }],
  "core.Boot": [KeepLegacyAlive$1, RefreshAuthToken],
  "core.Router": [{
    path: ROUTE_ROLES,
    component: Roles$1
  }, {
    path: ROUTE_ROLE + "/:role_uuid?",
    component: Role$1
  }],
  "admin.MainMenu": [{
    text: /*#__PURE__*/React.createElement(FormattedMessage$1, {
      module: "core",
      id: "roleManagement.label"
    }),
    icon: /*#__PURE__*/React.createElement(AccountBox, null),
    route: "/" + ROUTE_ROLES,
    filter: function filter(rights) {
      return rights.includes(RIGHT_ROLE_SEARCH);
    },
    id: 'admin.roleManagement'
  }]
};
var CoreModule = function CoreModule(cfg) {
  var def = _objectSpread({}, DEFAULT_CONFIG);
  def.refs.push({
    key: "core.DatePicker",
    ref: openIMISDatePicker$1
  });
  return _objectSpread(_objectSpread({}, def), cfg);
};
function combine() {
  for (var _len = arguments.length, hocs = new Array(_len), _key = 0; _key < _len; _key++) {
    hocs[_key] = arguments[_key];
  }
  return function (Component) {
    return hocs.reduceRight(function (acc, hoc) {
      return hoc(acc);
    }, Component);
  };
}

export { AdvancedFiltersDialog$1 as AdvancedFiltersDialog, AlertForwarder$1 as AlertForwarder, AmountInput$1 as AmountInput, App$1 as App, AutoSuggestion$1 as AutoSuggestion, Autocomplete$1 as Autocomplete, Block, CLEARED_STATE_FILTER, ConfirmDialog$1 as ConfirmDialog, ConstantBasedPicker$1 as ConstantBasedPicker, Contributions, ControlledField$1 as ControlledField, CoreModule, CustomFilterFieldStatusPicker, CustomFilterTypeStatusPicker$1 as CustomFilterTypeStatusPicker, EXPORT_FILE_FORMATS, Error$2 as Error, ErrorBoundary, FakeInput$1 as FakeInput, FatalErrorPage as FatalError, FieldLabel$1 as FieldLabel, Filter$1 as Filter, Form$1 as Form, FormPanel, FormattedMessage$1 as FormattedMessage, InfoButton, LanguagePicker$1 as LanguagePicker, MainMenuContribution$1 as MainMenuContribution, MonthPicker$1 as MonthPicker, NumberInput$1 as NumberInput, PagedDataHandler, Picker$1 as Picker, ProgressOrError$1 as ProgressOrError, ProxyPage, PublishedComponent$1 as PublishedComponent, Searcher$1 as Searcher, SearcherActionButton, SearcherExport$1 as SearcherExport, SearcherPane$1 as SearcherPane, SelectDialog$1 as SelectDialog, SelectInput$1 as SelectInput, Table$3 as Table, TableService, TableServiceReview, TextAreaInput, TextInput$1 as TextInput, ValidatedTextAreaInput, ValidatedTextInput, WarningBox, YearPicker$1 as YearPicker, apiHeaders, baseApiUrl, clearConfirm, clearCurrentPaginationPage, combine, coreAlert, coreConfirm, createFieldsBasedOnJSON, decodeId, dispatchMutationErr, dispatchMutationReq, dispatchMutationResp, downloadExport, encodeId, ensureArray, fetchCustomFilter, fetchMutation, fetchPasswordPolicy, formatAmount, formatDateFromISO, formatDateTimeFromISO, formatGQLString, formatGraphQLError, formatJsonField, formatMessage, formatMessageWithValues, formatMutation, formatNodeQuery, formatPageQuery, formatPageQueryWithCount, formatQuery, formatServerError, formatSorter, getLanguageNameByCode, getTimeDifferenceInDays, getTimeDifferenceInDaysFromToday, graphql, graphqlMutation, graphqlWithVariables, historyPush, isEmptyObject, journalize, onLogout, openBlob, pageInfo, parseData, passwordGenerator, prepareForComparison, prepareMutation, redirectToSamlLogout, renderInputComponent, sort, toISODate, toISODateTime, useAuthentication, useBoolean, useDebounceCb, useGraphqlMutation, useGraphqlQuery, useModulesManager, usePrevious, usePublicPageLanguage, useToast, useTranslations, useUserQuery, validatePassword, withHistory, withModulesManager, withTooltip };
//# sourceMappingURL=index.es.js.map
